/* eslint-disable no-undef */
import React, { useState, useEffect, useRef } from 'react';
import { npAudio } from './audioCoordinator';
import AdUnit from './AdUnit';
import AstrologyContent from './AstrologyContent';
import BirthChartContent from './BirthChartContent';
import StockMarketLive from './StockMarketLive';
import GrandOpeningPage from './GrandOpeningPage';
import { Fireworks, Balloons, Poppers, CurtainOpen, StarBurst } from './SpecialEffects';
import Login from './Login';
import Signup from './Signup';
import AdminDashboard from './AdminDashboard';
import About from './About';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions';
import RefundPolicy from './RefundPolicy';
import GrievanceOfficer from './GrievanceOfficer';
import LegalFooter from './LegalFooter';
import GetAppPage, { GetAppQR } from './GetApp';
import Pricing from './Pricing';
import Leaderboard from './Leaderboard';
import UserProfile from './UserProfile';
import NethajIQPage from './NethajIQPage';
import AdvancedMemeGenerator from './AdvancedMemeGenerator';
import BANNERS from './CategoryBanners';
import './App.css';
import './global.css';
import './Responsive.css';
import WatchNowPage from './WatchNowPage';
import DealsPage from './DealsPage';
const VAPID_PUBLIC_KEY = 'BAI2N-zfDM5CqQRcoa4xT8b3saOmbZlh_66RJguIKHh0V0wGsCqyCSIR6LHlKLu9REmRotDy7avI1ZcyNC11FLg';
function urlBase64ToUint8Array(b){const p='='.repeat((4-b.length%4)%4);const d=(b+p).replace(/-/g,'+').replace(/_/g,'/');return Uint8Array.from([...atob(d)].map(c=>c.charCodeAt(0)));}
async function subscribeToPush(token){try{if(!('serviceWorker' in navigator)||!('PushManager' in window))return;const reg=await navigator.serviceWorker.ready;if(await reg.pushManager.getSubscription())return;const perm=await Notification.requestPermission();if(perm!=='granted')return;const sub=await reg.pushManager.subscribe({userVisibleOnly:true,applicationServerKey:urlBase64ToUint8Array(VAPID_PUBLIC_KEY)});await fetch((process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com')+'/push/subscribe',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+token},body:JSON.stringify(sub)});}catch(e){console.log('Push failed',e);}}






























const LANG_KEY = 'nethaji_lang';
const T = {
  en: {
    search_placeholder: 'Search speeches...',
    logout: 'Logout',
    trial: (d) => `Trial: ${d}d`,
    premium: '✅ Pro',
    expired: '🔒 Expired',
    home: 'Home', new: 'New', old: 'Old',
    categories: 'CATEGORIES',
    menu: 'MENU',
    my_profile: '👤 My Profile',
    pricing: '💰 Pricing',
    top_charts: '🏅 Top Charts',
    about: 'ℹ️ About',
    advanced_search: '🔍 Advanced Search',
    trending_now: '🔥 Trending Now',
    browse_speaker: '🎤 Browse by Speaker',
    all_speakers: 'All Speakers',
    all_videos: 'All Videos',
    continue_watching: '▶ Continue Watching',
    no_videos: 'No videos found',
    no_videos_sub: 'Try a different category or search',
    views: 'views',
    hypes: 'hypes',
    new_badge: 'NEW',
    premium_badge: 'PREMIUM',
    upgrade: 'Upgrade to continue watching.',
    view_plans: 'View Plans',
    trial_expiring: (d) => `⚠️ Trial expires in ${d} day${d===1?'':'s'}! Upgrade now.`,
    watch_now: '▶ Watch Now',
    share: '🔗 Share',
    download: '⬇️ Download',
    hype: '🔥 Hype',
    subscribe_speaker: 'Follow',
    search_title: '🔍 Search',
    search_btn: 'Search',
    know_rights: 'KNOW YOUR RIGHTS',
    watch_now_btn: '▶ WATCH NOW',
    trailer: 'TRAILER ▶',
    trending: '🔥 TRENDING',
    legal_videos: 'Legal Videos',
    see_all: 'See All ›',
    featured: '⭐ FEATURED',
    must_watch: 'Must Watch',
    topics: '📚 TOPICS',
    know_rights_title: 'Know Your Rights',
    view_all: 'View All ›',
    now_streaming: 'NOW STREAMING',
    lang_toggle: 'தமிழ்',
    email_label: 'Email Address',
    phone_label: 'Contact Number',
    subscribe_now: 'Subscribe Now',
    free_beta: 'FREE BETA',
    free_beta_msg: '🎉 All content is FREE during our Beta launch — Enjoy unlimited access!',
    limited_time: 'Limited Time Only',
    now_streaming_live: 'NOW STREAMING',
    browse_by_speaker: 'Browse by Speaker',
    cat_Shorts: '📱 Shorts',
    cat_Reels: '🎬 Reels',
    cat_Interviews: '🎤 Interviews',
    cat_Devotional: '🙏 Devotional',
    cat_Stock_Market: '📊 Stock Market',
    cat_Astrology: '⭐ Astrology',
    cat_New: 'New',
    cat_Legal: 'Legal',
    cat_Legal: 'Legal',
    cat_Live_News: 'Live News',
    cat_Movies: 'Movies',
    cat_Kids: 'Kids',
    cat_Nethaji_TV: 'Nethaji TV',
    cat_MGR_Songs: 'Songs',
    cat_Sports: 'Sports',
    cat_Health: 'Health & Fitness',
    cat_Kitchen: 'Kitchen',
    cat_Education: 'Education',
    cat_Auto: 'Automobiles',
    cat_Tourism: 'Tourism',
    cat_Women: 'Women',
    cat_Deals: 'Deals & Offers',
    cat_Transport: 'Transport',
    cat_Men: 'Men',
    cat_Sun_Detective: '🔍 Sun Detective',
    free_access: '🎁 Free Access',
    ticker_text: 'NETHAJI PRIME OTT — Tamil Sociopolitical Media · Parties · Politics · Online Stream · Full Episodes & Videos',
  },
  ta: {
    search_placeholder: 'உரைகளை தேடுங்கள்...',
    logout: 'வெளியேறு',
    trial: (d) => `சோதனை: ${d} நாள்`,
    premium: '✅ பிரீமியம்',
    expired: '🔒 காலாவதி',
    home: 'முகப்பு', new: 'புதியது', old: 'பழையது',
    categories: 'பிரிவுகள்',
    menu: 'மெனு',
    my_profile: '👤 என் சுயவிவரம்',
    pricing: '💰 விலை நிர்ணயம்',
    top_charts: '🏅 சிறந்தவை',
    about: 'ℹ️ பற்றி',
    advanced_search: '🔍 விரிவான தேடல்',
    trending_now: '🔥 இப்போது பிரபலம்',
    browse_speaker: '🎤 பேச்சாளரை தேர்ந்தெடு',
    all_speakers: 'அனைத்து பேச்சாளர்கள்',
    all_videos: 'அனைத்து வீடியோக்கள்',
    continue_watching: '▶ தொடர்ந்து பாருங்கள்',
    no_videos: 'வீடியோக்கள் இல்லை',
    no_videos_sub: 'வேறு பிரிவு அல்லது தேடலை முயற்சிக்கவும்',
    views: 'பார்வைகள்',
    hypes: 'ஹைப்ஸ்',
    new_badge: 'புதியது',
    premium_badge: 'பிரீமியம்',
    upgrade: 'தொடர்ந்து பார்க்க மேம்படுத்தவும்.',
    view_plans: 'திட்டங்களை பார்க்க',
    trial_expiring: (d) => `⚠️ சோதனை ${d} நாளில் முடியும்! இப்போதே மேம்படுத்துங்கள்.`,
    watch_now: '▶ இப்போது பாருங்கள்',
    share: '🔗 பகிர்',
    download: '⬇️ பதிவிறக்கம்',
    hype: '🔥 ஹைப்',
    subscribe_speaker: 'பின்தொடர்',
    search_title: '🔍 தேடல்',
    search_btn: 'தேடு',
    know_rights: 'உங்கள் உரிமைகளை அறிந்துகொள்ளுங்கள்',
    watch_now_btn: '▶ இப்போது பாருங்கள்',
    trailer: 'டிரெய்லர் ▶',
    trending: '🔥 பிரபலம்',
    legal_videos: 'சட்ட வீடியோக்கள்',
    see_all: 'அனைத்தும் பார்க்க ›',
    featured: '⭐ சிறப்பு',
    must_watch: 'கண்டிப்பாக பாருங்கள்',
    topics: '📚 தலைப்புகள்',
    know_rights_title: 'உங்கள் உரிமைகளை அறியுங்கள்',
    view_all: 'அனைத்தும் பார்க்க ›',
    now_streaming: 'இப்போது ஸ்ட்ரீமிங்',
    lang_toggle: 'EN',
    email_label: 'மின்னஞ்சல்',
    phone_label: 'தொலைபேசி எண்',
    subscribe_now: 'சந்தா செலுத்து',
    free_beta: 'இலவச பீட்டா',
    free_beta_msg: '🎉 பீட்டா அறிமுகத்தின் போது அனைத்து உள்ளடக்கமும் இலவசம் — வரம்பற்ற அணுகலை அனுபவியுங்கள்!',
    limited_time: 'குறைந்த காலம் மட்டுமே',
    now_streaming_live: 'இப்போது ஸ்ட்ரீமிங்',
    browse_by_speaker: 'பேச்சாளரை தேர்ந்தெடு',
    cat_Shorts: 'குறும் காணொளிகள்',
    cat_Reels: 'ரீல்ஸ்',
    cat_Interviews: 'நேர்காணல்கள்',
    cat_Devotional: 'பக்தி',
    cat_Stock_Market: 'பங்கு சந்தை',
    cat_Astrology: 'ஜோதிடம்',
    cat_New: 'புதியது',
    cat_Legal: 'சட்டம்',
    cat_Legal: '\u0b9a\u0b9f\u0bcd\u0b9f\u0bae\u0bcd',
    cat_Live_News: '\u0ba8\u0bc7\u0bb0\u0b9f\u0bbf \u0b9a\u0bc6\u0baf\u0bcd\u0ba4\u0bbf',
    cat_Movies: '\u0ba4\u0bae\u0bbf\u0bb4\u0bcd \u0b9a\u0bbf\u0ba9\u0bbf\u0bae\u0bbe',
    cat_Kids: '\u0b95\u0bc1\u0bb4\u0ba8\u0bcd\u0ba4\u0bc8\u0b95\u0bb3\u0bcd',
    cat_Nethaji_TV: '\u0ba8\u0bc7\u0ba4\u0bbe\u0b9c\u0bbf \u0b9f\u0bbf\u0bb5\u0bbf \u0b9a\u0bae\u0bc2\u0b95 \u0bae\u0bc0\u0b9f\u0bbf\u0baf\u0bbe',
    cat_MGR_Songs: 'பாடல்கள்',
    cat_Sports: 'விளையாட்டு',
    cat_Health: 'ஆரோக்கியம்',
    cat_Kitchen: 'சமையலறை',
    cat_Education: 'கல்வி',
    cat_Auto: 'வாகனங்கள்',
    cat_Tourism: 'சுற்றுலா',
    cat_Women: 'மகளிர்',
    cat_Deals: 'சலுகைகள்',
    cat_Transport: '\u0bb5\u0bbe\u0b95\u0ba9\u0bae\u0bcd',
    cat_Men: '\u0b86\u0ba3\u0bcd\u0b95\u0bb3\u0bcd',
    cat_Sun_Detective: '\u0b9a\u0ba9\u0bcd \u0b9f\u0bbf\u0b9f\u0bc6\u0b95\u0bcd\u0b9f\u0bbf\u0bb5\u0bcd',
    free_access: '🎁 இலவச அணுகல்',
    ticker_text: 'நேதாஜி பிரைம் OTT — தமிழ் சமூக அரசியல் ஊடகம் · கட்சிகள் · அரசியல் · நேரடி ஒளிபரப்பு · முழு எபிசோட்கள் & வீடியோக்கள்',
  }
};

const CW_KEY = 'nethaji_continue_watching';
function getContinueWatching() { try { return JSON.parse(localStorage.getItem(CW_KEY) || '{}'); } catch { return {}; } }
const NV_KEY = 'nethaji_last_seen_ts';
function getLastSeenTs() { return parseInt(localStorage.getItem(NV_KEY) || '0'); }
function markAllSeen() { localStorage.setItem(NV_KEY, Date.now().toString()); }
function getNewVideoCount(videos) {
  const lastSeen = getLastSeenTs();
  if (!lastSeen) return 0;
  return videos.filter(v => new Date(v.created_at).getTime() > lastSeen).length;
}
// eslint-disable-next-line no-unused-vars
function getWatchStats() {
  const cw = getContinueWatching();
  const entries = Object.values(cw);
  const totalSeconds = entries.reduce((sum, e) => sum + (e.currentTime || 0), 0);
  const speakerMap = {};
  entries.forEach(e => { if (e.speaker_name) speakerMap[e.speaker_name] = (speakerMap[e.speaker_name] || 0) + 1; });
  const topSpeaker = Object.entries(speakerMap).sort((a, b) => b[1] - a[1])[0]?.[0] || null;
  return { totalVideos: entries.length, totalMinutes: Math.floor(totalSeconds / 60), topSpeaker };
}
function saveProgress(videoId, currentTime, duration, videoData) {
  if (!videoId || !duration || currentTime < 5) return;
  const percent = currentTime / duration;
  if (percent > 0.92) {
    removeProgress(videoId);
    // Step 26: Track video completion
    try {
      const tok = localStorage.getItem('token');
      if (tok) fetch((process.env.REACT_APP_BACKEND_URL||'https://nethajiprime-backend.onrender.com')+'/api/video-completion', {
        method:'POST',
        headers:{'Content-Type':'application/json','Authorization':'Bearer '+tok},
        body:JSON.stringify({video_id:videoId, title:videoData.title, speaker:videoData.speaker_name, category:videoData.category})
      }).catch(()=>{});
    } catch(e) {}
    return;
  }
  const cw = getContinueWatching();
  cw[videoId] = { currentTime: Math.floor(currentTime), duration: Math.floor(duration), percent: Math.round(percent * 100), title: videoData.title, speaker_name: videoData.speaker_name, thumbnail_url: videoData.thumbnail_url, category: videoData.category, savedAt: Date.now() };
  localStorage.setItem(CW_KEY, JSON.stringify(cw));
}
function removeProgress(videoId) { const cw = getContinueWatching(); delete cw[videoId]; localStorage.setItem(CW_KEY, JSON.stringify(cw)); }
function getContinueWatchingList() {
  const cw = getContinueWatching();
  return Object.entries(cw).map(([id, data]) => ({ id, ...data })).sort((a, b) => b.savedAt - a.savedAt).slice(0, 6);
}
function formatDuration(seconds) { if (!seconds) return '0:00'; const mins = Math.floor(seconds / 60); const secs = seconds % 60; return `${mins}:${secs.toString().padStart(2, '0')}`; }

const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';
function getTrendingScore(video) {
  const now = Date.now();
  const uploadDate = new Date(video.upload_date || video.created_at || video.publishedAt || Date.now()).getTime();
  const ageHours = (now - uploadDate) / (1000 * 60 * 60);
  const recencyScore = Math.max(0, 100 - ageHours / 24);
  return ((video.views_count||0) * 0.4) + ((video.like_count||0) * 0.4) + ((video.hype_count||0) * 0.2) + recencyScore;
}
function shareOnWhatsApp(video, category) {
  const videoUrl = video.videoId ? 'https://youtu.be/'+video.videoId : 'https://nethajiprime.com/watch/'+video.id;
  const currentUrl = window.location.href.includes('nethajiprime.com') ? window.location.href : 'https://nethajiprime.com';
  const ottUrl = currentUrl;
  const msg = encodeURIComponent('🔥 ' + video.title + '\n\nWatch now: ' + videoUrl + '\n\nMore content: ' + ottUrl);
  window.open('https://wa.me/?text=' + msg, '_blank');
}
function copyVideoLink(video) {
  navigator.clipboard.writeText(video.videoId ? 'https://youtu.be/'+video.videoId : 'https://nethajiprime.com/watch/'+video.id);
  alert('Link copied!');
}
const IS_LIVE = false;
setInterval(() => { fetch((process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com")+"/health").catch(()=>{}); }, 240000);

const wakeBackend = async (retries = 3) => {
  for (let i = 0; i < retries; i++) {
    try { await fetch(`${API_URL}/health`, { signal: AbortSignal.timeout(8000) }); return true; }
    catch (e) { if (i < retries - 1) await new Promise(r => setTimeout(r, 3000)); }
  }
  return false;
};

// ══════════════════════════════
// FULLSCREEN VIDEO PLAYER
// ══════════════════════════════
function FullscreenPlayer({ video, onClose, user, hasAccess, onSubscribeChange, onUpgrade, onVideoSelect, videos, t, setContinueWatchingList }) {
  const videoRef = useRef(null);
  const timerRef = useRef(null);
  const progressRef = useRef(null);
  const token = localStorage.getItem('token');
  const isPremiumLocked = video.is_premium && !hasAccess;

  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(video.like_count || 0);
  const [subscribed, setSubscribed] = useState(false); const [subscribing, setSubscribing] = useState(false);
  const [subscriberCount, setSubscriberCount] = useState(video.subscriber_count || 0);
  const [hyped, setHyped] = useState(false);
  const [hypeCount, setHypeCount] = useState(video.hype_count || 0);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [showComments, setShowComments] = useState(false);
  const [commentSubmitted, setCommentSubmitted] = useState(false);
  const [showUpgradePopup, setShowUpgradePopup] = useState(false);
  const [relatedVideos, setRelatedVideos] = useState([]);
  // ── Autoplay-next / continuous watch ──────────────────────────────────────
  const [autoplayOn, setAutoplayOn] = useState(() => localStorage.getItem('np_autoplay') !== '0');
  const [upNext, setUpNext] = useState(null);     // next video queued after end
  const [countdown, setCountdown] = useState(0);  // seconds left before auto-advance
  const countdownRef = useRef(null);
  const AUTOPLAY_SECONDS = 6;
  const EPISODE_SECONDS = 10;                       // longer window for the series "Next Episode" card
  const [nextEpisode, setNextEpisode] = useState(null);   // series next-episode from /series/next (null = standalone/last)
  const [upNextIsEpisode, setUpNextIsEpisode] = useState(false);
  const clearCountdown = () => { if (countdownRef.current) { clearInterval(countdownRef.current); countdownRef.current = null; } };
  // Next relevant video the viewer can actually watch (skip premium-locked ones
  // for non-subscribers so free users get a smooth chain, not a repeated wall).
  const pickNextVideo = () => {
    const pool = [...relatedVideos, ...(videos || [])];
    const seen = new Set([String(video.id)]);
    for (const v of pool) {
      const id = String(v.id);
      if (seen.has(id)) continue;
      seen.add(id);
      if (video.category && v.category && v.category !== video.category) continue;
      if (v.is_premium && !hasAccess) continue;
      return v;
    }
    return null;
  };
  const advanceToUpNext = (next) => {
    clearCountdown();
    const nv = next || upNext;
    setUpNext(null); setCountdown(0); setUpNextIsEpisode(false);
    if (!nv) return;
    if (videoRef.current) { try { videoRef.current.pause(); videoRef.current.src = ''; } catch (e) {} }
    onVideoSelect({ ...nv, _autoplay: true });
    window.scrollTo(0, 0);
  };
  const cancelUpNext = () => { clearCountdown(); setUpNext(null); setCountdown(0); setUpNextIsEpisode(false); };
  const startUpNext = () => {
    // The next episode in the same series wins over a generic same-category pick.
    // nextEpisode is null when the video is standalone or is the last episode,
    // in which case we fall back to the existing autoplay behavior.
    const episode = nextEpisode;
    const next = episode || pickNextVideo();
    if (!next) return;
    const isEp = !!episode;
    setUpNext(next); setUpNextIsEpisode(isEp);
    setCountdown(isEp ? EPISODE_SECONDS : AUTOPLAY_SECONDS); clearCountdown();
    countdownRef.current = setInterval(() => {
      if (document.hidden) return;                 // pause countdown while backgrounded
      setCountdown(c => {
        if (c <= 1) { clearCountdown(); advanceToUpNext(next); return 0; }
        return c - 1;
      });
    }, 1000);
  };
  const toggleAutoplay = () => {
    setAutoplayOn(on => {
      const nv = !on;
      localStorage.setItem('np_autoplay', nv ? '1' : '0');
      if (!nv) cancelUpNext();
      return nv;
    });
  };
  useEffect(() => () => clearCountdown(), []);
  // Series continuity: ask the backend whether this video has a next episode.
  // Resets per video; null result (standalone / last episode / 404) leaves the
  // generic autoplay-next in charge.
  useEffect(() => {
    let cancelled = false;
    setNextEpisode(null);
    (async () => {
      try {
        const r = await fetch(`${API_URL}/series/next/${video.id}`);
        if (!r.ok) return;
        const d = await r.json();
        if (!cancelled) setNextEpisode(d.next || null);
      } catch (e) {}
    })();
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [video.id]);
  // Join the audio coordinator so radio / bulletin / legal TTS can pause this
  // video, and so this video stops them when it plays (see handleVideoPlay).
  useEffect(() => {
    npAudio.register('video-main', () => { try { videoRef.current && videoRef.current.pause(); } catch (e) {} });
    return () => npAudio.unregister('video-main');
  }, []);
  // Arriving via autoplay -> actually start playback on this fresh mount.
  useEffect(() => {
    if (!video._autoplay) return;
    const el = videoRef.current; if (!el) return;
    const tryPlay = () => { if (el.play) el.play().catch(() => {}); };
    if (el.readyState >= 2) tryPlay();
    else { el.addEventListener('canplay', tryPlay, { once: true }); return () => el.removeEventListener('canplay', tryPlay); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [video.id]);

  useEffect(() => {
    fetchLikeStatus(); fetchSubscriptionStatus(); fetchHypeStatus(); fetchComments(); incrementViews(); fetchRelatedVideos();
    if (video.resumeAt && videoRef.current) {
      const seekTo = () => {
        if (videoRef.current && videoRef.current.readyState >= 1) { videoRef.current.currentTime = video.resumeAt; }
        else { videoRef.current?.addEventListener('loadedmetadata', () => { if (videoRef.current) videoRef.current.currentTime = video.resumeAt; }, { once: true }); }
      };
      setTimeout(seekTo, 500);
    }
    progressRef.current = setInterval(() => {
      if (videoRef.current && !videoRef.current.paused && videoRef.current.duration) {
        saveProgress(video.id, videoRef.current.currentTime, videoRef.current.duration, video);
      }
    }, 10000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      if (progressRef.current) clearInterval(progressRef.current);
      const videoEl = videoRef.current;
      if (videoEl && videoEl.duration) saveProgress(video.id, videoEl.currentTime, videoEl.duration, video);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [video.id]);

  const handleVideoPlay = () => {
    npAudio.stopOthers('video-main');   // OTT video takes over: stop radio / bulletin / legal TTS
    if (isPremiumLocked) {
      timerRef.current = setTimeout(() => { if (videoRef.current) videoRef.current.pause(); setShowUpgradePopup(true); }, 30000);
    }
  };
  const handleVideoPause = () => { if (timerRef.current) clearTimeout(timerRef.current); };
  const handleVideoEnded = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    // Track completion on video end
    try {
      const tok = localStorage.getItem('token');
      if (tok) fetch((process.env.REACT_APP_BACKEND_URL||'https://nethajiprime-backend.onrender.com')+'/api/video-completion', {
        method:'POST',
        headers:{'Content-Type':'application/json','Authorization':'Bearer '+tok},
        body:JSON.stringify({video_id:video.id, title:video.title, speaker:video.speaker_name, category:video.category})
      }).catch(()=>{});
    } catch(e) {}
    if (autoplayOn) startUpNext();
  };

  const fetchRelatedVideos = async () => {
    try {
      const catParam = video.category ? `?category=${encodeURIComponent(video.category)}` : '';
      const response = await fetch(`${API_URL}/speeches${catParam}`);
      const data = await response.json();
      // Same category (fetched via ?category=) and newest-first (backend orders
      // by created_at desc); take the 4 most recent.
      const sameCat = (data.speeches || [])
        .filter(v => v.id !== video.id)
        .sort((a, b) => new Date(b.published_at || b.created_at || 0) - new Date(a.published_at || a.created_at || 0));
      setRelatedVideos(sameCat.slice(0, 4));
    } catch (error) { console.error('Error:', error); }
  };
  const incrementViews = async () => { try { await fetch(`${API_URL}/speeches/${video.id}/view`, { method: 'POST', headers: { 'Authorization': `Bearer ${token}` } }); } catch (e) {} };
  const fetchLikeStatus = async () => { try { const r = await fetch(`${API_URL}/videos/${video.id}/like-status`, { headers: { 'Authorization': `Bearer ${token}` } }); const d = await r.json(); setLiked(d.liked); setLikeCount(d.like_count); } catch (e) {} };
  const fetchHypeStatus = async () => { try { const r = await fetch(`${API_URL}/videos/${video.id}/hype-status`, { headers: { 'Authorization': `Bearer ${token}` } }); const d = await r.json(); setHyped(d.hyped); setHypeCount(d.hype_count); } catch (e) {} };
  const fetchSubscriptionStatus = async () => { if (!video.speaker_name) return; try { const r = await fetch(`${API_URL}/speakers/${video.speaker_name}/subscription-status`, { headers: { 'Authorization': `Bearer ${token}` } }); const d = await r.json(); setSubscribed(d.subscribed); } catch (e) {} };
  const fetchComments = async () => { try { const r = await fetch(`${API_URL}/videos/${video.id}/comments`); const d = await r.json(); setComments(d.comments || []); } catch (e) {} };

  const handleLike = async () => {
    const wasLiked = liked; setLiked(!wasLiked); setLikeCount(prev => wasLiked ? prev - 1 : prev + 1);
    try { await fetch(`${API_URL}/videos/${video.id}/like`, { method: wasLiked ? 'DELETE' : 'POST', headers: { 'Authorization': `Bearer ${token}` } }); }
    catch (e) { setLiked(wasLiked); setLikeCount(prev => wasLiked ? prev + 1 : prev - 1); }
  };
  const handleHype = async () => {
    const wasHyped = hyped;
    setHyped(!wasHyped);
    setHypeCount(prev => wasHyped ? Math.max(0, prev - 1) : prev + 1);
    try {
      // Original hype on backend
      await fetch(`${API_URL}/videos/${video.id}/hype`, {
        method: wasHyped ? 'DELETE' : 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      // New powerful hype algorithm
      if (!wasHyped) {
        const hypeRes = await fetch(`${API_URL}/api/hype/${video.id}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ user_id: user?.id || 'anonymous' })
        });
        const hypeData = await hypeRes.json();
        setHypeCount(hypeData.hype_count || hypeCount + 1);
        if (hypeData.is_viral) {
          alert('This video is going VIRAL on Nethaji Prime!');
        }
        // Add points for hyping
        if (user?.id) {
          fetch(`${API_URL}/api/points/${user.id}`, {
            method: 'POST',
            headers: {'Content-Type':'application/json'},
            body: JSON.stringify({action:'hype', user_name: user.full_name || 'Anonymous', video_id: video.id})
          });
        }
      }
    } catch(e) { console.error('Hype error:', e); }
  };
  const handleSubscribe = async () => { if (!video.speaker_name || subscribing) return; setSubscribing(true); setTimeout(()=>setSubscribing(false),2000);
    try {
      if (subscribed) { await fetch(`${API_URL}/speakers/${video.speaker_name}/subscribe`, { method: 'DELETE', headers: { 'Authorization': `Bearer ${token}` } }); setSubscribed(false); setSubscriberCount(prev => { const n = Math.max(0, prev - 1); if (onSubscribeChange) onSubscribeChange(video.speaker_name, n); return n; }); }
      else { await fetch(`${API_URL}/speakers/${video.speaker_name}/subscribe`, { method: 'POST', headers: { 'Authorization': `Bearer ${token}` } }); setSubscribed(true); setSubscriberCount(prev => { const n = prev + 1; if (onSubscribeChange) onSubscribeChange(video.speaker_name, n); return n; }); }
    } catch (e) {}
  };
  const handleAddComment = async (e) => {
    e.preventDefault(); if (!newComment.trim()) return;
    try { const r = await fetch(`${API_URL}/videos/${video.id}/comments`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify({ comment_text: newComment }) }); if (r.ok) { setNewComment(''); fetchComments(); setCommentSubmitted(true); setTimeout(() => setCommentSubmitted(false), 5000); } } catch (e) {}
  };
  const handleShare = () => {
    const shareUrl = 'https://www.nethajiprime.com/watch/'+video.id;
    if (navigator.share) {
      navigator.share({ 
        title: video.title, 
        text: 'Watch "'+video.title+'" on Nethaji Prime OTT', 
        url: shareUrl 
      }).catch(()=>{});
    } else { 
      navigator.clipboard.writeText(shareUrl); 
      alert('Link copied!'); 
    }
  };
  const handleWhatsAppShare = () => { const shareUrl = `https://www.nethajiprime.com/watch/${video.id}`; window.open(`https://wa.me/?text=${encodeURIComponent(`🎬 Watch "${video.title}" on Nethaji Prime!\n\n${shareUrl}`)}`, '_blank'); };
  const handleSocialShare = (platform) => {
    const shareUrl = `https://www.nethajiprime.com/watch/${video.id}`;
    const msg = `Watch "${video.title}" by ${video.speaker_name} on Nethaji Prime!`;
    const eu = encodeURIComponent(shareUrl); const em = encodeURIComponent(msg);
    const links = { facebook: `https://www.facebook.com/sharer/sharer.php?u=${eu}`, twitter: `https://twitter.com/intent/tweet?text=${em}&url=${eu}`, telegram: `https://t.me/share/url?url=${eu}&text=${em}`, threads: `https://www.threads.net/intent/post?text=${em}%20${eu}` };
    if (links[platform]) window.open(links[platform], '_blank');
    else { navigator.clipboard.writeText(`${msg} ${shareUrl}`); alert('✅ Link copied!'); }
  };

  const btnStyle = (active, color = '#d4a843') => ({ padding: '8px 16px', background: active ? color : 'transparent', color: active ? '#fff' : color, border: `1px solid ${color}`, borderRadius: '3px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' });

  const handleClose = () => { setShowUpgradePopup(false); setContinueWatchingList(getContinueWatchingList()); onClose(); };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 99999, background: '#000', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {/* TOP BAR — always visible, close button always here */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 16px', height: '52px', minHeight: '52px', background: '#0a0000', borderBottom: '2px solid rgba(212,168,67,0.3)', flexShrink: 0, zIndex: 9001 }}>
        <span style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: '13px', fontWeight: '800', letterSpacing: '2px', color: '#d4a843', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 'calc(100% - 56px)' }}>
          ▶ {video.title}
        </span>
        <button
          onClick={handleClose}
          style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#cc0000', border: '2px solid #ff4444', color: '#fff', fontSize: '20px', fontWeight: '900', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: '0 0 16px rgba(204,0,0,0.7)' }}
        >✕</button>
      </div>

      {/* SCROLLABLE CONTENT */}
      <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', background: '#0a0a0a' }}>
        {/* VIDEO */}
        <div style={{ position: 'relative', background: '#000' }}>
          {isPremiumLocked && !showUpgradePopup && (
            <div style={{ background: 'rgba(255,165,0,0.15)', borderBottom: '1px solid #ffa500', padding: '8px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#ffa500', fontSize: '13px' }}>✅ Premium — 30-second free preview</span>
              <button onClick={() => { handleClose(); onUpgrade(); }} style={{ background: '#ffa500', color: '#fff', border: 'none', padding: '4px 12px', borderRadius: '3px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>Upgrade</button>
            </div>
          )}
          <div style={{position:'relative'}} ref={(el) => { window._npVideoContainer = el; }}>
          <video ref={videoRef} controls playsInline webkit-playsinline="true" x-webkit-airplay="allow" onPlay={handleVideoPlay} onPause={handleVideoPause} onEnded={handleVideoEnded} style={{ display: 'block', margin: '0 auto', background: '#000', objectFit: 'contain', maxWidth: '100%', height: 'auto', aspectRatio: (video.category==='Shorts'||video.category==='Reels') ? '9 / 16' : '16 / 9', width: (video.category==='Shorts'||video.category==='Reels') ? 'min(100%, calc(min(88vh, 820px) * 9 / 16))' : 'min(100%, calc(85vh * 16 / 9))' }} controlsList="nofullscreen">
            <source src={video.video_url} type="video/mp4" />
          </video>
          {/* Nethaji Prime OTT Watermark */}
          <div style={{position:'absolute',bottom:'52px',right:'48px',pointerEvents:'none',zIndex:50,display:'flex',alignItems:'center',gap:'5px',background:'rgba(0,0,0,0.6)',borderRadius:'4px',padding:'4px 10px'}}>
            <img src="https://media.nethajiprime.com/nethaji-logo.png" alt="NP" style={{height:'18px',width:'auto',opacity:0.9}} />
            <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'10px',fontWeight:'800',color:'rgba(245,200,66,0.9)',letterSpacing:'1px',whiteSpace:'nowrap'}}>NETHAJI PRIME OTT</span>
          </div>
          {/* Custom Fullscreen Button */}
          <button onClick={()=>{
            const v = videoRef.current;
            if(!v) return;
            if(document.fullscreenElement || document.webkitFullscreenElement){
              (document.exitFullscreen||document.webkitExitFullscreen).call(document);
            } else {
              (v.requestFullscreen||v.webkitRequestFullscreen||v.mozRequestFullScreen).call(v);
            }
          }} style={{position:'absolute',bottom:'8px',right:'8px',zIndex:50,background:'rgba(0,0,0,0.7)',border:'1px solid rgba(212,168,67,0.4)',color:'#f5c842',padding:'5px 10px',borderRadius:'4px',cursor:'pointer',fontSize:'16px',lineHeight:1}}>⛶</button>
          <p style={{ textAlign: 'center', color: '#aaa', fontSize: '12px', padding: '6px 10px', background: '#0d1520', margin: 0 }}>
            📱 On iPhone: tap the video, then tap the volume icon to unmute
          </p>
          {/* Series "Next Episode" card — prominent overlay, 10s auto-advance */}
          {upNext && upNextIsEpisode && (
            <div style={{ position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center', background:'rgba(0,0,0,0.72)', zIndex:60, padding:'16px' }}>
              <div style={{ width:'440px', maxWidth:'92%', background:'#0d0d0d', border:'1px solid rgba(212,168,67,0.5)', borderRadius:'12px', padding:'18px', boxShadow:'0 8px 40px rgba(0,0,0,0.7)' }}>
                <div style={{ color:'#f5c842', fontSize:'11px', fontWeight:800, letterSpacing:'2px', marginBottom:'12px' }}>
                  NEXT EPISODE{upNext.season_number ? ` · S${upNext.season_number}E${upNext.episode_number}` : ''} · IN {countdown}s
                </div>
                <div onClick={() => advanceToUpNext(upNext)} style={{ display:'flex', gap:'14px', cursor:'pointer', marginBottom:'16px' }}>
                  <div style={{ position:'relative', flexShrink:0, width:'150px', height:'84px', borderRadius:'8px', overflow:'hidden', background:'#000' }}>
                    {upNext.thumbnail_url && <img src={upNext.thumbnail_url} alt={upNext.title} style={{ width:'100%', height:'100%', objectFit:'cover' }} />}
                    <div style={{ position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center', background:'rgba(0,0,0,0.3)', color:'#fff', fontSize:'26px' }}>▶</div>
                  </div>
                  <div style={{ flex:1, minWidth:0, alignSelf:'center' }}>
                    <div style={{ color:'#fff', fontSize:'15px', fontWeight:700, lineHeight:1.3, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical' }}>{upNext.title}</div>
                  </div>
                </div>
                <div style={{ display:'flex', gap:'10px' }}>
                  <button onClick={() => advanceToUpNext(upNext)} style={{ flex:1, background:'#f5c842', color:'#000', border:'none', borderRadius:'6px', padding:'11px', fontSize:'13px', fontWeight:800, cursor:'pointer' }}>▶ Next Episode</button>
                  <button onClick={cancelUpNext} style={{ background:'transparent', color:'#ccc', border:'1px solid rgba(255,255,255,0.3)', borderRadius:'6px', padding:'11px 18px', fontSize:'13px', cursor:'pointer' }}>Cancel</button>
                </div>
              </div>
            </div>
          )}
          {/* Generic same-category autoplay-next — small corner card (unchanged) */}
          {upNext && !upNextIsEpisode && (
            <div style={{ position:'absolute', bottom:'46px', right:'12px', width:'300px', maxWidth:'82%', background:'rgba(0,0,0,0.92)', border:'1px solid rgba(212,168,67,0.45)', borderRadius:'8px', padding:'10px', zIndex:60, display:'flex', gap:'10px', alignItems:'center' }}>
              <div onClick={() => advanceToUpNext(upNext)} style={{ position:'relative', flexShrink:0, width:'110px', height:'62px', borderRadius:'6px', overflow:'hidden', background:'#000', cursor:'pointer' }}>
                {upNext.thumbnail_url && <img src={upNext.thumbnail_url} alt={upNext.title} style={{ width:'100%', height:'100%', objectFit:'cover' }} />}
                <div style={{ position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center', background:'rgba(0,0,0,0.35)', color:'#fff', fontSize:'22px' }}>▶</div>
              </div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ color:'#f5c842', fontSize:'10px', fontWeight:800, letterSpacing:'1px', marginBottom:'3px' }}>PLAYING NEXT IN {countdown}s</div>
                <div style={{ color:'#fff', fontSize:'12px', fontWeight:600, lineHeight:1.3, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>{upNext.title}</div>
                <div style={{ display:'flex', gap:'8px', marginTop:'6px' }}>
                  <button onClick={() => advanceToUpNext(upNext)} style={{ background:'#f5c842', color:'#000', border:'none', borderRadius:'4px', padding:'4px 10px', fontSize:'11px', fontWeight:700, cursor:'pointer' }}>Play now</button>
                  <button onClick={cancelUpNext} style={{ background:'transparent', color:'#ccc', border:'1px solid rgba(255,255,255,0.3)', borderRadius:'4px', padding:'4px 10px', fontSize:'11px', cursor:'pointer' }}>Cancel</button>
                </div>
              </div>
            </div>
          )}
          </div>

          {/* UPGRADE POPUP */}
          {showUpgradePopup && (
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.92)', zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '30px', textAlign: 'center' }}>
              <div style={{ fontSize: '3em', marginBottom: '16px' }}>✅</div>
              <h2 style={{ color: '#ffa500', marginBottom: '12px', fontSize: '1.5em' }}>This is a Premium Video</h2>
              <p style={{ color: '#ccc', marginBottom: '8px', fontSize: '14px' }}>You've watched the free 30-second preview.</p>
              <button onClick={() => { handleClose(); onUpgrade(); }} style={{ background: '#ffa500', color: '#fff', border: 'none', padding: '14px 32px', borderRadius: '6px', cursor: 'pointer', fontSize: '16px', fontWeight: '700', marginBottom: '12px', width: '100%' }}>🚀 Upgrade to Premium — ₹199/month</button>
              <button onClick={() => setShowUpgradePopup(false)} style={{ background: 'transparent', color: '#aaa', border: '1px solid #aaa', padding: '10px 24px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', width: '100%' }}>Watch Free Preview Again</button>
            </div>
          )}
        </div>

        {/* VIDEO DETAILS */}
        <div style={{ padding: '16px', background: '#0f0505' }}>
          <h2 style={{ color: '#fff', fontSize: '18px', marginBottom: '8px' }}>{video.title} {video.is_premium && <span style={{ color: '#ffa500', fontSize: '14px' }}>✅ Premium</span>}</h2>
          <div onClick={toggleAutoplay} title="Autoplay the next video when this one ends" style={{ display:'inline-flex', alignItems:'center', gap:'8px', cursor:'pointer', marginBottom:'12px', userSelect:'none' }}>
            <span style={{ color:'rgba(255,255,255,0.8)', fontSize:'12px', fontWeight:600 }}>Autoplay next</span>
            <div style={{ width:'36px', height:'20px', borderRadius:'10px', background: autoplayOn ? '#f5c842' : 'rgba(255,255,255,0.25)', position:'relative', transition:'background 0.2s' }}>
              <div style={{ position:'absolute', top:'2px', left: autoplayOn ? '18px' : '2px', width:'16px', height:'16px', borderRadius:'50%', background:'#fff', transition:'left 0.2s' }} />
            </div>
          </div>
          <div style={{ color: '#aaa', fontSize: '13px', marginBottom: '16px' }}>
            <span>{video.speaker_name}</span> • <span>{video.views_count > 0 ? `${video.views_count} ${t.views}` : ""}</span> • <span>{subscriberCount} followers</span> • <span>{new Date(video.publishedAt||video.created_at||Date.now()).toLocaleDateString()}</span>
          </div>

          {/* STATS CHART */}
          <div style={{background:"linear-gradient(135deg,rgba(212,168,67,0.05),rgba(0,0,0,0))",border:"1px solid rgba(212,168,67,0.15)",borderRadius:"12px",padding:"16px",marginBottom:"12px"}}>
            <div style={{color:"#d4a843",fontWeight:900,fontSize:"12px",letterSpacing:"2px",marginBottom:"12px"}}>📊 VIDEO STATS</div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"8px",marginBottom:"16px"}}>
              {[
                {label:"Views",value:(video.views_count||0).toLocaleString("en-IN"),icon:"👁️",color:"#0066cc"},
                {label:"Likes",value:(likeCount||0).toLocaleString("en-IN"),icon:"👍",color:"#00aa44"},
                {label:"Hypes",value:(hypeCount||0).toLocaleString("en-IN"),icon:"🔥",color:"#ff6600"},
                {label:"Comments",value:(comments.length||0).toLocaleString("en-IN"),icon:"💬",color:"#9900cc"},
              ].map(stat=>(
                <div key={stat.label} style={{background:"rgba(255,255,255,0.03)",borderRadius:"8px",padding:"10px",textAlign:"center",border:"1px solid rgba(255,255,255,0.05)"}}>
                  <div style={{fontSize:"20px",marginBottom:"4px"}}>{stat.icon}</div>
                  <div style={{color:stat.color,fontWeight:900,fontSize:"clamp(12px,2vw,16px)"}}>{stat.value}</div>
                  <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>{stat.label}</div>
                </div>
              ))}
            </div>
            {/* Engagement Bar Chart */}
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px",marginBottom:"6px"}}>ENGAGEMENT BREAKDOWN</div>
            {[
              {label:"Views",value:video.views_count||0,color:"#0066cc",max:Math.max(video.views_count||1,likeCount||1,hypeCount||1,comments.length||1)},
              {label:"Likes",value:likeCount||0,color:"#00aa44",max:Math.max(video.views_count||1,likeCount||1,hypeCount||1,comments.length||1)},
              {label:"Hypes",value:hypeCount||0,color:"#ff6600",max:Math.max(video.views_count||1,likeCount||1,hypeCount||1,comments.length||1)},
              {label:"Comments",value:comments.length||0,color:"#9900cc",max:Math.max(video.views_count||1,likeCount||1,hypeCount||1,comments.length||1)},
            ].map(bar=>(
              <div key={bar.label} style={{marginBottom:"6px"}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:"2px"}}>
                  <span style={{color:"rgba(255,255,255,0.5)",fontSize:"10px"}}>{bar.label}</span>
                  <span style={{color:bar.color,fontSize:"10px",fontWeight:700}}>{bar.value.toLocaleString("en-IN")}</span>
                </div>
                <div style={{background:"rgba(255,255,255,0.05)",borderRadius:"4px",height:"6px",overflow:"hidden"}}>
                  <div style={{background:bar.color,height:"100%",width:(bar.max>0?(bar.value/bar.max*100):0)+"%",borderRadius:"4px",transition:"width 1s ease"}}></div>
                </div>
              </div>
            ))}
            {/* Viral Score */}
            <div style={{marginTop:"12px",padding:"8px",background:"rgba(255,102,0,0.1)",borderRadius:"6px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span style={{color:"rgba(255,255,255,0.5)",fontSize:"11px"}}>🚀 Viral Score</span>
              <span style={{color:"#ff6600",fontWeight:900,fontSize:"13px"}}>{Math.round(((video.views_count||0)*0.4)+((likeCount||0)*0.4)+((hypeCount||0)*0.2))}</span>
            </div>
          </div>

          {/* ACTION BUTTONS */}
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '12px' }}>
            <button onClick={handleLike} style={btnStyle(liked)}>👍 {liked ? 'Liked' : 'Like'} ({likeCount})</button>
            <button onClick={handleHype} style={btnStyle(hyped, '#ff6b35')}>🔥 {hyped ? 'Hyped!' : 'Hype'} ({hypeCount})</button>
            <button onClick={handleSubscribe} style={btnStyle(subscribed)}>{subscribed ? '✔ Following' : 'Follow'}</button>
            <button onClick={onUpgrade} style={{fontFamily:"'Barlow Condensed',sans-serif",padding:'8px 16px',background:'linear-gradient(135deg,#cc0000,#880000)',color:'#fff',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px',fontWeight:'800',letterSpacing:'1.5px',textTransform:'uppercase',boxShadow:'0 4px 16px rgba(180,0,0,0.4)',whiteSpace:'nowrap'}}>🎬 Subscribe Channel</button>
            <button onClick={handleShare} style={btnStyle(false)}>🔗 Share</button>
            <button onClick={()=>{
              const msg = "🔥 Watch this on Nethaji Prime OTT!\n\n" + video.title + "\n\nBy: " + video.speaker_name + "\n\n🎬 Watch here: https://www.nethajiprime.com/watch/" + video.id + "\n\n📱 Download Nethaji Prime App for more Tamil content!";
              window.open("https://wa.me/?text=" + encodeURIComponent(msg), "_blank");
              // Track share for points
              if(user?.id) fetch(API_URL+"/api/points/"+user.id, {method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({action:"share", user_name:user.full_name||"Anonymous", video_id:video.id})});
            }} style={{ padding: '8px 16px', background: '#25D366', color: '#fff', borderRadius: '6px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: '700' }}>📱 WhatsApp Group</button>
            <button onClick={handleWhatsAppShare} style={{ padding: '8px 16px', background: '#25D366', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>📱 WhatsApp</button>
            <button onClick={() => handleSocialShare('facebook')} style={{ padding: '8px 16px', background: '#1877F2', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>📘 Facebook</button>
            <button onClick={() => handleSocialShare('twitter')} style={{ padding: '8px 16px', background: '#000', color: '#fff', border: '1px solid #333', borderRadius: '3px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>𝕏 Twitter</button>
            <button onClick={() => handleSocialShare('telegram')} style={{ padding: '8px 16px', background: '#2AABEE', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>✈️ Telegram</button>
            <button onClick={() => handleSocialShare('threads')} style={{ padding: '8px 16px', background: '#000', color: '#fff', border: '1px solid #333', borderRadius: '3px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>🧵 Threads</button>
            <button onClick={() => { navigator.clipboard.writeText(`https://www.nethajiprime.com/watch/${video.id}`); alert('✅ Link copied for Instagram!'); }} style={{ padding: '8px 16px', background: 'linear-gradient(45deg, #f09433, #dc2743, #bc1888)', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>📸 Instagram</button>
            <button onClick={() => setShowComments(!showComments)} style={btnStyle(showComments)}>💬 Comments ({comments.length})</button>
          </div>

          {hypeCount > 0 && (
            <div style={{ background: 'rgba(255,107,53,0.1)', border: '1px solid rgba(255,107,53,0.4)', borderRadius: '4px', padding: '8px 14px', marginBottom: '14px', fontSize: '13px', color: '#ff6b35' }}>
              🔥 {hypeCount} {hypeCount === 1 ? 'person has' : 'people have'} hyped this video!{hypeCount >= 10 ? ' 🚀 Trending!' : ''}
            </div>
          )}

          <p style={{ color: '#ccc', fontSize: '14px', lineHeight: 1.6 }}>{video.description}</p>


          {/* Standard Nethaji TV Description */}
          <div style={{marginTop:'16px',padding:'14px 16px',background:'rgba(255,255,255,0.03)',borderRadius:'8px',border:'1px solid rgba(212,168,67,0.15)',fontSize:'13px',color:'rgba(255,255,255,0.7)',lineHeight:1.8}}>
            <div style={{color:'#d4a843',fontWeight:900,fontSize:'14px',marginBottom:'8px'}}>📺 Nethaji TV</div>
            <div style={{marginBottom:'8px'}}>💰 Donate Us: Google Pay: <strong style={{color:'#fff'}}>91-94444 56788</strong></div>
            <div style={{marginBottom:'8px',fontFamily:"'Noto Sans Tamil',sans-serif"}}>அரசியல், சமூக பிரச்சனை, அறிவியல், கலாச்சாரம், விளையாட்டு, சினிமா மற்றும் பொழுதுபோக்கு அம்சங்களை வழங்கும் ஊடகம்.</div>
            <div style={{marginBottom:'12px'}}>A Sociopolitical Tamil media channel focusing on Politics, Social issues, Science, Culture, Sports, Cinema and Entertainment.</div>
            <div style={{marginBottom:'4px'}}>📱 WhatsApp: <a href="https://wa.me/919342330234" target="_blank" rel="noreferrer" style={{color:'#25D366'}}>91 93423 30234</a></div>
            <div style={{marginBottom:'12px'}}>📞 Talk to us: <a href="tel:+916382811018" style={{color:'#d4a843'}}>+91 6382811018</a></div>
            <div style={{display:'flex',flexWrap:'wrap',gap:'8px'}}>
              <a href="https://www.nethajiprime.com/" target="_blank" rel="noreferrer" style={{color:'#d4a843',textDecoration:'none'}}>🎬 Nethaji Prime OTT</a>
              <a href="https://www.rvlawassociates.com/" target="_blank" rel="noreferrer" style={{color:'#d4a843',textDecoration:'none'}}>⚖️ Legal Help</a>
              <a href="https://facebook.com/R.Varadharajan.NMK" target="_blank" rel="noreferrer" style={{color:'#1877F2',textDecoration:'none'}}>📘 Facebook</a>
              <a href="https://instagram.com/nethaji_makkal_katchi" target="_blank" rel="noreferrer" style={{color:'#E1306C',textDecoration:'none'}}>📸 Instagram</a>
              <a href="https://twitter.com/nmkparty" target="_blank" rel="noreferrer" style={{color:'#1DA1F2',textDecoration:'none'}}>🐦 Twitter</a>
              <a href="https://t.me/nethaji_tv" target="_blank" rel="noreferrer" style={{color:'#2AABEE',textDecoration:'none'}}>💬 Telegram</a>
              <a href="https://nmkindia.com" target="_blank" rel="noreferrer" style={{color:'#d4a843',textDecoration:'none'}}>🌐 NMK Website</a>
            </div>
          </div>

          {/* COMMENTS */}
          {showComments && (
            <div style={{ marginTop: '20px', padding: '20px', background: 'linear-gradient(160deg,#1e0404,#100101)', borderRadius: '6px' }}>
              <h3 style={{ marginBottom: '15px', color: '#d4a843' }}>Comments</h3>
              <form onSubmit={handleAddComment} style={{ marginBottom: '20px' }}>
                <input type="text" value={newComment} onChange={(e) => setNewComment(e.target.value)} placeholder="Add a comment..." style={{ width: '100%', padding: '10px', background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(0,168,225,0.3)', borderRadius: '3px', color: '#fff', marginBottom: '10px', boxSizing: 'border-box' }} />
                <button type="submit" style={{ padding: '8px 20px', background: '#d4a843', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}>Post Comment</button>
              </form>
              {commentSubmitted && <div style={{ padding: '10px 14px', background: 'rgba(212,168,67,0.1)', border: '1px solid rgba(212,168,67,0.4)', borderRadius: '4px', color: '#d4a843', fontSize: '13px', marginBottom: '16px' }}>✅ Comment submitted — under review.</div>}
              {comments.map((comment) => (
                <div key={comment.id} style={{ padding: '12px', marginBottom: '10px', background: '#180202', borderRadius: '3px', borderLeft: '3px solid #d4a843' }}>
                  <strong style={{ color: '#d4a843' }}>{comment.user_name}</strong>
                  <p style={{ margin: '5px 0 0 0', color: '#ccc' }}>{comment.comment_text}</p>
                </div>
              ))}
            </div>
          )}

          {/* TRANSCRIPT */}
          {video.transcript && (
            <div style={{ marginTop: '20px', padding: '20px', background: '#0a0000', borderRadius: '8px', border: '1px solid rgba(212,168,67,0.12)' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                <h3 style={{ color: '#d4a843', fontSize: '16px', margin: 0 }}>📝 Speech Transcript</h3>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={() => navigator.clipboard.writeText(video.transcript).then(() => alert('Copied!'))} style={{ padding: '6px 14px', background: 'transparent', color: '#d4a843', border: '1px solid rgba(212,168,67,0.4)', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>📋 Copy</button>
                  <button onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(`📝 "${video.title}"\n\n${video.transcript.substring(0,500)}...\n\nhttps://nethajiprime.com`)}`, '_blank')} style={{ padding: '6px 14px', background: '#25D366', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}>📱 Share</button>
                </div>
              </div>
              <div style={{ maxHeight: '300px', overflowY: 'auto', lineHeight: '1.8', color: '#ddd', fontSize: '15px', whiteSpace: 'pre-wrap' }}>{video.transcript}</div>
            </div>
          )}

          {/* CHAPTERS */}
          {video.chapters && video.chapters.length > 0 && (
            <div style={{ marginTop: '20px' }}>
              <h3 style={{ color: '#d4a843', fontSize: '16px', marginBottom: '16px' }}>⏱️ Chapters</h3>
              {video.chapters.map((chapter, index) => {
                const mins = Math.floor(chapter.time / 60); const secs = chapter.time % 60;
                return (
                  <div key={index} onClick={() => { if (videoRef.current) { videoRef.current.currentTime = chapter.time; videoRef.current.play(); } }}
                    style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 14px', background: '#180202', borderRadius: '6px', cursor: 'pointer', border: '1px solid rgba(212,168,67,0.12)', marginBottom: '8px' }}>
                    <span style={{ color: '#d4a843', fontWeight: '700', fontSize: '13px', minWidth: '40px', fontFamily: 'monospace' }}>{mins}:{secs.toString().padStart(2, '0')}</span>
                    <span style={{ color: '#fff', fontSize: '14px' }}>{chapter.label}</span>
                    <span style={{ marginLeft: 'auto', color: '#aaa', fontSize: '12px' }}>↪ Jump</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* RELATED VIDEOS */}
        {relatedVideos.length > 0 && (
          <div style={{ padding: '16px', background: '#0a0000', borderTop: '1px solid rgba(212,168,67,0.1)' }}>
            <h3 style={{ color: '#d4a843', fontSize: '14px', fontWeight: '900', letterSpacing: '2px', marginBottom: '12px', fontFamily: "'Barlow Condensed',sans-serif" }}>▶ RELATED VIDEOS</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: '10px' }}>
              {relatedVideos.map(v => (
                <div key={v.id} onClick={() => { if(videoRef.current){videoRef.current.pause();videoRef.current.src='';} onVideoSelect(v); window.scrollTo(0,0); }} style={{ cursor: 'pointer', borderRadius: '8px', overflow: 'hidden', background: '#140202', border: '1px solid rgba(212,168,67,0.1)' }}>
                  {v.thumbnail_url ? <img src={v.thumbnail_url} alt={v.title} style={{ width: '100%', height: '90px', objectFit: 'cover', display: 'block' }} /> : <div style={{ width: '100%', height: '90px', background: '#1a0303', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', color: '#d4a843' }}>▶</div>}
                  <div style={{ padding: '8px' }}>
                    <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: '11px', fontWeight: '700', color: '#f0e0c0', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.title}</div>
                    <div style={{ fontSize: '10px', color: 'rgba(212,168,67,0.4)', marginTop: '2px' }}>{v.speaker_name}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* UP NEXT */}
        {videos && videos.length > 0 && (
          <div style={{ padding: '16px', background: '#0a0000', borderTop: '1px solid rgba(212,168,67,0.1)' }}>
            <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: '11px', fontWeight: '900', letterSpacing: '3px', color: 'rgba(212,168,67,0.5)', textTransform: 'uppercase', marginBottom: '12px' }}>▶ UP NEXT</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: '10px' }}>
              {videos.filter(v => v.id !== video.id && (!video.category || v.category === video.category)).slice(0, 8).map(v => (
                <div key={v.id} onClick={() => { if(videoRef.current){videoRef.current.pause();videoRef.current.src='';} onVideoSelect(v); window.scrollTo(0,0); }} style={{ cursor: 'pointer', borderRadius: '8px', overflow: 'hidden', background: '#140202', border: '1px solid rgba(212,168,67,0.1)' }}>
                  {v.thumbnail_url ? <img src={v.thumbnail_url} alt={v.title} style={{ width: '100%', height: '90px', objectFit: 'cover', display: 'block' }} /> : <div style={{ width: '100%', height: '90px', background: '#1a0303', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', color: '#d4a843' }}>▶</div>}
                  <div style={{ padding: '8px' }}>
                    <div style={{ fontFamily: "'Barlow Condensed',sans-serif", fontSize: '11px', fontWeight: '700', color: '#f0e0c0', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{v.title}</div>
                    <div style={{ fontSize: '10px', color: 'rgba(212,168,67,0.4)', marginTop: '2px' }}>{v.speaker_name}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


// ══ GRAND OPENING CELEBRATION ══
function GrandOpeningCover({ onClose }) {
  const [visible, setVisible] = React.useState(true);
  const [particles, setParticles] = React.useState([]);
  const audioRef = React.useRef(null);

  React.useEffect(() => {
    // Generate confetti particles
    const colors = ['#f5c842','#cc0000','#fff','#ff6b00','#00d480','#ff69b4','#00bfff'];
    const shapes = ['●','★','♦','▲','✦','❋'];
    const p = Array.from({length: 80}, (_, i) => ({
      id: i,
      color: colors[i % colors.length],
      shape: shapes[i % shapes.length],
      left: Math.random() * 100,
      delay: Math.random() * 3,
      duration: 3 + Math.random() * 4,
      size: 10 + Math.random() * 16,
      rotate: Math.random() * 360,
    }));
    setParticles(p);

    // Play celebration beep sequence
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const playNote = (freq, start, dur) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain); gain.connect(ctx.destination);
        osc.frequency.value = freq;
        osc.type = 'sine';
        gain.gain.setValueAtTime(0.3, ctx.currentTime + start);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + dur);
        osc.start(ctx.currentTime + start);
        osc.stop(ctx.currentTime + start + dur + 0.1);
      };
      // Celebratory fanfare
      [523,659,784,1047,784,1047,1319].forEach((f,i) => playNote(f, i*0.18, 0.25));
      setTimeout(() => {
        [784,988,1175,1568,1175,1568,1976].forEach((f,i) => playNote(f, i*0.18, 0.25));
      }, 1500);
    } catch(e) {}

    // Auto close after 12 seconds
    const timer = setTimeout(() => { setVisible(false); setTimeout(onClose, 800); }, 12000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div style={{position:'fixed',inset:0,zIndex:999999,background:'#000',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',overflow:'hidden'}}>

      {/* Confetti */}
      <style>{`
        @keyframes fall { 0% { transform: translateY(-20px) rotate(0deg); opacity:1; } 100% { transform: translateY(105vh) rotate(720deg); opacity:0; } }
        @keyframes glow { 0%,100% { text-shadow: 0 0 20px rgba(245,200,66,0.8), 0 0 40px rgba(245,200,66,0.4); } 50% { text-shadow: 0 0 40px rgba(245,200,66,1), 0 0 80px rgba(245,200,66,0.6), 0 0 120px rgba(245,200,66,0.3); } }
        @keyframes scale-in { 0% { transform: scale(0) rotate(-10deg); opacity:0; } 60% { transform: scale(1.1) rotate(2deg); } 100% { transform: scale(1) rotate(0deg); opacity:1; } }
        @keyframes slide-up { 0% { transform: translateY(40px); opacity:0; } 100% { transform: translateY(0); opacity:1; } }
        @keyframes firework { 0%,100% { opacity:1; } 50% { opacity:0.3; } }
      `}</style>

      {particles.map(p => (
        <div key={p.id} style={{
          position:'absolute', left:`${p.left}%`, top:'-20px',
          color: p.color, fontSize:`${p.size}px`,
          animation: `fall ${p.duration}s ${p.delay}s linear infinite`,
          pointerEvents:'none'
        }}>{p.shape}</div>
      ))}

      {/* Background gradient */}
      <div style={{position:'absolute',inset:0,background:'radial-gradient(ellipse at center,#1a0000 0%,#000000 70%)',zIndex:0}}></div>
      <div style={{position:'absolute',inset:0,background:'radial-gradient(ellipse at 30% 40%,rgba(212,168,67,0.08) 0%,transparent 60%)',zIndex:0}}></div>

      {/* Content */}
      <div style={{position:'relative',zIndex:10,textAlign:'center',padding:'20px 5%',maxWidth:'700px'}}>

        {/* Fireworks emoji row */}
        <div style={{fontSize:'clamp(24px,5vw,40px)',marginBottom:'16px',animation:'firework 0.5s infinite'}}>
          🎆 🎇 🎆
        </div>

        {/* Grand Opening Text */}
        <div style={{
          fontFamily:"'Barlow Condensed',sans-serif",
          fontSize:'clamp(11px,2vw,16px)',
          fontWeight:'900',
          letterSpacing:'6px',
          color:'rgba(212,168,67,0.7)',
          marginBottom:'12px',
          animation:'slide-up 0.8s ease forwards',
          textTransform:'uppercase'
        }}>🎊 Grand Opening 🎊</div>

        {/* Main Logo */}
        <div style={{
          fontFamily:"'Cinzel',serif",
          fontSize:'clamp(36px,8vw,80px)',
          fontWeight:'900',
          color:'#f5c842',
          lineHeight:1,
          marginBottom:'8px',
          animation:'glow 2s ease-in-out infinite, scale-in 1s ease forwards',
        }}>NETHAJI<br/>PRIME</div>

        <div style={{
          fontFamily:"'Barlow Condensed',sans-serif",
          fontSize:'clamp(16px,3vw,28px)',
          fontWeight:'900',
          letterSpacing:'8px',
          color:'#cc0000',
          marginBottom:'24px',
          animation:'slide-up 1s ease forwards',
          textTransform:'uppercase'
        }}>OTT</div>

        {/* Tamil text */}
        <div style={{
          fontFamily:"'Barlow',sans-serif",
          fontSize:'clamp(14px,2.5vw,22px)',
          color:'rgba(255,255,255,0.9)',
          marginBottom:'8px',
          animation:'slide-up 1.2s ease forwards',
        }}>மக்களுக்காக — நேதாஜி பிரைம்</div>

        <div style={{
          fontFamily:"'Barlow Condensed',sans-serif",
          fontSize:'clamp(11px,2vw,16px)',
          color:'rgba(212,168,67,0.6)',
          letterSpacing:'2px',
          marginBottom:'32px',
          animation:'slide-up 1.4s ease forwards',
        }}>Tamil Sociopolitical Media Platform</div>

        {/* Gold divider */}
        <div style={{display:'flex',alignItems:'center',gap:'12px',justifyContent:'center',marginBottom:'28px'}}>
          <div style={{height:'1px',width:'80px',background:'linear-gradient(90deg,transparent,#f5c842)'}}></div>
          <span style={{color:'#f5c842',fontSize:'20px'}}>★</span>
          <div style={{height:'1px',width:'80px',background:'linear-gradient(90deg,#f5c842,transparent)'}}></div>
        </div>

        {/* Now Live badge */}
        <div style={{
          display:'inline-block',
          background:'linear-gradient(135deg,#cc0000,#880000)',
          color:'#fff',
          fontFamily:"'Barlow Condensed',sans-serif",
          fontSize:'clamp(14px,2.5vw,20px)',
          fontWeight:'900',
          letterSpacing:'4px',
          padding:'10px 32px',
          borderRadius:'4px',
          marginBottom:'24px',
          boxShadow:'0 0 30px rgba(204,0,0,0.6)',
          animation:'firework 1s infinite',
        }}>🔴 NOW LIVE</div>

        {/* Features */}
        <div style={{display:'flex',gap:'16px',justifyContent:'center',flexWrap:'wrap',marginBottom:'28px'}}>
          {['⚖️ Legal AI','📈 Stock Market','🕵️ Sun Detective','🙏 Devotional','🎙️ Interviews'].map((f,i)=>(
            <span key={i} style={{
              fontFamily:"'Barlow Condensed',sans-serif",
              fontSize:'clamp(10px,1.5vw,13px)',
              color:'rgba(212,168,67,0.7)',
              letterSpacing:'1px',
              padding:'4px 10px',
              border:'1px solid rgba(212,168,67,0.2)',
              borderRadius:'20px',
            }}>{f}</span>
          ))}
        </div>

        {/* Enter button */}
        <button onClick={()=>{setVisible(false);setTimeout(onClose,300);}} style={{
          fontFamily:"'Barlow Condensed',sans-serif",
          fontSize:'clamp(13px,2vw,16px)',
          fontWeight:'900',
          letterSpacing:'3px',
          color:'#000',
          background:'linear-gradient(135deg,#f5c842,#d4a843)',
          border:'none',
          padding:'14px 40px',
          borderRadius:'4px',
          cursor:'pointer',
          boxShadow:'0 4px 24px rgba(245,200,66,0.4)',
          textTransform:'uppercase',
        }}>🎬 ENTER NETHAJI PRIME</button>

        {/* Auto close note */}
        <div style={{marginTop:'16px',fontSize:'11px',color:'rgba(255,255,255,0.3)',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px'}}>
          Auto-entering in a few seconds...
        </div>
      </div>
    </div>
  );
}



// Global audio tracker - stops audio anywhere in app
window._bulletinAudio = null;
window.stopBulletinAudio = function() {
  if (window._bulletinAudio) {
    window._bulletinAudio.pause();
    window._bulletinAudio.src = '';
    window._bulletinAudio = null;
  }
};

// ═══════════════════════════════════════
// NETHAJI BULLETIN v5 - Fixed Audio
// ═══════════════════════════════════════

// Single global audio instance
let _globalAudio = null;
let _globalSession = 0;

function stopAllBulletinAudio() {
  _globalSession++;
  if (_globalAudio) {
    _globalAudio.pause();
    _globalAudio.src = '';
    _globalAudio = null;
  }
}

function NethajiBulletin({ lang }) {
  const API_URL = process.env.REACT_APP_BACKEND_URL || "https://nethajiprime-backend.onrender.com";
  const [bulletin, setBulletin] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [playing, setPlaying] = React.useState(false);
  const [currentLine, setCurrentLine] = React.useState(-1);
  const [speed, setSpeed] = React.useState(1);
  const speedRef = React.useRef(1);
  const [clock, setClock] = React.useState("");
  const videoRef = React.useRef(null);

  // Live newsroom clock
  React.useEffect(() => {
    const tick = () => setClock(new Date().toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", second: "2-digit" }));
    tick();
    const iv = setInterval(tick, 1000);
    return () => clearInterval(iv);
  }, []);

  // Register with the audio coordinator so radio/video can stop the bulletin.
  React.useEffect(() => {
    npAudio.register('bulletin-app', () => {
      stopAllBulletinAudio();
      setPlaying(false);
      setCurrentLine(-1);
      if (videoRef.current) videoRef.current.pause();
    });
    return () => npAudio.unregister('bulletin-app');
  }, []);

  // Stop audio and reload when tab changes
  React.useEffect(() => {
    stopAllBulletinAudio();
    setPlaying(false);
    setCurrentLine(-1);
    if (videoRef.current) videoRef.current.pause();
    setLoading(true);
    setBulletin(null);
    const bulletinLang = lang === "ta" ? "ta" : lang === "en_india" ? "en_india" : "en_world";
    fetch(API_URL + "/api/bulletin/today?lang=" + bulletinLang)
      .then(r => r.json())
      .then(data => { if (data.bulletin) setBulletin(data.bulletin); setLoading(false); })
      .catch(() => setLoading(false));
    // Cleanup on unmount
    return () => {
      stopAllBulletinAudio();
      if (videoRef.current) videoRef.current.pause();
    };
  }, [lang]);

  const audioElRef = React.useRef(null);

  const changeSpeed = (s) => {
    setSpeed(s);
    speedRef.current = s;
    if (audioElRef.current) audioElRef.current.playbackRate = s;
  };

  // Audio-driven playback (aligned with the WatchNowPage model): read the full
  // story bodies (bulletin.sentences), play the pre-generated per-story R2 audio
  // (bulletin.tts_sentences), and advance ONLY when each clip's audio finishes.
  // No fixed/duration watchdog timer — each slide stays until its TTS ends.
  const playBulletin = () => {
    if (!bulletin) return;
    stopAllBulletinAudio();
    npAudio.stopOthers('bulletin-app');   // starting bulletin stops radio + video
    const session = _globalSession;
    setPlaying(true);
    setCurrentLine(0);
    const ttsLang = lang === "ta" ? "ta" : "en-in";
    const BACKEND = API_URL;
    // Bodies and pre-gen audio are 1:1 aligned by index (Phase 1). Fall back to the
    // headlines array only when sentences are unavailable (legacy/English bulletins).
    const bodies = (bulletin.sentences && bulletin.sentences.length > 0)
      ? bulletin.sentences
      : (bulletin.headlines || []);
    const pregenUrls = bulletin.tts_sentences || [];
    if (!audioElRef.current) audioElRef.current = new Audio();

    const playIndex = (i) => {
      if (i >= bodies.length || session !== _globalSession) {
        setPlaying(false); setCurrentLine(-1);
        if (videoRef.current) videoRef.current.pause();
        return;
      }
      setCurrentLine(i);
      const sentenceText = String(bodies[i] || '').replace(/\*\*/g, '').trim();
      const liveSrc = BACKEND + '/tts?text=' + encodeURIComponent(sentenceText.substring(0, 500)) + '&lang=' + ttsLang;
      const pregen = (pregenUrls[i] && pregenUrls[i] !== null) ? pregenUrls[i] : null;

      const audio = audioElRef.current;
      _globalAudio = audio;

      let advanced = false;
      const goNext = () => {
        if (advanced || session !== _globalSession) return;
        advanced = true;
        if (videoRef.current) videoRef.current.pause();
        setTimeout(() => playIndex(i + 1), 400);
      };

      // Try pre-gen audio first; on failure fall back to live /tts for THIS sentence
      // (never skip). Advance only on the 'ended' event.
      const start = (src, isFallback) => {
        audio.onended = null; audio.onerror = null; audio.oncanplay = null;
        audio.src = src;
        audio.onended = goNext;
        audio.oncanplay = () => {
          audio.oncanplay = null;
          audio.playbackRate = speedRef.current;
          if (videoRef.current) { videoRef.current.muted = true; videoRef.current.playbackRate = 1.0; videoRef.current.play().catch(() => {}); }
          audio.play().catch(goNext);
        };
        audio.onerror = () => {
          if (!isFallback && pregen) start(liveSrc, true);  // pre-gen failed -> live TTS this sentence
          else goNext();                                    // live also failed -> move on
        };
        audio.load();
      };
      start(pregen || liveSrc, !pregen);

      // Best-effort preload of the next pre-gen clip.
      if (i + 1 < bodies.length && pregenUrls[i + 1]) {
        const p = new Audio(); p.preload = 'auto'; p.src = pregenUrls[i + 1];
      }
    };
    playIndex(0);
  };

  const stopBulletin = () => {
    stopAllBulletinAudio();
    if (videoRef.current) videoRef.current.pause();
    setPlaying(false);
    setCurrentLine(-1);
  };

  if (loading) return (
    <div style={{background:"#000",padding:40,textAlign:"center",color:"#00a8e1",borderBottom:"2px solid #cc0000"}}>
      <div style={{fontSize:32,marginBottom:8}}>📺</div>
      <div style={{fontSize:14,letterSpacing:2}}>Loading Nethaji Bulletin...</div>
    </div>
  );
  if (!bulletin) return null;

  const hour = new Date().getHours();
  const isMorning = hour < 12;
  // Display the same story bodies that playback reads, so the karaoke highlight and
  // "READING NOW" slide (keyed on currentLine) always match the audio 1:1.
  const headlines = (bulletin.sentences && bulletin.sentences.length > 0) ? bulletin.sentences : (bulletin.headlines || []);

  // Breaking-news ticker: seamless loop (content duplicated, -50% keyframe) with
  // duration proportional to the headline count, so the scroll speed stays constant
  // and readable whether there are 10 or 35 stories (was a fixed 40s → too fast now).
  const tickerText = (headlines || []).join("   •   ");
  const tickerDuration = Math.min(800, Math.max(40, (headlines || []).length * 20));

  return (
    <div style={{background:"#000",borderBottom:"3px solid #cc0000",position:"relative",overflow:"hidden"}}>
      <style>{`
        @keyframes pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.4;transform:scale(0.82)} }
        @keyframes ticker { 0%{transform:translateX(0)} 100%{transform:translateX(-100%)} }
        @keyframes npTicker { from{transform:translateX(0)} to{transform:translateX(-50%)} }
        @keyframes npSlideIn { 0%{opacity:0;transform:translateX(26px)} 100%{opacity:1;transform:translateX(0)} }
        @keyframes npLiveDot { 0%,100%{opacity:1;box-shadow:0 0 0 0 rgba(255,255,255,0.6)} 50%{opacity:0.55;box-shadow:0 0 0 5px rgba(255,255,255,0)} }
        .bulletin-layout { display: flex; flex-direction: row; min-height: 420px; }
        .bulletin-anchor { width: 45%; position: relative; flex-shrink: 0; background: #000; }
        .bulletin-anchor video { width: 100%; height: 100%; min-height: 420px; object-fit: cover; display: block; }
        .bulletin-news { flex: 1; padding: 20px 24px; display: flex; flex-direction: column; background: linear-gradient(135deg,#050510,#0a0a1a); }
        @media (max-width: 768px) {
          .bulletin-layout { flex-direction: column; }
          .bulletin-anchor { width: 100%; }
          .bulletin-anchor video { min-height: 280px; max-height: 320px; object-fit: cover; }
          .bulletin-news { padding: 16px; }
        }
      `}</style>

      {/* Newsroom Header */}
      <div style={{background:"linear-gradient(90deg,#1a0008,#2a0012,#1a0008)",padding:"10px 16px",borderBottom:"2px solid #cc0000",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:8}}>
        <div style={{display:"flex",alignItems:"center",gap:12,flexWrap:"wrap"}}>
          <span style={{display:"inline-flex",alignItems:"center",gap:7,background:"#cc0000",padding:"4px 10px",borderRadius:4}}>
            <span style={{width:9,height:9,borderRadius:"50%",background:"#fff",display:"inline-block",animation:"npLiveDot 1.1s infinite"}}/>
            <span style={{color:"#fff",fontWeight:900,fontSize:12,letterSpacing:2}}>LIVE</span>
          </span>
          <span style={{color:"#FFD700",fontWeight:900,fontSize:14,letterSpacing:2}}>📺 NETHAJI PRIME</span>
          <span style={{color:"rgba(255,255,255,0.5)",fontSize:11,fontWeight:700}}>
            {playing ? "🔴 ON AIR" : (isMorning ? "🌅 MORNING EDITION" : "🌆 EVENING EDITION")}
          </span>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
          {[["Politics","#cc0000"],["Economy","#1e88e5"],["Sports","#2e7d32"],["World","#8e24aa"],["Tech","#f5a623"]].map(([c,col]) => (
            <span key={c} style={{background:col+"22",border:"1px solid "+col,color:col,fontSize:9,fontWeight:800,letterSpacing:1,padding:"2px 7px",borderRadius:10}}>{c.toUpperCase()}</span>
          ))}
          <span style={{color:"#FFD700",fontSize:12,fontWeight:800,fontFamily:"monospace",letterSpacing:1,minWidth:74,textAlign:"right"}}>{clock}</span>
        </div>
      </div>

      {/* Main Layout */}
      <div className="bulletin-layout">
        {/* Anchor */}
        <div className="bulletin-anchor">
          <video ref={videoRef} src={bulletin.anchor_video} loop muted playsInline/>
          <div style={{position:"absolute",inset:0,background:"linear-gradient(to right,transparent 60%,#000 100%)"}}/>
          <div style={{position:"absolute",bottom:0,left:0,right:0,background:"linear-gradient(transparent,rgba(0,0,0,0.95))",padding:"30px 14px 10px"}}>
            <div style={{display:"inline-block",background:"#cc0000",padding:"3px 10px",marginBottom:3}}>
              <span style={{color:"#fff",fontWeight:900,fontSize:13,letterSpacing:2}}>{bulletin.anchor_name}</span>
            </div>
            <div style={{color:"#d4a843",fontSize:10,letterSpacing:2}}>{bulletin.anchor_tamil} | NEWS ANCHOR</div>
          </div>
        </div>

        {/* News */}
        <div className="bulletin-news">
          {/* Reading Now */}
          {playing && currentLine >= 0 && currentLine < headlines.length && (
            <div key={currentLine} style={{background:"linear-gradient(135deg,rgba(255,215,0,0.14),rgba(204,0,0,0.12))",border:"1px solid rgba(255,215,0,0.5)",borderRadius:8,padding:"10px 14px",marginBottom:14,minHeight:60,animation:"npSlideIn 0.4s ease"}}>
              <div style={{color:"#FFD700",fontSize:10,fontWeight:900,letterSpacing:3,marginBottom:4}}>🎙️ READING NOW</div>
              <div style={{color:"#fff",fontSize:13.5,lineHeight:1.5,fontWeight:700}}>{headlines[currentLine]}</div>
            </div>
          )}

          {/* Headlines */}
          <div style={{flex:1,overflowY:"auto",maxHeight:300}}>
            <div style={{color:"#d4a843",fontSize:10,fontWeight:900,letterSpacing:3,marginBottom:8,display:"flex",alignItems:"center",gap:6}}>
              <div style={{width:3,height:12,background:"#cc0000",flexShrink:0}}/>
              TOP {headlines.length} HEADLINES
            </div>
            {headlines.map((h, i) => {
              const active = playing && i === currentLine;
              return (
              <div key={i} style={{
                color: active ? "#FFD700" : "rgba(255,255,255,0.55)",
                fontSize: active ? 13.5 : 12,
                padding:"7px 10px",
                borderRadius:6,
                background: active ? "rgba(255,215,0,0.12)" : "transparent",
                borderLeft: active ? "3px solid #FFD700" : "3px solid transparent",
                marginBottom:3,
                lineHeight:1.4,
                fontWeight: active ? 800 : 400,
                transition:"all 0.35s ease"
              }}>
                <span style={{color: active ? "#FFD700":"#555",fontWeight:900,marginRight:6,fontSize:10}}>{active ? "🔊" : (i+1)+"."}</span>
                {h}
              </div>
              );
            })}
          </div>

          {/* Controls */}
          <div style={{marginTop:12,paddingTop:10,borderTop:"1px solid rgba(255,255,255,0.05)",display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
            <button onClick={playing ? stopBulletin : playBulletin} style={{
              background:playing?"linear-gradient(135deg,#cc0000,#880000)":"linear-gradient(135deg,#d4a843,#b8860b)",
              border:"none",borderRadius:6,padding:"10px 20px",
              color:"#fff",fontWeight:900,fontSize:13,cursor:"pointer",letterSpacing:1
            }}>
              {playing ? "⏹ STOP" : "▶ PLAY BULLETIN"}
            </button>
            <div style={{display:"flex",alignItems:"center",gap:4}}>
              <span style={{color:"rgba(255,255,255,0.35)",fontSize:10,fontWeight:700,marginRight:2}}>SPEED</span>
              {[0.75,1,1.25,1.5].map(s => (
                <button key={s} onClick={() => changeSpeed(s)} style={{
                  background: speed===s ? "#FFD700" : "transparent",
                  border: "1px solid " + (speed===s ? "#FFD700" : "rgba(255,215,0,0.35)"),
                  color: speed===s ? "#1a0008" : "#FFD700",
                  borderRadius:14, padding:"4px 9px", fontSize:11, fontWeight:800, cursor:"pointer"
                }}>{s}x</button>
              ))}
            </div>
            {playing && <span style={{color:"rgba(255,255,255,0.4)",fontSize:11,animation:"pulse 1s infinite"}}>Broadcasting...</span>}
          </div>
        </div>
      </div>

      {/* Ticker */}
      <div style={{background:"#cc0000",padding:"5px 0",overflow:"hidden"}}>
        <div style={{display:"flex",alignItems:"center"}}>
          <div style={{background:"#000",padding:"5px 12px",flexShrink:0,fontWeight:900,fontSize:10,color:"#d4a843",letterSpacing:2,whiteSpace:"nowrap"}}>BREAKING</div>
          <div style={{overflow:"hidden",flex:1}}>
            <div style={{display:"inline-flex",whiteSpace:"nowrap",willChange:"transform",animation:`npTicker ${tickerDuration}s linear infinite`}}>
              <span style={{color:"#fff",fontSize:11,fontWeight:600,paddingRight:40}}>{tickerText}</span>
              <span aria-hidden="true" style={{color:"#fff",fontSize:11,fontWeight:600,paddingRight:40}}>{tickerText}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


function LiveNewsTab({ lang = "en" }) {
  React.useEffect(() => {
    return () => { 
      window._bulletinAudio = null;
      if (window._currentBulletinAudio) {
        window._currentBulletinAudio.pause();
        window._currentBulletinAudio.src = '';
        window._currentBulletinAudio = null;
      }
    };
  }, []);
  const TAMIL_CHANNELS = [
    { id: "puthiya", name: "Puthiya Thalaimurai", color: "#cc0000" },
    { id: "thanthi", name: "Thanthi TV", color: "#0055aa" },
    { id: "sun", name: "Sun News", color: "#ff6600" },
    { id: "polimer", name: "Polimer News", color: "#006633" },
    { id: "news18", name: "News18 Tamil", color: "#cc0000" },
    { id: "news7", name: "News7 Tamil", color: "#0077cc" },
    { id: "ddnews", name: "DD Tamil News", color: "#006400" },
  ];
  const INDIA_CHANNELS = []
  const WORLD_CHANNELS = []
  const [activeTab, setActiveTab] = React.useState("tamil");
  const [tamilChannels, setTamilChannels] = React.useState(TAMIL_CHANNELS.map(c => ({...c, videoId: null})));
  const [indiaChannels, setIndiaChannels] = React.useState(INDIA_CHANNELS);
  const [worldChannels, setWorldChannels] = React.useState(WORLD_CHANNELS);
  const [watching, setWatching] = React.useState(null);
  const [news, setNews] = React.useState([]);
  const [currentNews, setCurrentNews] = React.useState(0);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    fetch(API_URL+"/api/live-channels?region=tamil")
      .then(r => r.json()).then(data => { if (Array.isArray(data)) setTamilChannels(prev => prev.map(ch => { const found = data.find(d => d.id === ch.id); return found ? {...ch, videoId: found.videoId} : ch; })); }).catch(() => {});
    fetch(API_URL+"/api/live-channels?region=india")
      .then(r => r.json()).then(data => { if (Array.isArray(data)) setIndiaChannels(data); }).catch(() => {});
    fetch(API_URL+"/api/live-channels?region=world")
      .then(r => r.json()).then(data => { if (Array.isArray(data)) setWorldChannels(data); }).catch(() => {});
    const rssFeeds = {
      tamil: "https://api.rss2json.com/v1/api.json?rss_url=https://feeds.bbci.co.uk/tamil/rss.xml",
      india: "https://api.rss2json.com/v1/api.json?rss_url=https://timesofindia.indiatimes.com/rssfeedstopstories.cms",
      world: "https://api.rss2json.com/v1/api.json?rss_url=https://feeds.bbci.co.uk/news/world/rss.xml"
    };
    fetch(rssFeeds["tamil"])
      .then(r => r.json()).then(d => { if (d.items) { setNews(d.items.slice(0, 20)); setLoading(false); } }).catch(() => setLoading(false));
    const t = setInterval(() => {
      fetch(API_URL+"/api/live-channels?region=tamil")
        .then(r => r.json()).then(data => { if (Array.isArray(data)) setTamilChannels(prev => prev.map(ch => { const found = data.find(d => d.id === ch.id); return found ? {...ch, videoId: found.videoId} : ch; })); }).catch(() => {});
    }, 30 * 60 * 1000);
    return () => clearInterval(t);
  }, []);
  React.useEffect(() => {
    if (news.length === 0) return;
    const t = setInterval(() => setCurrentNews(i => (i + 1) % Math.min(news.length, 10)), 8000);
    return () => clearInterval(t);
  }, [news]);
  const istTime = new Date().toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour: "2-digit", minute: "2-digit" });
  const RSS = {
    tamil: "https://api.rss2json.com/v1/api.json?rss_url=https://feeds.bbci.co.uk/tamil/rss.xml",
    india: "https://api.rss2json.com/v1/api.json?rss_url=https://timesofindia.indiatimes.com/rssfeedstopstories.cms",
    world: "https://api.rss2json.com/v1/api.json?rss_url=https://feeds.bbci.co.uk/news/world/rss.xml"
  };
  React.useEffect(() => {
    setLoading(true);
    setNews([]);
    fetch(RSS[activeTab])
      .then(r => r.json()).then(d => { if (d.items) { setNews(d.items.slice(0, 20)); setLoading(false); } }).catch(() => setLoading(false));
  }, [activeTab]);
  const activeChannels = activeTab === "tamil" ? tamilChannels : activeTab === "india" ? indiaChannels : worldChannels;
  const renderGrid = (channels) => (
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:"14px"}}>
      {channels.map(ch => (
        <div key={ch.id} className="ch-card"
          style={{background:"linear-gradient(135deg,#0a0000,#150000)",border:watching&&watching.id===ch.id?"2px solid #d4a843":"1px solid rgba(204,0,0,0.2)",borderRadius:"8px",overflow:"hidden",boxShadow:"0 4px 16px rgba(0,0,0,0.4)"}}
          onClick={() => ch.videoId && setWatching(ch)}>
          <div style={{padding:"24px 16px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:"10px",background:"linear-gradient(135deg,rgba(204,0,0,0.15),#000)",minHeight:"120px",position:"relative"}}>
            <div style={{position:"absolute",top:0,left:0,right:0,height:"2px",background:"linear-gradient(90deg,transparent,#cc0000,transparent)"}}></div>
            <div style={{width:"56px",height:"56px",borderRadius:"50%",background:"linear-gradient(135deg,"+ch.color+","+ch.color+"88)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"14px",fontWeight:900,color:"#fff",letterSpacing:"1px"}}>NEWS</div>
            <div style={{color:"#fff",fontWeight:900,fontSize:"14px",letterSpacing:"1px",textAlign:"center"}}>{ch.name}</div>
            <div style={{display:"flex",alignItems:"center",gap:"5px"}}>
              <div style={{width:"6px",height:"6px",borderRadius:"50%",background:"#ff0000",animation:"pulse 1s infinite"}}></div>
              <span style={{color:"rgba(255,255,255,0.5)",fontSize:"10px",letterSpacing:"2px"}}>LIVE 24/7</span>
            </div>
          </div>
          <div style={{padding:"10px 14px",display:"flex",alignItems:"center",justifyContent:"space-between",background:"rgba(0,0,0,0.5)"}}>
            <span style={{color:"rgba(255,255,255,0.35)",fontSize:"10px"}}>Courtesy: {ch.name}</span>
            <button onClick={e => { e.stopPropagation(); if(ch.videoId) window.open("https://www.youtube.com/watch?v="+ch.videoId,"_blank"); }}
              style={{background:"linear-gradient(135deg,#cc0000,#880000)",border:"none",color:"#fff",padding:"5px 14px",borderRadius:"3px",cursor:"pointer",fontSize:"11px",fontWeight:900}}>
              WATCH
            </button>
          </div>
        </div>
      ))}
    </div>
  );
  return (
    <div className="live-news-container" style={{background:"#000",minHeight:"100vh"}}>
      <style>{`
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.3} }
        @keyframes fadeIn { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
        @keyframes ticker { 0%{transform:translateX(0)} 100%{transform:translateX(-50%)} }
        .ch-card:hover { transform:scale(1.02); }
        .ch-card { transition:all 0.25s ease; cursor:pointer; }
        .news-fade { animation:fadeIn 0.5s ease; }
      `}</style>
      <div style={{background:"linear-gradient(135deg,#0a0000,#1a0300,#0a0000)",padding:"32px 4% 16px",borderBottom:"3px solid #cc0000",position:"relative"}}>
        <div style={{position:"absolute",top:0,left:0,right:0,height:"2px",background:"linear-gradient(90deg,transparent,#cc0000,#ff4444,#cc0000,transparent)"}}></div>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:"12px"}}>
          <div style={{display:"flex",alignItems:"center",gap:"14px"}}>
            <div style={{display:"flex",alignItems:"center",gap:"6px",background:"rgba(204,0,0,0.25)",border:"1px solid rgba(204,0,0,0.6)",padding:"5px 12px",borderRadius:"3px"}}>
              <div style={{width:"8px",height:"8px",borderRadius:"50%",background:"#ff0000",animation:"pulse 1s infinite"}}></div>
              <span style={{color:"#ff4444",fontWeight:900,letterSpacing:"4px",fontSize:"12px"}}>LIVE</span>
            </div>
            <div>
              <div style={{color:"#fff",fontWeight:900,fontSize:"26px",letterSpacing:"3px",lineHeight:1.1}}>NETHAJI PRIME</div>
              <div style={{color:"#d4a843",fontWeight:700,fontSize:"11px",letterSpacing:"6px"}}>NEWS NETWORK</div>
            </div>
          </div>
          <div style={{textAlign:"right"}}>
            <div style={{color:"#d4a843",fontWeight:900,fontSize:"22px",letterSpacing:"2px"}}>{istTime}</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px",letterSpacing:"3px"}}>INDIA STANDARD TIME</div>
          </div>
        </div>
        {news.length > 0 && (
          <div key={currentNews} className="news-fade" style={{marginTop:"14px",padding:"8px 14px",background:"rgba(0,0,0,0.6)",borderLeft:"4px solid #cc0000",borderRadius:"0 4px 4px 0"}}>
            <span style={{color:"#ff4444",fontWeight:900,fontSize:"10px",letterSpacing:"3px",marginRight:"10px"}}>BREAKING</span>
            <span style={{color:"rgba(255,255,255,0.9)",fontWeight:600,fontSize:"14px",fontFamily:"sans-serif"}}>{news[currentNews]?.title}</span>
          </div>
        )}
      </div>
      <div style={{background:"#0a0000",borderBottom:"1px solid rgba(212,168,67,0.2)",padding:"0 4%",display:"flex"}}>
        {[["tamil","TAMIL NADU"],["india","INDIA"],["world","INTERNATIONAL"]].map(([key,label]) => (
          <button key={key} onClick={() => { setActiveTab(key); setWatching(null); }}
            style={{padding:"12px 24px",background:"transparent",border:"none",borderBottom:activeTab===key?"3px solid #cc0000":"3px solid transparent",color:activeTab===key?"#fff":"rgba(255,255,255,0.4)",fontWeight:900,fontSize:"13px",letterSpacing:"2px",cursor:"pointer",transition:"all 0.2s"}}>
            {label}
          </button>
        ))}
      </div>
      <NethajiBulletin lang={activeTab === "tamil" ? "ta" : activeTab === "india" ? "en_india" : "en_world"} />
      {watching && (
        <div style={{background:"#000"}}>
          <div style={{background:"#0a0000",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(204,0,0,0.3)"}}>
            <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
              <div style={{width:"7px",height:"7px",borderRadius:"50%",background:"#ff0000",animation:"pulse 1s infinite"}}></div>
              <span style={{color:"#d4a843",fontWeight:900,fontSize:"15px"}}>{watching.name}</span>
              <span style={{background:"#cc0000",color:"#fff",fontSize:"9px",fontWeight:900,padding:"2px 7px",borderRadius:"2px"}}>ON AIR</span>
              <span style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>Content courtesy: {watching.name}</span>
            </div>
            <div style={{display:"flex",gap:"8px"}}>


              <button onClick={() => setWatching(null)}
                style={{background:"rgba(204,0,0,0.15)",border:"1px solid rgba(204,0,0,0.5)",color:"#ff4444",padding:"4px 12px",borderRadius:"3px",cursor:"pointer",fontSize:"11px",fontWeight:700}}>CLOSE</button>
            </div>
          </div>
          <div style={{position:"relative",paddingTop:"56.25%"}}>
            <iframe key={watching.videoId}
              src={"https://www.youtube.com/embed/"+watching.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1&modestbranding=1"}
              style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen />
          </div>
        </div>
      )}
      <div style={{padding:"20px 4%",background:"#050000"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"18px"}}>
          <div style={{height:"1px",flex:1,background:"linear-gradient(90deg,#cc0000,transparent)"}}></div>
          <span style={{color:"#d4a843",fontWeight:900,fontSize:"12px",letterSpacing:"4px"}}>
            {activeTab==="tamil"?"TAMIL NADU NEWS CHANNELS":activeTab==="india"?"INDIA NEWS CHANNELS":"INTERNATIONAL NEWS CHANNELS"}
          </span>
          <div style={{height:"1px",flex:1,background:"linear-gradient(90deg,transparent,#cc0000)"}}></div>
        </div>
        {renderGrid(activeChannels)}
      </div>
      {news.length > 0 && (
        <div style={{background:"linear-gradient(90deg,#cc0000,#880000,#cc0000)",padding:"7px 0",overflow:"hidden"}}>
          <div style={{display:"flex",gap:"60px",animation:"ticker 60s linear infinite",whiteSpace:"nowrap",width:"max-content"}}>
            {news.concat(news).map((item,i) => (
              <span key={i} style={{color:"#fff",fontSize:"13px",fontWeight:700,flexShrink:0,fontFamily:"sans-serif"}}>{item.title}</span>
            ))}
          </div>
        </div>
      )}
      <div style={{padding:"20px 4% 32px",background:"#000"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"14px"}}>
          <div style={{width:"3px",height:"18px",background:"#cc0000",borderRadius:"2px"}}></div>
          <span style={{color:"#d4a843",fontWeight:900,fontSize:"12px",letterSpacing:"4px"}}>LATEST HEADLINES</span>
        </div>
        {loading ? <div style={{color:"rgba(255,255,255,0.25)",fontSize:"11px"}}>LOADING...</div> :
          news.slice(0,10).map((item,i) => (
            <a key={i} href={item.link} target="_blank" rel="noopener noreferrer"
              style={{display:"flex",alignItems:"flex-start",gap:"14px",padding:"11px 0",borderBottom:"1px solid rgba(255,255,255,0.05)",textDecoration:"none"}}>
              <span style={{color:"#cc0000",fontWeight:900,fontSize:"13px",minWidth:"26px"}}>{String(i+1).padStart(2,"0")}</span>
              <div style={{flex:1}}>
                <div style={{color:"rgba(255,255,255,0.85)",fontSize:"13px",lineHeight:1.5,fontFamily:"sans-serif"}}>{item.title}</div>
                <div style={{color:"rgba(255,255,255,0.2)",fontSize:"10px",marginTop:"3px"}}>{new Date(item.pubDate).toLocaleString("en-IN",{timeZone:"Asia/Kolkata"})}</div>
              </div>
            </a>
          ))
        }
      </div>
    </div>
  );
}
function MoviesPage({ onBack, t, onVideoSelect }) {
  const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';
  const BUNNY_LIBRARY = process.env.REACT_APP_BUNNY_LIBRARY_ID || '675198';
  const [movies, setMovies] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [watching, setWatching] = React.useState(null);
  const [activeCat, setActiveCat] = React.useState('All');
  const [showGetStarted, setShowGetStarted] = React.useState(true);
  const CATEGORIES = ['All','Action','Drama','Comedy','Romance','Thriller','Family'];
  const SAMPLE_MOVIES = [
    {id:'m1',title:'Anbe Sivam',year:2003,genre:'Drama',language:'Tamil',thumbnail:'https://image.tmdb.org/t/p/original/bvLIBCKrPGVxpGmJM2xMwfG8TYq.jpg',bunnyId:null,isPremium:false},
    {id:'m2',title:'Vikram',year:2022,genre:'Action',language:'Tamil',thumbnail:'https://image.tmdb.org/t/p/original/n6zYKm5nU4UHZXe3kMEg3RIGUhM.jpg',bunnyId:null,isPremium:true},
    {id:'m3',title:'96',year:2018,genre:'Romance',language:'Tamil',thumbnail:'https://image.tmdb.org/t/p/original/6FjohQKDWsQpFNVFAoB0XnHpHny.jpg',bunnyId:null,isPremium:false},
    {id:'m4',title:'Kaithi',year:2019,genre:'Thriller',language:'Tamil',thumbnail:'https://image.tmdb.org/t/p/original/uBiI5E9GcHMonrHbfzfF7ZBamXe.jpg',bunnyId:null,isPremium:true},
    {id:'m5',title:'Super Deluxe',year:2019,genre:'Thriller',language:'Tamil',thumbnail:'https://image.tmdb.org/t/p/original/qMIgOXFKcoEJIWFBKGpqBYvIuRY.jpg',bunnyId:null,isPremium:true},
    {id:'m6',title:'Mersal',year:2017,genre:'Action',language:'Tamil',thumbnail:'https://image.tmdb.org/t/p/original/7YMHj5vIYSElOTSMLNGnEBCmHxM.jpg',bunnyId:null,isPremium:false},
    {id:'m7',title:'RRR',year:2022,genre:'Action',language:'Telugu',thumbnail:'https://image.tmdb.org/t/p/original/nEufeZlyAOLqO2brrs0yeF1lgXO.jpg',bunnyId:null,isPremium:true},
    {id:'m8',title:'Baahubali 2',year:2017,genre:'Action',language:'Telugu',thumbnail:'https://image.tmdb.org/t/p/original/4PCHDOoVPmSItyxGsWxLk7HDXBP.jpg',bunnyId:null,isPremium:true},
    {id:'m9',title:'Pushpa',year:2021,genre:'Action',language:'Telugu',thumbnail:'https://image.tmdb.org/t/p/original/rugyJdeoJm7cwQxuDDMPPOnuRHV.jpg',bunnyId:null,isPremium:true},
    {id:'m10',title:'KGF Chapter 2',year:2022,genre:'Action',language:'Kannada',thumbnail:'https://image.tmdb.org/t/p/original/tqgNxITFGlGFfzA4YQB7RaLpJVR.jpg',bunnyId:null,isPremium:true},
    {id:'m11',title:'Pathaan',year:2023,genre:'Action',language:'Hindi',thumbnail:'https://image.tmdb.org/t/p/original/szzFCAgvKOopZBGMBwWRkqIyFXX.jpg',bunnyId:null,isPremium:true},
    {id:'m12',title:'3 Idiots',year:2009,genre:'Comedy',language:'Hindi',thumbnail:'https://image.tmdb.org/t/p/original/66A9MqXOyVFCssoloscw79z8Tew.jpg',bunnyId:null,isPremium:false},
    {id:'m13',title:'Dangal',year:2016,genre:'Drama',language:'Hindi',thumbnail:'https://image.tmdb.org/t/p/original/9oCVODHFMlT0IKBJpRZRuHdznvf.jpg',bunnyId:null,isPremium:false},
    {id:'m14',title:'Drishyam 2',year:2022,genre:'Thriller',language:'Malayalam',thumbnail:'https://image.tmdb.org/t/p/original/6zhJBDFHgHSAHtPqGfLhCh1FTXM.jpg',bunnyId:null,isPremium:true},
    {id:'m15',title:'Lucifer',year:2019,genre:'Action',language:'Malayalam',thumbnail:'https://image.tmdb.org/t/p/original/x8rGQMBMbYSSmEXhLQYuAMWCJKF.jpg',bunnyId:null,isPremium:true},
    {id:'m16',title:'Minnal Murali',year:2021,genre:'Action',language:'Malayalam',thumbnail:'https://image.tmdb.org/t/p/original/6Sy2HvjNuFHiNKhzPxcHpFXzpGT.jpg',bunnyId:null,isPremium:false},
    {id:'m17',title:'Avatar',year:2009,genre:'Sci-Fi',language:'English',thumbnail:'https://image.tmdb.org/t/p/original/jRXYjXNq0Cs2TcJjLkki24MLp7u.jpg',bunnyId:null,isPremium:true},
    {id:'m18',title:'Interstellar',year:2014,genre:'Sci-Fi',language:'English',thumbnail:'https://image.tmdb.org/t/p/original/gEU2QniE6E77NI6lCU6MxlNBvIx.jpg',bunnyId:null,isPremium:true},
    {id:'m19',title:'The Dark Knight',year:2008,genre:'Action',language:'English',thumbnail:'https://image.tmdb.org/t/p/original/qJ2tW6WMUDux911r6m7haRef0WH.jpg',bunnyId:null,isPremium:false},
    {id:'m20',title:'Pather Panchali',year:1955,genre:'Drama',language:'Bengali',thumbnail:'https://image.tmdb.org/t/p/original/lNYzHZ7zYiAUKTCEeTkFMfXoRUd.jpg',bunnyId:null,isPremium:false},
    {id:'m21',title:'Kahaani',year:2012,genre:'Thriller',language:'Bengali',thumbnail:'https://image.tmdb.org/t/p/original/jSsqNBfnFNlJl9AVpGxRvNv4rLz.jpg',bunnyId:null,isPremium:false},
    {id:'m22',title:'Ponniyin Selvan',year:2022,genre:'Drama',language:'Tamil',thumbnail:'https://image.tmdb.org/t/p/original/6KQLHiEGdBus7KBFkiGAXGsGiQx.jpg',bunnyId:null,isPremium:true},
    {id:'m23',title:'Vada Chennai',year:2018,genre:'Action',language:'Tamil',thumbnail:'https://image.tmdb.org/t/p/original/qOmRgHCDRHR7oXKiUGJMoqDfkwZ.jpg',bunnyId:null,isPremium:true},
    {id:'m24',title:'Pariyerum Perumal',year:2018,genre:'Drama',language:'Tamil',thumbnail:'https://image.tmdb.org/t/p/original/NzgOBFHRKOhgJGXMPYHzxMpnXN.jpg',bunnyId:null,isPremium:false},
  ];
  const TMDB_KEY = process.env.REACT_APP_TMDB_API_KEY || '37da9703eaac4825584803c672bc1679';
  const [activeLang, setActiveLang] = React.useState('all');
  const LANGUAGES = [
    {code:'all',label:'All Languages'},
    {code:'ta',label:'Tamil'},
    {code:'te',label:'Telugu'},
    {code:'ml',label:'Malayalam'},
    {code:'kn',label:'Kannada'},
    {code:'hi',label:'Hindi'},
    {code:'bn',label:'Bengali'},
    {code:'en',label:'English'},
  ];
  React.useEffect(()=>{
    setLoading(true);
    const langParam = activeLang==='all' ? '' : '&with_original_language='+activeLang;
    const genreParam = activeCat==='All' ? '' : '';
    fetch('https://api.themoviedb.org/3/discover/movie?api_key='+TMDB_KEY+'&sort_by=popularity.desc&include_adult=false'+langParam+'&page=1')
      .then(r=>r.json())
      .then(d=>{
        if(d.results && d.results.length>0){
          const mapped = d.results.map(m=>({
            id: 'm'+m.id,
            title: m.title || m.original_title,
            year: m.release_date ? new Date(m.release_date).getFullYear() : '',
            genre: 'Movie',
            language: m.original_language,
            thumbnail: m.poster_path ? 'https://image.tmdb.org/t/p/original'+m.poster_path : null,
            backdrop: m.backdrop_path ? 'https://image.tmdb.org/t/p/original'+m.backdrop_path : null,
            overview: m.overview,
            rating: m.vote_average,
            bunnyId: null,
            isPremium: m.vote_average > 7.5,
          }));
          setMovies(mapped);
        } else {
          setMovies(SAMPLE_MOVIES);
        }
      })
      .catch(()=>setMovies(SAMPLE_MOVIES))
      .finally(()=>setLoading(false));
  },[activeLang]);
  const filtered = activeCat==='All' ? movies : movies.filter(m=>m.genre===activeCat);
  const featured = movies[0];
  if(showGetStarted) return (
    <div style={{background:'#000',minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'20px',position:'relative',overflow:'hidden'}}>
      <div style={{position:'absolute',inset:0,background:'linear-gradient(135deg,#1a0000 0%,#000 50%,#0a0a1a 100%)',zIndex:0}}/>
      <div style={{position:'absolute',top:0,left:0,right:0,padding:'20px 40px',display:'flex',justifyContent:'space-between',alignItems:'center',zIndex:10}}>
        <div style={{color:'#d4a843',fontWeight:900,fontSize:'24px',letterSpacing:'2px'}}>NETHAJI PRIME</div>
        <button onClick={onBack} style={{background:'transparent',border:'1px solid rgba(255,255,255,0.3)',color:'#fff',padding:'6px 16px',borderRadius:'4px',cursor:'pointer',fontSize:'13px'}}>Back</button>
      </div>
      <div style={{position:'relative',zIndex:10,textAlign:'center',maxWidth:'600px'}}>
        <div style={{fontSize:'clamp(12px,2vw,14px)',color:'#d4a843',fontWeight:700,letterSpacing:'4px',marginBottom:'16px'}}>UNLIMITED TAMIL ENTERTAINMENT</div>
        <h1 style={{fontSize:'clamp(32px,6vw,64px)',fontWeight:900,color:'#fff',lineHeight:1.1,marginBottom:'16px'}}>
          Movies, Series<br/>
          <span style={{color:'#e50914'}}>& More</span>
        </h1>
        <p style={{color:'rgba(255,255,255,0.7)',fontSize:'clamp(14px,2vw,18px)',marginBottom:'32px',lineHeight:1.6}}>
          Watch unlimited Tamil movies and series.<br/>Plans from just <strong style={{color:'#d4a843'}}>&#8377;99/month</strong>
        </p>
        <button onClick={()=>setShowGetStarted(false)} style={{background:'#e50914',border:'none',borderRadius:'4px',color:'#fff',padding:'clamp(12px,2vw,16px) clamp(24px,4vw,48px)',fontSize:'clamp(16px,2vw,20px)',fontWeight:700,cursor:'pointer',letterSpacing:'1px',transition:'all 0.2s'}}
          onMouseEnter={e=>e.target.style.background='#f40612'}
          onMouseLeave={e=>e.target.style.background='#e50914'}>
          GET STARTED
        </button>
        <div style={{color:'rgba(255,255,255,0.4)',fontSize:'12px',marginTop:'16px'}}>Cancel anytime. No hidden fees.</div>
      </div>
      <div style={{position:'absolute',bottom:'40px',left:0,right:0,display:'flex',justifyContent:'center',gap:'40px',zIndex:10,flexWrap:'wrap',padding:'0 20px'}}>
        {[['??','1000+','Tamil Movies'],['??','50+','Web Series'],['??','500+','Music Videos'],['??','Any Device','Watch Anywhere']].map(([icon,num,label])=>(
          <div key={label} style={{textAlign:'center'}}>
            <div style={{fontSize:'24px',marginBottom:'4px'}}>{icon}</div>
            <div style={{color:'#d4a843',fontWeight:900,fontSize:'18px'}}>{num}</div>
            <div style={{color:'rgba(255,255,255,0.5)',fontSize:'11px'}}>{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
  if(watching) return (
    <div style={{background:'#000',minHeight:'100vh'}}>
      <div style={{background:'#0a0000',padding:'10px 16px',display:'flex',alignItems:'center',justifyContent:'space-between',borderBottom:'1px solid rgba(212,168,67,0.2)'}}>
        <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
          <button onClick={()=>setWatching(null)} style={{background:'transparent',border:'1px solid #d4a843',color:'#d4a843',padding:'5px 14px',borderRadius:'4px',cursor:'pointer',fontSize:'12px',fontWeight:700}}>&#8592; Back</button>
          <div style={{color:'#d4a843',fontWeight:900,fontSize:'15px'}}>{watching.title}</div>
        </div>
        <div style={{color:'#d4a843',fontSize:'11px',fontWeight:700,letterSpacing:'2px'}}>NETHAJI PRIME</div>
      </div>
      <div style={{position:'relative',paddingTop:'56.25%',background:'#000',maxWidth:'1200px',margin:'0 auto'}}>
        {watching.bunnyId ? (
          <iframe src={"https://iframe.mediadelivery.net/embed/"+BUNNY_LIBRARY+"/"+watching.bunnyId+"?autoplay=true&preload=true"} style={{position:'absolute',top:0,left:0,width:'100%',height:'100%',border:'none'}} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture" allowFullScreen />
        ) : (
          <div style={{position:'absolute',inset:0,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',background:'#0a0000'}}>
            <div style={{fontSize:'48px',marginBottom:'16px'}}>??</div>
            <div style={{color:'#d4a843',fontWeight:900,fontSize:'18px',marginBottom:'8px'}}>{watching.title}</div>
            <div style={{color:'rgba(255,255,255,0.4)',fontSize:'13px',marginBottom:'24px'}}>Video coming soon  Upload to Bunny.net to play</div>
            <div style={{background:'rgba(212,168,67,0.1)',border:'1px solid rgba(212,168,67,0.3)',borderRadius:'8px',padding:'12px 20px',color:'#d4a843',fontSize:'12px',textAlign:'center',maxWidth:'300px'}}>
              Go to Bunny.net ? Upload video ? Copy Video ID ? Add to Supabase content table
            </div>
          </div>
        )}
        <div style={{position:'absolute',bottom:'8px',right:'8px',background:'rgba(0,0,0,0.7)',padding:'4px 8px',borderRadius:'4px',color:'#d4a843',fontSize:'10px',fontWeight:700,letterSpacing:'2px',pointerEvents:'none',zIndex:10}}>NETHAJI PRIME OTT</div>
      </div>
      <div style={{padding:'16px',maxWidth:'1200px',margin:'0 auto'}}>
        <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
          <span style={{background:'#e50914',color:'#fff',fontSize:'11px',fontWeight:700,padding:'3px 10px',borderRadius:'3px'}}>{watching.genre}</span>
          <span style={{color:'rgba(255,255,255,0.4)',fontSize:'12px',padding:'3px 0'}}>{watching.year}</span>
          {watching.isPremium && <span style={{background:'rgba(212,168,67,0.2)',color:'#d4a843',fontSize:'11px',fontWeight:700,padding:'3px 10px',borderRadius:'3px',border:'1px solid rgba(212,168,67,0.4)'}}>PRIME</span>}
        </div>
      </div>
    </div>
  );
  return (
    <div style={{background:'#141414',minHeight:'100vh',paddingBottom:'40px'}}>
      <div style={{background:'rgba(0,0,0,0.9)',padding:'14px 4%',display:'flex',alignItems:'center',justifyContent:'space-between',position:'sticky',top:0,zIndex:100,borderBottom:'1px solid rgba(212,168,67,0.15)'}}>
        <div style={{display:'flex',alignItems:'center',gap:'16px'}}>
          <button onClick={onBack} style={{background:'transparent',border:'1px solid rgba(255,255,255,0.3)',color:'#fff',padding:'5px 14px',borderRadius:'4px',cursor:'pointer',fontSize:'12px'}}>&#8592; Back</button>
          <div style={{color:'#d4a843',fontWeight:900,fontSize:'18px',letterSpacing:'2px'}}>NETHAJI PRIME MOVIES</div>
        </div>
        <button onClick={()=>setShowGetStarted(true)} style={{background:'#e50914',border:'none',borderRadius:'4px',color:'#fff',padding:'6px 16px',fontSize:'12px',fontWeight:700,cursor:'pointer'}}>&#8377;99/month</button>
      </div>
      {featured && (
        <div style={{position:'relative',height:'clamp(300px,50vw,500px)',overflow:'hidden'}}>
          <img src={featured.thumbnail} alt={featured.title} style={{width:'100%',height:'100%',objectFit:'cover',filter:'brightness(0.4)'}} onError={e=>e.target.style.display='none'} />
          <div style={{position:'absolute',inset:0,background:'linear-gradient(0deg,#141414 0%,transparent 50%)'}}/>
          <div style={{position:'absolute',bottom:'10%',left:'4%',maxWidth:'500px'}}>
            <div style={{color:'#d4a843',fontSize:'12px',fontWeight:700,letterSpacing:'3px',marginBottom:'8px'}}>FEATURED</div>
            <h2 style={{color:'#fff',fontSize:'clamp(24px,4vw,42px)',fontWeight:900,margin:'0 0 12px',lineHeight:1.1}}>{featured.title}</h2>
            <div style={{display:'flex',gap:'8px',marginBottom:'16px',flexWrap:'wrap'}}>
              <span style={{color:'#46d369',fontSize:'13px',fontWeight:700}}>{featured.year}</span>
              <span style={{background:'rgba(255,255,255,0.15)',color:'#fff',fontSize:'11px',padding:'2px 8px',borderRadius:'3px'}}>{featured.genre}</span>
              {featured.isPremium && <span style={{background:'#d4a843',color:'#000',fontSize:'11px',fontWeight:900,padding:'2px 8px',borderRadius:'3px'}}>PRIME</span>}
            </div>
            <div style={{display:'flex',gap:'10px'}}>
              <button onClick={()=>setWatching(featured)} style={{background:'#fff',border:'none',borderRadius:'4px',color:'#000',padding:'10px 24px',fontSize:'15px',fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',gap:'6px'}}>&#9654; Play</button>
              <button style={{background:'rgba(109,109,110,0.7)',border:'none',borderRadius:'4px',color:'#fff',padding:'10px 20px',fontSize:'14px',fontWeight:700,cursor:'pointer'}}>&#8505; More Info</button>
            </div>
          </div>
        </div>
      )}
      <div style={{padding:'8px 4% 0',display:'flex',gap:'6px',overflowX:'auto'}}>
        {LANGUAGES.map(l=>(
          <button key={l.code} onClick={()=>setActiveLang(l.code)} style={{background:activeLang===l.code?'#d4a843':'transparent',border:'1px solid '+(activeLang===l.code?'#d4a843':'rgba(255,255,255,0.3)'),color:activeLang===l.code?'#000':'#fff',padding:'4px 14px',borderRadius:'20px',cursor:'pointer',fontSize:'11px',fontWeight:700,flexShrink:0,transition:'all 0.2s'}}>{l.label}</button>
        ))}
      </div>
      <div style={{padding:'4px 4% 8px',display:'flex',gap:'8px',overflowX:'auto'}}>
        {CATEGORIES.map(cat=>(
          <button key={cat} onClick={()=>setActiveCat(cat)} style={{background:activeCat===cat?'#fff':'transparent',border:'1px solid rgba(255,255,255,0.3)',color:activeCat===cat?'#000':'#fff',padding:'5px 16px',borderRadius:'20px',cursor:'pointer',fontSize:'12px',fontWeight:700,flexShrink:0,transition:'all 0.2s'}}>{cat}</button>
        ))}
      </div>
      {loading ? (
        <div style={{textAlign:'center',padding:'60px',color:'rgba(255,255,255,0.4)'}}>
          <div style={{width:'40px',height:'40px',border:'3px solid #333',borderTopColor:'#d4a843',borderRadius:'50%',animation:'spin 0.8s linear infinite',margin:'0 auto 16px'}}/>
          Loading movies...
        </div>
      ) : (
        <div style={{padding:'0 4%'}}>
          <div style={{color:'#fff',fontWeight:700,fontSize:'16px',marginBottom:'12px'}}>{activeCat==='All'?'All Movies':activeCat}</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(clamp(130px,18vw,200px),1fr))',gap:'clamp(6px,1.5vw,12px)'}}>
            {filtered.map(movie=>(
              <div key={movie.id} onClick={()=>setWatching(movie)} style={{cursor:'pointer',borderRadius:'4px',overflow:'hidden',transition:'transform 0.2s',position:'relative'}}
                onMouseEnter={e=>e.currentTarget.style.transform='scale(1.05)'}
                onMouseLeave={e=>e.currentTarget.style.transform='scale(1)'}>
                <div style={{position:'relative',paddingTop:'150%',background:'#1a1a1a'}}>
                  <img src={movie.thumbnail} alt={movie.title} style={{position:'absolute',top:0,left:0,width:'100%',height:'100%',objectFit:'cover'}} onError={e=>{e.target.style.display='none';}} />
                  <div style={{position:'absolute',inset:0,background:'linear-gradient(0deg,rgba(0,0,0,0.8) 0%,transparent 60%)'}}/>
                  {movie.isPremium && <div style={{position:'absolute',top:'6px',right:'6px',background:'#d4a843',color:'#000',fontSize:'8px',fontWeight:900,padding:'2px 6px',borderRadius:'2px'}}>PRIME</div>}
                  <div style={{position:'absolute',inset:0,display:'flex',alignItems:'center',justifyContent:'center',opacity:0,transition:'opacity 0.2s'}}
                    onMouseEnter={e=>e.currentTarget.style.opacity='1'}
                    onMouseLeave={e=>e.currentTarget.style.opacity='0'}>
                    <div style={{width:'44px',height:'44px',borderRadius:'50%',background:'rgba(255,255,255,0.9)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'18px'}}>&#9654;</div>
                  </div>
                  <div style={{position:'absolute',bottom:'6px',left:'6px',right:'6px'}}>
                    <div style={{color:'#fff',fontWeight:700,fontSize:'11px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{movie.title}</div>
                    <div style={{color:'rgba(255,255,255,0.5)',fontSize:'10px'}}>{movie.year}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
function NethajiFeedsPage({ onBack, initialVideo=null, initialChannel='nethajitv', t, onVideoWatch }) {
  const [showUpgrade, setShowUpgrade] = React.useState(false);
  const trackWatch = () => {
    if (onVideoWatch) onVideoWatch();
    const c = parseInt(localStorage.getItem("np_videos_watched")||"0") + 1;
    localStorage.setItem("np_videos_watched", c.toString());
    if (c % 3 === 0) setShowUpgrade(true);
  };
  const CHANNELS = [
    {id:"nethajitv", name:"Nethaji TV", channelId:"UCUcNLZFSeEPCmhFPMsTB_4g", color:"#cc0000"},
    {id:"nmktv", name:"NMK TV", channelId:"UCHxP-ry5QxMKTDXTQIGUs9Q", color:"#0055aa"},
    {id:"harichandra", name:"Harichandra", channelId:"UCk_iGqMBw24OPUjKyWcJKmw", color:"#ff6600"},
    {id:"bharathtv", name:"Bharath TV", channelId:"UC1xF2lFpUvHXZCAXwR_fVIw", color:"#00695c"},
  ];
  const [activeChannel, setActiveChannel] = React.useState(initialChannel);
  const [activeTab, setActiveTab] = React.useState("latest");
  const [videos, setVideos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [watching, setWatching] = React.useState(initialVideo);
  const [videoStats, setVideoStats] = React.useState({});
  const [comments, setComments] = React.useState([]);
  const [commentsLoading, setCommentsLoading] = React.useState(false);
  const [channelStats, setChannelStats] = React.useState({});
  const threeDaysAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
  const latestVideos = videos.filter(v => new Date(v.pubDate) >= threeDaysAgo);
  const oldVideos = videos.filter(v => new Date(v.pubDate) < threeDaysAgo);
  const trendingVideos = [...videos].sort((a,b) => (b.viewCount||0) - (a.viewCount||0)).slice(0,20);
  const displayVideos = activeTab === "latest" ? latestVideos : activeTab === "trending" ? trendingVideos : oldVideos;

  React.useEffect(() => {
    setLoading(true);
    setVideos([]);
    const ch = CHANNELS.find(c => c.id === activeChannel);
    if (!ch) return;
    fetch(API_URL+"/api/youtube-feeds?channel_id=" + ch.channelId + "&max_results=200")
      .then(r => r.json())
      .then(data => {
        if (data.items) { setVideos(data.items); }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [activeChannel]);

  React.useEffect(() => {
    if (!watching) return;
    // Fetch video stats
    fetch(API_URL+"/api/youtube-stats?video_ids="+watching.videoId)
      .then(r=>r.json())
      .then(data=>{
        if(data.stats && data.stats[watching.videoId]) {
          const s = data.stats[watching.videoId];
          setVideoStats(prev=>({...prev, [watching.videoId]: s}));
        }
      }).catch(()=>{});
    setComments([]);
    setCommentsLoading(true);
    fetch(API_URL+"/api/youtube-comments?video_id="+watching.videoId+"&max_results=20")
      .then(r=>r.json())
      .then(data=>{ if(data.comments) setComments(data.comments); setCommentsLoading(false); })
      .catch(()=>setCommentsLoading(false));
  }, [watching]);

  React.useEffect(() => {
    if (videos.length === 0) return;
    const ch = CHANNELS.find(c => c.id === activeChannel);
    if (!ch) return;
    const ids = videos.slice(0,20).map(v => v.videoId).join(",");
    fetch(API_URL+"/api/youtube-stats?video_ids="+ids+"&channel_id="+ch.channelId)
      .then(r=>r.json())
      .then(data=>{
        if (data.stats) {
          setVideoStats(data.stats);
          if (data.stats.channel) setChannelStats(data.stats.channel);
        }
      })
      .catch(()=>{});
  }, [videos, activeChannel]);










  return (
    <div style={{background:"#080000",minHeight:"100vh",paddingBottom:"40px"}}>
      {/* Upgrade Modal */}
      {showUpgrade && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:99998,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}}>
          <div style={{background:"linear-gradient(135deg,#1a0500,#2d0a00)",border:"2px solid #d4a843",borderRadius:"16px",padding:"24px",maxWidth:"380px",width:"100%",textAlign:"center"}}>
            <div style={{fontSize:"48px",marginBottom:"12px"}}>👑</div>
            <div style={{color:"#d4a843",fontWeight:900,fontSize:"20px",marginBottom:"8px"}}>Enjoying Nethaji Prime?</div>
            <div style={{color:"rgba(255,255,255,0.6)",fontSize:"13px",marginBottom:"16px"}}>Upgrade to Premium for unlimited access, HD quality & ad-free experience.</div>
            <div style={{background:"rgba(212,168,67,0.1)",borderRadius:"10px",padding:"12px",marginBottom:"16px"}}>
              <div style={{color:"#d4a843",fontWeight:900,fontSize:"24px"}}>₹99/month</div>
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>or ₹799/year — Save 33%!</div>
            </div>
            <div style={{display:"flex",gap:"10px"}}>
              <button onClick={()=>{setShowUpgrade(false);onBack();}} style={{flex:1,background:"#d4a843",border:"none",borderRadius:"8px",color:"#000",fontWeight:900,fontSize:"14px",padding:"12px",cursor:"pointer"}}>Upgrade Now 🚀</button>
              <button onClick={()=>setShowUpgrade(false)} style={{background:"transparent",border:"1px solid rgba(255,255,255,0.2)",borderRadius:"8px",color:"rgba(255,255,255,0.4)",fontSize:"12px",padding:"12px",cursor:"pointer"}}>Later</button>
            </div>
          </div>
        </div>
      )}

      <div style={{background:"#0a0000",padding:"12px 4%",display:"flex",alignItems:"center",gap:"16px",borderBottom:"2px solid #d4a843",position:"sticky",top:0,zIndex:100}}>
        <button onClick={onBack} style={{background:"transparent",border:"1px solid #d4a843",color:"#d4a843",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"13px",fontWeight:700}}>Back</button>
        <div style={{color:"#d4a843",fontWeight:900,fontSize:"clamp(12px,2.5vw,16px)",letterSpacing:"1px"}}>{t && t.cat_Nethaji_TV ? t.cat_Nethaji_TV : "Social Media"}</div>
          {channelStats.subscribers && <div style={{color:"rgba(255,255,255,0.5)",fontSize:"11px"}}>&#128100; {Number(channelStats.subscribers).toLocaleString("en-IN")} subscribers</div>}
      </div>
      {watching && (
        <div style={{background:"#000"}}>
          <div style={{background:"#0a0000",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(212,168,67,0.2)"}}>
            <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
              <img src="https://media.nethajiprime.com/nethaji-logo.png" alt="Nethaji Prime" style={{height:"28px",objectFit:"contain"}} />
              <div>
                <div style={{color:"#d4a843",fontWeight:900,fontSize:"13px"}}>{watching.title}</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>Nethaji Prime OTT</div>
              </div>
            </div>
            <button onClick={() => setWatching(null)} style={{background:"rgba(204,0,0,0.2)",border:"1px solid #cc0000",color:"#ff4444",padding:"5px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>CLOSE</button>
          </div>
          <div style={{position:"relative",paddingTop:"56.25%",background:"#000"}}>
            <iframe key={watching.videoId}
              src={"https://www.youtube.com/embed/"+watching.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1&modestbranding=1"}
              style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen title={watching.title} />
          </div>
          <div style={{padding:"10px 16px",background:"#080808",borderBottom:"1px solid rgba(212,168,67,0.1)"}}>
            <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"6px",marginBottom:"8px"}}>
              {[
                {label:"Views",value:(videoStats[watching.videoId]?.views||videoStats[watching.videoId]?.viewCount||0).toLocaleString("en-IN"),icon:"👁️",color:"#0066cc"},
                {label:"Likes",value:(videoStats[watching.videoId]?.likes||videoStats[watching.videoId]?.likeCount||0).toLocaleString("en-IN"),icon:"👍",color:"#00aa44"},
                {label:"Comments",value:((videoStats[watching.videoId]?.comments||0)+(comments.length||0)).toLocaleString("en-IN"),icon:"💬",color:"#9900cc"},
                {label:"Date",value:watching.pubDate?new Date(watching.pubDate||watching.publishedAt||watching.created_at).toLocaleDateString("en-IN"):"--",icon:"📅",color:"#d4a843"},
              ].map(s=>(
                <div key={s.label} style={{background:"rgba(255,255,255,0.04)",borderRadius:"6px",padding:"6px",textAlign:"center"}}>
                  <div style={{fontSize:"14px"}}>{s.icon}</div>
                  <div style={{color:s.color,fontWeight:900,fontSize:"11px"}}>{s.value}</div>
                  <div style={{color:"rgba(255,255,255,0.3)",fontSize:"9px"}}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div style={{"padding":"12px 16px","background":"#0a0000","borderTop":"1px solid rgba(212,168,67,0.1)"}}>
            <div style={{"display":"flex","gap":"8px","flexWrap":"wrap","marginBottom":"10px"}}>
              {/* Hype Button - Nethaji Prime exclusive */}
              <button onClick={async()=>{
                const k="yt_hype_"+watching?.videoId;
                if(!localStorage.getItem(k)){
                  localStorage.setItem(k,"1");
                  try {
                    const res = await fetch(API_URL+"/api/hype/"+watching.videoId,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({user_id:localStorage.getItem("user_id")||"anonymous"})});
                    const data = await res.json();
                    if(data.is_viral){alert("🔥 VIRAL! This video is trending on Nethaji Prime!");}
                    else{alert("🔥 Hyped! "+data.hype_count+" people hyped this!");}
                  } catch(e){alert("🔥 Hyped!");}
                } else {alert("Already hyped!");}
              }} style={{"background":localStorage.getItem("yt_hype_"+watching?.videoId)?"rgba(255,80,0,0.4)":"rgba(255,80,0,0.15)","border":"1px solid rgba(255,80,0,0.4)","borderRadius":"6px","color":"#ff5000","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>{localStorage.getItem("yt_hype_"+watching?.videoId)?"🔥 Hyped!":"🔥 Hype"}</button>
              {/* Subscribe - Push notifications */}
              <button onClick={async()=>{
                const k="np_sub_"+activeChannel;
                const isSub=localStorage.getItem(k);
                if(isSub){localStorage.removeItem(k);}
                else{
                  if("Notification" in window){
                    const perm=await Notification.requestPermission();
                    if(perm==="granted"){localStorage.setItem(k,"1");alert("✅ Subscribed! You will get push notifications for new videos!");}
                    else{alert("Please enable notifications in browser settings.");}
                  } else {localStorage.setItem(k,"1");alert("✅ Subscribed!");}
                }
              }} style={{"background":localStorage.getItem("np_sub_"+activeChannel)?"rgba(0,170,68,0.3)":"rgba(204,0,0,0.2)","border":"1px solid "+(localStorage.getItem("np_sub_"+activeChannel)?"#00aa44":"#cc0000"),"borderRadius":"6px","color":localStorage.getItem("np_sub_"+activeChannel)?"#00cc44":"#ff4444","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>{localStorage.getItem("np_sub_"+activeChannel)?"✅ Subscribed":"🔔 Subscribe"}</button>
              {/* Add to My Feed */}
              <button onClick={()=>{
                const ch=CHANNELS.find(c=>c.id===activeChannel);
                const chName=ch?ch.name:activeChannel;
                const k="np_myfeed_"+activeChannel;
                const isFollowing=localStorage.getItem(k);
                if(isFollowing){localStorage.removeItem(k);const myFeeds=JSON.parse(localStorage.getItem("np_myfeeds")||"[]");localStorage.setItem("np_myfeeds",JSON.stringify(myFeeds.filter(f=>f.id!==activeChannel)));alert("Removed from My Feed");}
                else{localStorage.setItem(k,"1");const myFeeds=JSON.parse(localStorage.getItem("np_myfeeds")||"[]");myFeeds.push({id:activeChannel,name:chName,channelId:ch?.channelId});localStorage.setItem("np_myfeeds",JSON.stringify(myFeeds));alert("✅ Added to My Feed!");}
              }} style={{"background":localStorage.getItem("np_myfeed_"+activeChannel)?"rgba(0,102,204,0.3)":"rgba(0,102,204,0.15)","border":"1px solid #0066cc","borderRadius":"6px","color":"#4499ff","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>{localStorage.getItem("np_myfeed_"+activeChannel)?"📌 In My Feed":"📌 My Feed"}</button>
              {/* Watch on YouTube */}
              <button onClick={()=>window.open("https://youtu.be/"+watching?.videoId,"_blank")} style={{"background":"rgba(255,0,0,0.2)","border":"1px solid #ff0000","borderRadius":"6px","color":"#ff4444","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>▶ YouTube</button>
              <button onClick={()=>window.open("https://www.youtube.com/watch?v="+watching?.videoId+"&like=1","_blank")} style={{"background":"rgba(255,255,255,0.08)","border":"1px solid rgba(255,255,255,0.2)","borderRadius":"6px","color":"#fff","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>👍 Like</button>
              <button onClick={()=>window.open("https://www.youtube.com/watch?v="+watching?.videoId+"#comments","_blank")} style={{"background":"rgba(255,255,255,0.08)","border":"1px solid rgba(255,255,255,0.2)","borderRadius":"6px","color":"#fff","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>💬 Comment</button>
              <button onClick={()=>{const msg=encodeURIComponent("🔥 "+watching?.title+"\n\nWatch: https://youtu.be/"+watching?.videoId+"\n\nMore Tamil content: https://nethajiprime.com");window.open("https://wa.me/?text="+msg,"_blank");}} style={{"background":"rgba(37,211,102,0.15)","border":"1px solid rgba(37,211,102,0.4)","borderRadius":"6px","color":"#25d366","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>📤 WhatsApp</button>
            </div>
            {/* Prominent Subscribe Banner */}
            <div style={{background:"linear-gradient(135deg,rgba(204,0,0,0.15),rgba(204,0,0,0.05))",border:"1px solid rgba(204,0,0,0.4)",borderRadius:"10px",padding:"10px 12px",marginBottom:"10px",display:"flex",alignItems:"center",gap:"10px"}}>
              <div style={{fontSize:"24px"}}>🔔</div>
              <div style={{flex:1}}>
                <div style={{color:"#ff4444",fontWeight:900,fontSize:"12px"}}>Subscribe to Nethaji TV on YouTube!</div>
                <div style={{color:"rgba(255,255,255,0.5)",fontSize:"10px"}}>Click to subscribe and never miss a video</div>
              </div>
              <button onClick={()=>{const ch=CHANNELS.find(c=>c.id===activeChannel);if(ch)window.open("https://www.youtube.com/channel/"+ch.channelId+"?sub_confirmation=1","_blank");}} style={{background:"#cc0000",border:"none",borderRadius:"8px",color:"#fff",fontWeight:900,fontSize:"12px",padding:"8px 14px",cursor:"pointer",flexShrink:0}}>🔔 Subscribe!</button>
            </div>
            {/* Prominent Share Banner */}
            <div style={{background:"linear-gradient(135deg,rgba(37,211,102,0.15),rgba(37,211,102,0.05))",border:"1px solid rgba(37,211,102,0.4)",borderRadius:"10px",padding:"10px 12px",marginBottom:"10px",display:"flex",alignItems:"center",gap:"10px"}}>
              <div style={{fontSize:"24px"}}>📢</div>
              <div style={{flex:1}}>
                <div style={{color:"#25D366",fontWeight:900,fontSize:"12px"}}>Help Nethaji TV grow!</div>
                <div style={{color:"rgba(255,255,255,0.5)",fontSize:"10px"}}>Share this video to increase YouTube views & subscribers</div>
              </div>
              <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 Must watch! "+watching?.title+"\n\nWatch on Nethaji Prime: https://nethajiprime.com\n\nYouTube: https://youtu.be/"+watching?.videoId),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"8px",color:"#fff",fontWeight:900,fontSize:"12px",padding:"8px 14px",cursor:"pointer",flexShrink:0}}>📱 Share Now!</button>
            </div>
            <div style={{"display":"flex","gap":"8px","flexWrap":"wrap"}}>
              <button onClick={()=>{window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+watching?.title+"\n\nWatch: https://youtu.be/"+watching?.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank");}} style={{"background":"#25D366","border":"none","borderRadius":"6px","color":"#fff","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>WhatsApp</button>
              <button onClick={()=>{window.open("https://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent("https://youtu.be/"+watching.videoId),"_blank");}} style={{"background":"#1877F2","border":"none","borderRadius":"6px","color":"#fff","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>Facebook</button>
              <button onClick={()=>{window.open("https://twitter.com/intent/tweet?url="+encodeURIComponent("https://youtu.be/"+watching.videoId)+"&text="+encodeURIComponent(watching.title),"_blank");}} style={{"background":"#000","border":"1px solid #fff","borderRadius":"6px","color":"#fff","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>Twitter</button>
              <button onClick={()=>{window.open("https://t.me/share/url?url="+encodeURIComponent("https://youtu.be/"+watching.videoId)+"&text="+encodeURIComponent(watching.title),"_blank");}} style={{"background":"#0088cc","border":"none","borderRadius":"6px","color":"#fff","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>Telegram</button>
              <button onClick={()=>{window.open("https://www.threads.net/intent/post?text="+encodeURIComponent("🔥 "+watching?.title+"\n\nWatch: https://youtu.be/"+watching?.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank");}} style={{"background":"#000","border":"1px solid #fff","borderRadius":"6px","color":"#fff","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>Threads</button>
              <button onClick={()=>{window.open("https://www.instagram.com/","_blank");}} style={{"background":"linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)","border":"none","borderRadius":"6px","color":"#fff","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>Instagram</button>
              <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+watching.videoId);alert("Link copied!");}} style={{"background":"rgba(255,255,255,0.1)","border":"1px solid rgba(255,255,255,0.3)","borderRadius":"6px","color":"#fff","fontSize":"12px","fontWeight":700,"padding":"6px 12px","cursor":"pointer"}}>Copy Link</button>
            </div>
          </div>
          {/* Related Videos & Up Next */}
          <div style={{"padding":"16px","background":"#0a0000","borderTop":"1px solid rgba(212,168,67,0.1)"}}>
            <div style={{"color":"#d4a843","fontWeight":900,"fontSize":"14px","marginBottom":"12px"}}>&#128172; Comments ({comments.length})</div>
            {commentsLoading && <div style={{"color":"rgba(255,255,255,0.4)","fontSize":"12px","textAlign":"center","padding":"20px"}}>Loading comments...</div>}
            {!commentsLoading && comments.length === 0 && <div style={{"color":"rgba(255,255,255,0.4)","fontSize":"12px","textAlign":"center","padding":"20px"}}>No comments yet</div>}
            {comments.map((c,i) => (
              <div key={i} style={{"display":"flex","gap":"10px","marginBottom":"14px","padding":"10px","background":"rgba(255,255,255,0.03)","borderRadius":"8px","border":"1px solid rgba(255,255,255,0.06)"}}>
                <img src={c.avatar} alt={c.author} style={{"width":"32px","height":"32px","borderRadius":"50%","flexShrink":0,"objectFit":"cover"}} onError={e=>e.target.style.display="none"} />
                <div style={{"flex":1}}>
                  <div style={{"display":"flex","alignItems":"center","gap":"8px","marginBottom":"4px"}}>
                    <span style={{"color":"#d4a843","fontSize":"12px","fontWeight":700}}>{c.author}</span>
                    <span style={{"color":"rgba(255,255,255,0.3)","fontSize":"10px"}}>{new Date(c.published).toLocaleDateString("en-IN")}</span>
                    {c.likes > 0 && <span style={{"color":"rgba(255,255,255,0.4)","fontSize":"10px"}}>&#128077; {c.likes}</span>}
                  </div>
                  <div style={{"color":"#e2e8f0","fontSize":"12px","lineHeight":"1.5"}} dangerouslySetInnerHTML={{__html: c.text}} />
                </div>
              </div>
            ))}
          </div>
          {watching && videos.length > 0 && (
          <div style={{"padding":"12px 16px","background":"#080000"}}>
            <div style={{"color":"#d4a843","fontWeight":900,"fontSize":"13px","marginBottom":"10px"}}>RELATED VIDEOS</div>
            <div style={{"display":"grid","gridTemplateColumns":"repeat(auto-fill,minmax(140px,1fr))","gap":"10px","marginBottom":"16px"}}>
              {videos.filter(v=>v.videoId!==watching.videoId).slice(0,6).map((v,i)=>(
                <div key={i} onClick={()=>{window.open("https://youtu.be/"+v.videoId,"_blank");}} style={{"cursor":"pointer","borderRadius":"6px","overflow":"hidden","background":"#0a0000","border":"1px solid rgba(212,168,67,0.1)"}}>
                  <div style={{"position":"relative","paddingTop":"56.25%"}}>
                    <img src={v.thumbnail} alt={v.title} style={{"position":"absolute","top":0,"left":0,"width":"100%","height":"100%","objectFit":"cover"}} onError={e=>e.target.style.display="none"} />
                    <div style={{"position":"absolute","inset":0,"display":"flex","alignItems":"center","justifyContent":"center"}}>
                      <div style={{"width":"30px","height":"30px","borderRadius":"50%","background":"rgba(0,0,0,0.7)","display":"flex","alignItems":"center","justifyContent":"center","color":"#fff","fontSize":"12px"}}>&#9654;</div>
                    </div>
                  </div>
                  <div style={{"padding":"6px 8px","color":"#e2e8f0","fontSize":"10px","fontWeight":600,"overflow":"hidden","display":"-webkit-box","WebkitLineClamp":2,"WebkitBoxOrient":"vertical"}}>{v.title}</div>
                </div>
              ))}
            </div>
            <div style={{"color":"#d4a843","fontWeight":900,"fontSize":"13px","marginBottom":"10px"}}>UP NEXT</div>
            {videos.filter(v=>v.videoId!==watching.videoId).slice(0,3).map((v,i)=>(
              <div key={i} onClick={()=>{window.open("https://youtu.be/"+v.videoId,"_blank");}} style={{"display":"flex","gap":"10px","marginBottom":"10px","cursor":"pointer","padding":"8px","borderRadius":"6px","background":"rgba(255,255,255,0.03)","border":"1px solid rgba(255,255,255,0.06)"}}>
                <img src={v.thumbnail} alt={v.title} style={{"width":"100px","height":"60px","objectFit":"cover","borderRadius":"4px","flexShrink":0}} onError={e=>e.target.style.display="none"} />
                <div>
                  <div style={{"color":"#e2e8f0","fontSize":"11px","fontWeight":600,"lineHeight":"1.3"}}>{v.title}</div>
                  <div style={{"color":"rgba(255,255,255,0.3)","fontSize":"10px","marginTop":"4px"}}>{new Date(v.pubDate).toLocaleDateString("en-IN")}</div>
                </div>
              </div>
            ))}
          </div>
          )}
        </div>
      )}
      <div style={{padding:"16px 4% 8px",display:"flex",gap:"8px",flexWrap:"wrap"}}>
        {CHANNELS.map(ch => (
          <button key={ch.id} onClick={() => setActiveChannel(ch.id)}
            style={{padding:"8px 18px",background:activeChannel===ch.id?ch.color:"transparent",border:"1px solid "+ch.color,color:activeChannel===ch.id?"#fff":ch.color,borderRadius:"20px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>
            {ch.name}
          </button>
        ))}
      </div>
      <div style={{padding:"8px 4% 0",display:"flex",gap:"8px",borderBottom:"1px solid rgba(212,168,67,0.1)",marginBottom:"0"}}>
        <button onClick={() => setActiveTab("trending")}
          style={{padding:"8px 20px",background:"transparent",border:"none",borderBottom:activeTab==="trending"?"2px solid #ff4444":"2px solid transparent",color:activeTab==="trending"?"#ff4444":"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:"13px",fontWeight:700,letterSpacing:"1px"}}>TRENDING</button>
        <button onClick={() => setActiveTab("latest")}
          style={{padding:"8px 20px",background:"transparent",border:"none",borderBottom:activeTab==="latest"?"2px solid #d4a843":"2px solid transparent",color:activeTab==="latest"?"#d4a843":"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:"13px",fontWeight:700,letterSpacing:"1px"}}>
          LATEST ({latestVideos.length})
        </button>
        <button onClick={() => setActiveTab("old")}
          style={{padding:"8px 20px",background:"transparent",border:"none",borderBottom:activeTab==="old"?"2px solid #d4a843":"2px solid transparent",color:activeTab==="old"?"#d4a843":"rgba(255,255,255,0.4)",cursor:"pointer",fontSize:"13px",fontWeight:700,letterSpacing:"1px"}}>
          OLD ({oldVideos.length})
        </button>
      </div>
      <div style={{padding:"8px 4%"}}>
        {loading && <div style={{textAlign:"center",color:"#d4a843",padding:"40px",fontSize:"14px"}}>Loading latest videos...</div>}
        {!loading && displayVideos.length === 0 && <div style={{textAlign:"center",color:"rgba(255,255,255,0.4)",padding:"40px",fontSize:"13px"}}>No videos in this section</div>}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(clamp(140px,30vw,200px),1fr))",gap:"clamp(8px,2vw,16px)"}}>
          {displayVideos.map((video,i) => (
            <div key={i} onClick={() => {window.open("https://youtu.be/"+video.videoId,"_blank");}}
              style={{background:"#0a0000",border:"1px solid rgba(212,168,67,0.15)",borderRadius:"8px",overflow:"hidden",cursor:"pointer",transition:"all 0.25s"}}
              onMouseEnter={e => e.currentTarget.style.borderColor="rgba(212,168,67,0.7)"}
              onMouseLeave={e => e.currentTarget.style.borderColor="rgba(212,168,67,0.15)"}>
              <div style={{position:"relative",paddingTop:"56.25%",background:"#111"}}>
                <img src={video.thumbnail} alt={video.title}
                  style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover"}}
                  onError={e => e.target.style.display="none"} />
                <div style={{position:"absolute",inset:0,background:"linear-gradient(0deg,rgba(0,0,0,0.6),transparent 50%)"}}></div>
                <div style={{position:"absolute",top:"6px",right:"6px",background:"rgba(0,0,0,0.7)",padding:"2px 5px",borderRadius:"3px",display:"flex",alignItems:"center"}}>
                  <img src="https://media.nethajiprime.com/nethaji-logo.png" alt="NP" style={{height:"12px",objectFit:"contain"}} />
                </div>
                <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <div style={{width:"40px",height:"40px",borderRadius:"50%",background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"16px",color:"#fff"}}>&#9654;</div>
                </div>
              </div>
              <div style={{padding:"8px 10px"}}>
                <div style={{color:"#fff",fontWeight:700,fontSize:"11px",lineHeight:"1.3",marginBottom:"4px",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden"}}>{video.title}</div>
                <div style={{color:"rgba(255,255,255,0.3)",fontSize:"9px",display:"flex",gap:"8px",flexWrap:"wrap"}}>
                <span>{new Date(video.pubDate||video.publishedAt||video.created_at).toLocaleDateString("en-IN")}</span>
                {videoStats[video.videoId] && (
                  <>
                    <span>&#128065; {videoStats[video.videoId].views?.toLocaleString("en-IN")||0}</span>
                    <span>&#128077; {videoStats[video.videoId].likes?.toLocaleString("en-IN")||0}</span>
                  </>
                )}
              </div><div style={{display:"flex",gap:"4px",marginTop:"6px"}} onClick={e=>e.stopPropagation()}><button onClick={()=>{const msg=encodeURIComponent("🔥 "+video.title+"\n\nWatch: https://youtu.be/"+video.videoId+"\n\nMore Tamil content: https://nethajiprime.com");window.open("https://wa.me/?text="+msg,"_blank");}} style={{background:"#25D366",border:"none",borderRadius:"4px",color:"#fff",fontSize:"9px",fontWeight:700,padding:"3px 8px",cursor:"pointer",flex:1}}>WhatsApp</button><button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+video.videoId);alert("Link copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:"4px",color:"#fff",fontSize:"9px",fontWeight:700,padding:"3px 8px",cursor:"pointer",flex:1}}>Copy</button></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}










function TransportPage({ onBack, t, onVideoSelect }) {
  const [ottVideosTransport, setOttVideosTransport] = React.useState([]);
  React.useEffect(()=>{
    fetch((process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com")+"/speeches?category=Transport")
      .then(r=>r.json()).then(d=>{if(d.speeches)setOttVideosTransport(d.speeches);})
      .catch(()=>{});
  },[]);
  const TRANSPORT_SERVICES = [
    {id:"rapido", name:"Rapido", emoji:"🛵", color:"#ffcc00", desc:"Book bike taxi & auto", url:"https://rapido.bike/", category:"Cab"},
    {id:"ola", name:"Ola Cabs", emoji:"🚗", color:"#00cc44", desc:"Book cab anywhere", url:"https://www.olacabs.com/", category:"Cab"},
    {id:"uber", name:"Uber", emoji:"🚙", color:"#000000", desc:"Ride with Uber", url:"https://www.uber.com/in/en/", category:"Cab"},
    {id:"redbus", name:"RedBus", emoji:"🚌", color:"#cc0000", desc:"Book bus tickets", url:"https://www.redbus.in/", category:"Bus"},
    {id:"irctc", name:"IRCTC Train", emoji:"🚂", color:"#0033cc", desc:"Book train tickets", url:"https://www.irctc.co.in/", category:"Train"},
    {id:"makemytrip", name:"MakeMyTrip", emoji:"✈️", color:"#e8161d", desc:"Flights & Hotels", url:"https://www.makemytrip.com/", category:"Flight"},
    {id:"goibibo", name:"Goibibo", emoji:"🏨", color:"#0066cc", desc:"Hotels & Flights", url:"https://www.goibibo.com/", category:"Flight"},
    {id:"cleartrip", name:"Cleartrip", emoji:"🌍", color:"#ff6600", desc:"Travel deals", url:"https://www.cleartrip.com/", category:"Flight"},
    {id:"yatra", name:"Yatra", emoji:"🗺️", color:"#cc0066", desc:"Travel packages", url:"https://www.yatra.com/", category:"Flight"},
    {id:"abhibus", name:"AbhiBus", emoji:"🚌", color:"#ff9900", desc:"Bus booking Tamil Nadu", url:"https://www.abhibus.com/", category:"Bus"},
  ];

  const CATEGORIES = ["All", "Cab", "Bus", "Train", "Flight"];
  const [activeCategory, setActiveCategory] = React.useState("All");

  const POPULAR_ROUTES = [
    {from:"Chennai", to:"Madurai", bus:"₹350", train:"₹280", flight:"₹2,999"},
    {from:"Chennai", to:"Coimbatore", bus:"₹420", train:"₹320", flight:"₹2,499"},
    {from:"Chennai", to:"Bangalore", bus:"₹500", train:"₹380", flight:"₹1,999"},
    {from:"Madurai", to:"Tirupati", bus:"₹380", train:"₹290", flight:"₹3,499"},
    {from:"Chennai", to:"Tirupati", bus:"₹280", train:"₹220", flight:"₹2,299"},
  ];

  const filtered = activeCategory === "All" ? TRANSPORT_SERVICES : TRANSPORT_SERVICES.filter(s => s.category === activeCategory);

  return (
    <div style={{background:"linear-gradient(135deg,#000a1a,#001530)",minHeight:"100vh",paddingBottom:"40px"}}>
      <BANNERS.Transport />
      {ottVideosTransport.length>0&&(
        <div style={{padding:'16px 4%',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
          <div style={{color:'#d4a843',fontWeight:900,fontSize:'14px',marginBottom:'12px'}}>Nethaji Prime Transport Videos</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
            {ottVideosTransport.map((v,i)=>(
              <VideoCard 
                key={v.id||i} 
                video={v} 
                isNew={false} 
                hasAccess={true}
                onClick={()=>{
                  if(v.video_url && !v.video_url.includes('youtube') && !v.video_url.includes('youtu.be')){
                    if(onVideoSelect) onVideoSelect(v);
                  } else {
                    window.open(v.video_url,'_blank');
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
      <div style={{background:"linear-gradient(90deg,#000a1a,#001530)",padding:"clamp(8px,2vw,12px) 4%",display:"flex",alignItems:"center",gap:"16px",borderBottom:"2px solid #0066cc",position:"sticky",top:0,zIndex:100}}>
        <button onClick={onBack} style={{background:"transparent",border:"1px solid #0066cc",color:"#0066cc",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"13px",fontWeight:700}}>Back</button><button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("Watch Transport on Nethaji Prime OTT!\\n\\nhttps://nethajiprime.com/#transport"),"_blank")} style={{marginLeft:"8px",padding:"6px 12px",background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"11px",fontWeight:700,cursor:"pointer"}}>Share</button>
        <div>
          <div style={{color:"#4499ff",fontWeight:900,fontSize:"clamp(14px,3vw,20px)",letterSpacing:"2px"}}>🚗 TRANSPORT & TRAVEL</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>Cab • Bus • Train • Flight • Hotels</div>
        </div>
        <div style={{marginLeft:"auto",background:"rgba(0,102,204,0.1)",border:"1px solid rgba(0,102,204,0.4)",borderRadius:"6px",padding:"4px 10px",color:"#4499ff",fontSize:"10px",fontWeight:900}}>NETHAJI PRIME</div>
      </div>

      {/* Category Filter */}
      <div style={{padding:"10px 4%",display:"flex",gap:"8px",overflowX:"auto",borderBottom:"1px solid rgba(0,102,204,0.2)"}}>
        {CATEGORIES.map(c=>(
          <button key={c} onClick={()=>setActiveCategory(c)} style={{background:activeCategory===c?"#0066cc":"rgba(0,102,204,0.1)",border:"1px solid #0066cc",color:activeCategory===c?"#fff":"#4499ff",padding:"5px 12px",borderRadius:"20px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0}}>{c}</button>
        ))}
      </div>

      {/* Services Grid */}
      <div style={{padding:"12px 4%"}}>
        <div style={{color:"#4499ff",fontWeight:900,fontSize:"13px",marginBottom:"10px"}}>🚀 BOOK NOW</div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(clamp(140px,28vw,180px),1fr))",gap:"10px",marginBottom:"20px"}}>
          {filtered.map(s=>(
            <div key={s.id} onClick={()=>window.open(s.url,"_blank")} style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.1)",borderRadius:"12px",padding:"16px",cursor:"pointer",textAlign:"center"}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor=s.color;e.currentTarget.style.background="rgba(255,255,255,0.08)";}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor="rgba(255,255,255,0.1)";e.currentTarget.style.background="rgba(255,255,255,0.04)";}}>
              <div style={{fontSize:"36px",marginBottom:"8px"}}>{s.emoji}</div>
              <div style={{color:"#fff",fontWeight:700,fontSize:"13px",marginBottom:"4px"}}>{s.name}</div>
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px",marginBottom:"10px"}}>{s.desc}</div>
              <div style={{background:s.color,color:"#fff",borderRadius:"6px",padding:"6px",fontSize:"11px",fontWeight:700}}>Book Now →</div>
            </div>
          ))}
        </div>

        {/* Popular Routes */}
        <div style={{color:"#4499ff",fontWeight:900,fontSize:"13px",marginBottom:"10px"}}>📍 POPULAR TAMIL NADU ROUTES</div>
        <div style={{display:"flex",flexDirection:"column",gap:"8px"}}>
          {POPULAR_ROUTES.map((route,i)=>(
            <div key={i} style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(0,102,204,0.2)",borderRadius:"10px",padding:"12px"}}>
              <div style={{display:"flex",alignItems:"center",gap:"8px",marginBottom:"8px"}}>
                <span style={{color:"#fff",fontWeight:700,fontSize:"13px"}}>{route.from}</span>
                <span style={{color:"rgba(255,255,255,0.3)"}}>→</span>
                <span style={{color:"#fff",fontWeight:700,fontSize:"13px"}}>{route.to}</span>
              </div>
              <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
                <button onClick={()=>window.open("https://www.redbus.in/bus-tickets/"+route.from.toLowerCase()+"-to-"+route.to.toLowerCase(),"_blank")} style={{background:"rgba(204,0,0,0.2)",border:"1px solid #cc0000",color:"#ff4444",padding:"4px 10px",borderRadius:"4px",cursor:"pointer",fontSize:"11px",fontWeight:700}}>🚌 Bus {route.bus}</button>
                <button onClick={()=>window.open("https://www.irctc.co.in/","_blank")} style={{background:"rgba(0,51,204,0.2)",border:"1px solid #0033cc",color:"#4466ff",padding:"4px 10px",borderRadius:"4px",cursor:"pointer",fontSize:"11px",fontWeight:700}}>🚂 Train {route.train}</button>
                <button onClick={()=>window.open("https://www.makemytrip.com/flights/","_blank")} style={{background:"rgba(232,22,29,0.2)",border:"1px solid #e8161d",color:"#ff4444",padding:"4px 10px",borderRadius:"4px",cursor:"pointer",fontSize:"11px",fontWeight:700}}>✈️ Flight {route.flight}</button>
              </div>
            </div>
          ))}
        </div>
      </div>

    <div style={{padding:'16px',background:'rgba(255,255,255,0.02)',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
      <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',fontWeight:'700',letterSpacing:'2px',marginBottom:'12px'}}>SPONSORED PARTNERS</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'10px'}}>
        {[{name:'Rapido',url:'https://rapido.bike',desc:'Bike taxi',color:'#ffcc00',emoji:'🏍'},{name:'Ola',url:'https://olacabs.com',desc:'Book cab',color:'#3cb815',emoji:'🚖'},{name:'IRCTC',url:'https://irctc.co.in',desc:'Train tickets',color:'#1a5fa8',emoji:'🚂'},{name:'RedBus',url:'https://redbus.in',desc:'Bus booking',color:'#d84315',emoji:'🚌'}].map((a,i)=>(
          <div key={i} onClick={()=>window.open(a.url,'_blank')} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'12px',cursor:'pointer',borderTop:'2px solid '+a.color,textAlign:'center'}}>
            <div style={{fontSize:'22px',marginBottom:'4px'}}>{a.emoji}</div>
            <div style={{color:a.color,fontWeight:'800',fontSize:'12px',marginBottom:'3px'}}>{a.name}</div>
            <div style={{color:'rgba(255,255,255,0.35)',fontSize:'10px',marginBottom:'8px'}}>{a.desc}</div>
            <button style={{padding:'4px 10px',background:a.color,border:'none',borderRadius:'5px',color:'#fff',fontWeight:'700',cursor:'pointer',fontSize:'10px'}}>Open</button>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
}


function ReferralSection({ user, API_URL }) {
  const [referralCode, setReferralCode] = React.useState("");
  const [referralUrl, setReferralUrl] = React.useState("");
  const [stats, setStats] = React.useState({total_referrals: 0});
  const [copied, setCopied] = React.useState(false);

  React.useEffect(() => {
    if (!user?.id) return;
    fetch(`${API_URL}/api/referral/code/${user.id}`)
      .then(r=>r.json())
      .then(data=>{
        setReferralCode(data.referral_code);
        setReferralUrl(data.referral_url);
      }).catch(()=>{});
    fetch(`${API_URL}/api/referral/stats/${user.id}`)
      .then(r=>r.json())
      .then(data=>setStats(data))
      .catch(()=>{});
  }, [user]);

  const copyLink = () => {
    navigator.clipboard.writeText(referralUrl);
    setCopied(true);
    setTimeout(()=>setCopied(false), 2000);
  };

  const shareWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent("Join Nethaji Prime OTT - Tamil news, sports, movies & more! Use my referral code "+referralCode+" to get free access: "+referralUrl)}`, "_blank");
  };

  return (
    <div style={{background:"rgba(212,168,67,0.05)",border:"1px solid rgba(212,168,67,0.2)",borderRadius:"12px",padding:"16px",marginTop:"16px"}}>
      <div style={{color:"#d4a843",fontWeight:900,fontSize:"14px",marginBottom:"12px"}}>🎁 REFER & EARN</div>
      <div style={{color:"rgba(255,255,255,0.6)",fontSize:"12px",marginBottom:"12px"}}>
        Invite friends to Nethaji Prime! Each referral earns you <span style={{color:"#d4a843",fontWeight:700}}>50 points</span>!
      </div>
      <div style={{background:"rgba(0,0,0,0.3)",borderRadius:"8px",padding:"10px",marginBottom:"10px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <span style={{color:"#d4a843",fontWeight:900,fontSize:"16px",letterSpacing:"3px"}}>{referralCode || "Loading..."}</span>
        <button onClick={copyLink} style={{background:copied?"#00aa44":"rgba(212,168,67,0.2)",border:"1px solid #d4a843",color:"#d4a843",padding:"4px 10px",borderRadius:"4px",cursor:"pointer",fontSize:"11px",fontWeight:700}}>
          {copied ? "✅ Copied!" : "📋 Copy"}
        </button>
      </div>
      <div style={{display:"flex",gap:"8px",marginBottom:"12px"}}>
        <button onClick={shareWhatsApp} style={{flex:1,background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",padding:"8px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>📱 Share on WhatsApp</button>
        <button onClick={copyLink} style={{flex:1,background:"rgba(212,168,67,0.2)",border:"1px solid #d4a843",borderRadius:"6px",color:"#d4a843",padding:"8px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>🔗 Copy Link</button>
      </div>
      <div style={{display:"flex",justifyContent:"space-between",background:"rgba(0,0,0,0.2)",borderRadius:"8px",padding:"10px"}}>
        <div style={{textAlign:"center"}}>
          <div style={{color:"#d4a843",fontWeight:900,fontSize:"20px"}}>{stats.total_referrals}</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>Friends Invited</div>
        </div>
        <div style={{textAlign:"center"}}>
          <div style={{color:"#00aa44",fontWeight:900,fontSize:"20px"}}>{stats.total_referrals * 50}</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>Points Earned</div>
        </div>
        <div style={{textAlign:"center"}}>
          <div style={{color:"#0066cc",fontWeight:900,fontSize:"20px"}}>{stats.total_referrals * 7}</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>Days Free Access</div>
        </div>
      </div>
    </div>
  );
}

function WomenPage({ onBack, t, onVideoSelect }) {
  const [ottVideosWomen, setOttVideosWomen] = React.useState([]);
  React.useEffect(()=>{
    fetch((process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com")+"/speeches?category=Women")
      .then(r=>r.json()).then(d=>{if(d.speeches)setOttVideosWomen(d.speeches);})
      .catch(()=>{});
  },[]);
  const WOMEN_CHANNELS = []

  const GENRES = ["All", "Tamil", "Tamil Temples", "India", "North India"];
  const [activeChannel, setActiveChannel] = React.useState("templestn");
  const [activeGenre, setActiveGenre] = React.useState("All");
  const [videos, setVideos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [watching, setWatching] = React.useState(null);
  const API_URL_T = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';

  React.useEffect(() => {
    setLoading(true);
    setVideos([]);
    const ch = TOURISM_CHANNELS.find(c => c.id === activeChannel);
    if (!ch) return;
    fetch(API_URL_T+"/api/youtube-feeds?channel_id="+ch.channelId+"&max_results=20")
      .then(r=>r.json())
      .then(data=>{ if(data.items) setVideos(data.items); setLoading(false); })
      .catch(()=>setLoading(false));
  }, [activeChannel]);

  const filteredChannels = activeGenre === "All" ? TOURISM_CHANNELS : TOURISM_CHANNELS.filter(c => c.genre === activeGenre);
  const ch = TOURISM_CHANNELS.find(c => c.id === activeChannel);

  return (
    <div style={{background:"linear-gradient(135deg,#0a0500,#1a0d00)",minHeight:"100vh",paddingBottom:"40px"}}>
      <BANNERS.Tourism />
      {ottVideosTourism.length>0&&(
        <div style={{padding:'16px 4%',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
          <div style={{color:'#d4a843',fontWeight:900,fontSize:'14px',marginBottom:'12px'}}>Nethaji Prime Tourism Videos</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
            {ottVideosTourism.map((v,i)=>(
              <VideoCard 
                key={v.id||i} 
                video={v} 
                isNew={false} 
                hasAccess={true}
                onClick={()=>{
                  if(v.video_url && !v.video_url.includes('youtube') && !v.video_url.includes('youtu.be')){
                    if(onVideoSelect) onVideoSelect(v);
                  } else {
                    window.open(v.video_url,'_blank');
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
      <div style={{background:"linear-gradient(90deg,#0a0500,#1a0d00)",padding:"clamp(8px,2vw,12px) 4%",display:"flex",alignItems:"center",gap:"16px",borderBottom:"2px solid #d4a843",position:"sticky",top:0,zIndex:100}}>
        <button onClick={onBack} style={{background:"transparent",border:"1px solid #d4a843",color:"#d4a843",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"13px",fontWeight:700}}>Back</button><button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("Watch Tourism on Nethaji Prime OTT!\\n\\nhttps://nethajiprime.com/#tourism"),"_blank")} style={{marginLeft:"8px",padding:"6px 12px",background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"11px",fontWeight:700,cursor:"pointer"}}>Share</button>
        <div>
          <div style={{color:"#d4a843",fontWeight:900,fontSize:"clamp(14px,3vw,20px)",letterSpacing:"2px"}}>🛕 {t && t.cat_Tourism ? t.cat_Tourism.toUpperCase() : "TOURISM"}</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>Tamil Temples • South India • North India • Culture</div>
        </div>
        <div style={{marginLeft:"auto",background:"rgba(212,168,67,0.1)",border:"1px solid rgba(212,168,67,0.4)",borderRadius:"6px",padding:"4px 10px",color:"#d4a843",fontSize:"10px",fontWeight:900,letterSpacing:"2px"}}>NETHAJI PRIME OTT</div>
      </div>

      {watching && (
        <div style={{background:"#000"}}>
          <div style={{background:"#0a0500",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(212,168,67,0.3)"}}>
            <div style={{color:"#d4a843",fontWeight:900,fontSize:"13px"}}>{watching.title}</div>
            <button onClick={()=>setWatching(null)} style={{background:"rgba(204,0,0,0.2)",border:"1px solid #cc0000",color:"#ff4444",padding:"5px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>CLOSE</button>
          </div>
          <div style={{position:"relative",paddingTop:"56.25%",background:"#000"}}>
            <iframe key={watching.videoId} src={"https://www.youtube.com/embed/"+watching.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1"} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title={watching.title} />
            <div style={{position:"absolute",bottom:"12px",right:"12px",background:"rgba(0,0,0,0.6)",color:"#d4a843",fontSize:"11px",fontWeight:900,padding:"4px 10px",borderRadius:"4px",letterSpacing:"2px",pointerEvents:"none",zIndex:10}}>NETHAJI PRIME OTT</div>
          </div>
            <div style={{padding:"12px",background:"rgba(0,0,0,0.4)",borderTop:"1px solid rgba(212,168,67,0.15)"}}>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"8px",marginBottom:"10px"}}>
                {[
                  {label:"Views",value:(watching?.viewCount||watching?.view_count||"N/A"),icon:"👁️",color:"#0066cc"},
                  {label:"Likes",value:(watching?.likeCount||watching?.like_count||"N/A"),icon:"👍",color:"#00aa44"},
                  {label:"Published",value:watching?.pubDate?new Date(watching.pubDate||watching.publishedAt||watching.created_at).toLocaleDateString("en-IN"):"N/A",icon:"📅",color:"#d4a843"},
                ].map(stat=>(
                  <div key={stat.label} style={{background:"rgba(255,255,255,0.05)",borderRadius:"8px",padding:"8px",textAlign:"center"}}>
                    <div style={{fontSize:"16px"}}>{stat.icon}</div>
                    <div style={{color:stat.color,fontWeight:900,fontSize:"13px"}}>{stat.value}</div>
                    <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>{stat.label}</div>
                  </div>
                ))}
              </div>
              <div style={{display:"flex",gap:"8px"}}>
                <button onClick={()=>{const k="yt_like_"+watching?.videoId;if(!localStorage.getItem(k)){localStorage.setItem(k,"1");alert("Liked!");}else{alert("Already liked!");}}} style={{flex:1,background:"rgba(0,170,68,0.2)",border:"1px solid #00aa44",color:"#00aa44",borderRadius:"6px",padding:"8px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>👍 Like</button>
                <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+watching?.title+"\n\nWatch: https://youtu.be/"+watching?.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{flex:1,background:"rgba(37,211,102,0.2)",border:"1px solid #25D366",color:"#25D366",borderRadius:"6px",padding:"8px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>📱 Share</button>
                <button onClick={()=>window.open("https://youtube.com/watch?v="+watching?.videoId,"_blank")} style={{flex:1,background:"rgba(255,0,0,0.2)",border:"1px solid #ff0000",color:"#ff4444",borderRadius:"6px",padding:"8px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>▶ YouTube</button>
              </div>
            </div>
          <div style={{padding:"12px 16px",background:"#0a0500",borderTop:"1px solid rgba(212,168,67,0.2)",display:"flex",gap:"8px",flexWrap:"wrap"}}>
            <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+watching?.title+"\n\nWatch: https://youtu.be/"+watching?.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>📱 WhatsApp</button>
            <button onClick={()=>window.open("https://t.me/share/url?url="+encodeURIComponent("https://youtu.be/"+watching.videoId),"_blank")} style={{background:"#0088cc",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>✈️ Telegram</button>
            <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+watching.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.3)",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>🔗 Copy</button>
          </div>
        </div>
      )}

      <div style={{padding:"10px 4%",display:"flex",gap:"8px",overflowX:"auto",borderBottom:"1px solid rgba(212,168,67,0.2)"}}>
        {GENRES.map(g=>(
          <button key={g} onClick={()=>setActiveGenre(g)} style={{background:activeGenre===g?"#d4a843":"rgba(212,168,67,0.1)",border:"1px solid #d4a843",color:activeGenre===g?"#000":"#d4a843",padding:"5px 12px",borderRadius:"20px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0}}>{g}</button>
        ))}
      </div>

      <div style={{padding:"10px 4%",display:"flex",gap:"8px",overflowX:"auto",borderBottom:"1px solid rgba(212,168,67,0.1)"}}>
        {filteredChannels.map(c=>(
          <button key={c.id} onClick={()=>setActiveChannel(c.id)} style={{background:activeChannel===c.id?c.color:"rgba(255,255,255,0.05)",border:"1px solid "+c.color,color:activeChannel===c.id?"#fff":c.color,padding:"6px 14px",borderRadius:"6px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0,whiteSpace:"nowrap"}}>{c.icon} {c.name}</button>
        ))}
      </div>

      <div style={{padding:"12px 4%"}}>
        {loading && <div style={{textAlign:"center",color:"rgba(255,255,255,0.4)",padding:"40px"}}>No content available.</div>}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(clamp(160px,28vw,240px),1fr))",gap:"clamp(8px,2vw,16px)"}}>
          {videos.map((video,i)=>(
            <div key={i} onClick={()=>{setWatching(video);}} style={{background:"rgba(212,168,67,0.05)",border:"1px solid rgba(212,168,67,0.2)",borderRadius:"10px",overflow:"hidden",cursor:"pointer"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor="#d4a843"}
              onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(212,168,67,0.2)"}>
              <div style={{position:"relative",paddingTop:"56.25%"}}>
                <img src={video.thumbnail} alt={video.title} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover"}} onError={e=>e.target.style.display="none"} />
                <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <div style={{width:"40px",height:"40px",borderRadius:"50%",background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",color:"#d4a843",fontSize:"16px"}}>&#9654;</div>
                </div>
                <div style={{position:"absolute",top:"8px",left:"8px",background:ch?.color||"#d4a843",color:"#000",fontSize:"9px",fontWeight:900,padding:"2px 6px",borderRadius:"2px"}}>{ch?.genre||"TOURISM"}</div>
                <div style={{position:"absolute",bottom:"6px",right:"6px",background:"rgba(0,0,0,0.6)",color:"#d4a843",fontSize:"8px",fontWeight:900,padding:"2px 6px",borderRadius:"2px",letterSpacing:"1px"}}>NETHAJI PRIME</div>
              </div>
              <div style={{padding:"10px"}}>
                <div style={{color:"#e2e8f0",fontSize:"11px",fontWeight:600,lineHeight:"1.3",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",marginBottom:"6px"}}>{video.title}</div>
                <div style={{color:"rgba(255,255,255,0.3)",fontSize:"9px",marginBottom:"6px"}}>{new Date(video.pubDate||video.publishedAt||video.created_at).toLocaleDateString("en-IN")}</div>
                <div style={{display:"flex",gap:"6px"}} onClick={e=>e.stopPropagation()}>
                  <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+video.title+"\n\nWatch: https://youtu.be/"+video.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer"}}>WhatsApp</button>
                  <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+video.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer"}}>Copy</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

    <div style={{padding:'16px',background:'rgba(255,255,255,0.02)',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
      <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',fontWeight:'700',letterSpacing:'2px',marginBottom:'12px'}}>SPONSORED PARTNERS</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'10px'}}>
        {[{name:'MakeMyTrip',url:'https://makemytrip.com',desc:'Flights hotels',color:'#e8202a',emoji:'✈️'},{name:'RedBus',url:'https://redbus.in',desc:'Bus tickets',color:'#d84315',emoji:'🚌'},{name:'IRCTC',url:'https://irctc.co.in',desc:'Train tickets',color:'#1a5fa8',emoji:'🚂'},{name:'Airbnb',url:'https://airbnb.co.in',desc:'Unique stays',color:'#ff5a5f',emoji:'🏠'}].map((a,i)=>(
          <div key={i} onClick={()=>window.open(a.url,'_blank')} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'12px',cursor:'pointer',borderTop:'2px solid '+a.color,textAlign:'center'}}>
            <div style={{fontSize:'22px',marginBottom:'4px'}}>{a.emoji}</div>
            <div style={{color:a.color,fontWeight:'800',fontSize:'12px',marginBottom:'3px'}}>{a.name}</div>
            <div style={{color:'rgba(255,255,255,0.35)',fontSize:'10px',marginBottom:'8px'}}>{a.desc}</div>
            <button style={{padding:'4px 10px',background:a.color,border:'none',borderRadius:'5px',color:'#fff',fontWeight:'700',cursor:'pointer',fontSize:'10px'}}>Open</button>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
}

function AutoPage({ onBack, t, onVideoSelect }) {
  const [ottVideosAuto, setOttVideosAuto] = React.useState([]);
  React.useEffect(()=>{
    fetch((process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com")+"/speeches?category=Auto")
      .then(r=>r.json()).then(d=>{if(d.speeches)setOttVideosAuto(d.speeches);})
      .catch(()=>{});
  },[]);
  const AUTO_CHANNELS = []

  const GENRES = ["All", "Tamil", "India", "International"];
  const [activeChannel, setActiveChannel] = React.useState("tamilcar");
  const [activeGenre, setActiveGenre] = React.useState("All");
  const [videos, setVideos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [watching, setWatching] = React.useState(null);
  const API_URL_A = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';

  React.useEffect(() => {
    setLoading(true);
    setVideos([]);
    const ch = AUTO_CHANNELS.find(c => c.id === activeChannel);
    if (!ch) return;
    fetch(API_URL_A+"/api/youtube-feeds?channel_id="+ch.channelId+"&max_results=20")
      .then(r=>r.json())
      .then(data=>{ if(data.items) setVideos(data.items); setLoading(false); })
      .catch(()=>setLoading(false));
  }, [activeChannel]);

  const filteredChannels = activeGenre === "All" ? AUTO_CHANNELS : AUTO_CHANNELS.filter(c => c.genre === activeGenre);
  const ch = AUTO_CHANNELS.find(c => c.id === activeChannel);

  return (
    <div style={{background:"linear-gradient(135deg,#0a0a00,#1a1000)",minHeight:"100vh",paddingBottom:"40px"}}>
      <BANNERS.Auto />
      {ottVideosAuto.length>0&&(
        <div style={{padding:'16px 4%',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
          <div style={{color:'#d4a843',fontWeight:900,fontSize:'14px',marginBottom:'12px'}}>Nethaji Prime Auto Videos</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
            {ottVideosAuto.map((v,i)=>(
              <VideoCard 
                key={v.id||i} 
                video={v} 
                isNew={false} 
                hasAccess={true}
                onClick={()=>{
                  if(v.video_url && !v.video_url.includes('youtube') && !v.video_url.includes('youtu.be')){
                    if(onVideoSelect) onVideoSelect(v);
                  } else {
                    window.open(v.video_url,'_blank');
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
      <div style={{background:"linear-gradient(90deg,#0a0a00,#1a1000)",padding:"clamp(8px,2vw,12px) 4%",display:"flex",alignItems:"center",gap:"16px",borderBottom:"2px solid #ff6600",position:"sticky",top:0,zIndex:100}}>
        <button onClick={onBack} style={{background:"transparent",border:"1px solid #ff6600",color:"#ff6600",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"13px",fontWeight:700}}>Back</button><button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("Watch Automobiles on Nethaji Prime OTT!\\n\\nhttps://nethajiprime.com/#auto"),"_blank")} style={{marginLeft:"8px",padding:"6px 12px",background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"11px",fontWeight:700,cursor:"pointer"}}>Share</button>
        <div>
          <div style={{color:"#ffaa00",fontWeight:900,fontSize:"clamp(14px,3vw,20px)",letterSpacing:"2px"}}>🚗 {t && t.cat_Auto ? t.cat_Auto.toUpperCase() : "AUTOMOBILES"}</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>Cars • Bikes • EV • Reviews • Tamil • International</div>
        </div>
        <div style={{marginLeft:"auto",background:"rgba(255,102,0,0.1)",border:"1px solid rgba(255,102,0,0.4)",borderRadius:"6px",padding:"4px 10px",color:"#ff6600",fontSize:"10px",fontWeight:900,letterSpacing:"2px"}}>NETHAJI PRIME OTT</div>
      </div>

      {watching && (
        <div style={{background:"#000"}}>
          <div style={{background:"#0a0a00",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(255,102,0,0.3)"}}>
            <div style={{color:"#ffaa00",fontWeight:900,fontSize:"13px"}}>{watching.title}</div>
            <button onClick={()=>setWatching(null)} style={{background:"rgba(204,0,0,0.2)",border:"1px solid #cc0000",color:"#ff4444",padding:"5px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>CLOSE</button>
          </div>
          <div style={{position:"relative",paddingTop:"56.25%",background:"#000"}}>
            <iframe key={watching.videoId} src={"https://www.youtube.com/embed/"+watching.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1"} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title={watching.title} />
            <div style={{position:"absolute",bottom:"12px",right:"12px",background:"rgba(0,0,0,0.6)",color:"#ffaa00",fontSize:"11px",fontWeight:900,padding:"4px 10px",borderRadius:"4px",letterSpacing:"2px",pointerEvents:"none",zIndex:10}}>NETHAJI PRIME OTT</div>
          </div>
          <div style={{padding:"12px 16px",background:"#0a0a00",borderTop:"1px solid rgba(255,102,0,0.2)",display:"flex",gap:"8px",flexWrap:"wrap"}}>
            <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+watching?.title+"\n\nWatch: https://youtu.be/"+watching?.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>📱 WhatsApp</button>
            <button onClick={()=>window.open("https://t.me/share/url?url="+encodeURIComponent("https://youtu.be/"+watching.videoId),"_blank")} style={{background:"#0088cc",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>✈️ Telegram</button>
            <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+watching.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.3)",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>🔗 Copy</button>
          </div>
        </div>
      )}

      <div style={{padding:"10px 4%",display:"flex",gap:"8px",overflowX:"auto",borderBottom:"1px solid rgba(255,102,0,0.2)"}}>
        {GENRES.map(g=>(
          <button key={g} onClick={()=>setActiveGenre(g)} style={{background:activeGenre===g?"#ff6600":"rgba(255,102,0,0.1)",border:"1px solid #ff6600",color:activeGenre===g?"#fff":"#ffaa00",padding:"5px 12px",borderRadius:"20px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0}}>{g}</button>
        ))}
      </div>

      <div style={{padding:"10px 4%",display:"flex",gap:"8px",overflowX:"auto",borderBottom:"1px solid rgba(255,102,0,0.1)"}}>
        {filteredChannels.map(c=>(
          <button key={c.id} onClick={()=>setActiveChannel(c.id)} style={{background:activeChannel===c.id?c.color:"rgba(255,255,255,0.05)",border:"1px solid "+c.color,color:activeChannel===c.id?"#fff":c.color,padding:"6px 14px",borderRadius:"6px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0,whiteSpace:"nowrap"}}>{c.icon} {c.name}</button>
        ))}
      </div>

      <div style={{padding:"12px 4%"}}>
        {loading && <div style={{textAlign:"center",color:"rgba(255,255,255,0.4)",padding:"40px"}}>Loading automobile content...</div>}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(clamp(160px,28vw,240px),1fr))",gap:"clamp(8px,2vw,16px)"}}>
          {videos.map((video,i)=>(
            <div key={i} onClick={()=>{setWatching(video);}} style={{background:"rgba(255,102,0,0.05)",border:"1px solid rgba(255,102,0,0.2)",borderRadius:"10px",overflow:"hidden",cursor:"pointer"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor="#ff6600"}
              onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(255,102,0,0.2)"}>
              <div style={{position:"relative",paddingTop:"56.25%"}}>
                <img src={video.thumbnail} alt={video.title} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover"}} onError={e=>e.target.style.display="none"} />
                <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <div style={{width:"40px",height:"40px",borderRadius:"50%",background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",color:"#ffaa00",fontSize:"16px"}}>&#9654;</div>
                </div>
                <div style={{position:"absolute",top:"8px",left:"8px",background:ch?.color||"#ff6600",color:"#fff",fontSize:"9px",fontWeight:900,padding:"2px 6px",borderRadius:"2px"}}>{ch?.genre||"AUTO"}</div>
                <div style={{position:"absolute",bottom:"6px",right:"6px",background:"rgba(0,0,0,0.6)",color:"#ffaa00",fontSize:"8px",fontWeight:900,padding:"2px 6px",borderRadius:"2px",letterSpacing:"1px"}}>NETHAJI PRIME</div>
              </div>
              <div style={{padding:"10px"}}>
                <div style={{color:"#e2e8f0",fontSize:"11px",fontWeight:600,lineHeight:"1.3",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",marginBottom:"6px"}}>{video.title}</div>
                <div style={{color:"rgba(255,255,255,0.3)",fontSize:"9px",marginBottom:"6px"}}>{new Date(video.pubDate||video.publishedAt||video.created_at).toLocaleDateString("en-IN")}</div>
                <div style={{display:"flex",gap:"6px"}} onClick={e=>e.stopPropagation()}>
                  <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+video.title+"\n\nWatch: https://youtu.be/"+video.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer"}}>WhatsApp</button>
                  <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+video.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer"}}>Copy</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

    <div style={{padding:'16px',background:'rgba(255,255,255,0.02)',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
      <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',fontWeight:'700',letterSpacing:'2px',marginBottom:'12px'}}>SPONSORED PARTNERS</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'10px'}}>
        {[{name:'PolicyBazaar',url:'https://policybazaar.com/motor-insurance',desc:'Car insurance',color:'#e8202a',emoji:'🚗'},{name:'Cars24',url:'https://cars24.com',desc:'Buy sell cars',color:'#ff6b00',emoji:'🚙'},{name:'GoMechanic',url:'https://gomechanic.in',desc:'Car service',color:'#00b4d8',emoji:'🔧'},{name:'FastTag',url:'https://ihmcl.com',desc:'FASTag',color:'#0057a8',emoji:'🛣️'}].map((a,i)=>(
          <div key={i} onClick={()=>window.open(a.url,'_blank')} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'12px',cursor:'pointer',borderTop:'2px solid '+a.color,textAlign:'center'}}>
            <div style={{fontSize:'22px',marginBottom:'4px'}}>{a.emoji}</div>
            <div style={{color:a.color,fontWeight:'800',fontSize:'12px',marginBottom:'3px'}}>{a.name}</div>
            <div style={{color:'rgba(255,255,255,0.35)',fontSize:'10px',marginBottom:'8px'}}>{a.desc}</div>
            <button style={{padding:'4px 10px',background:a.color,border:'none',borderRadius:'5px',color:'#fff',fontWeight:'700',cursor:'pointer',fontSize:'10px'}}>Open</button>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
}

function EducationPage({ onBack, t, onVideoSelect }) {
  const [ottVideosEducation, setOttVideosEducation] = React.useState([]);
  React.useEffect(()=>{
    fetch((process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com")+"/speeches?category=Education")
      .then(r=>r.json()).then(d=>{if(d.speeches)setOttVideosEducation(d.speeches);})
      .catch(()=>{});
  },[]);
  const EDU_CHANNELS = []

  const GENRES = ["All", "Tamil", "Kids", "Adults"];
  const [activeChannel, setActiveChannel] = React.useState("kalvitv");
  const [activeGenre, setActiveGenre] = React.useState("All");
  const [videos, setVideos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [watching, setWatching] = React.useState(null);
  const API_URL_E = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';

  React.useEffect(() => {
    setLoading(true);
    setVideos([]);
    const ch = EDU_CHANNELS.find(c => c.id === activeChannel);
    if (!ch) return;
    fetch(API_URL_E+"/api/youtube-feeds?channel_id="+ch.channelId+"&max_results=20")
      .then(r=>r.json())
      .then(data=>{ if(data.items) setVideos(data.items); setLoading(false); })
      .catch(()=>setLoading(false));
  }, [activeChannel]);

  const filteredChannels = activeGenre === "All" ? EDU_CHANNELS : EDU_CHANNELS.filter(c => c.genre === activeGenre);
  const ch = EDU_CHANNELS.find(c => c.id === activeChannel);

  return (
    <div style={{background:"linear-gradient(135deg,#000a1a,#001030)",minHeight:"100vh",paddingBottom:"40px"}}>
      <BANNERS.Education />
      {ottVideosEducation.length>0&&(
        <div style={{padding:'16px 4%',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
          <div style={{color:'#d4a843',fontWeight:900,fontSize:'14px',marginBottom:'12px'}}>Nethaji Prime Education Videos</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
            {ottVideosEducation.map((v,i)=>(
              <VideoCard 
                key={v.id||i} 
                video={v} 
                isNew={false} 
                hasAccess={true}
                onClick={()=>{
                  if(v.video_url && !v.video_url.includes('youtube') && !v.video_url.includes('youtu.be')){
                    if(onVideoSelect) onVideoSelect(v);
                  } else {
                    window.open(v.video_url,'_blank');
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
      <div style={{background:"linear-gradient(90deg,#000a1a,#001030)",padding:"clamp(8px,2vw,12px) 4%",display:"flex",alignItems:"center",gap:"16px",borderBottom:"2px solid #0066cc",position:"sticky",top:0,zIndex:100}}>
        <button onClick={onBack} style={{background:"transparent",border:"1px solid #0066cc",color:"#0066cc",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"13px",fontWeight:700}}>Back</button><button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("Watch Education on Nethaji Prime OTT!\\n\\nhttps://nethajiprime.com/#education"),"_blank")} style={{marginLeft:"8px",padding:"6px 12px",background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"11px",fontWeight:700,cursor:"pointer"}}>Share</button>
        <div>
          <div style={{color:"#4499ff",fontWeight:900,fontSize:"clamp(14px,3vw,20px)",letterSpacing:"2px"}}>📚 {t && t.cat_Education ? t.cat_Education.toUpperCase() : "EDUCATION"}</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>Tamil • Kids • Adults • Science • Nature</div>
        </div>
        <div style={{marginLeft:"auto",background:"rgba(0,102,204,0.1)",border:"1px solid rgba(0,102,204,0.4)",borderRadius:"6px",padding:"4px 10px",color:"#4499ff",fontSize:"10px",fontWeight:900,letterSpacing:"2px"}}>NETHAJI PRIME OTT</div>
      </div>

      {watching && (
        <div style={{background:"#000"}}>
          <div style={{background:"#000a1a",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(0,102,204,0.3)"}}>
            <div style={{color:"#4499ff",fontWeight:900,fontSize:"13px"}}>{watching.title}</div>
            <button onClick={()=>setWatching(null)} style={{background:"rgba(204,0,0,0.2)",border:"1px solid #cc0000",color:"#ff4444",padding:"5px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>CLOSE</button>
          </div>
          <div style={{position:"relative",paddingTop:"56.25%",background:"#000"}}>
            <iframe key={watching.videoId} src={"https://www.youtube.com/embed/"+watching.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1"} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title={watching.title} />
            <div style={{position:"absolute",bottom:"12px",right:"12px",background:"rgba(0,0,0,0.6)",color:"#4499ff",fontSize:"11px",fontWeight:900,padding:"4px 10px",borderRadius:"4px",letterSpacing:"2px",pointerEvents:"none",zIndex:10}}>NETHAJI PRIME OTT</div>
          </div>
          <div style={{padding:"12px 16px",background:"#000a1a",borderTop:"1px solid rgba(0,102,204,0.2)",display:"flex",gap:"8px",flexWrap:"wrap"}}>
            <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+watching?.title+"\n\nWatch: https://youtu.be/"+watching?.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>📱 WhatsApp</button>
            <button onClick={()=>window.open("https://t.me/share/url?url="+encodeURIComponent("https://youtu.be/"+watching.videoId),"_blank")} style={{background:"#0088cc",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>✈️ Telegram</button>
            <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+watching.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.3)",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>🔗 Copy</button>
          </div>
        </div>
      )}

      <div style={{padding:"10px 4%",display:"flex",gap:"8px",overflowX:"auto",borderBottom:"1px solid rgba(0,102,204,0.2)"}}>
        {GENRES.map(g=>(
          <button key={g} onClick={()=>setActiveGenre(g)} style={{background:activeGenre===g?"#0066cc":"rgba(0,102,204,0.1)",border:"1px solid #0066cc",color:activeGenre===g?"#fff":"#4499ff",padding:"5px 12px",borderRadius:"20px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0}}>{g}</button>
        ))}
      </div>

      <div style={{padding:"10px 4%",display:"flex",gap:"8px",overflowX:"auto",borderBottom:"1px solid rgba(0,102,204,0.1)"}}>
        {filteredChannels.map(c=>(
          <button key={c.id} onClick={()=>setActiveChannel(c.id)} style={{background:activeChannel===c.id?c.color:"rgba(255,255,255,0.05)",border:"1px solid "+c.color,color:activeChannel===c.id?"#fff":c.color,padding:"6px 14px",borderRadius:"6px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0,whiteSpace:"nowrap"}}>{c.icon} {c.name}</button>
        ))}
      </div>

      <div style={{padding:"12px 4%"}}>
        {loading && <div style={{textAlign:"center",color:"rgba(255,255,255,0.4)",padding:"40px"}}>No content available.</div>}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(clamp(160px,28vw,240px),1fr))",gap:"clamp(8px,2vw,16px)"}}>
          {videos.map((video,i)=>(
            <div key={i} onClick={()=>{setWatching(video);}} style={{background:"rgba(0,102,204,0.05)",border:"1px solid rgba(0,102,204,0.2)",borderRadius:"10px",overflow:"hidden",cursor:"pointer"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor="#0066cc"}
              onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(0,102,204,0.2)"}>
              <div style={{position:"relative",paddingTop:"56.25%"}}>
                <img src={video.thumbnail} alt={video.title} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover"}} onError={e=>e.target.style.display="none"} />
                <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <div style={{width:"40px",height:"40px",borderRadius:"50%",background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",color:"#4499ff",fontSize:"16px"}}>&#9654;</div>
                </div>
                <div style={{position:"absolute",top:"8px",left:"8px",background:ch?.color||"#0066cc",color:"#fff",fontSize:"9px",fontWeight:900,padding:"2px 6px",borderRadius:"2px"}}>{ch?.genre||"EDUCATION"}</div>
                <div style={{position:"absolute",bottom:"6px",right:"6px",background:"rgba(0,0,0,0.6)",color:"#4499ff",fontSize:"8px",fontWeight:900,padding:"2px 6px",borderRadius:"2px",letterSpacing:"1px"}}>NETHAJI PRIME</div>
              </div>
              <div style={{padding:"10px"}}>
                <div style={{color:"#e2e8f0",fontSize:"11px",fontWeight:600,lineHeight:"1.3",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",marginBottom:"6px"}}>{video.title}</div>
                <div style={{color:"rgba(255,255,255,0.3)",fontSize:"9px",marginBottom:"6px"}}>{new Date(video.pubDate||video.publishedAt||video.created_at).toLocaleDateString("en-IN")}</div>
                <div style={{display:"flex",gap:"6px"}} onClick={e=>e.stopPropagation()}>
                  <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+video.title+"\n\nWatch: https://youtu.be/"+video.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer"}}>WhatsApp</button>
                  <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+video.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer"}}>Copy</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

    <div style={{padding:'16px',background:'rgba(255,255,255,0.02)',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
      <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',fontWeight:'700',letterSpacing:'2px',marginBottom:'12px'}}>SPONSORED PARTNERS</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'10px'}}>
        {[{name:'BYJUS',url:'https://byjus.com',desc:'Learning app',color:'#7c4dff',emoji:'📚'},{name:'Vedantu',url:'https://vedantu.com',desc:'Live tuitions',color:'#3f8cff',emoji:'👨‍🏫'},{name:'Unacademy',url:'https://unacademy.com',desc:'TNPSC exams',color:'#08bd80',emoji:'🎯'},{name:'Coursera',url:'https://coursera.org',desc:'Certificates',color:'#0056d2',emoji:'🏆'}].map((a,i)=>(
          <div key={i} onClick={()=>window.open(a.url,'_blank')} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'12px',cursor:'pointer',borderTop:'2px solid '+a.color,textAlign:'center'}}>
            <div style={{fontSize:'22px',marginBottom:'4px'}}>{a.emoji}</div>
            <div style={{color:a.color,fontWeight:'800',fontSize:'12px',marginBottom:'3px'}}>{a.name}</div>
            <div style={{color:'rgba(255,255,255,0.35)',fontSize:'10px',marginBottom:'8px'}}>{a.desc}</div>
            <button style={{padding:'4px 10px',background:a.color,border:'none',borderRadius:'5px',color:'#fff',fontWeight:'700',cursor:'pointer',fontSize:'10px'}}>Open</button>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
}

function KitchenPage({ onBack, t, onVideoSelect }) {
  const [ottVideosKitchen, setOttVideosKitchen] = React.useState([]);
  React.useEffect(()=>{
    fetch((process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com")+"/speeches?category=Kitchen")
      .then(r=>r.json()).then(d=>{if(d.speeches)setOttVideosKitchen(d.speeches);})
      .catch(()=>{});
  },[]);
  const KITCHEN_CHANNELS = []

  const GENRES = ["All", "Tamil", "Indian", "Asian", "International"];
  const [activeChannel, setActiveChannel] = React.useState("samayalsarayal");
  const [activeGenre, setActiveGenre] = React.useState("All");
  const [videos, setVideos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [watching, setWatching] = React.useState(null);
  const API_URL_K = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';

  React.useEffect(() => {
    setLoading(true);
    setVideos([]);
    const ch = KITCHEN_CHANNELS.find(c => c.id === activeChannel);
    if (!ch) return;
    fetch(API_URL_K+"/api/youtube-feeds?channel_id="+ch.channelId+"&max_results=20")
      .then(r=>r.json())
      .then(data=>{ if(data.items) setVideos(data.items); setLoading(false); })
      .catch(()=>setLoading(false));
  }, [activeChannel]);

  const filteredChannels = activeGenre === "All" ? KITCHEN_CHANNELS : KITCHEN_CHANNELS.filter(c => c.genre === activeGenre);
  const ch = KITCHEN_CHANNELS.find(c => c.id === activeChannel);

  return (
    <div style={{background:"linear-gradient(135deg,#1a0a00,#2d1500)",minHeight:"100vh",paddingBottom:"40px"}}>
      <BANNERS.Kitchen />
      {ottVideosKitchen.length>0&&(
        <div style={{padding:'16px 4%',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
          <div style={{color:'#d4a843',fontWeight:900,fontSize:'14px',marginBottom:'12px'}}>Nethaji Prime Kitchen Videos</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
            {ottVideosKitchen.map((v,i)=>(
              <VideoCard 
                key={v.id||i} 
                video={v} 
                isNew={false} 
                hasAccess={true}
                onClick={()=>{
                  if(v.video_url && !v.video_url.includes('youtube') && !v.video_url.includes('youtu.be')){
                    if(onVideoSelect) onVideoSelect(v);
                  } else {
                    window.open(v.video_url,'_blank');
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
      <div style={{background:"linear-gradient(90deg,#1a0a00,#2d1500)",padding:"clamp(8px,2vw,12px) 4%",display:"flex",alignItems:"center",gap:"16px",borderBottom:"2px solid #ff6600",position:"sticky",top:0,zIndex:100}}>
        <button onClick={onBack} style={{background:"transparent",border:"1px solid #ff6600",color:"#ff6600",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"13px",fontWeight:700}}>Back</button><button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("Watch: "+watching.title+"\n\nhttps://youtu.be/"+watching.videoId+"\n\nWatch on Nethaji Prime: https://nethajiprime.com/#kitchen"),"_blank")} style={{marginLeft:"8px",padding:"6px 12px",background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"11px",fontWeight:700,cursor:"pointer"}}>Share</button>
        <div>
          <div style={{color:"#ff9900",fontWeight:900,fontSize:"clamp(14px,3vw,20px)",letterSpacing:"2px"}}>🍳 {t && t.cat_Kitchen ? t.cat_Kitchen.toUpperCase() : "KITCHEN"}</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>Tamil • Indian • Asian • International Cuisine</div>
        </div>
        <div style={{marginLeft:"auto",background:"rgba(255,102,0,0.1)",border:"1px solid rgba(255,102,0,0.4)",borderRadius:"6px",padding:"4px 10px",color:"#ff6600",fontSize:"10px",fontWeight:900,letterSpacing:"2px"}}>NETHAJI PRIME OTT</div>
      </div>

      {watching && (
        <div style={{background:"#000"}}>
          <div style={{background:"#1a0a00",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(255,102,0,0.3)"}}>
            <div style={{color:"#ff9900",fontWeight:900,fontSize:"13px"}}>{watching.title}</div>
            <button onClick={()=>setWatching(null)} style={{background:"rgba(204,0,0,0.2)",border:"1px solid #cc0000",color:"#ff4444",padding:"5px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>CLOSE</button>
          </div>
          <div style={{position:"relative",paddingTop:"56.25%",background:"#000"}}>
            <iframe key={watching.videoId} src={"https://www.youtube.com/embed/"+watching.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1"} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title={watching.title} />
            <div style={{position:"absolute",bottom:"12px",right:"12px",background:"rgba(0,0,0,0.6)",color:"#ff9900",fontSize:"11px",fontWeight:900,padding:"4px 10px",borderRadius:"4px",letterSpacing:"2px",pointerEvents:"none",zIndex:10}}>NETHAJI PRIME OTT</div>
          </div>
          <div style={{padding:"12px 16px",background:"#1a0a00",borderTop:"1px solid rgba(255,102,0,0.2)",display:"flex",gap:"8px",flexWrap:"wrap"}}>
            <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+watching?.title+"\n\nWatch: https://youtu.be/"+watching?.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>📱 WhatsApp</button>
            <button onClick={()=>window.open("https://t.me/share/url?url="+encodeURIComponent("https://youtu.be/"+watching.videoId),"_blank")} style={{background:"#0088cc",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>✈️ Telegram</button>
            <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+watching.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.3)",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>🔗 Copy</button>
          </div>
        </div>
      )}

      <div style={{padding:"10px 4%",display:"flex",gap:"8px",overflowX:"auto",borderBottom:"1px solid rgba(255,102,0,0.2)"}}>
        {GENRES.map(g=>(
          <button key={g} onClick={()=>setActiveGenre(g)} style={{background:activeGenre===g?"#ff6600":"rgba(255,102,0,0.1)",border:"1px solid #ff6600",color:activeGenre===g?"#fff":"#ff9900",padding:"5px 12px",borderRadius:"20px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0}}>{g}</button>
        ))}
      </div>

      <div style={{padding:"10px 4%",display:"flex",gap:"8px",overflowX:"auto",borderBottom:"1px solid rgba(255,102,0,0.1)"}}>
        {filteredChannels.map(c=>(
          <button key={c.id} onClick={()=>setActiveChannel(c.id)} style={{background:activeChannel===c.id?c.color:"rgba(255,255,255,0.05)",border:"1px solid "+c.color,color:activeChannel===c.id?"#fff":c.color,padding:"6px 14px",borderRadius:"6px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0,whiteSpace:"nowrap"}}>{c.icon} {c.name}</button>
        ))}
      </div>

      <div style={{padding:"12px 4%"}}>
        {loading && <div style={{textAlign:"center",color:"rgba(255,255,255,0.4)",padding:"40px"}}>Loading recipes...</div>}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(clamp(160px,28vw,240px),1fr))",gap:"clamp(8px,2vw,16px)"}}>
          {videos.map((video,i)=>(
            <div key={i} onClick={()=>{setWatching(video);}} style={{background:"rgba(255,102,0,0.05)",border:"1px solid rgba(255,102,0,0.2)",borderRadius:"10px",overflow:"hidden",cursor:"pointer"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor="#ff6600"}
              onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(255,102,0,0.2)"}>
              <div style={{position:"relative",paddingTop:"56.25%"}}>
                <img src={video.thumbnail} alt={video.title} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover"}} onError={e=>e.target.style.display="none"} />
                <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <div style={{width:"40px",height:"40px",borderRadius:"50%",background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",color:"#ff9900",fontSize:"16px"}}>&#9654;</div>
                </div>
                <div style={{position:"absolute",top:"8px",left:"8px",background:ch?.color||"#ff6600",color:"#fff",fontSize:"9px",fontWeight:900,padding:"2px 6px",borderRadius:"2px"}}>{ch?.genre||"KITCHEN"}</div>
                <div style={{position:"absolute",bottom:"6px",right:"6px",background:"rgba(0,0,0,0.6)",color:"#ff9900",fontSize:"8px",fontWeight:900,padding:"2px 6px",borderRadius:"2px",letterSpacing:"1px"}}>NETHAJI PRIME</div>
              </div>
              <div style={{padding:"10px"}}>
                <div style={{color:"#e2e8f0",fontSize:"11px",fontWeight:600,lineHeight:"1.3",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",marginBottom:"6px"}}>{video.title}</div>
                <div style={{color:"rgba(255,255,255,0.3)",fontSize:"9px",marginBottom:"6px"}}>{new Date(video.pubDate||video.publishedAt||video.created_at).toLocaleDateString("en-IN")}</div>
                <div style={{display:"flex",gap:"6px"}} onClick={e=>e.stopPropagation()}>
                  <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+video.title+"\n\nWatch: https://youtu.be/"+video.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer"}}>WhatsApp</button>
                  <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+video.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer"}}>Copy</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

    <div style={{padding:'16px',background:'rgba(255,255,255,0.02)',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
      <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',fontWeight:'700',letterSpacing:'2px',marginBottom:'12px'}}>SPONSORED PARTNERS</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'10px'}}>
        {[{name:'BigBasket',url:'https://bigbasket.com',desc:'Groceries',color:'#84c225',emoji:'🛒'},{name:'Swiggy',url:'https://swiggy.com',desc:'Food delivery',color:'#fc8019',emoji:'🍔'},{name:'Amazon Kitchen',url:'https://www.amazon.in/s?k=kitchen+appliances&tag=nethajiprimei-21',desc:'Appliances',color:'#ff9900',emoji:'🍳'},{name:'Prestige',url:'https://prestigesmartchef.com',desc:'Gadgets',color:'#cc0000',emoji:'🥘'}].map((a,i)=>(
          <div key={i} onClick={()=>window.open(a.url,'_blank')} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'12px',cursor:'pointer',borderTop:'2px solid '+a.color,textAlign:'center'}}>
            <div style={{fontSize:'22px',marginBottom:'4px'}}>{a.emoji}</div>
            <div style={{color:a.color,fontWeight:'800',fontSize:'12px',marginBottom:'3px'}}>{a.name}</div>
            <div style={{color:'rgba(255,255,255,0.35)',fontSize:'10px',marginBottom:'8px'}}>{a.desc}</div>
            <button style={{padding:'4px 10px',background:a.color,border:'none',borderRadius:'5px',color:'#fff',fontWeight:'700',cursor:'pointer',fontSize:'10px'}}>Open</button>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
}

function HealthPage({ onBack, t, onVideoSelect }) {
  const [ottVideosHealth, setOttVideosHealth] = React.useState([]);
  React.useEffect(()=>{
    fetch((process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com")+"/speeches?category=Health")
      .then(r=>r.json()).then(d=>{if(d.speeches)setOttVideosHealth(d.speeches);})
      .catch(()=>{});
  },[]);
  const HEALTH_CHANNELS = []

  const GENRES = ["All", "Tamil", "Yoga", "Fitness", "Wellness"];
  const [activeChannel, setActiveChannel] = React.useState("healthtamil");
  const [activeGenre, setActiveGenre] = React.useState("All");
  const [videos, setVideos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [watching, setWatching] = React.useState(null);
  const API_URL_H = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';

  React.useEffect(() => {
    setLoading(true);
    setVideos([]);
    const ch = HEALTH_CHANNELS.find(c => c.id === activeChannel);
    if (!ch) return;
    fetch(API_URL_H+"/api/youtube-feeds?channel_id="+ch.channelId+"&max_results=20")
      .then(r=>r.json())
      .then(data=>{ if(data.items) setVideos(data.items); setLoading(false); })
      .catch(()=>setLoading(false));
  }, [activeChannel]);

  const filteredChannels = activeGenre === "All" ? HEALTH_CHANNELS : HEALTH_CHANNELS.filter(c => c.genre === activeGenre);
  const ch = HEALTH_CHANNELS.find(c => c.id === activeChannel);

  return (
    <div style={{background:"linear-gradient(135deg,#001a00,#003310)",minHeight:"100vh",paddingBottom:"40px"}}>
      <BANNERS.Health />
      {ottVideosHealth.length>0&&(
        <div style={{padding:'16px 4%',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
          <div style={{color:'#d4a843',fontWeight:900,fontSize:'14px',marginBottom:'12px'}}>Nethaji Prime Health Videos</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
            {ottVideosHealth.map((v,i)=>(
              <VideoCard 
                key={v.id||i} 
                video={v} 
                isNew={false} 
                hasAccess={true}
                onClick={()=>{
                  if(v.video_url && !v.video_url.includes('youtube') && !v.video_url.includes('youtu.be')){
                    if(onVideoSelect) onVideoSelect(v);
                  } else {
                    window.open(v.video_url,'_blank');
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
      <div style={{background:"linear-gradient(90deg,#001a00,#003310)",padding:"clamp(8px,2vw,12px) 4%",display:"flex",alignItems:"center",gap:"16px",borderBottom:"2px solid #00aa44",position:"sticky",top:0,zIndex:100}}>
        <button onClick={onBack} style={{background:"transparent",border:"1px solid #00aa44",color:"#00aa44",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"13px",fontWeight:700}}>Back</button><button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("Watch Health on Nethaji Prime OTT!\\n\\nhttps://nethajiprime.com/#health"),"_blank")} style={{marginLeft:"8px",padding:"6px 12px",background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"11px",fontWeight:700,cursor:"pointer"}}>Share</button>
        <div>
          <div style={{color:"#00cc66",fontWeight:900,fontSize:"clamp(14px,3vw,20px)",letterSpacing:"2px"}}>💪 {t && t.cat_Health ? t.cat_Health.toUpperCase() : "HEALTH & FITNESS"}</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>Yoga • Fitness • Wellness • Tamil Health</div>
        </div>
        <div style={{marginLeft:"auto",background:"rgba(0,170,68,0.1)",border:"1px solid rgba(0,170,68,0.4)",borderRadius:"6px",padding:"4px 10px",color:"#00aa44",fontSize:"10px",fontWeight:900,letterSpacing:"2px"}}>NETHAJI PRIME OTT</div>
      </div>

      {watching && (
        <div style={{background:"#000"}}>
          <div style={{background:"#001a00",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(0,170,68,0.3)"}}>
            <div style={{color:"#00cc66",fontWeight:900,fontSize:"13px"}}>{watching.title}</div>
            <button onClick={()=>setWatching(null)} style={{background:"rgba(204,0,0,0.2)",border:"1px solid #cc0000",color:"#ff4444",padding:"5px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>CLOSE</button>
          </div>
          <div style={{position:"relative",paddingTop:"56.25%",background:"#000"}}>
            <iframe key={watching.videoId} src={"https://www.youtube.com/embed/"+watching.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1"} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title={watching.title} />
            <div style={{position:"absolute",bottom:"12px",right:"12px",background:"rgba(0,0,0,0.6)",color:"#00cc66",fontSize:"11px",fontWeight:900,padding:"4px 10px",borderRadius:"4px",letterSpacing:"2px",pointerEvents:"none",zIndex:10}}>NETHAJI PRIME OTT</div>
          </div>
          <div style={{padding:"12px 16px",background:"#001a00",borderTop:"1px solid rgba(0,170,68,0.2)",display:"flex",gap:"8px",flexWrap:"wrap"}}>
            <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+watching?.title+"\n\nWatch: https://youtu.be/"+watching?.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>📱 WhatsApp</button>
            <button onClick={()=>window.open("https://t.me/share/url?url="+encodeURIComponent("https://youtu.be/"+watching.videoId),"_blank")} style={{background:"#0088cc",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>✈️ Telegram</button>
            <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+watching.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.3)",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>🔗 Copy</button>
          </div>
        </div>
      )}

      <div style={{padding:"10px 4%",display:"flex",gap:"8px",overflowX:"auto",borderBottom:"1px solid rgba(0,170,68,0.2)"}}>
        {GENRES.map(g=>(
          <button key={g} onClick={()=>setActiveGenre(g)} style={{background:activeGenre===g?"#00aa44":"rgba(0,170,68,0.1)",border:"1px solid #00aa44",color:activeGenre===g?"#fff":"#00cc66",padding:"5px 12px",borderRadius:"20px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0}}>{g}</button>
        ))}
      </div>

      <div style={{padding:"10px 4%",display:"flex",gap:"8px",overflowX:"auto",borderBottom:"1px solid rgba(0,170,68,0.1)"}}>
        {filteredChannels.map(c=>(
          <button key={c.id} onClick={()=>setActiveChannel(c.id)} style={{background:activeChannel===c.id?c.color:"rgba(255,255,255,0.05)",border:"1px solid "+c.color,color:activeChannel===c.id?"#fff":c.color,padding:"6px 14px",borderRadius:"6px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0,whiteSpace:"nowrap"}}>{c.icon} {c.name}</button>
        ))}
      </div>

      <div style={{padding:"12px 4%"}}>
        {loading && <div style={{textAlign:"center",color:"rgba(255,255,255,0.4)",padding:"40px"}}>No content available.</div>}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(clamp(160px,28vw,240px),1fr))",gap:"clamp(8px,2vw,16px)"}}>
          {videos.map((video,i)=>(
            <div key={i} onClick={()=>{setWatching(video);}} style={{background:"rgba(0,170,68,0.05)",border:"1px solid rgba(0,170,68,0.2)",borderRadius:"10px",overflow:"hidden",cursor:"pointer"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor="#00aa44"}
              onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(0,170,68,0.2)"}>
              <div style={{position:"relative",paddingTop:"56.25%"}}>
                <img src={video.thumbnail} alt={video.title} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover"}} onError={e=>e.target.style.display="none"} />
                <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <div style={{width:"40px",height:"40px",borderRadius:"50%",background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",color:"#00cc66",fontSize:"16px"}}>&#9654;</div>
                </div>
                <div style={{position:"absolute",top:"8px",left:"8px",background:ch?.color||"#00aa44",color:"#fff",fontSize:"9px",fontWeight:900,padding:"2px 6px",borderRadius:"2px"}}>{ch?.genre||"HEALTH"}</div>
                <div style={{position:"absolute",bottom:"6px",right:"6px",background:"rgba(0,0,0,0.6)",color:"#00cc66",fontSize:"8px",fontWeight:900,padding:"2px 6px",borderRadius:"2px",letterSpacing:"1px"}}>NETHAJI PRIME</div>
              </div>
              <div style={{padding:"10px"}}>
                <div style={{color:"#e2e8f0",fontSize:"11px",fontWeight:600,lineHeight:"1.3",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",marginBottom:"6px"}}>{video.title}</div>
                <div style={{color:"rgba(255,255,255,0.3)",fontSize:"9px",marginBottom:"6px"}}>{new Date(video.pubDate||video.publishedAt||video.created_at).toLocaleDateString("en-IN")}</div>
                <div style={{display:"flex",gap:"6px"}} onClick={e=>e.stopPropagation()}>
                  <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+video.title+"\n\nWatch: https://youtu.be/"+video.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer"}}>WhatsApp</button>
                  <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+video.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer"}}>Copy</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

    <div style={{padding:'16px',background:'rgba(255,255,255,0.02)',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
      <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',fontWeight:'700',letterSpacing:'2px',marginBottom:'12px'}}>SPONSORED PARTNERS</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'10px'}}>
        {[{name:'PolicyBazaar',url:'https://policybazaar.com',desc:'Health insurance',color:'#e8202a',emoji:'🏥'},{name:'PharmEasy',url:'https://pharmeasy.in',desc:'Medicine delivery',color:'#00b5ad',emoji:'💊'},{name:'HealthKart',url:'https://healthkart.com',desc:'Supplements',color:'#ff6b00',emoji:'💪'},{name:'1mg',url:'https://1mg.com',desc:'Online pharmacy',color:'#e53935',emoji:'🩺'}].map((a,i)=>(
          <div key={i} onClick={()=>window.open(a.url,'_blank')} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'12px',cursor:'pointer',borderTop:'2px solid '+a.color,textAlign:'center'}}>
            <div style={{fontSize:'22px',marginBottom:'4px'}}>{a.emoji}</div>
            <div style={{color:a.color,fontWeight:'800',fontSize:'12px',marginBottom:'3px'}}>{a.name}</div>
            <div style={{color:'rgba(255,255,255,0.35)',fontSize:'10px',marginBottom:'8px'}}>{a.desc}</div>
            <button style={{padding:'4px 10px',background:a.color,border:'none',borderRadius:'5px',color:'#fff',fontWeight:'700',cursor:'pointer',fontSize:'10px'}}>Open</button>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
}

function SportsPage({ onBack, t, onVideoSelect }) {
  const [ottVideosSports, setOttVideosSports] = React.useState([]);
  React.useEffect(()=>{
    fetch((process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com")+"/speeches?category=Sports")
      .then(r=>r.json()).then(d=>{if(d.speeches)setOttVideosSports(d.speeches);})
      .catch(()=>{});
  },[]);
  const SPORTS_CHANNELS = [
    {id:"cricbuzz",name:"Cricbuzz",channelId:"UCSRQXk5yErn4e14vN76upOw",color:"#0066cc",icon:"🏏",sport:"Cricket"}
  ]

  const [activeChannel, setActiveChannel] = React.useState("starsports");
  const [activeSport, setActiveSport] = React.useState("All");
  const [videos, setVideos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [watching, setWatching] = React.useState(null);

  const SPORTS = ["All", "Cricket"];
  const API_URL_SPORTS = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';

  React.useEffect(() => {
    setLoading(true);
    setVideos([]);
    const ch = SPORTS_CHANNELS.find(c => c.id === activeChannel);
    if (!ch) return;
    fetch(API_URL_SPORTS+"/api/youtube-feeds?channel_id="+ch.channelId+"&max_results=50")
      .then(r=>r.json())
      .then(data=>{ if(data.items) setVideos(data.items); setLoading(false); })
      .catch(()=>setLoading(false));
  }, [activeChannel]);

  const filteredChannels = activeSport === "All" ? SPORTS_CHANNELS : SPORTS_CHANNELS.filter(c => c.sport === activeSport);
  const ch = SPORTS_CHANNELS.find(c => c.id === activeChannel);

  return (
    <div style={{background:"linear-gradient(135deg,#000510,#001030)",minHeight:"100vh",paddingBottom:"40px"}}>
      <BANNERS.Sports />
      {ottVideosSports.length>0&&(
        <div style={{padding:'16px 4%',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
          <div style={{color:'#d4a843',fontWeight:900,fontSize:'14px',marginBottom:'12px'}}>Nethaji Prime Sports Videos</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
            {ottVideosSports.map((v,i)=>(
              <VideoCard 
                key={v.id||i} 
                video={v} 
                isNew={false} 
                hasAccess={true}
                onClick={()=>{
                  if(v.video_url && !v.video_url.includes('youtube') && !v.video_url.includes('youtu.be')){
                    if(onVideoSelect) onVideoSelect(v);
                  } else {
                    window.open(v.video_url,'_blank');
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
      {/* Header */}
      <div style={{background:"linear-gradient(90deg,#000510,#001030)",padding:"12px 4%",display:"flex",alignItems:"center",gap:"16px",borderBottom:"2px solid #0066cc",position:"sticky",top:0,zIndex:100}}>
        <button onClick={onBack} style={{background:"transparent",border:"1px solid #0066cc",color:"#0066cc",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"13px",fontWeight:700}}>Back</button><button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("Watch Sports on Nethaji Prime OTT!\\n\\nhttps://nethajiprime.com/#sports"),"_blank")} style={{marginLeft:"8px",padding:"6px 12px",background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"11px",fontWeight:700,cursor:"pointer"}}>Share</button>
        <div>
          <div style={{color:"#0099ff",fontWeight:900,fontSize:"clamp(14px,3vw,20px)",letterSpacing:"2px"}}>&#127942; {t && t.cat_Sports ? t.cat_Sports.toUpperCase() : "SPORTS"}</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>Cricket • Football • Kabaddi • More</div>
        <div style={{marginLeft:"auto",background:"rgba(212,168,67,0.1)",border:"1px solid rgba(212,168,67,0.4)",borderRadius:"6px",padding:"4px 10px",color:"#d4a843",fontSize:"10px",fontWeight:900,letterSpacing:"2px"}}>NETHAJI PRIME OTT</div>
        </div>
      </div>

      {/* Video Player */}
      {watching && (
        <div style={{background:"#000"}}>
          <div style={{background:"#000510",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(0,102,204,0.3)"}}>
            <div>
              <div style={{color:"#0099ff",fontWeight:900,fontSize:"13px"}}>{watching.title}</div>
            </div>
            <button onClick={()=>setWatching(null)} style={{background:"rgba(204,0,0,0.2)",border:"1px solid #cc0000",color:"#ff4444",padding:"5px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>CLOSE</button>
          </div>
          <div style={{position:"relative",paddingTop:"56.25%",background:"#000"}}>
            <iframe key={watching.videoId} src={"https://www.youtube.com/embed/"+watching.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1"} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title={watching.title} />
            <div style={{position:"absolute",bottom:"12px",right:"12px",background:"rgba(0,0,0,0.6)",color:"#d4a843",fontSize:"11px",fontWeight:900,padding:"4px 10px",borderRadius:"4px",letterSpacing:"2px",pointerEvents:"none",zIndex:10}}>NETHAJI PRIME OTT</div>
          </div>
            <div style={{padding:"12px",background:"rgba(0,0,0,0.4)",borderTop:"1px solid rgba(212,168,67,0.15)"}}>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"8px",marginBottom:"10px"}}>
                {[
                  {label:"Views",value:(watching?.viewCount||watching?.view_count||"N/A"),icon:"👁️",color:"#0066cc"},
                  {label:"Likes",value:(watching?.likeCount||watching?.like_count||"N/A"),icon:"👍",color:"#00aa44"},
                  {label:"Published",value:watching?.pubDate?new Date(watching.pubDate||watching.publishedAt||watching.created_at).toLocaleDateString("en-IN"):"N/A",icon:"📅",color:"#d4a843"},
                ].map(stat=>(
                  <div key={stat.label} style={{background:"rgba(255,255,255,0.05)",borderRadius:"8px",padding:"8px",textAlign:"center"}}>
                    <div style={{fontSize:"16px"}}>{stat.icon}</div>
                    <div style={{color:stat.color,fontWeight:900,fontSize:"13px"}}>{stat.value}</div>
                    <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>{stat.label}</div>
                  </div>
                ))}
              </div>
              <div style={{display:"flex",gap:"8px"}}>
                <button onClick={()=>{const k="yt_like_"+watching?.videoId;if(!localStorage.getItem(k)){localStorage.setItem(k,"1");alert("Liked!");}else{alert("Already liked!");}}} style={{flex:1,background:"rgba(0,170,68,0.2)",border:"1px solid #00aa44",color:"#00aa44",borderRadius:"6px",padding:"8px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>👍 Like</button>
                <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+watching?.title+"\n\nWatch: https://youtu.be/"+watching?.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{flex:1,background:"rgba(37,211,102,0.2)",border:"1px solid #25D366",color:"#25D366",borderRadius:"6px",padding:"8px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>📱 Share</button>
                <button onClick={()=>window.open("https://youtube.com/watch?v="+watching?.videoId,"_blank")} style={{flex:1,background:"rgba(255,0,0,0.2)",border:"1px solid #ff0000",color:"#ff4444",borderRadius:"6px",padding:"8px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>▶ YouTube</button>
              </div>
            </div>
          {/* Share buttons */}
          <div style={{padding:"12px 16px",background:"#000510",borderTop:"1px solid rgba(0,102,204,0.2)"}}>
            <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
              <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+watching?.title+"\n\nWatch: https://youtu.be/"+watching?.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>📱 WhatsApp</button>
              <button onClick={()=>window.open("https://twitter.com/intent/tweet?url="+encodeURIComponent("https://youtu.be/"+watching.videoId)+"&text="+encodeURIComponent(watching.title),"_blank")} style={{background:"#000",border:"1px solid #fff",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>𝕏 Twitter</button>
              <button onClick={()=>window.open("https://t.me/share/url?url="+encodeURIComponent("https://youtu.be/"+watching.videoId),"_blank")} style={{background:"#0088cc",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>✈️ Telegram</button>
              <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+watching.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.3)",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>🔗 Copy</button>
            </div>
          </div>
        </div>
      )}

      {/* Sport Filter */}
      <div style={{padding:"12px 4%",display:"flex",gap:"8px",overflowX:"auto",borderBottom:"1px solid rgba(0,102,204,0.2)"}}>
        {SPORTS.map(sport=>(
          <button key={sport} onClick={()=>setActiveSport(sport)} style={{background:activeSport===sport?"#0066cc":"rgba(0,102,204,0.1)",border:"1px solid #0066cc",color:activeSport===sport?"#fff":"#0099ff",padding:"5px 12px",borderRadius:"20px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0}}>{sport}</button>
        ))}
      </div>

      {/* Channel Tabs */}
      <div style={{padding:"12px 4%",display:"flex",gap:"8px",overflowX:"auto"}}>
        {filteredChannels.map(c=>(
          <button key={c.id} onClick={()=>setActiveChannel(c.id)} style={{background:activeChannel===c.id?c.color:"rgba(255,255,255,0.05)",border:"1px solid "+c.color,color:activeChannel===c.id?"#fff":c.color,padding:"6px 14px",borderRadius:"6px",cursor:"pointer",fontSize:"12px",fontWeight:700,flexShrink:0,whiteSpace:"nowrap"}}>{c.icon} {c.name}</button>
        ))}
      </div>

      {/* Videos Grid */}
      <div style={{padding:"12px 4%"}}>
        {loading && <div style={{textAlign:"center",color:"rgba(255,255,255,0.4)",padding:"40px"}}>Loading sports content...</div>}
        {!loading && videos.length === 0 && <div style={{textAlign:"center",color:"rgba(255,255,255,0.4)",padding:"40px"}}>No videos available</div>}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(clamp(160px,28vw,240px),1fr))",gap:"clamp(8px,2vw,16px)"}}>
          {videos.map((video,i)=>(
            <div key={i} onClick={()=>{setWatching(video);}} style={{background:"rgba(0,102,204,0.05)",border:"1px solid rgba(0,102,204,0.2)",borderRadius:"10px",overflow:"hidden",cursor:"pointer"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor="#0066cc"}
              onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(0,102,204,0.2)"}>
              <div style={{position:"relative",paddingTop:"56.25%"}}>
                <img src={video.thumbnail} alt={video.title} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover"}} onError={e=>e.target.style.display="none"} />
                <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <div style={{width:"40px",height:"40px",borderRadius:"50%",background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:"16px"}}>&#9654;</div>
                </div>
                <div style={{position:"absolute",top:"8px",left:"8px",background:ch?.color||"#0066cc",color:"#fff",fontSize:"9px",fontWeight:900,padding:"2px 6px",borderRadius:"2px"}}>{ch?.sport||"SPORTS"}</div>
                <div style={{position:"absolute",bottom:"8px",right:"8px",background:"rgba(0,0,0,0.7)",color:"#d4a843",fontSize:"8px",fontWeight:900,padding:"2px 6px",borderRadius:"2px",letterSpacing:"1px"}}>NETHAJI PRIME</div>
              </div>
              <div style={{padding:"10px"}}>
                <div style={{color:"#e2e8f0",fontSize:"11px",fontWeight:600,lineHeight:"1.3",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",marginBottom:"6px"}}>{video.title}</div>
                <div style={{color:"rgba(255,255,255,0.3)",fontSize:"9px",marginBottom:"6px"}}>{new Date(video.pubDate||video.publishedAt||video.created_at).toLocaleDateString("en-IN")}</div>
                <div style={{display:"flex",gap:"6px"}} onClick={e=>e.stopPropagation()}>
                  <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+video.title+"\n\nWatch: https://youtu.be/"+video.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer"}}>WhatsApp</button>
                  <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+video.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer"}}>Copy</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

    <div style={{padding:'16px',background:'rgba(255,255,255,0.02)',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
      <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',fontWeight:'700',letterSpacing:'2px',marginBottom:'12px'}}>SPONSORED PARTNERS</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'10px'}}>
        {[{name:'Dream11',url:'https://dream11.com',desc:'Fantasy cricket',color:'#1a2e6b',emoji:'🏏'},{name:'MPL',url:'https://mpl.live',desc:'Win real money',color:'#6c3483',emoji:'🎮'},{name:'FanCode',url:'https://fancode.com',desc:'Live sports',color:'#ff3300',emoji:'📺'},{name:'Decathlon',url:'https://decathlon.in',desc:'Sports gear',color:'#0082c3',emoji:'⚽'}].map((a,i)=>(
          <div key={i} onClick={()=>window.open(a.url,'_blank')} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'12px',cursor:'pointer',borderTop:'2px solid '+a.color,textAlign:'center'}}>
            <div style={{fontSize:'22px',marginBottom:'4px'}}>{a.emoji}</div>
            <div style={{color:a.color,fontWeight:'800',fontSize:'12px',marginBottom:'3px'}}>{a.name}</div>
            <div style={{color:'rgba(255,255,255,0.35)',fontSize:'10px',marginBottom:'8px'}}>{a.desc}</div>
            <button style={{padding:'4px 10px',background:a.color,border:'none',borderRadius:'5px',color:'#fff',fontWeight:'700',cursor:'pointer',fontSize:'10px'}}>Open</button>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
}



function MGRSongsPage({ onBack, t }) {
  const [ottVideosSongs, setOttVideosSongs] = React.useState([]);
  React.useEffect(()=>{
    fetch((process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com")+"/speeches?category=Songs")
      .then(r=>r.json()).then(d=>{if(d.speeches)setOttVideosSongs(d.speeches);})
      .catch(()=>{});
  },[]);
  const MUSIC_CHANNELS = []
  const [activeMusicChannel, setActiveMusicChannel] = React.useState(null);
  const [musicFeedVideos, setMusicFeedVideos] = React.useState([]);
  const [musicFeedLoading, setMusicFeedLoading] = React.useState(false);
  const [watchingMusic, setWatchingMusic] = React.useState(null);
  const API_URL_MGR = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';

  React.useEffect(() => {
    if (!activeMusicChannel) return;
    setMusicFeedLoading(true);
    setMusicFeedVideos([]);
    fetch(API_URL_MGR+"/api/youtube-feeds?channel_id="+activeMusicChannel+"&max_results=20")
      .then(r=>r.json())
      .then(data=>{ if(data.items) setMusicFeedVideos(data.items); setMusicFeedLoading(false); })
      .catch(()=>setMusicFeedLoading(false));
  }, [activeMusicChannel]);


  React.useEffect(() => {
    if (!activeMusicChannel) return;
    setMusicFeedLoading(true);
    setMusicFeedVideos([]);
    fetch(API_URL_MGR+"/api/youtube-feeds?channel_id="+activeMusicChannel+"&max_results=20")
      .then(r=>r.json())
      .then(data=>{ if(data.items) setMusicFeedVideos(data.items); setMusicFeedLoading(false); })
      .catch(()=>setMusicFeedLoading(false));
  }, [activeMusicChannel]);
  const SONGS = [
    {id:"t1",title:"MGR Thathuva Padalgal - Jukebox",titleTa:"எம்.ஜி.ஆர் தத்துவ பாடல்கள்",videoId:"Ts2tqCtfcxE",desc:"Nalla Nallan, Naan Ungal & more"},
    {id:"t2",title:"MGR Super Hit Thathuva Padalgal",titleTa:"சூப்பர் ஹிட் தத்துவ பாடல்கள்",videoId:"XIGP1YgaVLE",desc:"Dharmam Thalai Kaakkum & more"},
    {id:"t3",title:"MGR Kolgai Padalgal Jukebox",titleTa:"எம்.ஜி.ஆர் கொள்கை பாடல்கள்",videoId:"_JhS5ZRYp9c",desc:"Naan Anaiyittal, Thambiku Oru & more"},
    {id:"t4",title:"MGR Thathuva Padalgal HD",titleTa:"தத்துவ பாடல்கள் HD",videoId:"8k-8KcnwACg",desc:"வாழ்க்கையில் முன்னேற"},
    {id:"t5",title:"MGR Thathuva Padalgal Hits",titleTa:"தத்துவ பாடல்கள் ஹிட்ஸ்",videoId:"J1qP7008DT4",desc:"MGR Old Songs"},
    {id:"t6",title:"MGR Kolgai Padalgal - Hornpipe",titleTa:"கொள்கை பாடல்கள்",videoId:"GcYgZRKCkGk",desc:"60s & 70s Hits"},
    {id:"t7",title:"MGR Thathuva Paadalgal",titleTa:"தத்துவப் பாடல்கள்",videoId:"kXhPMjVP7eQ",desc:"Philosophical Songs"},
    {id:"t8",title:"MGR Philoshopical Hits HD",titleTa:"தத்துவ ஹிட்ஸ் HD",videoId:"G64r6mUQF48",desc:"Rhythm Zone Presents"},
    {id:"t9",title:"MGR 100 Thathuva Paadalgal",titleTa:"100 தத்துவ பாடல்கள்",videoId:"a_QkDYH3dt4",desc:"MGR 100 Years Special"},
  ];
  const [watching, setWatching] = React.useState(null);
  return (
    <div style={{background:"linear-gradient(135deg,#020010,#0a0020)",minHeight:"100vh",paddingBottom:"40px"}}>
      <BANNERS.Songs />
      {ottVideosSongs.length>0&&(
        <div style={{padding:'16px 4%',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
          <div style={{color:'#d4a843',fontWeight:900,fontSize:'14px',marginBottom:'12px'}}>Nethaji Prime Songs Videos</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
            {ottVideosSongs.map((v,i)=>(
              <VideoCard 
                key={v.id||i} 
                video={v} 
                isNew={false} 
                hasAccess={true}
                onClick={()=>{
                  if(v.video_url && !v.video_url.includes('youtube') && !v.video_url.includes('youtu.be')){
                    if(onVideoSelect) onVideoSelect(v);
                  } else {
                    window.open(v.video_url,'_blank');
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
      <div style={{background:"linear-gradient(90deg,#020010,#0a0030)",padding:"12px 4%",display:"flex",alignItems:"center",gap:"16px",borderBottom:"2px solid #d4a843",position:"sticky",top:0,zIndex:100}}>
        <button onClick={onBack} style={{background:"transparent",border:"1px solid #d4a843",color:"#d4a843",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"13px",fontWeight:700}}>Back</button><button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("Watch Songs on Nethaji Prime OTT!\\n\\nhttps://nethajiprime.com/#songs"),"_blank")} style={{marginLeft:"8px",padding:"6px 12px",background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"11px",fontWeight:700,cursor:"pointer"}}>Share</button>
        <div>
          <div style={{color:"#d4a843",fontWeight:900,fontSize:"clamp(14px,3vw,20px)",letterSpacing:"2px"}}>{t && t.cat_MGR_Songs ? t.cat_MGR_Songs.toUpperCase() : "MGR SONGS"}</div>
          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>எம்.ஜி.ஆர் தத்துவ பாடல்கள் | Philosophical Songs</div>
        </div>
      </div>
      {/* Music Channels */}
      {watchingMusic && (
        <div style={{background:"#000"}}>
          <div style={{background:"#020010",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(212,168,67,0.2)"}}>
            <div style={{color:"#d4a843",fontWeight:900,fontSize:"13px"}}>{watchingMusic.title}</div>
            <button onClick={()=>setWatchingMusic(null)} style={{background:"rgba(204,0,0,0.2)",border:"1px solid #cc0000",color:"#ff4444",padding:"5px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>CLOSE</button>
          </div>
          <div style={{position:"relative",paddingTop:"56.25%",background:"#000"}}>
            <iframe key={watchingMusic.videoId} src={"https://www.youtube.com/embed/"+watchingMusic.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1"} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title={watchingMusic.title} />
            <div style={{position:"absolute",bottom:"12px",right:"12px",background:"rgba(0,0,0,0.6)",color:"#d4a843",fontSize:"11px",fontWeight:900,padding:"4px 10px",borderRadius:"4px",letterSpacing:"2px",pointerEvents:"none",zIndex:10}}>NETHAJI PRIME OTT</div>
          </div>
            <div style={{padding:"12px",background:"rgba(0,0,0,0.4)",borderTop:"1px solid rgba(212,168,67,0.15)"}}>
              <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"8px",marginBottom:"10px"}}>
                {[
                  {label:"Views",value:(watching?.viewCount||watching?.view_count||"N/A"),icon:"👁️",color:"#0066cc"},
                  {label:"Likes",value:(watching?.likeCount||watching?.like_count||"N/A"),icon:"👍",color:"#00aa44"},
                  {label:"Published",value:watching?.pubDate?new Date(watching.pubDate||watching.publishedAt||watching.created_at).toLocaleDateString("en-IN"):"N/A",icon:"📅",color:"#d4a843"},
                ].map(stat=>(
                  <div key={stat.label} style={{background:"rgba(255,255,255,0.05)",borderRadius:"8px",padding:"8px",textAlign:"center"}}>
                    <div style={{fontSize:"16px"}}>{stat.icon}</div>
                    <div style={{color:stat.color,fontWeight:900,fontSize:"13px"}}>{stat.value}</div>
                    <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>{stat.label}</div>
                  </div>
                ))}
              </div>
              <div style={{display:"flex",gap:"8px"}}>
                <button onClick={()=>{const k="yt_like_"+watching?.videoId;if(!localStorage.getItem(k)){localStorage.setItem(k,"1");alert("Liked!");}else{alert("Already liked!");}}} style={{flex:1,background:"rgba(0,170,68,0.2)",border:"1px solid #00aa44",color:"#00aa44",borderRadius:"6px",padding:"8px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>👍 Like</button>
                <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+watching?.title+"\n\nWatch: https://youtu.be/"+watching?.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{flex:1,background:"rgba(37,211,102,0.2)",border:"1px solid #25D366",color:"#25D366",borderRadius:"6px",padding:"8px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>📱 Share</button>
                <button onClick={()=>window.open("https://youtube.com/watch?v="+watching?.videoId,"_blank")} style={{flex:1,background:"rgba(255,0,0,0.2)",border:"1px solid #ff0000",color:"#ff4444",borderRadius:"6px",padding:"8px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>▶ YouTube</button>
              </div>
            </div>
          <div style={{padding:"12px 16px",background:"#020010",borderTop:"1px solid rgba(212,168,67,0.1)",display:"flex",gap:"8px",flexWrap:"wrap"}}>
            <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+watchingMusic.title+"\n\nWatch: https://youtu.be/"+watchingMusic.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>📱 WhatsApp</button>
            <button onClick={()=>window.open("https://t.me/share/url?url="+encodeURIComponent("https://youtu.be/"+watchingMusic.videoId),"_blank")} style={{background:"#0088cc",border:"none",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>✈️ Telegram</button>
            <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+watchingMusic.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.3)",borderRadius:"6px",color:"#fff",fontSize:"12px",fontWeight:700,padding:"6px 12px",cursor:"pointer"}}>🔗 Copy</button>
          </div>
        </div>
      )}
      <div style={{padding:"10px 4%",borderBottom:"1px solid rgba(212,168,67,0.1)"}}>
        <div style={{color:"#d4a843",fontWeight:900,fontSize:"13px",marginBottom:"8px"}}>🎵 HD MUSIC CHANNELS</div>
        <div style={{display:"flex",gap:"8px",overflowX:"auto",paddingBottom:"4px"}}>
          <button onClick={()=>setActiveMusicChannel(null)} style={{background:activeMusicChannel===null?"#d4a843":"rgba(212,168,67,0.1)",border:"1px solid #d4a843",color:activeMusicChannel===null?"#000":"#d4a843",padding:"5px 12px",borderRadius:"20px",cursor:"pointer",fontSize:"11px",fontWeight:700,flexShrink:0}}>MGR Songs</button>
          {MUSIC_CHANNELS.map(ch=>(
            <button key={ch.id} onClick={()=>setActiveMusicChannel(ch.channelId)} style={{background:activeMusicChannel===ch.channelId?ch.color:"rgba(255,255,255,0.05)",border:"1px solid "+ch.color,color:activeMusicChannel===ch.channelId?"#fff":ch.color,padding:"5px 12px",borderRadius:"20px",cursor:"pointer",fontSize:"11px",fontWeight:700,flexShrink:0,whiteSpace:"nowrap"}}>{ch.icon} {ch.name}</button>
          ))}
        </div>
      </div>
      {activeMusicChannel && (
        <div style={{padding:"12px 4%"}}>
          {musicFeedLoading && <div style={{textAlign:"center",color:"rgba(255,255,255,0.4)",padding:"20px"}}>Loading music...</div>}
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(clamp(140px,28vw,200px),1fr))",gap:"clamp(8px,2vw,14px)"}}>
            {musicFeedVideos.map((video,i)=>(
              <div key={i} onClick={()=>setWatchingMusic(video)} style={{background:"rgba(212,168,67,0.03)",border:"1px solid rgba(212,168,67,0.15)",borderRadius:"10px",overflow:"hidden",cursor:"pointer"}}
                onMouseEnter={e=>e.currentTarget.style.borderColor="rgba(212,168,67,0.6)"}
                onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(212,168,67,0.15)"}>
                <div style={{position:"relative",paddingTop:"56.25%"}}>
                  <img src={video.thumbnail} alt={video.title} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover"}} onError={e=>e.target.style.display="none"} />
                  <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                    <div style={{width:"40px",height:"40px",borderRadius:"50%",background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",color:"#d4a843",fontSize:"20px"}}>&#9654;</div>
                  </div>
                  <div style={{position:"absolute",bottom:"6px",right:"6px",background:"rgba(0,0,0,0.6)",color:"#d4a843",fontSize:"8px",fontWeight:900,padding:"2px 6px",borderRadius:"2px",letterSpacing:"1px"}}>NETHAJI PRIME</div>
                </div>
                <div style={{padding:"8px"}}>
                  <div style={{color:"#e2e8f0",fontSize:"11px",fontWeight:600,lineHeight:"1.3",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",marginBottom:"4px"}}>{video.title}</div>
                  <div style={{color:"rgba(255,255,255,0.3)",fontSize:"9px"}}>{new Date(video.pubDate||video.publishedAt||video.created_at).toLocaleDateString("en-IN")}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {watching && (
        <div style={{background:"#000"}}>
          <div style={{background:"#020010",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(212,168,67,0.2)"}}>
            <div>
              <div style={{color:"#d4a843",fontWeight:900,fontSize:"13px"}}>{watching.titleTa}</div>
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>{watching.desc} | Nethaji Prime OTT</div>
            </div>
            <button onClick={()=>setWatching(null)} style={{background:"rgba(204,0,0,0.2)",border:"1px solid #cc0000",color:"#ff4444",padding:"5px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>CLOSE</button>
          </div>
          <div style={{position:"relative",paddingTop:"56.25%",background:"#000"}}>
            <iframe key={watching.videoId} src={"https://www.youtube.com/embed/"+watching.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1&modestbranding=1"} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title={watching.title} />
          </div>
        </div>
      )}
      <div style={{padding:"20px 4%"}}>
        <div style={{textAlign:"center",marginBottom:"24px"}}>
          <div style={{fontSize:"clamp(20px,5vw,36px)",fontWeight:900,color:"#d4a843",textShadow:"0 0 20px rgba(212,168,67,0.5)"}}>புரட்சி தலைவர் MGR</div>
          <div style={{color:"rgba(255,255,255,0.5)",fontSize:"13px",marginTop:"4px"}}>தத்துவ பாடல்கள் - Philosophical Songs Collection</div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(min(100%,clamp(140px,28vw,200px)),1fr))",gap:"clamp(8px,2vw,14px)"}}>
          {SONGS.map(song => (
            <div key={song.id} onClick={()=>setWatching(song)}
              style={{background:"rgba(212,168,67,0.05)",border:"1px solid rgba(212,168,67,0.2)",borderRadius:"10px",overflow:"hidden",cursor:"pointer",transition:"all 0.25s"}}
              onMouseEnter={e=>e.currentTarget.style.borderColor="rgba(212,168,67,0.7)"}
              onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(212,168,67,0.2)"}>
              <div style={{position:"relative",paddingTop:"56.25%",background:"#000"}}>
                <img src={"https://img.youtube.com/vi/"+song.videoId+"/mqdefault.jpg"} alt={song.title}
                  style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover"}}
                  onError={e=>e.target.style.display="none"} />
                <div style={{position:"absolute",inset:0,background:"linear-gradient(0deg,rgba(0,0,0,0.7),transparent 50%)"}} />
                <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <div style={{width:"44px",height:"44px",borderRadius:"50%",background:"rgba(212,168,67,0.8)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"18px",color:"#000"}}>&#9654;</div>
                </div>
              </div>
              <div style={{padding:"10px 12px"}}>
                <div style={{color:"#d4a843",fontWeight:700,fontSize:"12px",lineHeight:"1.3",marginBottom:"4px"}}>{song.titleTa}</div>
                <div style={{color:"rgba(255,255,255,0.5)",fontSize:"10px"}}>{song.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div style={{padding:'16px',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
        <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',fontWeight:'700',letterSpacing:'2px',marginBottom:'12px'}}>MUSIC STREAMING</div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'10px'}}>
          {[{name:'Gaana',url:'https://gaana.com',desc:'50M+ Tamil songs',color:'#e72c30',emoji:'🎵'},{name:'Spotify',url:'https://spotify.com',desc:'Premium streaming',color:'#1db954',emoji:'🎧'},{name:'JioSaavn',url:'https://jiosaavn.com',desc:'Free Tamil music',color:'#2BC5B4',emoji:'🎶'},{name:'Wynk Music',url:'https://wynk.in',desc:'Airtel music app',color:'#ef5da8',emoji:'🎼'}].map((a,i)=>(
            <div key={i} onClick={()=>window.open(a.url,'_blank')} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'12px',cursor:'pointer',borderTop:'2px solid '+a.color,textAlign:'center'}}>
              <div style={{fontSize:'22px',marginBottom:'4px'}}>{a.emoji}</div>
              <div style={{color:a.color,fontWeight:'800',fontSize:'12px',marginBottom:'3px'}}>{a.name}</div>
              <div style={{color:'rgba(255,255,255,0.35)',fontSize:'10px',marginBottom:'8px'}}>{a.desc}</div>
              <button style={{padding:'4px 10px',background:a.color,border:'none',borderRadius:'5px',color:'#fff',fontWeight:'700',cursor:'pointer',fontSize:'10px'}}>Listen</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function KidsPage({ onBack, t, onVideoSelect }) {
  const [ottVideosKids, setOttVideosKids] = React.useState([]);
  React.useEffect(()=>{
    fetch((process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com")+"/speeches?category=Kids")
      .then(r=>r.json()).then(d=>{if(d.speeches)setOttVideosKids(d.speeches);})
      .catch(()=>{});
  },[]);

  const CATEGORIES = ["All","Rhymes","Stories","Education","Songs"];
  const VIDEOS = [
    {id:"k1",title:"Dosai Amma Dosai Tamil Rhymes",cat:"Rhymes",videoId:"pV__qHbDBfE",channel:"ChuChu TV Tamil"},
    {id:"k2",title:"Tamil Baby Songs for Children",cat:"Rhymes",videoId:"Kihkfhy6Vh4",channel:"ChuChu TV Tamil"},
    {id:"k3",title:"Tamil Rhymes and Baby Songs",cat:"Rhymes",videoId:"xoqrUqeLrmQ",channel:"ChuChu TV Tamil"},
    {id:"k4",title:"Saindhadamma Tamil Rhymes",cat:"Rhymes",videoId:"1dMG9sa8qUo",channel:"Infobells Tamil"},
    {id:"k5",title:"Tamil Moral Stories for Kids",cat:"Stories",videoId:"Yvv5xsiQBIs",channel:"Koo Koo TV Tamil"},
    {id:"k6",title:"Tamil Bedtime Stories",cat:"Stories",videoId:"Y7fh19zHlaw",channel:"Koo Koo TV Tamil"},
    {id:"k7",title:"Tamil Kids Learning Songs",cat:"Songs",videoId:"Kihkfhy6Vh4",channel:"ChuChu TV Tamil"},
    {id:"k8",title:"Nila Nila Odi Va Baby Songs",cat:"Songs",videoId:"xoqrUqeLrmQ",channel:"ChuChu TV Tamil"},
    {id:"k9",title:"Tamil Alphabet Learning",cat:"Education",videoId:"1dMG9sa8qUo",channel:"Infobells Tamil"},
    {id:"k10",title:"Tamil Numbers and Colors",cat:"Education",videoId:"pV__qHbDBfE",channel:"ChuChu TV Tamil"},
  ];
  const [activeCat, setActiveCat] = React.useState("All");
  const [watching, setWatching] = React.useState(null);
  const filtered = activeCat === "All" ? VIDEOS : VIDEOS.filter(v => v.cat === activeCat);
  return (
    <div style={{background:"#05000a",minHeight:"100vh",paddingBottom:"40px"}}>
      <BANNERS.Kids />
      {ottVideosKids.length>0&&(
        <div style={{padding:'16px 4%',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
          <div style={{color:'#d4a843',fontWeight:900,fontSize:'14px',marginBottom:'12px'}}>Nethaji Prime Kids Videos</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
            {ottVideosKids.map((v,i)=>(
              <VideoCard 
                key={v.id||i} 
                video={v} 
                isNew={false} 
                hasAccess={true}
                onClick={()=>{
                  if(v.video_url && !v.video_url.includes('youtube') && !v.video_url.includes('youtu.be')){
                    if(onVideoSelect) onVideoSelect(v);
                  } else {
                    window.open(v.video_url,'_blank');
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
      <div style={{background:"#0a0010",padding:"12px 4%",display:"flex",alignItems:"center",gap:"16px",borderBottom:"2px solid #d4a843",position:"sticky",top:0,zIndex:100}}>
        <button onClick={onBack} style={{background:"transparent",border:"1px solid #d4a843",color:"#d4a843",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"13px",fontWeight:700}}>Back</button><button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("Watch Kids on Nethaji Prime OTT!\\n\\nhttps://nethajiprime.com/#kids"),"_blank")} style={{marginLeft:"8px",padding:"6px 12px",background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"11px",fontWeight:700,cursor:"pointer"}}>Share</button>
        <div style={{color:"#d4a843",fontWeight:900,fontSize:"clamp(14px,3vw,18px)",letterSpacing:"2px"}}>{t && t.cat_Kids ? t.cat_Kids.toUpperCase() : "KIDS"}</div>
        <div style={{color:"rgba(255,255,255,0.4)",fontSize:"12px"}}>Tamil Rhymes, Stories and Songs for Children</div>
      </div>
      {watching && (
        <div style={{background:"#000"}}>
          <div style={{background:"#0a0010",padding:"8px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid rgba(212,168,67,0.2)"}}>
            <div style={{display:"flex",alignItems:"center",gap:"10px"}}>
              <img src="https://media.nethajiprime.com/nethaji-logo.png" alt="Nethaji Prime" style={{height:"28px",objectFit:"contain"}} />
              <div>
                <div style={{color:"#d4a843",fontWeight:900,fontSize:"14px"}}>{watching.title}</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>Courtesy: {watching.channel} | Nethaji Prime OTT</div>
              </div>
            </div>
            <button onClick={() => setWatching(null)} style={{background:"rgba(204,0,0,0.2)",border:"1px solid #cc0000",color:"#ff4444",padding:"5px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>CLOSE</button>
          </div>
          <div style={{position:"relative",paddingTop:"56.25%",background:"#000"}}>
            <iframe key={watching.videoId}
              src={"https://www.youtube.com/embed/"+watching.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1&modestbranding=1"}
              style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",border:"none"}}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen title={watching.title} />
          </div>
        </div>
      )}
      <div style={{padding:"16px 4% 8px",display:"flex",gap:"8px",flexWrap:"wrap"}}>
        {CATEGORIES.map(cat => (
          <button key={cat} onClick={() => setActiveCat(cat)}
            style={{padding:"6px 16px",background:activeCat===cat?"#d4a843":"transparent",border:"1px solid rgba(212,168,67,0.4)",color:activeCat===cat?"#000":"#d4a843",borderRadius:"20px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>
            {cat}
          </button>
        ))}
      </div>
      <div style={{padding:"8px 4%"}}>
        <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"16px"}}>
          <div style={{height:"1px",flex:1,background:"linear-gradient(90deg,#d4a843,transparent)"}}></div>
          <span style={{color:"#d4a843",fontWeight:900,fontSize:"12px",letterSpacing:"3px"}}>{activeCat==="All"?"ALL KIDS CONTENT":activeCat.toUpperCase()}</span>
          <div style={{height:"1px",flex:1,background:"linear-gradient(90deg,transparent,#d4a843)"}}></div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(clamp(140px,30vw,200px),1fr))",gap:"clamp(8px,2vw,16px)"}}>
          {filtered.map(video => (
            <div key={video.id} onClick={() => setWatching(video)}
              style={{background:"#0a0010",border:"1px solid rgba(212,168,67,0.15)",borderRadius:"8px",overflow:"hidden",cursor:"pointer",transition:"all 0.25s"}}
              onMouseEnter={e => e.currentTarget.style.borderColor="rgba(212,168,67,0.7)"}
              onMouseLeave={e => e.currentTarget.style.borderColor="rgba(212,168,67,0.15)"}>
              <div style={{position:"relative",paddingTop:"56.25%",background:"#111"}}>
                <img src={"https://img.youtube.com/vi/"+video.videoId+"/mqdefault.jpg"} alt={video.title}
                  style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover"}}
                  onError={e => e.target.style.display="none"} />
                <div style={{position:"absolute",inset:0,background:"linear-gradient(0deg,rgba(0,0,0,0.6),transparent 50%)"}}></div>
                <div style={{position:"absolute",top:"8px",left:"8px",background:"#9900cc",color:"#fff",fontSize:"9px",fontWeight:900,padding:"2px 6px",borderRadius:"2px"}}>{video.cat}</div>
                <div style={{position:"absolute",top:"8px",right:"8px",background:"rgba(0,0,0,0.7)",padding:"3px 6px",borderRadius:"4px",display:"flex",alignItems:"center"}}>
                  <img src="https://media.nethajiprime.com/nethaji-logo.png" alt="NP" style={{height:"14px",objectFit:"contain"}} />
                </div>
                <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <div style={{width:"44px",height:"44px",borderRadius:"50%",background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"18px",color:"#fff"}}>&#9654;</div>
                </div>
              </div>
              <div style={{padding:"10px 12px"}}>
                <div style={{color:"#fff",fontWeight:700,fontSize:"12px",marginBottom:"4px",lineHeight:"1.3"}}>{video.title}</div>
                <div style={{color:"rgba(255,255,255,0.3)",fontSize:"10px"}}>Courtesy: {video.channel}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

    <div style={{padding:'16px',background:'rgba(255,255,255,0.02)',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
      <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',fontWeight:'700',letterSpacing:'2px',marginBottom:'12px'}}>SPONSORED PARTNERS</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'10px'}}>
        {[{name:'BYJUS',url:'https://byjus.com',desc:'Fun learning',color:'#7c4dff',emoji:'🎒'},{name:'Amazon Toys',url:'https://www.amazon.in/s?k=kids+educational+toys&tag=nethajiprimei-21',desc:'Educational toys',color:'#ff9900',emoji:'🧸'},{name:'Vedantu',url:'https://vedantu.com/kids',desc:'Online classes',color:'#3f8cff',emoji:'📖'},{name:'Hotstar',url:'https://hotstar.com',desc:'Kids shows',color:'#0077ff',emoji:'🎬'}].map((a,i)=>(
          <div key={i} onClick={()=>window.open(a.url,'_blank')} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'12px',cursor:'pointer',borderTop:'2px solid '+a.color,textAlign:'center'}}>
            <div style={{fontSize:'22px',marginBottom:'4px'}}>{a.emoji}</div>
            <div style={{color:a.color,fontWeight:'800',fontSize:'12px',marginBottom:'3px'}}>{a.name}</div>
            <div style={{color:'rgba(255,255,255,0.35)',fontSize:'10px',marginBottom:'8px'}}>{a.desc}</div>
            <button style={{padding:'4px 10px',background:a.color,border:'none',borderRadius:'5px',color:'#fff',fontWeight:'700',cursor:'pointer',fontSize:'10px'}}>Open</button>
          </div>
        ))}
      </div>
    </div>
    </div>
  );
}
function MemeGenerator({ onBack }) {
  const canvasRef = React.useRef(null);
  const [topText, setTopText] = React.useState("Nethaji Prime OTT");
  const [botText, setBotText] = React.useState("Tamil - Politics - Truth");
  const [topSize, setTopSize] = React.useState(42);
  const [botSize, setBotSize] = React.useState(36);
  const [textColor, setTextColor] = React.useState("#ffffff");
  const [bgColor, setBgColor] = React.useState("#000000");
  const [bgImage, setBgImage] = React.useState(null);
  const [outline, setOutline] = React.useState(true);
  const [watermark, setWatermark] = React.useState(true);
  const [fontStyle, setFontStyle] = React.useState("bold");

  const COLORS = ["#ffffff","#f5c842","#ff4444","#00ff88","#000000","#cc0000","#0055aa","#ff6600"];

  const drawMeme = React.useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, 500, 500);
    if (bgImage) {
      ctx.drawImage(bgImage, 0, 0, 500, 500);
      ctx.fillStyle = "rgba(0,0,0,0.3)";
      ctx.fillRect(0, 0, 500, 500);
    } else {
      ctx.fillStyle = bgColor;
      ctx.fillRect(0, 0, 500, 500);
    }
    const drawText = (text, y, size) => {
      if (!text) return;
      ctx.font = fontStyle + " " + size + "px Arial";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      if (outline) {
        ctx.strokeStyle = "#000";
        ctx.lineWidth = size / 8;
        ctx.lineJoin = "round";
        ctx.strokeText(text, 250, y);
      }
      ctx.fillStyle = textColor;
      ctx.fillText(text, 250, y);
    };
    drawText(topText, topSize + 10, topSize);
    drawText(botText, 500 - botSize - 10, botSize);
    if (watermark) {
      ctx.font = "bold 16px Arial";
      ctx.textAlign = "right";
      ctx.textBaseline = "bottom";
      ctx.fillStyle = "rgba(255,255,255,0.7)";
      ctx.fillText("nethajiprime.com", 495, 495);
    }
  }, [topText, botText, topSize, botSize, textColor, bgColor, bgImage, outline, watermark, fontStyle]);

  React.useEffect(() => { drawMeme(); }, [drawMeme]);

  const loadImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = new Image();
      img.onload = () => setBgImage(img);
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
  };

  const downloadMeme = () => {
    const link = document.createElement("a");
    link.download = "nethaji-prime-meme.png";
    link.href = canvasRef.current.toDataURL("image/png");
    link.click();
  };

  return (
    <div style={{background:"#080000",minHeight:"100vh",padding:"0 0 40px"}}>
      <div style={{background:"#0a0000",padding:"12px 4%",display:"flex",alignItems:"center",gap:"16px",borderBottom:"2px solid #d4a843"}}>
        <button onClick={onBack} style={{background:"transparent",border:"1px solid #d4a843",color:"#d4a843",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"13px",fontWeight:700}}>Back</button>
        <div style={{color:"#d4a843",fontWeight:900,fontSize:"18px",letterSpacing:"2px"}}>MEME GENERATOR</div>
        <div style={{color:"rgba(255,255,255,0.4)",fontSize:"12px"}}>Create Tamil political memes</div>
      </div>
      <div style={{padding:"20px 4%",display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:"24px",maxWidth:"900px",margin:"0 auto"}}>
        <div>
          <div style={{marginBottom:"16px"}}>
            <div style={{color:"#d4a843",fontSize:"12px",fontWeight:700,letterSpacing:"1px",marginBottom:"6px"}}>BACKGROUND</div>
            <div style={{display:"flex",gap:"8px",marginBottom:"8px"}}>
              <label style={{background:"#cc0000",color:"#fff",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontWeight:700}}>
                UPLOAD IMAGE
                <input type="file" accept="image/*" onChange={loadImage} style={{display:"none"}} />
              </label>
              <button onClick={() => setBgImage(null)} style={{background:"transparent",border:"1px solid rgba(255,255,255,0.2)",color:"rgba(255,255,255,0.6)",padding:"6px 14px",borderRadius:"4px",cursor:"pointer",fontSize:"12px"}}>Solid Color</button>
            </div>
            <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
              {["#000000","#cc0000","#1a1a2e","#0d3b00","#1a0050","#ffffff","#ff6600","#003366"].map(c => (
                <div key={c} onClick={() => {setBgColor(c);setBgImage(null);}}
                  style={{width:"28px",height:"28px",borderRadius:"50%",background:c,cursor:"pointer",border:bgColor===c&&!bgImage?"3px solid #d4a843":"1px solid rgba(255,255,255,0.3)"}}/>
              ))}
            </div>
          </div>
          <div style={{marginBottom:"16px"}}>
            <div style={{color:"#d4a843",fontSize:"12px",fontWeight:700,letterSpacing:"1px",marginBottom:"6px"}}>TOP TEXT</div>
            <input value={topText} onChange={e => setTopText(e.target.value)}
              style={{width:"100%",background:"#0a0000",border:"1px solid rgba(212,168,67,0.3)",color:"#fff",padding:"8px 12px",borderRadius:"4px",fontSize:"14px",marginBottom:"6px"}} />
            <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
              <span style={{color:"rgba(255,255,255,0.5)",fontSize:"11px"}}>Size: {topSize}</span>
              <input type="range" min="20" max="80" value={topSize} onChange={e => setTopSize(parseInt(e.target.value))} style={{flex:1}} />
            </div>
          </div>
          <div style={{marginBottom:"16px"}}>
            <div style={{color:"#d4a843",fontSize:"12px",fontWeight:700,letterSpacing:"1px",marginBottom:"6px"}}>BOTTOM TEXT</div>
            <input value={botText} onChange={e => setBotText(e.target.value)}
              style={{width:"100%",background:"#0a0000",border:"1px solid rgba(212,168,67,0.3)",color:"#fff",padding:"8px 12px",borderRadius:"4px",fontSize:"14px",marginBottom:"6px"}} />
            <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
              <span style={{color:"rgba(255,255,255,0.5)",fontSize:"11px"}}>Size: {botSize}</span>
              <input type="range" min="20" max="80" value={botSize} onChange={e => setBotSize(parseInt(e.target.value))} style={{flex:1}} />
            </div>
          </div>
          <div style={{marginBottom:"16px"}}>
            <div style={{color:"#d4a843",fontSize:"12px",fontWeight:700,letterSpacing:"1px",marginBottom:"6px"}}>TEXT COLOR</div>
            <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
              {COLORS.map(c => (
                <div key={c} onClick={() => setTextColor(c)}
                  style={{width:"28px",height:"28px",borderRadius:"50%",background:c,cursor:"pointer",border:textColor===c?"3px solid #d4a843":"1px solid rgba(255,255,255,0.3)"}}/>
              ))}
            </div>
          </div>
          <div style={{marginBottom:"16px"}}>
            <div style={{color:"#d4a843",fontSize:"12px",fontWeight:700,letterSpacing:"1px",marginBottom:"6px"}}>TEXT STYLE</div>
            <div style={{display:"flex",gap:"8px"}}>
              {["bold","normal","italic"].map(s => (
                <button key={s} onClick={() => setFontStyle(s)}
                  style={{padding:"6px 14px",background:fontStyle===s?"#d4a843":"transparent",border:"1px solid rgba(212,168,67,0.4)",color:fontStyle===s?"#000":"#d4a843",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontWeight:700,textTransform:"capitalize"}}>
                  {s}
                </button>
              ))}
            </div>
          </div>
          <div style={{marginBottom:"20px",display:"flex",gap:"16px"}}>
            <label style={{display:"flex",alignItems:"center",gap:"6px",cursor:"pointer",color:"rgba(255,255,255,0.7)",fontSize:"13px"}}>
              <input type="checkbox" checked={outline} onChange={e => setOutline(e.target.checked)} /> Text outline
            </label>
            <label style={{display:"flex",alignItems:"center",gap:"6px",cursor:"pointer",color:"rgba(255,255,255,0.7)",fontSize:"13px"}}>
              <input type="checkbox" checked={watermark} onChange={e => setWatermark(e.target.checked)} /> Watermark
            </label>
          </div>
          <button onClick={downloadMeme}
            style={{background:"linear-gradient(135deg,#cc0000,#880000)",border:"none",color:"#fff",padding:"12px 24px",borderRadius:"4px",cursor:"pointer",fontSize:"14px",fontWeight:900,letterSpacing:"2px",width:"100%"}}>
            DOWNLOAD MEME
          </button>
        </div>
        <div>
          <div style={{color:"#d4a843",fontSize:"12px",fontWeight:700,letterSpacing:"1px",marginBottom:"8px"}}>PREVIEW</div>
          <canvas ref={canvasRef} width="500" height="500" style={{width:"100%",borderRadius:"8px",border:"1px solid rgba(212,168,67,0.2)"}} />
          <div style={{color:"rgba(255,255,255,0.3)",fontSize:"11px",marginTop:"6px",textAlign:"center"}}>500 x 500 px - Perfect for WhatsApp</div>
        </div>
      </div>
    </div>
  );
}
function App() {
  const [user, setUser] = useState(null);
  const [showSignup, setShowSignup] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showRefund, setShowRefund] = useState(false);
  const [showGrievance, setShowGrievance] = useState(false);
  // Deep-link the four legal pages via hash so LegalFooter links work from any
  // view and each policy has a stable, shareable URL for the payment-gateway
  // reviewer (e.g. https://nethajiprime.com/#terms).
  React.useEffect(() => {
    const applyLegalHash = () => {
      const h = (window.location.hash || '').toLowerCase();
      setShowPrivacyPolicy(h === '#privacy');
      setShowTerms(h === '#terms');
      setShowRefund(h === '#refund');
      setShowGrievance(h === '#grievance');
    };
    applyLegalHash();
    window.addEventListener('hashchange', applyLegalHash);
    return () => window.removeEventListener('hashchange', applyLegalHash);
  }, []);
  const closeLegal = () => { try { if ((window.location.hash || '').match(/#(privacy|terms|refund|grievance)/i)) window.location.hash = ''; } catch (e) {} setShowPrivacyPolicy(false); setShowTerms(false); setShowRefund(false); setShowGrievance(false); };
  const [showPricing, setShowPricing] = useState(false);
    React.useEffect(() => {
      try {
        if (user && localStorage.getItem('np_force_pricing') === '1') {
          localStorage.removeItem('np_force_pricing');
          setShowPricing(true);
        }
      } catch (e) {}
    }, [user]);
  const [showMemeGenerator, setShowMemeGenerator] = useState(false);
  const [showMovies, setShowMovies] = useState(() => {
    try {
      // Auto-redirect to WatchNowPage if already authenticated (token + user exist)
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      return !!(token && user);
    } catch(e) { return false; }
  });
  const [showAdminDashboard, setShowAdminDashboard] = useState(false);
  const [showKids, setShowKids] = useState(false);
  const [showFeeds, setShowFeeds] = useState(false);
  const [showMGR, setShowMGR] = useState(false);
  const [showSports, setShowSports] = useState(false);
  const [showHealth, setShowHealth] = useState(false);
  const [showKitchen, setShowKitchen] = useState(false);
  const [showEducation, setShowEducation] = useState(false);
  const [showAuto, setShowAuto] = useState(false);
  const [showTourism, setShowTourism] = useState(false);
  const [showWomen, setShowWomen] = useState(false);
  const [showTransport, setShowTransport] = useState(false);
  const [showDeals, setShowDeals] = useState(false);
  const [showMen, setShowMen] = useState(false);
  const [showNethajIQ, setShowNethajIQ] = useState(false);
  const [viralVideos, setViralVideos] = useState([]);
  const [isPaidMode, setIsPaidMode] = useState(false);
  const isPaidModeRef = React.useRef(false);
  React.useEffect(() => { isPaidModeRef.current = isPaidMode; }, [isPaidMode]);
  useEffect(() => {
    fetch(API_URL+'/api/app-settings')
      .then(r=>r.json())
      .then(d=>{ if(d.settings){ const pm=d.settings.is_paid_mode==='true'; setIsPaidMode(pm); isPaidModeRef.current=pm; } })
      .catch(()=>{});
  }, []);
  const [showLeaderboard, setShowLeaderboard] = useState(false);


  // Fetch viral scores
  React.useEffect(() => {
    if (!user) return;
    fetch(API_URL + "/api/viral-scores")
      .then(r=>r.json())
      .then(data=>{ if(data.viral_videos) setViralVideos(data.viral_videos); })
      .catch(()=>{});
  }, [user]);


  // Personalization Algorithm
  const trackUserInterest = (category) => {
    try {
      const interests = JSON.parse(localStorage.getItem("np_interests") || "{}");
      interests[category] = (interests[category] || 0) + 1;
      localStorage.setItem("np_interests", JSON.stringify(interests));
    } catch(e) {}
  };

  const getUserTopInterest = () => {
    try {
      const interests = JSON.parse(localStorage.getItem("np_interests") || "{}");
      if (Object.keys(interests).length === 0) return null;
      return Object.entries(interests).sort((a,b) => b[1]-a[1])[0][0];
    } catch(e) { return null; }
  };

  const getPersonalizedDeals = (deals) => {
    const topInterest = getUserTopInterest();
    if (!topInterest) return deals;
    const interested = deals.filter(d => d.category.toLowerCase() === topInterest.toLowerCase());
    const others = deals.filter(d => d.category.toLowerCase() !== topInterest.toLowerCase());
    return [...interested, ...others];
  };


  // Convert free to paid - show upgrade prompt after 3 videos watched
  const [videosWatched, setVideosWatched] = React.useState(() => {
    return parseInt(localStorage.getItem("np_videos_watched") || "0");
  });
  const [showUpgradePrompt, setShowUpgradePrompt] = React.useState(false);

  // A/B TEST - determine group based on user email hash
  const getABGroup = () => {
    try {
      const id = (user?.email || localStorage.getItem('np_ab_id') || Math.random().toString());
      if (!localStorage.getItem('np_ab_id')) localStorage.setItem('np_ab_id', id);
      let hash = 0;
      for (let i = 0; i < id.length; i++) hash = ((hash << 5) - hash) + id.charCodeAt(i);
      return Math.abs(hash) % 2 === 0 ? 'A' : 'B';
    } catch(e) { return 'A'; }
  };
  const trackABClick = (group, action) => {
    try {
      const tok = localStorage.getItem('token');
      fetch(API_URL+'/api/ab-track', {method:'POST', headers:{'Content-Type':'application/json','Authorization':tok?'Bearer '+tok:''}, body:JSON.stringify({group, action, variant: group==='A'?'enjoying':'urgency'})}).catch(()=>{});
    } catch(e) {}
  };
  const trackVideoWatch = () => {
    const current = parseInt(localStorage.getItem("np_videos_watched") || "0");
    const count = current + 1;
    setVideosWatched(count);
    localStorage.setItem("np_videos_watched", count.toString());
    if (count % 3 === 0) setShowUpgradePrompt(true);
    // Step 23: Viral referral reward - notify backend when referred user hits 3 videos
    if (count === 3 && user?.email) {
      try {
        const tok = localStorage.getItem('token');
        fetch(API_URL+'/api/referral-reward', {
          method:'POST',
          headers:{'Content-Type':'application/json','Authorization':tok?'Bearer '+tok:''},
          body:JSON.stringify({referred_email: user.email, videos_watched: 3})
        }).then(r=>r.json()).then(d=>{
          if(d.success) {
            setStreakToast('🎁 Your referrer just earned 50 bonus points!');
            setTimeout(()=>setStreakToast(null),4000);
          }
        }).catch(()=>{});
      } catch(e) {}
    }
  };

  // STREAK ALGORITHM
  const [streakToast, setStreakToast] = useState(null);
  useEffect(() => {
    if (!user) return;
    try {
      const today = new Date().toISOString().slice(0,10);
      const STREAK_KEY = 'np_streak';
      const stored = JSON.parse(localStorage.getItem(STREAK_KEY) || '{}');
      const { lastDate, count=0 } = stored;
      if (lastDate === today) return;
      const yesterday = new Date(Date.now()-86400000).toISOString().slice(0,10);
      const newCount = lastDate === yesterday ? count+1 : 1;
      localStorage.setItem(STREAK_KEY, JSON.stringify({ lastDate: today, count: newCount }));
      if (newCount >= 3) {
        setStreakToast(newCount);
        const tok = localStorage.getItem('token');
        if (tok) fetch(API_URL+'/api/streak-reward',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+tok},body:JSON.stringify({streak_days:newCount,points:10})}).catch(()=>{});
        setTimeout(() => setStreakToast(null), 4000);
      }
    } catch(e) {}
  }, [user]);
  // END STREAK

  // Deep link handler for push notifications + video deep links
  React.useEffect(() => {
    // Check for ?video= param in URL (from share links)
    const params = new URLSearchParams(window.location.search);
    const videoId = params.get('video');
    if (videoId) {
      localStorage.setItem('np_deeplink_video', videoId);
      setShowMovies(true);
      // Clean URL without reloading
      const cleanUrl = window.location.pathname + window.location.hash;
      window.history.replaceState({}, '', cleanUrl);
    }
    const hash = window.location.hash;
    if (hash && hash !== '#') {
      localStorage.setItem('np_deeplink', hash);
    }
  }, []);

  React.useEffect(() => {
    if (!user) return;
    const hash = localStorage.getItem('np_deeplink');
    if (!hash) return;
    // keep in localStorage for refresh
    // Handle API categories
    const apiCategories = ['Shorts','Reels','Interviews','Devotional','Stock Market','Astrology','Sun Detective','Legal'];
    const hashCatMap = {'#shorts':'Shorts','#reels':'Reels','#interviews':'Interviews','#devotional':'Devotional','#stock-market':'Stock Market','#astrology':'Astrology','#sun-detective':'Sun Detective','#legal':'Legal'};
    const matchedCat = hashCatMap[hash];
    if (matchedCat) { setActiveCategory(matchedCat); return; }
    if (hash === '#deals') setShowDeals(true)
    else if (hash === '#sports') setShowSports(true)
    else if (hash === '#health') setShowHealth(true)
    else if (hash === '#news') setShowLiveNews(true)
    else if (hash === '#kitchen') setShowKitchen(true)
    else if (hash === '#education') setShowEducation(true)
    else if (hash === '#movies') setShowMovies(true)
    else if (hash === '#songs') setShowMGR(true)
    else if (hash === '#tourism') setShowTourism(true)
    else if (hash === '#women') setShowWomen(true)
    else if (hash === '#auto') setShowAuto(true)
    else if (hash === '#nethajitv') { setShowFeeds(true) }
    else if (hash === '#kids') { setShowKids(true) }
    else if (hash === '#men') { setShowMen(true) }
    else if (hash === '#transport') { setShowTransport(true) }
    else if (hash === '#nethajiq') { setShowNethajIQ(true) }
    else if (hash === '#movies') { setShowMovies(true) }
    else if (hash.startsWith('#video/')) {
      const videoId = hash.replace('#video/', '');
      const openVideo = (attempts) => {
        const el = document.getElementById('vid-' + videoId);
        if (el) {
          el.click();
        } else if (attempts > 0) {
          setTimeout(() => openVideo(attempts - 1), 1000);
        }
      };
      setTimeout(() => openVideo(10), 1500);
    }
  }, [user]);
  const [homeFeeds, setHomeFeeds] = React.useState({});
  const [homeVideoStats, setHomeVideoStats] = React.useState({});
  const [selectedFeedVideo, setSelectedFeedVideo] = React.useState(null);
  const [ytShorts, setYtShorts] = React.useState([]);
  const [fbReels, setFbReels] = React.useState([]);
  React.useEffect(() => {
    fetch(API_URL+'/api/facebook-reels')
      .then(r=>r.json())
      .then(d=>{ if(d.reels) setFbReels(d.reels); })
      .catch(()=>{});
  }, []);
  const [ytShortsLoading, setYtShortsLoading] = React.useState(false);
  React.useEffect(() => {
    if (ytShorts.length > 0) return;
    setYtShortsLoading(true);
    fetch(API_URL+'/api/youtube-feeds?channel_id=UCUcNLZFSeEPCmhFPMsTB_4g&max_results=50')
      .then(r=>r.json())
      .then(data=>{
        if(data.items){
          const shorts = data.items.filter(v=>
            v.title?.toLowerCase().includes('#shorts') ||
            v.title?.toLowerCase().includes('shorts') ||
            (v.duration && v.duration <= 60)
          );
          setYtShorts(shorts.length > 0 ? shorts : data.items.slice(0,20));
        }
        setYtShortsLoading(false);
      }).catch(()=>setYtShortsLoading(false));
  }, []);
  const [selectedFeedChannel, setSelectedFeedChannel] = React.useState('nethajitv');


  const [showProfile, setShowProfile] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [lang, setLang] = useState(() => localStorage.getItem(LANG_KEY) || 'en');
  const t = T[lang];
  const toggleLang = () => { const nl = lang === 'en' ? 'ta' : 'en'; setLang(nl); localStorage.setItem(LANG_KEY, nl); };
  const [showLegal, setShowLegal] = useState(false);
  const [showLiveNews, setShowLiveNews] = useState(false);
  React.useEffect(() => { if (!showLiveNews) { window.stopBulletinAudio && window.stopBulletinAudio(); } }, [showLiveNews]);
  const [watchStreak, setWatchStreak] = React.useState(() => {
    try {
      const data = JSON.parse(localStorage.getItem("watch_streak") || "{}");
      const today = new Date().toDateString();
      const yesterday = new Date(Date.now()-86400000).toDateString();
      if (data.lastWatch === today) return data.streak || 1;
      if (data.lastWatch === yesterday) return data.streak || 1;
      return 0;
    } catch { return 0; }
  });
  const updateStreak = React.useCallback(() => {
    try {
      const data = JSON.parse(localStorage.getItem("watch_streak") || "{}");
      const today = new Date().toDateString();
      const yesterday = new Date(Date.now()-86400000).toDateString();
      let newStreak = 1;
      if (data.lastWatch === today) { newStreak = data.streak || 1; }
      else if (data.lastWatch === yesterday) { newStreak = (data.streak || 0) + 1; }
      localStorage.setItem("watch_streak", JSON.stringify({streak: newStreak, lastWatch: today}));
      setWatchStreak(newStreak);
    } catch {}
  }, []);
  const [grandOpeningDone, setGrandOpeningDone] = useState(false);
  const [showGrandOpening, setShowGrandOpening] = useState(() => {
    // Show grand opening only when IS_LIVE is true and user hasn't seen it yet
    if (!IS_LIVE) return false;
    const seen = localStorage.getItem('grand_opening_seen');
    if (seen) return false;
    return true;
  });
  const [showContact, setShowContact] = useState(false);
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  window._setSelectedVideo = setSelectedVideo;

  // Launch celebration - show for 60 seconds when app loads fresh after launch
  const [showLaunchCelebration, setShowLaunchCelebration] = React.useState(() => {
    return false; // disabled

  });

  React.useEffect(() => {
    if (showLaunchCelebration) {
      localStorage.setItem('nethaji_launch_celebrated', 'true');
      // Play celebration music
      try {
        const audio = new Audio('https://archive.org/download/NadaswaramSong/Nadaswaram%20Song%201.mp3');
        audio.play().catch(()=>{});
        setTimeout(() => { try { audio.pause(); } catch(_){} }, 60000);
      } catch(_) {}
      // Hide after 60 seconds
      setTimeout(() => setShowLaunchCelebration(false), 60000);
    }
  }, [showLaunchCelebration]);
  const [activeCategory, setActiveCategory] = useState('All');
  const [categories, setCategories] = useState([{ name: 'All', emoji: '🎬' }]);
  const [searchQuery, setSearchQuery] = useState('');
  const [subscription, setSubscription] = useState(null);
  const [trendingVideos, setTrendingVideos] = useState([]);
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);
  const [speakers, setSpeakers] = useState([]);
  const [pendingVideoId, setPendingVideoId] = useState(null);
  const [continueWatchingList, setContinueWatchingList] = useState([]);
  const [referralCode, setReferralCode] = useState(null);
  const [newVideoCount, setNewVideoCount] = useState(0);
  const [showNewVideos, setShowNewVideos] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [astroTab, setAstroTab] = useState('Panchangam');

  useEffect(() => {
    // The session guard sets this flag when it logs the user out on a 401, then
    // reloads to a signed-out state. Surface a notice via the existing toast so
    // they know why they're back at the landing page rather than watching.
    if (localStorage.getItem('np_session_expired')) {
      localStorage.removeItem('np_session_expired');
      setStreakToast('⏱️ Your session expired — please sign in again.');
      setTimeout(() => setStreakToast(null), 6000);
    }
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (token && savedUser) { const parsedUser = JSON.parse(savedUser); setUser(parsedUser); setSubscription(parsedUser.subscription || null); }
    const params = new URLSearchParams(window.location.search);
    const videoId = params.get('video');
    if (videoId) {
      setPendingVideoId(videoId);
      localStorage.setItem('pendingVideoId', videoId);
    }
    // Also check localStorage for pending video from previous session
    const storedVideoId = localStorage.getItem('pendingVideoId');
    if (storedVideoId && !videoId) setPendingVideoId(storedVideoId);
    const ref = params.get('ref'); if (ref) { setReferralCode(ref.toUpperCase()); setShowSignup(true); window.history.replaceState({}, '', '/'); }
  }, []);

  useEffect(() => {
    wakeBackend().then(() => { if (user) { fetchCategories(); fetchVideos(); fetchTrendingVideos(); setContinueWatchingList(getContinueWatchingList());
      // Read URL params for deep linking
      const params = new URLSearchParams(window.location.search);
      const cat = params.get('category');
      if(cat) {
        setActiveCategory(cat);
        if(cat==='Sports') setShowSports(true);
        else if(cat==='Health') setShowHealth(true)
        else if(cat==='Kitchen') setShowKitchen(true)
        else if(cat==='Education') setShowEducation(true)
        else if(cat==='Auto'||cat==='Automobile') setShowAuto(true)
        else if(cat==='Tourism') setShowTourism(true)
        else if(cat==='Women') setShowWomen(true)
        else if(cat==='Transport') setShowTransport(true)
        else if(cat==='Deals'||cat==='Deals & Offers') setShowDeals(true);
        else if(cat==='Movies') setShowMovies(true)
        else if(cat==='Kids') setShowKids(true)
        else if(cat==='Men') setShowMen(true)
        else if(cat==='NethajIQ') setShowNethajIQ(true)
        else if(cat==='Songs'||cat==='MGR Songs') setShowMGR(true);
      }
    } });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (pendingVideoId) {
      fetch(`${API_URL}/speeches`).then(r => r.json()).then(data => {
        const video = (data.speeches || []).find(v => v.id === pendingVideoId || v.id === parseInt(pendingVideoId));
        if (video) {
          setSelectedVideo(video);const _d=JSON.parse(localStorage.getItem("watch_streak")||"{}");const _t=new Date().toDateString();const _y=new Date(Date.now()-86400000).toDateString();const _s=_d.lastWatch===_t?(_d.streak||1):_d.lastWatch===_y?(_d.streak||0)+1:1;localStorage.setItem("watch_streak",JSON.stringify({streak:_s,lastWatch:_t}));setWatchStreak(_s);
          setPendingVideoId(null);
          localStorage.removeItem('pendingVideoId');
          window.history.replaceState({}, '', '/');
          window.scrollTo(0, 0);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      }).catch(err => console.error(err));
    }
  }, [pendingVideoId]);

  useEffect(() => { if (user) { fetchVideos(); fetchTrendingVideos(); } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, activeCategory]);

  React.useEffect(() => {
    if (!user) return;
    const HOMECHANNELS = [
      {id:"nethajitv", name:"Nethaji TV", channelId:"UCUcNLZFSeEPCmhFPMsTB_4g", color:"#cc0000"},
      {id:"nmktv", name:"NMK TV", channelId:"UCHxP-ry5QxMKTDXTQIGUs9Q", color:"#0055aa"},
      {id:"harichandra", name:"Harichandra", channelId:"UCk_iGqMBw24OPUjKyWcJKmw", color:"#ff6600"},
      {id:"bharathtv", name:"Bharath TV", channelId:"UC1xF2lFpUvHXZCAXwR_fVIw", color:"#00695c"},
    ];
    Promise.all(HOMECHANNELS.map(ch =>
      fetch(API_URL+"/api/youtube-feeds?channel_id="+ch.channelId+"&max_results=6")
        .then(r=>r.json())
        .then(data=>({...ch, videos: data.items||[]}))
        .catch(()=>({...ch, videos:[]}))
    )).then(results => {
      const feeds = {};
      results.forEach(r => { feeds[r.id] = r; });
      setHomeFeeds(feeds);
      const allIds = Object.values(feeds).flatMap(ch => ch.videos.map(v => v.videoId)).slice(0,32).join(",");
      if (allIds) {
        fetch(API_URL+"/api/youtube-stats?video_ids="+allIds)
          .then(r=>r.json())
          .then(data=>{ if(data.stats) setHomeVideoStats(data.stats); })
          .catch(()=>{});
      }
    });
  }, [user]);

  // Auto-archive videos older than 7 days
  React.useEffect(() => {
    if (user) fetch(API_URL+'/api/auto-archive').catch(()=>{});
  }, [user]);


  // Push Notification Setup
  const subscribeToPush = async () => {
    try {
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        alert('Push notifications not supported on this browser');
        return;
      }
      let permission = Notification.permission;
      if (permission === 'denied') {
        alert('Notifications blocked. Please click the lock icon in address bar and allow notifications, then refresh.');
        return;
      }
      if (permission === 'default') {
        permission = await Notification.requestPermission();
      }
      if (permission !== 'granted') {
        return;
      }
      const reg = await navigator.serviceWorker.ready;
      const vapidRes = await fetch(API_URL + '/api/push-vapid-key');
      const { public_key } = await vapidRes.json();
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: public_key
      });
      await fetch(API_URL + '/api/push-subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subscription: sub.toJSON() })
      });
      alert('Notifications enabled! You will receive updates from Nethaji Prime.');
    } catch(e) {
      console.error('Push subscription error:', e);
    }
  };

  const fetchVideos = async () => {
    try {
      const endpoint = activeCategory === 'All' ? '/speeches' : `/speeches?category=${encodeURIComponent(activeCategory)}`;
      const response = await fetch(`${API_URL}${endpoint}`); const data = await response.json(); let speechList = data.speeches || [];
      // Imported YouTube videos live under WatchNow's ALL VIDEOS chip only.
      speechList = speechList.filter(v => v.content_type !== 'youtube');
        if (activeCategory === 'Shorts') {
          try {
            const sr = await fetch(`${API_URL}/api/shorts`);
            const sd = await sr.json();
            const shortsList = (sd.shorts || []).map(sh => ({
              id: sh.id, title: sh.title, category: 'Shorts',
              thumbnail_url: sh.thumbnail_url || '', video_url: sh.video_url || '',
              bunny_video_id: sh.bunny_video_id || '',
              views_count: sh.views || 0, like_count: sh.likes || 0,
              comment_count: sh.comments || 0, created_at: sh.created_at || '',
            }));
            const seen = new Set(speechList.map(v => v.id));
            speechList = [...shortsList.filter(s => !seen.has(s.id)), ...speechList];
          } catch (e) { console.error('Error fetching shorts:', e); }
        }
      setVideos(speechList); extractSpeakers(speechList); setNewVideoCount(getNewVideoCount(speechList));
    } catch (error) { console.error('Error fetching videos:', error); }
  };
  const extractSpeakers = (videoList) => {
    const speakerMap = {};
    videoList.forEach(v => { if (v.speaker_name) { if (!speakerMap[v.speaker_name]) speakerMap[v.speaker_name] = { name: v.speaker_name, count: 0, thumbnail: v.thumbnail_url }; speakerMap[v.speaker_name].count++; } });
    setSpeakers(Object.values(speakerMap).sort((a, b) => b.count - a.count));
  };
  const fetchTrendingVideos = async () => {
    try { const response = await fetch(`${API_URL}/speeches`); const data = await response.json(); const trending = (data.speeches || []).filter(v => v.content_type !== 'youtube').filter(v => (v.hype_count || 0) > 0 || (v.views_count || 0) > 0).sort((a, b) => ((b.hype_count || 0) + (b.views_count || 0)) - ((a.hype_count || 0) + (a.views_count || 0))).slice(0, 6); setTrendingVideos(trending); }
    catch (error) { console.error('Error:', error); }
  };
  const fetchCategories = async () => { try { const response = await fetch(`${API_URL}/categories`); const data = await response.json(); setCategories(data.filter(cat => { const name = typeof cat === 'string' ? cat : cat.name; return name !== 'New' && name !== 'Archive'; })); } catch (error) { console.error('Error fetching categories:', error); } };

  const setupPushNotifications = async (userData) => {
    try {
      if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
      const permission = await Notification.requestPermission(); if (permission !== 'granted') return;
      const registration = await navigator.serviceWorker.ready;
      const vapidRes = await fetch(`${API_URL}/push/vapid-public-key`); const { public_key } = await vapidRes.json();
      const padding = '='.repeat((4 - public_key.length % 4) % 4); const base64 = (public_key + padding).replace(/-/g, '+').replace(/_/g, '/'); const rawData = window.atob(base64); const applicationServerKey = new Uint8Array(rawData.length); for (let i = 0; i < rawData.length; ++i) applicationServerKey[i] = rawData.charCodeAt(i);
      const sub = await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
      const token = localStorage.getItem('token'); await fetch(`${API_URL}/push/subscribe`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify({ subscription: sub.toJSON() }) });
    } catch (error) { console.log('Push notification setup failed:', error); }
  };

const handleLogin = (userData) => {
    setUser(userData);
    setSubscription(userData.subscription || null);
    localStorage.setItem('token', userData.token || localStorage.getItem('token'));
    localStorage.setItem('user', JSON.stringify(userData));
    // Let render guard handle routing based on isPaidMode + subscription
    // Do NOT call setShowMovies here - render will decide
  };
  const handleSignup = (userData) => { setUser(userData); setSubscription(userData.subscription || null); localStorage.setItem('user', JSON.stringify(userData)); localStorage.setItem('token', userData.token || ''); setShowSignup(false); };
  const handleLogout = () => { localStorage.removeItem('token'); localStorage.removeItem('user'); localStorage.removeItem('np_deeplink'); localStorage.removeItem('np_google_user'); window.location.hash=''; setUser(null); setSubscription(null); setSelectedVideo(null); setShowMovies(false); };
  // Auto-set showMovies when user logs in (render guard will check isPaidMode)
  React.useEffect(() => {
    if (user) {
      setShowMovies(true);  // All users including admin go to WatchNow
    }
  }, [user]);

  const handleSearch = async (e) => { e.preventDefault(); if (!searchQuery.trim()) { fetchVideos(); return; } try { const response = await fetch(`${API_URL}/search?q=${encodeURIComponent(searchQuery)}`); const data = await response.json(); setVideos(data.speeches || []); } catch (error) { console.error('Error searching:', error); } };
  const handleSubscribeChange = (speakerName, newCount) => { setVideos(prev => prev.map(v => v.speaker_name === speakerName ? { ...v, subscriber_count: newCount } : v)); };
  // "Allowed to watch" is not "is paying". In free mode hasAccess() is true for
  // every visitor, so passing it as isPaidUser suppressed ads for everyone and
  // the banner slot silently rendered nothing site-wide. Ad exclusion needs the
  // subscription itself: paid plans, free trials and admins go ad-free, plain
  // free users do not. Shape is {has_access, plan} from check_user_subscription.
  const isAdFreeUser = () =>
    !!(subscription && subscription.has_access && subscription.plan !== 'free');

  const hasAccess = () => {
    if (!isPaidMode) return true; // Free mode - all access
    if (!user) return false;
    if (user.is_admin || user.is_superadmin) return true;
    if (subscription && subscription.has_access) return true;
    return false;
  };

  // App-download landing. This app has no <Route> table, so match the real
  // path (Vercel serves index.html for unknown paths) and the hash form.
  const getAppPath = (typeof window !== 'undefined' && window.location.pathname) || '';
  const getAppHash = (typeof window !== 'undefined' && window.location.hash) || '';
  if (getAppPath === '/get-app' || getAppPath === '/download' ||
      getAppHash === '#get-app' || getAppHash === '#download') return <GetAppPage />;

  if (showAbout) return <About onBack={() => setShowAbout(false)} />;
  if (showPrivacyPolicy) return <PrivacyPolicy onBack={closeLegal} />;
  if (showTerms) return <TermsAndConditions onBack={closeLegal} />;
  if (showRefund) return <RefundPolicy onBack={closeLegal} />;
  if (showGrievance) return <GrievanceOfficer onBack={closeLegal} />;
  if (showPricing) return <Pricing onBack={() => { if(isPaidMode){ localStorage.removeItem('token'); localStorage.removeItem('user'); localStorage.removeItem('np_google_user'); window.location.reload(); } else { setShowPricing(false); setShowMovies(false); } }} user={user} isPaidMode={isPaidMode} onSubscribed={() => { setShowPricing(false); setShowMovies(true); }} />;
  if (showLeaderboard) return <Leaderboard onBack={() => setShowLeaderboard(false)} onVideoSelect={(video) => { setShowLeaderboard(false); setSelectedVideo(video); }} />;
  if (showProfile) return <UserProfile user={user} subscription={subscription} onBack={() => setShowProfile(false)} onVideoSelect={(video) => { setShowProfile(false); setSelectedVideo(video); }} onUpgrade={() => { setShowProfile(false); setShowPricing(true); }} />;
  if (showSearch) return <SearchPage onBack={() => setShowSearch(false)} onVideoSelect={(video) => { setShowSearch(false); setSelectedVideo(video); }} categories={categories} />;
  if (showMemeGenerator) return <AdvancedMemeGenerator onBack={() => setShowMemeGenerator(false)} user={user} />;
  if (showMemeGenerator) return <AdvancedMemeGenerator onBack={() => setShowMemeGenerator(false)} user={user} />;
  // showMovies check moved after auth guard - see below
  if (showKids) return <KidsPage onBack={() => {setShowKids(false);window.location.hash="";localStorage.removeItem("np_deeplink");}} t={t}  shareUrl="https://nethajiprime.com/#kids" onVideoSelect={(v)=>{setShowKids(false);setSelectedVideo(v);}}/>;
  if (showFeeds) return <NethajiFeedsPage onBack={() => {setShowFeeds(false);window.location.hash="";localStorage.removeItem("np_deeplink");}} t={t} onVideoWatch={trackVideoWatch} />;
    if (showMGR) return <MGRSongsPage onBack={() => {setShowMGR(false);window.location.hash="";localStorage.removeItem("np_deeplink");}} t={t}  shareUrl="https://nethajiprime.com/#songs"/>;
    if (showSports) return <SportsPage onBack={() => {setShowSports(false);window.location.hash="";localStorage.removeItem("np_deeplink");}} t={t}  shareUrl="https://nethajiprime.com/#sports" onVideoSelect={(v)=>{setShowSports(false);setSelectedVideo(v);}}/>;
    if (showHealth) return <HealthPage onBack={() => {setShowHealth(false);window.location.hash="";localStorage.removeItem("np_deeplink");}} t={t}  shareUrl="https://nethajiprime.com/#health" onVideoSelect={(v)=>{setShowHealth(false);setSelectedVideo(v);}}/>;
    if (showKitchen) return <KitchenPage onBack={() => {setShowKitchen(false);window.location.hash="";localStorage.removeItem("np_deeplink");}} t={t}  shareUrl="https://nethajiprime.com/#kitchen" onVideoSelect={(v)=>{setShowKitchen(false);setSelectedVideo(v);}}/>;
    if (showEducation) return <EducationPage onBack={() => {setShowEducation(false);window.location.hash="";localStorage.removeItem("np_deeplink");}} t={t}  shareUrl="https://nethajiprime.com/#education" onVideoSelect={(v)=>{setShowEducation(false);setSelectedVideo(v);}}/>;
    if (showAuto) return <AutoPage onBack={() => {setShowAuto(false);window.location.hash="";localStorage.removeItem("np_deeplink");}} t={t}  shareUrl="https://nethajiprime.com/#auto" onVideoSelect={(v)=>{setShowAuto(false);setSelectedVideo(v);}}/>;
    // TourismPage coming soon
    if (showWomen) return <WomenPage onBack={() => {setShowWomen(false);window.location.hash="";localStorage.removeItem("np_deeplink");}} t={t}  shareUrl="https://nethajiprime.com/#women" onVideoSelect={(v)=>{setShowWomen(false);setSelectedVideo(v);}}/>;
    if (showTransport) return <TransportPage onBack={() => {setShowTransport(false);window.location.hash="";localStorage.removeItem("np_deeplink");}} t={t}  shareUrl="https://nethajiprime.com/#transport" onVideoSelect={(v)=>{setShowTransport(false);setSelectedVideo(v);}}/>;
    if (showDeals) return <DealsPage onBack={() => {setShowDeals(false);setShowMovies(true);window.location.hash="";localStorage.removeItem("np_deeplink");}} t={t}  shareUrl="https://nethajiprime.com/#deals"/>;
  if (showMen) return <MenPage onBack={() => {setShowMen(false);window.location.hash="";localStorage.removeItem("np_deeplink");}} t={t}  shareUrl="https://nethajiprime.com/#men" onVideoSelect={(v)=>{setShowMen(false);setSelectedVideo(v);}}/>;
  if (showNethajIQ) return <NethajIQPage onBack={() => {setShowNethajIQ(false);window.location.hash="";localStorage.removeItem("np_deeplink");}} user={user} />;

    if (selectedFeedVideo) return <NethajiFeedsPage onBack={() => setSelectedFeedVideo(null)} initialVideo={selectedFeedVideo} initialChannel={selectedFeedChannel} />;
  if (!user) {
    if (showSignup) return <Signup onSignupSuccess={handleSignup} onSwitchToLogin={() => setShowSignup(false)} referralCode={referralCode} />;
    // If unauthenticated user tried to enter WatchNow → show Login first, redirect after
    if (showMovies) return <Login onLoginSuccess={(userData) => { handleLogin(userData); }} onSwitchToSignup={() => { setShowSignup(true); }} />;
    if (!showSignup && !showAbout && !showPricing) return <LandingPage onLogin={() => setShowSignup(false)} onSignup={() => setShowSignup(true)} onLoginSuccess={handleLogin} referralCode={referralCode} streakToast={streakToast} onEnter={() => {
      // FREE MODE: direct entry (no payment required)
      if (!isPaidMode) { setShowMovies(true); return; }
      // PAID MODE: check if user has active subscription
      if (user && (user.is_admin || user.is_superadmin)) { setShowMovies(true); return; }
      if (user && subscription && subscription.has_access) { setShowMovies(true); return; }
      // No subscription → show pricing page first
      setShowPricing(true);
    }} />;
    return <Login onLoginSuccess={handleLogin} onSwitchToSignup={() => setShowSignup(true)} />;
  }
  // Superadmin/admin goes to WatchNow like regular users (admin panel accessible from menu)
  // Admin dashboard - only for admin/superadmin users
  if (showAdminDashboard && (user.is_admin || user.is_superadmin)) return <AdminDashboard user={user} onLogout={handleLogout} onBack={()=>{ setShowAdminDashboard(false); setShowMovies(true); }} />;
  // Legal full page
  if (showLegal) return (
    <div style={{minHeight:'100vh',background:'#0a0500'}}>
      <div style={{background:'#1a0505',padding:'10px 16px',borderBottom:'1px solid rgba(212,168,67,0.3)',display:'flex',alignItems:'center',gap:12}}>
        <button onClick={()=>{setShowLegal(false);setShowMovies(true);}} style={{background:'rgba(212,168,67,0.2)',border:'1px solid #d4a843',color:'#d4a843',padding:'6px 16px',borderRadius:6,cursor:'pointer',fontWeight:700}}>← Back</button>
        <span style={{color:'#d4a843',fontFamily:"'Bebas Neue',sans-serif",fontSize:18,letterSpacing:2}}>⚖️ LEGAL</span>
      </div>
      <LegalTab onVideoClick={setSelectedVideo} hasAccess={hasAccess()} t={t} lang={lang} />
    </div>
  );
  // showMovies check - only reached if user is authenticated (non-admin)
  if (showMovies) {
    // PAID MODE guard: check subscription before entering WatchNow
    if (isPaidMode && !(subscription && subscription.has_access) && !user.is_admin && !user.is_superadmin) {
      // No active subscription in paid mode → show pricing
      if (!showPricing) {
        setTimeout(() => setShowPricing(true), 0);
      }
      return <Pricing onBack={() => { handleLogout(); window.location.href='/'; }} user={user} isPaidMode={isPaidMode} onSubscribed={() => { setShowPricing(false); }} />;
    }
    return <WatchNowPage onBack={()=>{setShowMovies(false);window.location.hash='';}} user={user} t={t} onGoogleLogin={(u)=>{ setUser(u); localStorage.setItem('user', JSON.stringify(u)); }} onUpgrade={()=>{ setShowMovies(false); setShowPricing(true); }} onLogoutMain={handleLogout} isPaidMode={isPaidMode} onAdminDashboard={()=>{ setShowMovies(false); setShowAdminDashboard(true); }} onDeals={()=>{ setShowMovies(false); setShowDeals(true); }} onLegal={()=>{ setShowMovies(false); setShowLegal(true); }} />;
  }
  if (showNethajIQ) return <NethajIQPage onBack={() => setShowNethajIQ(false)} user={user} />;
  
  return (
    <div className="App" data-lang={lang} data-category={activeCategory} data-paid-mode={isPaidMode.toString()}>
      {showGrandOpening && <GrandOpeningCover onClose={()=>setShowGrandOpening(false)} />}
      {showLaunchCelebration && (
        <div style={{position:'fixed',top:0,left:0,width:'100%',height:'100%',pointerEvents:'none',zIndex:9000,overflow:'hidden'}}>
          <style>{`
            @keyframes lc_fall { 0%{transform:translateY(-20px) rotate(0deg);opacity:1} 100%{transform:translateY(110vh) rotate(720deg);opacity:0} }
            @keyframes lc_rise { 0%{transform:translateY(0) scale(0);opacity:1} 100%{transform:translateY(-100vh) scale(1.5);opacity:0} }
            @keyframes lc_banner { 0%{opacity:0;transform:translateY(-50px)} 20%{opacity:1;transform:translateY(0)} 80%{opacity:1} 100%{opacity:0} }
            @keyframes lc_glow { 0%,100%{text-shadow:0 0 20px #d4a843} 50%{text-shadow:0 0 60px #d4a843,0 0 100px #ff4444} }
          `}</style>
          {/* Confetti */}
          {[...Array(50)].map((_,i)=>(
            <div key={i} style={{
              position:'absolute',
              left:Math.random()*100+'%',
              top:'-20px',
              width: (5+Math.random()*10)+'px',
              height: (5+Math.random()*10)+'px',
              background:['#ff4444','#ffdd00','#00ff88','#4488ff','#ff44ff','#ff8800','#fff'][i%7],
              borderRadius: i%3===0?'50%':'2px',
              animation:`lc_fall ${2+Math.random()*4}s ${Math.random()*5}s linear infinite`
            }}/>
          ))}
          {/* Fireworks rising */}
          {[...Array(20)].map((_,i)=>(
            <div key={i} style={{
              position:'absolute',
              left:Math.random()*100+'%',
              bottom:'0',
              fontSize:(20+Math.random()*20)+'px',
              animation:`lc_rise ${1+Math.random()*2}s ${Math.random()*8}s ease-out infinite`
            }}>{'🎆🎇✨🎉🎊'[i%5]}</div>
          ))}
          {/* Banner */}
          <div style={{
            position:'absolute',top:'20%',left:'50%',transform:'translateX(-50%)',
            textAlign:'center',animation:'lc_banner 60s ease forwards',
            background:'rgba(0,0,0,0.85)',padding:'20px 40px',borderRadius:'16px',
            border:'2px solid #d4a843',whiteSpace:'nowrap'
          }}>
            <div style={{fontSize:'clamp(24px,5vw,48px)',fontWeight:900,color:'#d4a843',fontFamily:"'Cinzel',serif",animation:'lc_glow 1s infinite'}}>
              🎉 NETHAJI PRIME IS LIVE! 🎉
            </div>
            <div style={{color:'#fff',fontSize:'clamp(14px,2vw,20px)',marginTop:'8px',letterSpacing:'2px'}}>
              மக்களுக்காக — நேதாஜி பிரைம்
            </div>
          </div>
        </div>
      )}
      {showUpgradePrompt && !subscription?.has_access && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:99998,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}}>
          <div style={{background:getABGroup()==="B"?"linear-gradient(135deg,#1a0000,#3d0000)":"linear-gradient(135deg,#1a0500,#2d0a00)",border:getABGroup()==="B"?"2px solid #ff4444":"2px solid #d4a843",borderRadius:"16px",padding:"24px",maxWidth:"380px",width:"100%",textAlign:"center"}}>
            <div style={{fontSize:"48px",marginBottom:"12px"}}>{getABGroup()==="B"?"🔥":"👑"}</div>
            <div style={{color:getABGroup()==="B"?"#ff4444":"#d4a843",fontWeight:900,fontSize:"20px",marginBottom:"8px"}}>{getABGroup()==="B"?"⚡ Limited Time Offer!":"Enjoying Nethaji Prime?"}</div>
            <div style={{color:"rgba(255,255,255,0.6)",fontSize:"13px",marginBottom:"16px"}}>You've watched {videosWatched} videos! Upgrade to Premium for unlimited access, HD quality & ad-free experience.</div>
            <div style={{background:"rgba(212,168,67,0.1)",borderRadius:"10px",padding:"12px",marginBottom:"16px"}}>
              <div style={{color:"#d4a843",fontWeight:900,fontSize:"24px"}}>₹99/month</div>
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>or ₹799/year — Save 33%!</div>
            </div>
            <div style={{display:"flex",gap:"10px"}}>
              <button onClick={()=>{setShowUpgradePrompt(false);setShowPricing(true);}} style={{flex:1,background:"#d4a843",border:"none",borderRadius:"8px",color:"#000",fontWeight:900,fontSize:"14px",padding:"12px",cursor:"pointer"}}>Upgrade Now 🚀</button>
              <button onClick={()=>setShowUpgradePrompt(false)} style={{background:"transparent",border:"1px solid rgba(255,255,255,0.2)",borderRadius:"8px",color:"rgba(255,255,255,0.4)",fontSize:"12px",padding:"12px",cursor:"pointer"}}>Later</button>
            </div>
          </div>
        </div>
      )}
      {/* FULLSCREEN VIDEO PLAYER — rendered on top of everything */}
      {selectedVideo && (
        <FullscreenPlayer
          key={selectedVideo.id}
          video={selectedVideo}
          onClose={() => setSelectedVideo(null)}
          user={user}
          hasAccess={hasAccess()}
          onSubscribeChange={handleSubscribeChange}
          onUpgrade={() => { setSelectedVideo(null); setShowPricing(true); }}
          onVideoSelect={(v) => setSelectedVideo(v)}
          videos={videos}
          t={t}
          setContinueWatchingList={setContinueWatchingList}
        />
      )}

      <header className="App-header">
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',width:'100%',maxWidth:'100vw',boxSizing:'border-box',padding:'6px 2%',borderBottom:'1px solid rgba(212,168,67,0.12)',overflow:'hidden'}}>
          {/* LEFT - LOGO */}
          <div style={{display:'flex',alignItems:'center',gap:'10px',cursor:'pointer',flexShrink:0}} onClick={()=>setActiveCategory('All')}>
            <img src="https://media.nethajiprime.com/nethaji-logo.png" alt="Nethaji Prime OTT" style={{height:'clamp(34px,3.5vw,72px)',width:'auto',maxHeight:'72px',minHeight:'34px',objectFit:'contain',display:'block',filter:'drop-shadow(0 0 16px rgba(212,168,67,1.0)) drop-shadow(0 0 32px rgba(180,80,10,0.5)) brightness(1.3) saturate(1.5) contrast(1.1)'}} onError={(e)=>{e.target.style.display='none';e.target.nextSibling.style.display='flex';}} />
            <div style={{display:'none',flexDirection:'column',alignItems:'center',justifyContent:'center',background:'linear-gradient(135deg,#1a0000,#2a0000)',border:'2px solid #cc0000',borderRadius:'8px',padding:'4px 10px',minWidth:'80px'}}>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'18px',fontWeight:'900',color:'#f5c842',letterSpacing:'2px',lineHeight:1}}>NETHAJI</div>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'10px',fontWeight:'800',color:'#cc0000',letterSpacing:'3px',lineHeight:1}}>PRIME</div>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'9px',fontWeight:'700',color:'#fff',letterSpacing:'2px',background:'#cc0000',padding:'1px 6px',borderRadius:'2px',marginTop:'2px'}}>OTT</div>
            </div>
          </div>
          {/* MIDDLE - TITLE */}
          <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',textAlign:'center',flex:'1 1 0',minWidth:0,width:0,padding:'0 4px',overflow:'hidden'}}>
            <div className="footer-logo" style={{fontSize:'clamp(14px,2.5vw,28px)',margin:0,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',maxWidth:'100%'}}>NETHAJI <span>PRIME</span> <em>OTT</em></div>
            <div style={{fontSize:'clamp(8px,1.2vw,12px)',color:'#ffffff',marginTop:'2px',letterSpacing:'0.3px',width:'100%',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',textAlign:'center'}}>அரசியல் · சமூக பிரச்சனை · அறிவியல் · கலாச்சாரம் · விளையாட்டு · சினிமா · பொழுதுபோக்கு</div>
            <div style={{fontSize:'clamp(7px,1vw,10px)',color:'#ffffff',marginTop:'1px',letterSpacing:'0.3px',width:'100%',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',textAlign:'center'}}>Politics · Social Issues · Science · Culture · Sports · Astrology · Devotional · Cinema · Entertainment</div>
          </div>
          {/* RIGHT - ACTIONS */}
          <div style={{display:'flex',alignItems:'center',gap:'6px',flexShrink:0}}>
            <div className="search-container desktop-only" style={{marginRight:'4px'}}>
              <form onSubmit={handleSearch} style={{display:'flex',alignItems:'center',width:'100%'}}>
                <input type="text" placeholder={t.search_placeholder} value={searchQuery} onChange={(e)=>setSearchQuery(e.target.value)} />
                <span className="search-icon">🔍</span>
              </form>
            </div>
            {watchStreak > 0 && (
              <div title={"Day "+watchStreak+" streak! Keep watching daily!"} style={{display:"flex",alignItems:"center",gap:"4px",background:"linear-gradient(135deg,rgba(255,100,0,0.2),rgba(255,60,0,0.1))",border:"1px solid rgba(255,100,0,0.5)",borderRadius:"20px",padding:"4px 12px",flexShrink:0,cursor:"default"}}>
                <span style={{color:"#ff6600",fontWeight:900,fontSize:"11px",letterSpacing:"1px"}}>DAY</span>
                <span style={{color:"#fff",fontWeight:900,fontSize:"14px"}}>{watchStreak}</span>
                <span style={{color:"#ff6600",fontWeight:900,fontSize:"11px",letterSpacing:"1px"}}>STREAK</span>
              </div>
            )}
            <button onClick={()=>subscribeToPush()} style={{background:'transparent',border:'1px solid rgba(212,168,67,0.35)',color:'#d4a843',padding:'6px 8px',borderRadius:'4px',cursor:'pointer',fontSize:'14px',position:'relative',flexShrink:0}}>
              🔔{newVideoCount>0&&(<span style={{position:'absolute',top:'-6px',right:'-6px',background:'#ff4444',color:'#fff',borderRadius:'50%',width:'16px',height:'16px',fontSize:'9px',fontWeight:'700',display:'flex',alignItems:'center',justifyContent:'center'}}>{newVideoCount>9?'9+':newVideoCount}</span>)}
            </button>
            <button onClick={()=>setShowPricing(true)} style={{background:'#cc0000',color:'#fff',border:'none',padding:'6px 10px',borderRadius:'4px',cursor:'pointer',fontFamily:"'Barlow Condensed',sans-serif",fontSize:'11px',fontWeight:'800',letterSpacing:'1px',textTransform:'uppercase',flexShrink:0,whiteSpace:'nowrap'}}>{t.subscribe_now}</button>
          </div>
        </div>
        <div style={{display:'flex',alignItems:'center',width:'100%',padding:'0',flexWrap:'nowrap',height:'36px',overflow:'hidden'}}>
          <button onClick={()=>{const n=document.querySelector('.hcat-nav');if(n)n.scrollLeft-=200;}} style={{background:'transparent',border:'none',color:'rgba(212,168,67,0.7)',fontSize:'18px',cursor:'pointer',padding:'0 4px',flexShrink:0}}>&#8249;</button><div className='hcat-nav' style={{display:'flex',alignItems:'center',gap:'0',overflowX:'auto',overflowY:'hidden',flex:1,padding:'0 1%'}}>
            {categories.filter(cat=>{const name=typeof cat==='string'?cat:cat.name; return name!=='Legal' && name!=='Shorts';}).map((cat)=>{ const name=typeof cat==='string'?cat:cat.name; const emoji=typeof cat==='object'&&cat.emoji?cat.emoji:''; const displayName=name==='All'?t.home:name==='Archive'?t.old:name==='New'?t.cat_New:name==='Deals'?(t.cat_Deals||'Deals & Offers'):name==='NethajIQ'?'NethajIQ':t['cat_'+name.replace(' ','_')]||name;
      if(name==='Deals'){return(<button key={name} className={'hcat-pill '+(showDeals?'active':'')} onClick={()=>{trackUserInterest('Deals');setShowDeals(true);window.location.hash='deals';setShowMen(false);setShowNethajIQ(false);setShowWomen(false);setShowTourism(false);setShowAuto(false);setShowEducation(false);setShowKitchen(false);setShowHealth(false);setShowSports(false);setShowMGR(false);setShowFeeds(false);setShowKids(false);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setActiveCategory('All');window.location.hash='';window.scrollTo({top:0,behavior:'smooth'});}}>&#128722; {t.cat_Deals||'Deals'}</button>);}
      if(name==='NethajIQ'){return(<button key={name} onClick={()=>{setShowNethajIQ(true);}} style={{background:'linear-gradient(135deg,#9900cc,#cc44ff)',border:'none',borderRadius:'20px',color:'#fff',padding:'6px 14px',cursor:'pointer',fontWeight:'800',fontSize:'11px',whiteSpace:'nowrap',letterSpacing:'1px'}}>&#129504;&#9889; NethajIQ</button>);}
      const displayName2=displayName; const displayEmoji=name==='All'?'🏠':emoji; return(<button key={name} className={`hcat-pill ${activeCategory===name&&!showLegal&&!showLiveNews?'active':''}`} onClick={()=>{setActiveCategory(name);window.location.hash=name.toLowerCase().replace(' ','-');setSelectedSpeaker(null);setShowLegal(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();window.speechSynthesis.cancel();}}>{displayEmoji} {displayName}</button>); })}
            <button className={"hcat-pill " + (showLegal?"active":"")} onClick={()=>{window.speechSynthesis.cancel();setShowLegal(true);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();}}>&#9878; {t.cat_Legal}</button>
            <button className={"hcat-pill " + (showLiveNews?"active":"")} onClick={()=>{setShowLiveNews(true);window.location.hash="news";setShowLegal(false);setActiveCategory("All");window.scrollTo({top:0,behavior:"smooth"});}}>&#128308; {t.cat_Live_News}</button>

            
            <button className={"hcat-pill " + (showKids?"active":"")} onClick={()=>{setShowKids(true);window.location.hash='kids';window.location.hash="kids";setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setShowFeeds(false);setActiveCategory("All");window.scrollTo({top:0,behavior:"smooth"});}}>&#128049; {t.cat_Kids}</button>
            <button className={"hcat-pill " + (showFeeds&&!showLegal&&!showLiveNews&&!showMovies&&!showKids?"active":"")} onClick={()=>{setShowFeeds(true);window.location.hash="nethajitv";setShowKids(false);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setShowMGR(false);setActiveCategory("All");window.scrollTo({top:0,behavior:"smooth"});}}>&#128251; {t.cat_Nethaji_TV}</button><button className={"hcat-pill " + (showSports?"active":"")} onClick={()=>{trackUserInterest("Sports");setShowSports(true);window.location.hash="sports";setActiveCategory('Sports');window.location.hash="sports";setShowMGR(false);setShowFeeds(false);setShowKids(false);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setActiveCategory("All");window.scrollTo({top:0,behavior:"smooth"});}}>&#127942; {t.cat_Sports||'Sports'}</button><button className={"hcat-pill " + (showHealth?"active":"")} onClick={()=>{trackUserInterest("Health");setShowHealth(true);window.location.hash="health";setActiveCategory('Health');window.location.hash="health";setShowSports(false);setShowMGR(false);setShowFeeds(false);setShowKids(false);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setActiveCategory("All");window.scrollTo({top:0,behavior:"smooth"});}}>&#128170; {t.cat_Health||"Health"}</button><button className={"hcat-pill " + (showEducation?"active":"")} onClick={()=>{setShowEducation(true);window.location.hash="education";setActiveCategory('Education');setShowKitchen(false);setShowHealth(false);setShowSports(false);setShowMGR(false);setShowFeeds(false);setShowKids(false);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setActiveCategory("All");window.scrollTo({top:0,behavior:"smooth"});}}>&#128218; {t.cat_Education||"Education"}</button><button className={"hcat-pill " + (showTransport?"active":"")} onClick={()=>{setShowTransport(true);window.location.hash='transport';window.location.hash="transport";setShowWomen(false);setShowTourism(false);setShowAuto(false);setShowEducation(false);setShowKitchen(false);setShowHealth(false);setShowSports(false);setShowMGR(false);setShowFeeds(false);setShowKids(false);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setActiveCategory("All");window.scrollTo({top:0,behavior:"smooth"});}}>🚘 {t.cat_Transport||'Transport'}</button>
          
          </div><button onClick={()=>{const n=document.querySelector('.hcat-nav');if(n)n.scrollLeft+=200;}} style={{background:'transparent',border:'none',color:'rgba(212,168,67,0.7)',fontSize:'18px',cursor:'pointer',padding:'0 4px',flexShrink:0}}>&#8250;</button>
          <div style={{display:'flex',alignItems:'center',gap:'6px',flexShrink:0,paddingRight:'8px'}}>
            <button onClick={toggleLang} className="lang-toggle-btn desktop-only">🌐 {t.lang_toggle}</button>
            {subscription&&(<span className="desktop-only" style={{color:subscription.has_access?'#00d480':'#ff4444',fontSize:'11px',fontWeight:'600',background:subscription.has_access?'rgba(0,212,128,0.1)':'rgba(255,68,68,0.1)',padding:'3px 8px',borderRadius:'10px',marginRight:'4px'}}>{subscription.plan==='admin'?'👑 Admin':subscription.plan==='premium'?'✅ Premium':t.free_access}</span>)}
            <button onClick={()=>setShowProfile(true)} className="user-profile-btn desktop-only">👤 {user.full_name}</button>
            <button onClick={async()=>{
              if(!('Notification' in window)){alert('Notifications not supported');return;}
              if(Notification.permission==='granted'){alert('✅ Already subscribed to notifications!');return;}
              const perm = await Notification.requestPermission();
              if(perm==='granted'){
                const token = localStorage.getItem('token');
                await subscribeToPush(token);
                alert('🔔 You will be notified when new videos are uploaded!');
              } else {
                alert('❌ Please allow notifications in your browser settings');
              }
            }} className="bell-btn desktop-only" title="Get notified of new videos" style={{background:'rgba(212,168,67,0.15)',border:'1px solid rgba(212,168,67,0.4)',color:'#d4a843',borderRadius:'6px',padding:'6px 10px',cursor:'pointer',fontSize:'16px',marginRight:'4px'}}>🔔</button>
            <button onClick={handleLogout} className="auth-btn desktop-only">{t.logout}</button>
            <button className={`hamburger-btn ${menuOpen?'open':''}`} onClick={()=>setMenuOpen(!menuOpen)} style={{marginLeft:'4px'}}><span></span><span></span><span></span></button>
          </div>
        </div>
      </header>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`}>
        <div className="mobile-search"><form onSubmit={(e) => { e.preventDefault(); handleSearch(e); setMenuOpen(false); }}><input type="text" placeholder={`🔍 ${t.search_placeholder}`} value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} /></form></div>
        <div className="mobile-user-info"><span className="mobile-user-name">👤 {user.full_name}</span>{subscription && (<span style={{color:subscription.has_access?'#00d480':'#ff4444',fontSize:'11px',fontWeight:'700',background:subscription.has_access?'rgba(0,212,128,0.1)':'rgba(255,68,68,0.1)',padding:'3px 10px',borderRadius:'10px'}}>{subscription.plan==='admin'?'👑 Admin':subscription.plan==='premium'?'✅ Premium':'🎁 Free Access'}</span>)}</div>
        {/* SUBSCRIBE + BELL IN MOBILE MENU */}
        <div style={{display:'flex',gap:'10px',padding:'12px 5%',borderBottom:'1px solid rgba(212,168,67,0.15)'}}>
          <button onClick={()=>{setShowPricing(true);setMenuOpen(false);}} style={{flex:1,background:'#cc0000',color:'#fff',border:'none',padding:'12px',borderRadius:'6px',cursor:'pointer',fontFamily:"'Barlow Condensed',sans-serif",fontSize:'14px',fontWeight:'800',letterSpacing:'1.5px',textTransform:'uppercase'}}>🎬 {t.subscribe_now}</button>
          <button onClick={async()=>{ if(!('Notification' in window)){alert('Not supported');return;} if(Notification.permission==='granted'){alert('✅ Already enabled!');return;} await setupPushNotifications(user);setMenuOpen(false); }} style={{background:'rgba(212,168,67,0.15)',border:'1px solid rgba(212,168,67,0.4)',color:'#d4a843',padding:'12px 16px',borderRadius:'6px',cursor:'pointer',fontSize:'18px'}}>🔔</button>
        </div>
        <div className="mobile-menu-section-title">{t.categories}</div>
        {categories.filter(cat=>{const name=typeof cat==='string'?cat:cat.name; return name!=='Legal' && name!=='Deals' && name!=='NethajIQ';}).map((cat) => { const name=typeof cat==='string'?cat:cat.name; const emoji=typeof cat==='object'&&cat.emoji?cat.emoji:''; const displayName=name==='All'?t.home:name==='Archive'?t.old:name==='New'?t.cat_New:t['cat_'+name.replace(' ','_')]||name; const displayEmoji=name==='All'?'🏠':emoji; return(<button key={name} className={`mobile-menu-item mobile-cat-item ${activeCategory===name&&!showLegal?'active':''}`} onClick={()=>{setActiveCategory(name);setSelectedSpeaker(null);setShowLegal(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setMenuOpen(false);}}>{displayEmoji} {displayName}</button>); })}
        <button className={"mobile-menu-item mobile-cat-item " + (showDeals?"active":"")} onClick={()=>{setShowDeals(true);setMenuOpen(false);}}>🛒 {t.cat_Deals||'Deals & Offers'}</button>
        <button className={"mobile-menu-item mobile-cat-item " + (showNethajIQ?"active":"")} onClick={()=>{setShowNethajIQ(true);setMenuOpen(false);}}>🧠 NethajIQ</button>
        <button className={`mobile-menu-item mobile-cat-item ${showLegal?'active':''}`} onClick={()=>{window.speechSynthesis.cancel();setShowLegal(true);setMenuOpen(false);}}>⚖️ {t.cat_Legal}</button>
        <button className={"mobile-menu-item mobile-cat-item " + (showLiveNews?"active":"")} onClick={()=>{setShowLiveNews(true);setShowLegal(false);setActiveCategory("All");setMenuOpen(false);window.scrollTo({top:0,behavior:"smooth"});}}>&#128308; {t.cat_Live_News}</button>
        
        
        
        <button className={"mobile-menu-item mobile-cat-item " + (showKids?"active":"")} onClick={()=>{setShowKids(true);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setShowFeeds(false);setActiveCategory("All");setMenuOpen(false);window.scrollTo({top:0,behavior:"smooth"});}}>&#128049; {t.cat_Kids}</button>
        <button className={"mobile-menu-item mobile-cat-item " + (showFeeds?"active":"")} onClick={()=>{setShowFeeds(true);window.location.hash="nethajitv";setShowKids(false);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setShowMGR(false);setActiveCategory("All");setMenuOpen(false);window.scrollTo({top:0,behavior:"smooth"});}}>&#128251; {t.cat_Nethaji_TV}</button><button className={"mobile-menu-item mobile-cat-item " + (showSports?"active":"")} onClick={()=>{trackUserInterest("Sports");setShowSports(true);setShowMGR(false);setShowFeeds(false);setShowKids(false);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setActiveCategory("All");window.scrollTo({top:0,behavior:"smooth"});}}>&#127942; {t.cat_Sports||'Sports'}</button><button className={"mobile-menu-item mobile-cat-item " + (showHealth?"active":"")} onClick={()=>{trackUserInterest("Health");setShowHealth(true);setShowSports(false);setShowMGR(false);setShowFeeds(false);setShowKids(false);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setActiveCategory("All");window.scrollTo({top:0,behavior:"smooth"});}}>&#128170; {t.cat_Health||"Health"}</button><button className={"mobile-menu-item mobile-cat-item " + (showEducation?"active":"")} onClick={()=>{setShowEducation(true);window.location.hash="education";setShowKitchen(false);setShowHealth(false);setShowSports(false);setShowMGR(false);setShowFeeds(false);setShowKids(false);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setActiveCategory("All");window.scrollTo({top:0,behavior:"smooth"});}}>&#128218; {t.cat_Education||"Education"}</button><button className={"hcat-pill " + (showTransport?"active":"")} onClick={()=>{setShowTransport(true);setShowWomen(false);setShowTourism(false);setShowAuto(false);setShowEducation(false);setShowKitchen(false);setShowHealth(false);setShowSports(false);setShowMGR(false);setShowFeeds(false);setShowKids(false);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setActiveCategory("All");window.scrollTo({top:0,behavior:"smooth"});}}>🚘 {t.cat_Transport||'Transport'}</button>
        
        
        <button className="mobile-menu-item lang-mobile-btn" onClick={()=>{toggleLang();setMenuOpen(false);}}>🌐 {lang==='en'?'தமிழில் பார்க்க':'View in English'}</button>
        <div className="mobile-menu-section-title">{t.menu}</div>
        <button className="mobile-menu-item" onClick={()=>{setShowProfile(true);setMenuOpen(false);}}>{t.my_profile}</button>
        <button className="mobile-menu-item" onClick={()=>{setShowPricing(true);setMenuOpen(false);}}>{t.pricing}</button>
        <button className="mobile-menu-item" onClick={()=>{setShowLeaderboard(true);setMenuOpen(false);}}>{t.top_charts}</button>
        <button className="mobile-menu-item" onClick={()=>{setShowMemeGenerator(true);setMenuOpen(false);}}>MEME</button>
        <button className="mobile-menu-item" onClick={()=>{setShowAbout(true);setMenuOpen(false);}}>{t.about}</button>
        <button className="mobile-menu-item" style={{width:'100%',boxSizing:'border-box',textAlign:'left'}} onClick={()=>{setShowSearch(true);setMenuOpen(false);}}>{t.advanced_search}</button>
        <div style={{height:'1px',background:'rgba(212,168,67,0.15)',margin:'4px 0'}}/>
        <button className="mobile-menu-item" style={{color:'#ff4444',fontWeight:'800',width:'100%',boxSizing:'border-box',textAlign:'left'}} onClick={()=>{handleLogout();setMenuOpen(false);}}>🚪 {t.logout}</button>
      </div>

      <div className="main-content">
        {/* BANNERS */}
        {!showLegal && !showLiveNews && activeCategory !== 'Astrology' && activeCategory !== 'Stock Market' && activeCategory !== 'Devotional' && activeCategory !== 'Interviews' && activeCategory !== 'Shorts' && activeCategory !== 'Reels' && activeCategory !== 'Sun Detective' && (
          <div style={{width:'100%',lineHeight:0,position:'relative',overflow:'hidden'}}>
            <picture>
              <img src="https://pub-4f2f6c0fd7b44aaea59a2aad55084907.r2.dev/red%20border.jpg.jpeg" alt="Nethaji Prime Banner"
                style={{
                  width:'100%',
                  maxWidth:'100vw',
                  height:'auto',
                  display:'block'
                }}
              />
            </picture>
            {/* Golden shimmer overlay on left dark area */}
            <div style={{position:'absolute',inset:0,background:'linear-gradient(90deg, rgba(212,168,67,0.18) 0%, rgba(212,168,67,0.08) 30%, transparent 55%)',pointerEvents:'none',zIndex:2}}/>
            {/* Bottom golden glow */}
            <div style={{position:'absolute',bottom:0,left:0,right:0,height:'40%',background:'linear-gradient(0deg, rgba(180,80,10,0.25) 0%, transparent 100%)',pointerEvents:'none',zIndex:2}}/>
            {/* Top cinematic bar */}
            <div style={{position:'absolute',top:0,left:0,right:0,height:'3px',background:'linear-gradient(90deg,transparent,rgba(212,168,67,0.8),rgba(212,168,67,1),rgba(212,168,67,0.8),transparent)',zIndex:3}}/>

            <div onClick={()=>document.querySelector('.videos-section')?.scrollIntoView({behavior:'smooth'})} style={{position:'absolute',top:'72%',left:'20%',width:'14%',height:'12%',cursor:'pointer',zIndex:10}} />
            <div onClick={()=>setShowPricing(true)} style={{position:'absolute',top:'72%',left:'36%',width:'12%',height:'12%',cursor:'pointer',zIndex:10}} />
          </div>
        )}

        {/* ── ASTROLOGY BANNER ── */}
        {!showLegal  && activeCategory === 'Astrology' && (
          <div className="astro-banner">
            <svg width="100%" viewBox="0 0 1400 420" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
              <defs>
                <radialGradient id="astroBg" cx="50%" cy="50%" r="80%"><stop offset="0%" stopColor="#0a0030" stopOpacity="1"/><stop offset="50%" stopColor="#050018" stopOpacity="1"/><stop offset="100%" stopColor="#020008" stopOpacity="1"/></radialGradient>
                <radialGradient id="moonGlow" cx="78%" cy="22%" r="18%"><stop offset="0%" stopColor="#fffde0" stopOpacity="0.9"/><stop offset="40%" stopColor="#f5c842" stopOpacity="0.4"/><stop offset="100%" stopColor="#f5c842" stopOpacity="0"/></radialGradient>
                <radialGradient id="omGlow" cx="30%" cy="50%" r="30%"><stop offset="0%" stopColor="#ff8c00" stopOpacity="0.35"/><stop offset="100%" stopColor="#ff8c00" stopOpacity="0"/></radialGradient>
                <radialGradient id="centerGlow" cx="50%" cy="50%" r="40%"><stop offset="0%" stopColor="#8b00ff" stopOpacity="0.2"/><stop offset="100%" stopColor="#8b00ff" stopOpacity="0"/></radialGradient>
                <linearGradient id="astroFade" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" stopColor="#020008" stopOpacity="0.1"/><stop offset="60%" stopColor="#020008" stopOpacity="0.5"/><stop offset="100%" stopColor="#020008" stopOpacity="0.97"/></linearGradient>
                <linearGradient id="astroFadeL" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stopColor="#020008" stopOpacity="0.92"/><stop offset="40%" stopColor="#020008" stopOpacity="0.5"/><stop offset="100%" stopColor="#020008" stopOpacity="0"/></linearGradient>
                <linearGradient id="goldLine" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stopColor="#f5c842" stopOpacity="0"/><stop offset="30%" stopColor="#f5c842" stopOpacity="1"/><stop offset="70%" stopColor="#f5c842" stopOpacity="1"/><stop offset="100%" stopColor="#f5c842" stopOpacity="0"/></linearGradient>
                <filter id="starBlur"><feGaussianBlur stdDeviation="1.5"/></filter>
                <filter id="glowBlur"><feGaussianBlur stdDeviation="8"/></filter>
                <filter id="softGlow"><feGaussianBlur stdDeviation="3"/></filter>
              </defs>
              <rect width="1400" height="420" fill="url(#astroBg)"/>
              <rect width="1400" height="420" fill="url(#moonGlow)"/>
              <rect width="1400" height="420" fill="url(#omGlow)"/>
              <rect width="1400" height="420" fill="url(#centerGlow)"/>
              {[[50,20],[120,45],[200,15],[280,55],[370,25],[460,40],[560,18],[650,35],[750,22],[840,48],[930,30],[1020,52],[1110,20],[1200,42],[1300,28],[1380,55],[80,80],[160,95],[250,70],[340,100],[430,85],[520,65],[620,90],[720,75],[820,98],[920,68],[1010,88],[1100,72],[1190,95],[1290,78],[1360,92],[35,130],[140,145],[230,120],[320,155],[410,135],[510,118],[600,148],[700,128],[800,150],[900,122],[1000,142],[1090,125],[1180,152],[1280,132],[1370,148]].map(([x,y],i) => (<circle key={i} cx={x} cy={y} r={i%5===0?1.8:i%3===0?1.2:0.7} fill="#fff" opacity={0.3+0.5*(i%4)/4}/>))}
              {[[180,60],[420,35],[700,45],[950,28],[1150,58],[1320,38],[90,110],[350,95],[620,105],[880,90],[1130,108]].map(([x,y],i)=>(<g key={i}><circle cx={x} cy={y} r="3" fill="#fff" opacity="0.9"/><circle cx={x} cy={y} r="6" fill="#f5c842" opacity="0.2" filter="url(#starBlur)"/></g>))}
              <circle cx="1050" cy="88" r="72" fill="#fffde0" opacity="0.92"/>
              <circle cx="1068" cy="78" r="58" fill="#020008" opacity="0.88"/>
              <text x="280" y="255" fontFamily="serif" fontSize="140" fill="#ffaa30" opacity="0.55" textAnchor="middle" fontWeight="bold">ॐ</text>
              <circle cx="1100" cy="270" r="155" fill="none" stroke="#f5c842" strokeWidth="0.8" opacity="0.25"/>
              <circle cx="1100" cy="270" r="100" fill="none" stroke="#d4a843" strokeWidth="0.8" opacity="0.3"/>
              <circle cx="1100" cy="270" r="45" fill="none" stroke="#f5c842" strokeWidth="1" opacity="0.35"/>
              {Array.from({length:12},(_,i)=>{const angle=(i*30-90)*Math.PI/180;return <line key={i} x1={1100+45*Math.cos(angle)} y1={270+45*Math.sin(angle)} x2={1100+155*Math.cos(angle)} y2={270+155*Math.sin(angle)} stroke="#d4a843" strokeWidth="0.6" opacity="0.3"/>;  })}
              {['♈','♉','♊','♋','♌','♍','♎','♏','♐','♑','♒','♓'].map((sign,i)=>{const angle=(i*30-90)*Math.PI/180;const x=1100+116*Math.cos(angle),y=270+116*Math.sin(angle);return <text key={i} x={x} y={y+5} fontFamily="serif" fontSize="16" fill="#f5c842" opacity="0.8" textAnchor="middle">{sign}</text>;})}
              <circle cx="750" cy="130" r="22" fill="#c8a870" opacity="0.85"/>
              <ellipse cx="750" cy="130" rx="42" ry="9" fill="none" stroke="#d4a843" strokeWidth="2.5" opacity="0.6"/>
              <circle cx="900" cy="160" r="12" fill="#cc4422" opacity="0.8"/>
              <rect width="1400" height="420" fill="url(#astroFade)"/>
              <rect width="1400" height="420" fill="url(#astroFadeL)"/>
              <rect width="1400" height="2" fill="url(#goldLine)" opacity="0.8"/>
            </svg>
            <div className="astro-content" style={{position:"absolute",top:"50%",left:0,right:0,transform:"translateY(-50%)",width:"100%",maxWidth:"100%",padding:"20px 5%",boxSizing:"border-box",zIndex:10}}>
              <div className="astro-badge"><span className="astro-badge-dot"></span><span>{lang === 'ta' ? '🔮 ஜோதிட விழிப்புணர்வு' : '🔮 VEDIC ASTROLOGY'}</span></div>
              <div className="astro-title">
                <span className="astro-t1">{lang === 'ta' ? 'வேத' : 'VEDIC'}</span>
                <span className="astro-t2">{lang === 'ta' ? 'ஜோதிடம்' : 'ASTROLOGY'}</span>
                <span className="astro-t3">{lang === 'ta' ? 'உங்கள் விதியை அறியுங்கள்' : 'Know Your Destiny'}</span>
              </div>
              <div className="astro-rule"><span className="astro-rule-l"></span><span className="astro-rule-d">ॐ</span><span className="astro-rule-r"></span></div>
              <p className="astro-sub">{lang === 'ta' ? 'ராசி • கிரகங்கள் • நட்சத்திரம் • பலன்கள்' : 'Rashi · Planets · Nakshatras · Predictions'}<br/>{lang === 'ta' ? 'நேத்தாஜி பிரைம் OTT-யில் சிறந்த ஜோதிடர்கள்' : 'Expert astrologers exclusively on Nethaji Prime OTT'}</p>
              <div className="astro-tags">{['♈ Rashi','☿ Planets','⭐ Nakshatra','🌙 Moon Sign','☀ Sun Sign','🪐 Saturn'].map(tag => (<span key={tag} className="astro-tag">{tag}</span>))}</div>
            </div>
          </div>
        )}

        {!showLegal && activeCategory === "Astrology" && (
          <div style={{background:"linear-gradient(180deg,#020008,#000)",padding:"0 0 40px"}}>

            {/* -- SECTION TABS -- */}
            <div style={{display:"flex",gap:"0",borderBottom:"1px solid rgba(212,168,67,0.2)",overflowX:"auto",scrollbarWidth:"none",padding:"0 4%"}}>
              {["Birth Chart","Panchangam","Calendar","Festivals","Rasi","Nakshatra","Rahu Kalam","Muhurtham","Learn"].map((tab,i) => {
                const icons = ["&#9670;","&#9737;","&#128197;","&#127774;","&#9800;","&#11088;","&#9201;","&#128336;","&#128218;"];
                const isActive = astroTab === tab;
                return (
                  <button key={tab} onClick={() => { setAstroTab(tab); }}
                    style={{padding:"12px 16px",background:"transparent",border:"none",borderBottom:isActive?"2px solid #d4a843":"2px solid transparent",color:isActive?"#d4a843":"rgba(255,255,255,0.5)",cursor:"pointer",fontSize:"clamp(10px,1.5vw,13px)",fontWeight:700,whiteSpace:"nowrap",letterSpacing:"0.5px"}}
                    id={"astro-tab-"+i}>
                    <span dangerouslySetInnerHTML={{__html:icons[i]+" "+tab}} />
                  </button>
                );
              })}
            </div>

            {/* -- CONTENT AREA -- */}
            {astroTab === "Birth Chart" && <BirthChartContent />}
            <div id="astro-content" data-tab="Panchangam" style={{padding:"20px 4%",display:astroTab==="Birth Chart"?"none":"block"}}>
              <AstrologyContent astroTab={astroTab} lang={lang} />
            </div>

            {/* ── ASTROLOGY CATEGORY VIDEOS (below the tools) ── */}
            {videos.filter(v=>!selectedSpeaker||v.speaker_name===selectedSpeaker).length > 0 && (
              <div style={{padding:"0 4% 8px"}}>
                <div style={{display:"flex",alignItems:"center",gap:"10px",margin:"8px 0 18px"}}>
                  <div style={{height:"1px",flex:1,background:"linear-gradient(90deg,#d4a843,transparent)"}}></div>
                  <span style={{color:"#d4a843",fontWeight:900,fontSize:"13px",letterSpacing:"3px"}}>🎬 {lang==='ta'?'ஜோதிட வீடியோக்கள்':'ASTROLOGY VIDEOS'}</span>
                  <div style={{height:"1px",flex:1,background:"linear-gradient(90deg,transparent,#d4a843)"}}></div>
                </div>
                <div className="videos-grid">
                  {videos.filter(v=>!selectedSpeaker||v.speaker_name===selectedSpeaker).map((video)=>{
                    const isNew = new Date(video.created_at) > new Date(Date.now() - 3*24*60*60*1000);
                    return <VideoCard key={video.id} id={"vid-"+video.id} video={video} isNew={isNew} hasAccess={hasAccess()} onClick={()=>{trackVideoWatch();setSelectedVideo(video);}} onSpeakerClick={(e)=>{e.stopPropagation();setSelectedSpeaker(video.speaker_name);}} t={t}/>;
                  })}
                </div>
              </div>
            )}
          </div>
        )}
        {/* ── STOCK MARKET BANNER ── */}
        {!showLegal && activeCategory === 'Stock Market' && <StockMarketLive />}
        {/* StockMarketBot hidden - replaced by StockMarketLive */}
        {!showLegal  && activeCategory === 'Stock Market' && false && (
          <div className="stock-banner">
            <svg width="100%" viewBox="0 0 1400 420" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
              <defs>
                <linearGradient id="stockBg" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" stopColor="#000a00"/><stop offset="50%" stopColor="#001500"/><stop offset="100%" stopColor="#000800"/></linearGradient>
                <radialGradient id="stockGlow" cx="50%" cy="60%" r="60%"><stop offset="0%" stopColor="#00ff41" stopOpacity="0.08"/><stop offset="100%" stopColor="#00ff41" stopOpacity="0"/></radialGradient>
                <linearGradient id="stockFade" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" stopColor="#000800" stopOpacity="0.1"/><stop offset="55%" stopColor="#000800" stopOpacity="0.45"/><stop offset="100%" stopColor="#000800" stopOpacity="0.97"/></linearGradient>
                <linearGradient id="stockFadeL" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stopColor="#000800" stopOpacity="0.95"/><stop offset="35%" stopColor="#000800" stopOpacity="0.5"/><stop offset="100%" stopColor="#000800" stopOpacity="0"/></linearGradient>
                <linearGradient id="greenLine" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stopColor="#00ff41" stopOpacity="0"/><stop offset="30%" stopColor="#00ff41" stopOpacity="1"/><stop offset="70%" stopColor="#00ff41" stopOpacity="1"/><stop offset="100%" stopColor="#00ff41" stopOpacity="0"/></linearGradient>
                <linearGradient id="chartUp" x1="0%" y1="100%" x2="0%" y2="0%"><stop offset="0%" stopColor="#00ff41" stopOpacity="0"/><stop offset="100%" stopColor="#00ff41" stopOpacity="0.25"/></linearGradient>
                <filter id="greenGlow"><feGaussianBlur stdDeviation="4"/></filter>
              </defs>
              <rect width="1400" height="420" fill="url(#stockBg)"/>
              <rect width="1400" height="420" fill="url(#stockGlow)"/>
              {[60,110,160,210,260,310,360].map((y,i)=>(<line key={i} x1="0" y1={y} x2="1400" y2={y} stroke="#00ff41" strokeWidth="0.3" opacity="0.08"/>))}
              <path d="M600,380 L650,340 L700,355 L750,320 L800,300 L850,310 L900,270 L950,240 L1000,255 L1050,210 L1100,180 L1150,160 L1200,120 L1250,95 L1300,70 L1350,50 L1400,30 L1400,420 L600,420 Z" fill="url(#chartUp)" opacity="0.8"/>
              <path d="M600,380 L650,340 L700,355 L750,320 L800,300 L850,310 L900,270 L950,240 L1000,255 L1050,210 L1100,180 L1150,160 L1200,120 L1250,95 L1300,70 L1350,50 L1400,30" fill="none" stroke="#00ff41" strokeWidth="2.5" opacity="0.9"/>
              <path d="M0,80 L80,100 L160,90 L240,130 L320,115 L400,155 L480,140 L560,180" fill="none" stroke="#ff4422" strokeWidth="2" opacity="0.7"/>
              {[{x:620,open:320,close:290,high:280,low:340,up:true},{x:700,open:275,close:295,high:265,low:308,up:false},{x:780,open:255,close:228,high:218,low:267,up:true},{x:860,open:245,close:215,high:204,low:257,up:true},{x:940,open:205,close:222,high:195,low:232,up:false}].map((c,i)=>(<g key={i}><line x1={c.x+10} y1={c.high} x2={c.x+10} y2={c.low} stroke={c.up?'#00ff41':'#ff2200'} strokeWidth="1.5" opacity="0.8"/><rect x={c.x} y={Math.min(c.open,c.close)} width="18" height={Math.abs(c.open-c.close)||2} fill={c.up?'#00ff41':'#ff2200'} opacity="0.85" rx="1"/></g>))}
              <rect x="0" y="8" width="1400" height="28" fill="rgba(0,20,0,0.9)" opacity="0.95"/>
              {[{sym:'SENSEX',val:'72,815',chg:'+1.24%',up:true,x:20},{sym:'NIFTY50',val:'21,954',chg:'+0.98%',up:true,x:220},{sym:'RELIANCE',val:'₹2,847',chg:'+2.15%',up:true,x:440},{sym:'TCS',val:'₹3,920',chg:'-0.43%',up:false,x:640},{sym:'HDFC',val:'₹1,680',chg:'+1.67%',up:true,x:830},{sym:'GOLD',val:'₹62,450',chg:'+0.55%',up:true,x:1020}].map((t,i)=>(<g key={i}><text x={t.x} y="26" fontFamily="'Courier New',monospace" fontSize="10" fill="#00cc33" fontWeight="bold">{t.sym}</text><text x={t.x+62} y="26" fontFamily="'Courier New',monospace" fontSize="10" fill="#88ff88">{t.val}</text><text x={t.x+108} y="26" fontFamily="'Courier New',monospace" fontSize="10" fill={t.up?'#00ff41':'#ff4422'}>{t.chg}</text></g>))}
              <rect width="1400" height="420" fill="url(#stockFade)"/>
              <rect width="1400" height="420" fill="url(#stockFadeL)"/>
              <rect width="1400" height="2" fill="url(#greenLine)" opacity="0.8"/>
            </svg>
            <div className="stock-content" style={{position:"absolute",top:"50%",left:0,right:0,transform:"translateY(-50%)",width:"100%",maxWidth:"100%",padding:"20px 5%",boxSizing:"border-box",zIndex:10}}>
              <div className="stock-badge"><span className="stock-badge-dot"></span><span>{lang === 'ta' ? '📈 நேரடி சந்தை பகுப்பாய்வு' : '📈 LIVE MARKET ANALYSIS'}</span></div>
              <div className="stock-title">
                <span className="stock-t1">{lang === 'ta' ? 'பங்கு' : 'STOCK'}</span>
                <span className="stock-t2">{lang === 'ta' ? 'சந்தை' : 'MARKET'}</span>
                <span className="stock-t3">{lang === 'ta' ? 'முதலீட்டை புரிந்துகொள்ளுங்கள்' : 'Master Your Investments'}</span>
              </div>
              <div className="stock-rule"><span className="stock-rule-l"></span><span className="stock-rule-d">▲</span><span className="stock-rule-r"></span></div>
              <p className="stock-sub">{lang === 'ta' ? 'SENSEX · NIFTY · சரக்குகள் · பகுப்பாய்வு' : 'SENSEX · NIFTY · Commodities · Technical Analysis'}<br/>{lang === 'ta' ? 'நேத்தாஜி பிரைம் OTT-யில் சந்தை வல்லுநர்கள்' : 'Market experts exclusively on Nethaji Prime OTT'}</p>
              <div className="stock-tags">{['📈 SENSEX','📊 NIFTY','💰 Mutual Funds','🪙 Gold','🏦 IPO','₿ Crypto'].map(tag => (<span key={tag} className="stock-tag">{tag}</span>))}</div>
            </div>
          </div>
        )}

        {/* ── DEVOTIONAL BANNER ── */}
        {!showLegal  && activeCategory === 'Devotional' && (
          <div className="devot-banner" style={{overflow: window.innerWidth <= 768 ? "visible" : "hidden"}}>
            <img src="/surendar-raja-i--P5tc7P34-unsplash.jpg" alt="Brihadeeswara Temple Thanjavur" className="devot-real-img" onError={(e) => { e.target.style.display='none'; }}/>
            <div className="devot-cin-overlay"/>
            <div className="devot-om">ॐ</div>
            <div className="devot-content" style={{position:"absolute",top:"50%",left:0,right:0,transform:"translateY(-50%)",width:"100%",maxWidth:"100%",padding:"20px 5%",boxSizing:"border-box",zIndex:10}}>
              <div className="devot-badge"><span className="devot-badge-dot"></span><span>{lang === "ta" ? "🙏 திருவிழா சிறப்பு" : "🙏 DIVINE CONTENT"}</span></div>
              <div className="devot-title">
                <span className="devot-t1">{lang === "ta" ? "பக்தி" : "DEVOTIONAL"}</span>
                <span className="devot-t2">{lang === "ta" ? "சேவை" : "& DIVINE"}</span>
                <span className="devot-t3">{lang === "ta" ? "ஈஸ்வரன் அருளால் வாழ்க" : "Blessed by the Divine · Live in Grace"}</span>
              </div>
              <div className="devot-rule"><span className="devot-rule-l"></span><span className="devot-rule-d">🕉️</span><span className="devot-rule-r"></span></div>
              <p className="devot-sub">{lang === "ta" ? "முருகன் • விநாயகர் • லட்சுமி • சக்தி • சிவன்" : "Murugan · Ganesha · Lakshmi · Shakthi · Shiva"}<br/>{lang === "ta" ? "நேத்தாஜி பிரைம் OTT-யில் தெய்வீக உள்ளடக்கம்" : "Sacred Tamil devotional content on Nethaji Prime OTT"}</p>
              <div className="devot-tags">{["🦚 Murugan","🐘 Ganesha","🌸 Lakshmi","🔱 Shiva","🌺 Amman","🪔 Deepam"].map(tag => (<span key={tag} className="devot-tag">{tag}</span>))}</div>
            </div>
          </div>
        )}

{/* ── INTERVIEW BANNER ── */}
        {!showLegal  && activeCategory === 'Interviews' && (
          <div className="interview-banner" style={{overflow: window.innerWidth <= 768 ? "visible" : "hidden"}}>
            <img className="ib-photo" src="/hq720.jpg" alt="Interview" onError={(e) => { e.target.style.display='none'; }}/>
            <div className="ib-overlay-main"/><div className="ib-overlay-left"/><div className="ib-overlay-bottom"/><div className="ib-scanlines"/>
            <div className="ib-rec-badge"><span className="ib-rec-dot"/><span>● REC</span></div>
            <div className="ib-frame-corners"><span className="ib-corner ib-tl"/><span className="ib-corner ib-tr"/><span className="ib-corner ib-bl"/><span className="ib-corner ib-br"/></div>
            <div className="interview-content" style={{position:"absolute",top:"50%",left:0,right:0,transform:"translateY(-50%)",width:"100%",maxWidth:"100%",padding:"20px 5%",boxSizing:"border-box",zIndex:10}}>
              <div className="interview-badge"><span className="interview-badge-dot"></span><span>{lang === 'ta' ? '🎙️ பிரத்யேக நேர்காணல்' : '🎙️ EXCLUSIVE INTERVIEWS'}</span></div>
              <div className="interview-title">
                <span className="interview-t1">{lang === 'ta' ? 'பிரத்யேக' : 'EXCLUSIVE'}</span>
                <span className="interview-t2">{lang === 'ta' ? 'நேர்காணல்கள்' : 'INTERVIEWS'}</span>
                <span className="interview-t3">{lang === 'ta' ? 'தலைவர்களின் கதை — நேரடியாக' : 'The Story Behind the Leaders · Up Close & Personal'}</span>
              </div>
              <div className="interview-rule"><span className="interview-rule-l"></span><span className="interview-rule-d">🎙️</span><span className="interview-rule-r"></span></div>
              <p className="interview-sub">{lang === 'ta' ? 'தலைவர்கள் • கட்சி • வரலாறு • உண்மை' : 'Leaders · Parties · History · Raw Truth'}<br/>{lang === 'ta' ? 'நேத்தாஜி பிரைம் OTT-யில் பிரத்யேக நேர்காணல்கள்' : 'Exclusive political interviews on Nethaji Prime OTT'}</p>
              <div className="interview-tags">{['🎤 Live','📺 HD','🔴 Exclusive','🗣️ Unfiltered','📡 Breaking'].map(tag => (<span key={tag} className="interview-tag">{tag}</span>))}</div>
            </div>
          </div>
        )}

        {/* ── SHORTS BANNER ── */}
        {!showLegal  && activeCategory === 'Shorts' && (
          <div className="shorts-banner" style={{overflow: window.innerWidth <= 768 ? "visible" : "hidden"}}>
            <div className="sb-layer sb-bg"/><div className="sb-layer sb-light1"/><div className="sb-layer sb-light2"/><div className="sb-layer sb-light3"/>
            <div className="sb-layer sb-vignette"/><div className="sb-layer sb-left-fade"/><div className="sb-layer sb-bottom-fade"/>
            <div className="sb-phone"><div className="sb-phone-body"><div className="sb-phone-screen"><div className="sb-phone-content"><div className="sb-play-icon">▶</div></div></div><div className="sb-phone-notch"/></div></div>
            <div className="sb-phone sb-phone-2"><div className="sb-phone-body"><div className="sb-phone-screen"><div className="sb-phone-content sb-phone-content-2"><div className="sb-play-icon">▶</div></div></div><div className="sb-phone-notch"/></div></div>
            <div className="sb-phone sb-phone-3"><div className="sb-phone-body"><div className="sb-phone-screen"><div className="sb-phone-content sb-phone-content-3"><div className="sb-play-icon">▶</div></div></div><div className="sb-phone-notch"/></div></div>
            <div className="sb-sparks">{[...Array(8)].map((_,i) => <span key={i} className={`sb-spark sb-spark-${i}`}>✦</span>)}</div>
            <div className="shorts-content" style={{position:"absolute",top:"50%",left:0,right:0,transform:"translateY(-50%)",width:"100%",maxWidth:"100%",padding:"20px 5%",boxSizing:"border-box",zIndex:10}}>
              <div className="shorts-badge"><span className="shorts-badge-dot"/><span>{lang==='ta'?' குறும் காணொளிகள்':' SHORT VIDEOS'}</span></div>
              <div className="shorts-title">
                <span className="shorts-t1">{lang==='ta'?'விறுவிறுப்பான':'POWER-PACKED'}</span>
                <span className="shorts-t2">{lang==='ta'?'குறும் வீடியோக்கள்':'SHORTS'}</span>
                <span className="shorts-t3">{lang==='ta'?'60 வினாடிகளில் சக்திவாய்ந்த தகவல்':'60 Seconds of Pure Political Power'}</span>
              </div>
              <div className="shorts-rule"><span className="shorts-rule-l"/><span className="shorts-rule-d"></span><span className="shorts-rule-r"/></div>
              <p className="shorts-sub">{lang==='ta'?'விரைவான • தீவிரமான • தமிழ் அரசியல்':'Fast · Intense · Tamil Political Moments'}</p>
              <div className="shorts-tags">{[' 60sec','🔥 Trending','📱 Vertical','🎯 Punchy','💥 Viral'].map(t=>(<span key={t} className="shorts-tag">{t}</span>))}</div>
            </div>
          </div>
        )}

        {/* ── REELS BANNER ── */}
        {!showLegal  && activeCategory === 'Reels' && (
          <div className="reels-banner" style={{overflow: window.innerWidth <= 768 ? "visible" : "hidden"}}>
            <div className="rb-layer rb-bg"/><div className="rb-layer rb-glow1"/><div className="rb-layer rb-glow2"/><div className="rb-layer rb-glow3"/>
            <div className="rb-layer rb-vignette"/><div className="rb-layer rb-left-fade"/><div className="rb-layer rb-bottom-fade"/>
            <div className="rb-film-strip rb-strip-1">{[...Array(6)].map((_,i)=><div key={i} className={`rb-frame rb-frame-${i%3}`}><div className="rb-frame-inner"/></div>)}</div>
            <div className="rb-film-strip rb-strip-2">{[...Array(6)].map((_,i)=><div key={i} className={`rb-frame rb-frame-${(i+1)%3}`}><div className="rb-frame-inner"/></div>)}</div>
            <div className="rb-circle rb-circle-1"/><div className="rb-circle rb-circle-2"/><div className="rb-circle rb-circle-3"/>
            <div className="reels-content" style={{position:"absolute",top:"50%",left:0,right:0,transform:"translateY(-50%)",width:"100%",maxWidth:"100%",padding:"20px 5%",boxSizing:"border-box",zIndex:10}}>
              <div className="reels-badge"><span className="reels-badge-dot"/><span>{lang==='ta'?'🎬 சிறந்த தருணங்கள்':'🎬 CURATED REELS'}</span></div>
              <div className="reels-title">
                <span className="reels-t1">{lang==='ta'?'சிறந்த':'CINEMATIC'}</span>
                <span className="reels-t2">{lang==='ta'?'ரீல்ஸ்':'REELS'}</span>
                <span className="reels-t3">{lang==='ta'?'தமிழ் தலைவர்களின் சிறந்த தருணங்கள்':'Best Moments of Tamil Political Leaders'}</span>
              </div>
              <div className="reels-rule"><span className="reels-rule-l"/><span className="reels-rule-d">🎬</span><span className="reels-rule-r"/></div>
              <p className="reels-sub">{lang==='ta'?'வரலாற்று • உணர்ச்சிமிக்க • சக்திவாய்ந்த தருணங்கள்':'Historic · Emotional · Powerful Moments Captured'}</p>
              <div className="reels-tags">{['🎬 Cinematic','🏆 Best Moments','📽️ HD','🔴 Live','⭐ Featured'].map(t=>(<span key={t} className="reels-tag">{t}</span>))}</div>
            </div>
          </div>
        )}

        {/* NEW VIDEOS PANEL */}
        {showNewVideos && newVideoCount > 0 && (
          <div style={{background:'linear-gradient(160deg,#1e0404,#100101)',border:'1px solid #ff4444',borderRadius:'8px',margin:'12px 3%',padding:'16px'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'12px'}}>
              <h3 style={{color:'#ff4444',fontSize:'15px',fontWeight:'700',margin:0}}>NEW Videos Since Your Last Visit</h3>
              <button onClick={()=>{markAllSeen();setNewVideoCount(0);setShowNewVideos(false);}} style={{background:'none',border:'none',color:'#aaa',cursor:'pointer',fontSize:'13px'}}>✅ Mark all seen</button>
            </div>
            {videos.filter(v=>new Date(v.created_at).getTime()>getLastSeenTs()).slice(0,5).map(video=>(
              <div key={video.id} onClick={()=>{trackVideoWatch();setSelectedVideo(video);setShowNewVideos(false);markAllSeen();setNewVideoCount(0);}} style={{display:'flex',gap:'12px',alignItems:'center',padding:'8px',background:'#180202',borderRadius:'6px',cursor:'pointer',border:'1px solid rgba(212,168,67,0.12)',marginBottom:'8px'}}>
                {video.thumbnail_url&&<img src={video.thumbnail_url} alt={video.title} style={{width:'60px',height:'40px',objectFit:'cover',borderRadius:'4px',flexShrink:0}}/>}
                <div style={{flex:1}}><p style={{color:'#fff',fontSize:'13px',fontWeight:'600',margin:'0 0 2px'}}>{video.title}</p><p style={{color:'#aaa',fontSize:'11px',margin:0}}>{video.speaker_name} • {video.category}</p></div>
                <span style={{background:'#ff4444',color:'#fff',fontSize:'10px',fontWeight:'700',padding:'2px 8px',borderRadius:'10px',flexShrink:0}}>NEW</span>
              </div>
            ))}
          </div>
        )}

        {/* LEGAL TAB */}
        {showLegal && <LegalTab onVideoClick={setSelectedVideo} hasAccess={hasAccess()} t={t} lang={lang} />}
        {showLiveNews && <LiveNewsTab lang={lang} />}
        {!showLegal  && activeCategory === 'Sun Detective' && <SunDetectiveTab onVideoClick={setSelectedVideo} hasAccess={hasAccess()} t={t} lang={lang} />}

        {/* LAUNCH BANNER - Beta or Live */}
        {!showLegal && !showLiveNews && activeCategory === 'All' && (
          <div style={{background:'linear-gradient(90deg,#0a2a0a,#0d1a0d,#0a2a0a)',borderBottom:'1px solid rgba(0,212,128,0.3)',padding:'8px 4%',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
            <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
              {IS_LIVE ? (<>
                <span style={{background:'#f5c842',color:'#000',fontFamily:"'Barlow Condensed',sans-serif",fontSize:'9px',fontWeight:'900',letterSpacing:'2px',padding:'3px 8px',borderRadius:'2px'}}>🔴 LIVE</span>
                <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'12px',fontWeight:'700',letterSpacing:'1px',color:'rgba(245,200,66,0.9)'}}>🎉 Nethaji Prime OTT is now officially LIVE! Welcome aboard!</span>
              </>) : (<>
                <span style={{background:'#00d480',color:'#000',fontFamily:"'Barlow Condensed',sans-serif",fontSize:'9px',fontWeight:'900',letterSpacing:'2px',padding:'3px 8px',borderRadius:'2px'}}>FREE BETA</span>
                <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'12px',fontWeight:'700',letterSpacing:'1px',color:'rgba(0,212,128,0.9)'}}>🎉 All content is FREE during our Beta launch — Enjoy unlimited access!</span>
              </>)}
            </div>
            <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'10px',color:'rgba(0,212,128,0.6)',letterSpacing:'1px'}}>Limited Time Only</span>
          </div>
        )}

        {/* TICKER */}
        {!showLegal && !showLiveNews && activeCategory === 'All' && (
          <div style={{background:'linear-gradient(90deg,#0f0101,#1a0202,#0f0101)',borderTop:'1px solid rgba(212,168,67,0.15)',borderBottom:'1px solid rgba(212,168,67,0.15)',padding:'8px 4%',display:'flex',alignItems:'center',gap:'16px',overflow:'hidden'}}>
            <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'10px',fontWeight:'900',letterSpacing:'3px',background:'#cc0000',color:'#fff',padding:'3px 10px',borderRadius:'2px',flexShrink:0}}>● LIVE</span>
            <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'11px',fontWeight:'700',letterSpacing:'2px',color:'rgba(212,168,67,0.7)',whiteSpace:'nowrap'}}>NETHAJI PRIME OTT — Tamil Sociopolitical Media · Parties · Politics · Online Stream · Full Episodes & Videos</span>
          </div>
        )}

        {/* ANNOUNCEMENT BAR */}
        {!showLegal && !showLiveNews && activeCategory === 'All' && (
          <div style={{background:'linear-gradient(90deg,#1a0a00,#2a1500,#1a0a00)',borderBottom:'1px solid rgba(212,168,67,0.25)',borderTop:'1px solid rgba(212,168,67,0.1)',padding:'0 4%',display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:'8px',minHeight:'48px'}}>
            <div style={{display:'flex',alignItems:'center',gap:'16px',flexWrap:'wrap'}}>
              <span style={{color:'#f5c842',fontSize:'clamp(10px,2vw,12px)',fontWeight:900,letterSpacing:'2px'}}>NETHAJI PRIME OTT</span>
              <span style={{color:'rgba(212,168,67,0.4)',fontSize:'12px'}}>|</span>
              <button onClick={()=>setShowPricing(true)} style={{background:'linear-gradient(135deg,#d4a843,#b8922e)',border:'none',borderRadius:'20px',color:'#000',padding:'5px 16px',fontSize:'clamp(10px,2vw,12px)',fontWeight:900,cursor:'pointer',whiteSpace:'nowrap'}}>💰 Pricing & Donations</button>
              <button onClick={()=>setShowMemeGenerator(true)} style={{background:'rgba(212,168,67,0.1)',border:'1px solid rgba(212,168,67,0.3)',borderRadius:'20px',color:'#d4a843',padding:'5px 16px',fontSize:'clamp(10px,2vw,12px)',fontWeight:900,cursor:'pointer',whiteSpace:'nowrap'}}>😂 Meme Generator</button>
            </div>
              <button onClick={()=>{setShowMovies(true);window.location.hash='movies';window.scrollTo({top:0,behavior:'smooth'});}} style={{background:'linear-gradient(135deg,#e50914,#b20710)',border:'none',borderRadius:'20px',color:'#fff',padding:'5px 16px',fontSize:'clamp(10px,2vw,12px)',fontWeight:900,cursor:'pointer',whiteSpace:'nowrap'}}>{String.fromCodePoint(127916)} Watch Now</button>
            <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
              <span style={{background:'rgba(0,212,128,0.1)',border:'1px solid rgba(0,212,128,0.3)',borderRadius:'20px',color:'#00d480',padding:'4px 12px',fontSize:'clamp(9px,1.5vw,11px)',fontWeight:700}}>🎁 FREE during Beta</span>
            </div>
          </div>
        )}


        {/* HOUSE AD - BANNER */}
        {!showLegal && !showLiveNews && activeCategory === 'All' && (
          <div style={{padding:'8px 4%'}}>
            <AdUnit placement="banner" isPaidUser={isAdFreeUser()} />
          </div>
        )}

        {/* ALL VIDEOS */}
        {!showLegal && !showLiveNews && !showKids && !showMovies && !showSports && !showHealth && !showKitchen && !showEducation && !showAuto && !showTourism && !showWomen && !showTransport && !showMen && !showMGR && !showDeals && !showFeeds && activeCategory !== 'Astrology' && (
          <div className="videos-section">
            <h2 className="section-title">
              {selectedSpeaker?`🎤 ${selectedSpeaker}`:activeCategory==='All'?`🎬 ${t.all_videos}`:`🎬 ${activeCategory}`}
              {selectedSpeaker&&<button onClick={()=>setSelectedSpeaker(null)} style={{marginLeft:'10px',background:'none',border:'none',color:'#aaa',cursor:'pointer',fontSize:'14px'}}>✖ Clear</button>}
            </h2>
            {videos.filter(v=>!selectedSpeaker||v.speaker_name===selectedSpeaker).length===0?(
              <div className="no-videos"><h3>{t.no_videos}</h3><p>{t.no_videos_sub}</p></div>
            ):(
              <div className="videos-grid">
                {videos.filter(v=>!selectedSpeaker||v.speaker_name===selectedSpeaker).map((video)=>{
                  const isNew = new Date(video.created_at) > new Date(Date.now() - 3*24*60*60*1000);
                  return <VideoCard key={video.id} id={"vid-"+video.id} video={video} isNew={isNew} hasAccess={hasAccess()} onClick={()=>{trackVideoWatch();setSelectedVideo(video);const _d=JSON.parse(localStorage.getItem("watch_streak")||"{}");const _t=new Date().toDateString();const _y=new Date(Date.now()-86400000).toDateString();const _s=_d.lastWatch===_t?(_d.streak||1):_d.lastWatch===_y?(_d.streak||0)+1:1;localStorage.setItem("watch_streak",JSON.stringify({streak:_s,lastWatch:_t}));setWatchStreak(_s);}} onSpeakerClick={(e)=>{e.stopPropagation();setSelectedSpeaker(video.speaker_name);}} t={t}/>;
                })}
              </div>
            )}
          </div>
        )}

        {/* ── YOUTUBE SHORTS FROM NETHAJI TV ── */}
        {activeCategory === 'Shorts' && (
          <div style={{padding:"16px 4%",marginBottom:"8px"}}>
            <div style={{color:"#d4a843",fontWeight:900,fontSize:"14px",marginBottom:"12px"}}>📱 Nethaji TV Shorts on YouTube</div>
            {ytShortsLoading && <div style={{color:"rgba(255,255,255,0.4)",fontSize:"12px"}}>Loading shorts...</div>}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(120px,1fr))",gap:"10px"}}>
              {ytShorts.map((video,i)=>(
                <div key={i} onClick={()=>{trackVideoWatch();window.open("https://youtube.com/shorts/"+video.videoId,"_blank");}}
                  style={{cursor:"pointer",borderRadius:"10px",overflow:"hidden",background:"#0a0000",border:"1px solid rgba(204,0,0,0.3)",aspectRatio:"9/16",position:"relative"}}>
                  <img src={video.thumbnail} alt={video.title} style={{width:"100%",height:"100%",objectFit:"cover"}} onError={e=>e.target.style.display="none"}/>
                  <div style={{position:"absolute",inset:0,background:"linear-gradient(to top,rgba(0,0,0,0.8),transparent)",display:"flex",flexDirection:"column",justifyContent:"flex-end",padding:"8px"}}>
                    <div style={{color:"#fff",fontSize:"10px",fontWeight:700,lineHeight:1.2,marginBottom:"4px",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden"}}>{video.title}</div>
                    <div style={{display:"flex",gap:"4px"}}>
                      <button onClick={e=>{e.stopPropagation();const msg=encodeURIComponent("🔥 "+video.title+"\n\nWatch: https://youtube.com/shorts/"+video.videoId+"\n\nMore: https://nethajiprime.com");window.open("https://wa.me/?text="+msg,"_blank");}} style={{background:"#25d366",border:"none",borderRadius:"3px",color:"#fff",fontSize:"8px",padding:"2px 5px",cursor:"pointer"}}>📤</button>
                      <div style={{background:"rgba(255,0,0,0.8)",borderRadius:"3px",padding:"2px 5px",fontSize:"8px",color:"#fff",fontWeight:700}}>▶ YT</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

                {!showLegal && activeCategory === "Devotional" && (
          <div style={{background:"linear-gradient(180deg,#050005,#000)",padding:"24px 4%"}}>
            <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"20px"}}>
              <div style={{height:"1px",flex:1,background:"linear-gradient(90deg,#d4a843,transparent)"}}></div>
              <span style={{color:"#d4a843",fontWeight:900,fontSize:"13px",letterSpacing:"4px"}}>LIVE TEMPLE DARSHAN</span>
              <div style={{height:"1px",flex:1,background:"linear-gradient(90deg,transparent,#d4a843)"}}></div>
            </div>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:"16px"}}>
              {[
                {id:"tirupati",name:"Tirupati Balaji Live",videoId:"Unxt39MsYlw",color:"#ff6600"},
                {id:"meenakshi",name:"Madurai Meenakshi Temple",videoId:"Zx2iTNEuVWY",color:"#cc0000"},
                {id:"shirdi",name:"Shirdi Sai Baba Live",videoId:"i3J9p1niRvs",color:"#ff9900"},
                {id:"jothitv",name:"Jothi TV Devotional",videoId:"pUZmOrbqIzc",color:"#9900cc"},
              ].map(temple => (
                <div key={temple.id}
                  style={{background:"linear-gradient(135deg,#0a0005,#150010)",border:"1px solid rgba(212,168,67,0.2)",borderRadius:"8px",overflow:"hidden",cursor:"pointer",transition:"all 0.25s"}}
                  onMouseEnter={e => e.currentTarget.style.borderColor="rgba(212,168,67,0.8)"}
                  onMouseLeave={e => e.currentTarget.style.borderColor="rgba(212,168,67,0.2)"}
                  onClick={() => { const existing = document.getElementById("temple-player"); if(existing) existing.remove(); const wrapper = document.createElement("div"); wrapper.id="temple-player"; wrapper.style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.95);z-index:99999;display:flex;flex-direction:column;align-items:center;justify-content:center;"; const closeBtn = document.createElement("button"); closeBtn.innerText="X Close"; closeBtn.style="position:absolute;top:20px;right:20px;background:#cc0000;color:#fff;border:none;padding:10px 20px;borderRadius:4px;cursor:pointer;fontSize:14px;fontWeight:900;zIndex:100000;"; closeBtn.onclick=()=>wrapper.remove(); const iframe = document.createElement("iframe"); iframe.src="https://www.youtube.com/embed/"+temple.videoId+"?autoplay=1&rel=0&vq=hd1080&modestbranding=1"; iframe.style="width:90%;height:80vh;border:none;"; iframe.allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"; iframe.allowFullscreen=true; const title = document.createElement("div"); title.innerText=temple.name; title.style="color:#d4a843;fontWeight:900;fontSize:16px;marginBottom:10px;letterSpacing:2px;"; wrapper.appendChild(closeBtn); wrapper.appendChild(title); wrapper.appendChild(iframe); document.body.appendChild(wrapper); }}>
                  <div style={{position:"relative",paddingTop:"56.25%",background:"#000"}}>
                    <img src={"https://img.youtube.com/vi/"+temple.videoId+"/mqdefault.jpg"} alt={temple.name}
                      style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover",opacity:0.85}}
                      onError={e => e.target.style.display="none"} />
                    <div style={{position:"absolute",top:"8px",left:"8px",background:"#cc0000",color:"#fff",fontSize:"10px",fontWeight:900,padding:"2px 8px",borderRadius:"3px"}}>LIVE</div>
                    <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                      <div style={{width:"44px",height:"44px",borderRadius:"50%",background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"18px",color:"#fff"}}>&#9654;</div>
                    </div>
                  </div>
                  <div style={{padding:"10px 14px",display:"flex",alignItems:"center",justifyContent:"space-between",background:"rgba(0,0,0,0.5)"}}>
                    <div>
                      <div style={{color:"#d4a843",fontWeight:700,fontSize:"13px"}}>{temple.name}</div>
                      <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>Live Darshan 24/7</div>
                    </div>
                    <button style={{background:"linear-gradient(135deg,#d4a843,#a07820)",border:"none",color:"#000",padding:"5px 14px",borderRadius:"3px",cursor:"pointer",fontSize:"11px",fontWeight:900}}>WATCH</button>
                  </div>
                </div>
              ))}
            </div>
            <div style={{padding:'16px',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
              <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',fontWeight:'700',letterSpacing:'2px',marginBottom:'12px'}}>TEMPLE TOURS & SERVICES</div>
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'10px'}}>
                {[{name:'MakeMyTrip',url:'https://makemytrip.com/holidays/religious-tours.html',desc:'Temple tours',color:'#e8202a',emoji:'🛕'},{name:'IRCTC',url:'https://irctctourism.com',desc:'Pilgrimage packages',color:'#1a5fa8',emoji:'🚂'},{name:'Thrillophilia',url:'https://thrillophilia.com/temple-tours',desc:'Spiritual tours',color:'#ff6b35',emoji:'🙏'},{name:'Yatra',url:'https://yatra.com',desc:'Religious tours',color:'#ff9800',emoji:'✈️'}].map((a,i)=>(
                  <div key={i} onClick={()=>window.open(a.url,'_blank')} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'12px',cursor:'pointer',borderTop:'2px solid '+a.color,textAlign:'center'}}>
                    <div style={{fontSize:'22px',marginBottom:'4px'}}>{a.emoji}</div>
                    <div style={{color:a.color,fontWeight:'800',fontSize:'12px',marginBottom:'3px'}}>{a.name}</div>
                    <div style={{color:'rgba(255,255,255,0.35)',fontSize:'10px',marginBottom:'8px'}}>{a.desc}</div>
                    <button style={{padding:'4px 10px',background:a.color,border:'none',borderRadius:'5px',color:'#fff',fontWeight:'700',cursor:'pointer',fontSize:'10px'}}>Book</button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {/* FACEBOOK REELS */}
        {activeCategory === 'Reels' && (
          <div style={{padding:"16px 4%",marginBottom:"8px"}}>
            <div style={{color:"#d4a843",fontWeight:900,fontSize:"14px",marginBottom:"12px"}}>🎬 Nethaji TV Facebook Reels</div>
            {fbReels.length === 0 && (
              <div style={{color:"rgba(255,255,255,0.3)",fontSize:"12px",padding:"20px",textAlign:"center"}}>No reels added yet. Add from Admin panel.</div>
            )}
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:"12px"}}>
              {fbReels.map((reel,i)=>(
                <div key={i} onClick={()=>{trackVideoWatch();window.open(reel.url,"_blank");}}
                  style={{cursor:"pointer",borderRadius:"10px",overflow:"hidden",background:"#0a0000",border:"1px solid rgba(24,119,242,0.3)",aspectRatio:"9/16",position:"relative"}}>
                  {reel.thumbnail_url
                    ? <img src={reel.thumbnail_url} alt={reel.title} style={{width:"100%",height:"100%",objectFit:"cover"}}/>
                    : <div style={{width:"100%",height:"100%",background:"linear-gradient(135deg,#1877f2,#0a0000)",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"36px"}}>📱</div>
                  }
                  <div style={{position:"absolute",inset:0,background:"linear-gradient(to top,rgba(0,0,0,0.85),transparent)",display:"flex",flexDirection:"column",justifyContent:"flex-end",padding:"8px"}}>
                    <div style={{color:"#fff",fontSize:"10px",fontWeight:700,lineHeight:1.2,marginBottom:"6px",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",overflow:"hidden"}}>{reel.title}</div>
                    <div style={{display:"flex",gap:"4px",alignItems:"center"}}>
                      <div style={{background:"#1877f2",borderRadius:"3px",padding:"2px 6px",fontSize:"8px",color:"#fff",fontWeight:700}}>▶ FB</div>
                      <button onClick={e=>{e.stopPropagation();const msg=encodeURIComponent("🔥 "+reel.title+"\n\nWatch: "+reel.url+"\n\nMore Tamil content: https://nethajiprime.com");window.open("https://wa.me/?text="+msg,"_blank");}} style={{background:"#25d366",border:"none",borderRadius:"3px",color:"#fff",fontSize:"8px",padding:"2px 5px",cursor:"pointer"}}>📤</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* YOUTUBE CHANNEL FEEDS */}
        {!showLegal && !showLiveNews && activeCategory === "All" && Object.keys(homeFeeds).length > 0 && (
          <div style={{padding:"12px 4%"}}>
            {["nethajitv","nmktv","harichandra","bharathtv"].map(chId => {
              const ch = homeFeeds[chId];
              if (!ch || ch.videos.length === 0) return null;
              return (
                <div key={chId} style={{marginBottom:"24px"}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"10px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
                      <div style={{width:"4px",height:"20px",background:ch.color,borderRadius:"2px"}}></div>
                      <div style={{color:ch.color,fontWeight:900,fontSize:"14px",letterSpacing:"1px"}}>{ch.name}</div>
                    </div>
                    <button onClick={()=>{setShowFeeds(true);setShowMGR(false);setShowKids(false);setShowMovies(false);setShowLiveNews(false); window.stopBulletinAudio && window.stopBulletinAudio();setShowLegal(false);setActiveCategory("All");}} style={{background:"transparent",border:"1px solid "+ch.color,color:ch.color,padding:"3px 10px",borderRadius:"4px",cursor:"pointer",fontSize:"11px",fontWeight:700}}>See All</button>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(clamp(200px,30vw,280px),1fr))",gap:"clamp(10px,2vw,16px)"}}>
                    {ch.videos.slice(0,6).map((video,i) => (
                      <div key={i} onClick={()=>{trackVideoWatch();window.open("https://youtu.be/"+video.videoId,"_blank");trackVideoWatch();}} style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:"8px",overflow:"hidden",cursor:"pointer"}}
                        onMouseEnter={e=>e.currentTarget.style.borderColor=ch.color}
                        onMouseLeave={e=>e.currentTarget.style.borderColor="rgba(255,255,255,0.08)"}>
                        <div style={{position:"relative",paddingTop:"56.25%"}}>
                          <img src={video.thumbnail} alt={video.title} style={{position:"absolute",top:0,left:0,width:"100%",height:"100%",objectFit:"cover"}} onError={e=>e.target.style.display="none"} />
                          <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}>
                            <div style={{width:"36px",height:"36px",borderRadius:"50%",background:"rgba(0,0,0,0.7)",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff",fontSize:"14px"}}>&#9654;</div>
                          </div>
                        </div>
                        <div style={{padding:"8px"}}>
                          <div style={{color:"#e2e8f0",fontSize:"12px",fontWeight:600,lineHeight:"1.3",overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical",marginBottom:"6px"}}>{video.title}</div>
                          <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px",display:"flex",gap:"8px",flexWrap:"wrap",marginBottom:"6px"}}>
                            <span style={{"color":"#4499ff"}}>👁️ {homeVideoStats[video.videoId] ? Number(homeVideoStats[video.videoId].views).toLocaleString("en-IN") : new Date(video.pubDate||video.publishedAt||video.created_at).toLocaleDateString("en-IN")}</span>
                            <span style={{"color":"#00cc44"}}>👍 {homeVideoStats[video.videoId] ? Number(homeVideoStats[video.videoId].likes).toLocaleString("en-IN") : "▶ Watch"}</span>
                          </div>
                          <div style={{display:"flex",gap:"6px"}} onClick={e=>e.stopPropagation()}>
                            <button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("🔥 "+video.title+"\n\nWatch: https://youtu.be/"+video.videoId+"\n\nMore Tamil content: https://nethajiprime.com"),"_blank")} style={{background:"#25D366",border:"none",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer",flexShrink:0}}>WhatsApp</button>
                            <button onClick={()=>{navigator.clipboard.writeText("https://youtu.be/"+video.videoId);alert("Copied!");}} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:"4px",color:"#fff",fontSize:"10px",fontWeight:700,padding:"3px 8px",cursor:"pointer",flexShrink:0}}>Copy</button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {/* SPEAKERS */}
        {!showLegal && !showLiveNews && speakers.length > 0 && (activeCategory === 'All' || activeCategory === 'New' || activeCategory === 'Archive') && (
          <div className="speaker-section" style={{display:"none"}}>
            <h3 className="speaker-title">{t.browse_speaker}</h3>
            <div className="speaker-list">
              <button onClick={()=>setSelectedSpeaker(null)} className={`speaker-btn ${!selectedSpeaker?'active':''}`}>{t.all_speakers}</button>
              {speakers.map((speaker)=>(<button key={speaker.name} onClick={()=>setSelectedSpeaker(selectedSpeaker===speaker.name?null:speaker.name)} className={`speaker-btn ${selectedSpeaker===speaker.name?'active':''}`}>🎤 {speaker.name}<span className="speaker-count">{speaker.count}</span></button>))}
            </div>
          </div>
        )}

        {/* TRENDING */}
        
        {/* MY FEED SECTION */}
        {!showLegal && !showLiveNews && activeCategory === "All" && (() => {
          const myFeeds = JSON.parse(localStorage.getItem("np_myfeeds")||"[]");
          if(myFeeds.length === 0) return null;
          return (
            <div style={{padding:"12px 4%",borderBottom:"1px solid rgba(212,168,67,0.1)"}}>
              <div style={{color:"#d4a843",fontWeight:900,fontSize:"13px",marginBottom:"10px"}}>📌 MY FEED</div>
              <div style={{display:"flex",gap:"8px",overflowX:"auto",paddingBottom:"8px"}}>
                {myFeeds.map(ch=>(
                  <div key={ch.id} onClick={()=>{setShowFeeds(true);}} style={{background:"rgba(212,168,67,0.1)",border:"1px solid rgba(212,168,67,0.3)",borderRadius:"8px",padding:"8px 14px",cursor:"pointer",flexShrink:0,textAlign:"center"}}>
                    <div style={{color:"#d4a843",fontWeight:700,fontSize:"12px"}}>{ch.name}</div>
                    <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px"}}>Tap to watch</div>
                  </div>
                ))}
              </div>
            </div>
          );
        })()}

        {!showLegal && !showLiveNews && trendingVideos.length > 0 && activeCategory === 'All' && (
          <div className="videos-section" style={{paddingBottom:'0'}}>
            <h2 className="section-title">🔥 {t.trending_now}</h2>
            <div className="videos-grid">
              {trendingVideos.map((video) => (
                <div key={video.id} id={"vid-"+video.id} className="video-card" onClick={()=>{trackVideoWatch();setSelectedVideo(video);const _d=JSON.parse(localStorage.getItem("watch_streak")||"{}");const _t=new Date().toDateString();const _y=new Date(Date.now()-86400000).toDateString();const _s=_d.lastWatch===_t?(_d.streak||1):_d.lastWatch===_y?(_d.streak||0)+1:1;localStorage.setItem("watch_streak",JSON.stringify({streak:_s,lastWatch:_t}));setWatchStreak(_s);}}>
                  <div className="video-thumb"><img src={video.thumbnail_url} alt={video.title}/><div className="video-duration">{formatDuration(video.duration)}</div></div>
                  <div className="video-info"><h3 className="video-title">{video.title}</h3><div style={{display:"flex",gap:"6px",margin:"4px 0"}} onClick={e=>e.stopPropagation()}><button onClick={()=>shareOnWhatsApp(video)} style={{background:"#25D366",border:"none",borderRadius:"4px",color:"#fff",fontSize:"9px",fontWeight:700,padding:"2px 6px",cursor:"pointer"}}>WhatsApp</button><button onClick={()=>copyVideoLink(video)} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",borderRadius:"4px",color:"#fff",fontSize:"9px",fontWeight:700,padding:"2px 6px",cursor:"pointer"}}>Copy</button></div><div className="video-meta" style={{color:'rgba(255,255,255,0.85)'}}><span>{video.speaker_name}</span><span>•</span><span>{video.views_count||0} {t.views}</span><span>•</span><span>🔥 {video.hype_count||0} {t.hypes}</span></div></div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* CONTINUE WATCHING */}
        {!showLegal && !showLiveNews && activeCategory !== 'Sun Detective' && continueWatchingList.length > 0 && (
          <div className="videos-section">
            <h2 className="section-title">▶ {t.continue_watching}</h2>
            <div className="videos-grid">
              {continueWatchingList.map((item)=>(
                <div key={item.id} className="video-card" onClick={async()=>{
  // First try current videos list
  let video = videos.find(v=>String(v.id)===String(item.id));
  if(!video){
    // Fetch ALL videos to find it
    try {
      const r = await fetch(`${API_URL}/speeches`);
      const d = await r.json();
      video = (d.speeches||[]).find(v=>String(v.id)===String(item.id));
    } catch(e) {}
  }
  if(video){ setSelectedVideo({...video,resumeAt:item.currentTime}); }
  else { setSelectedVideo({...item,resumeAt:item.currentTime,video_url:null}); }
}}>
                  <div className="video-thumb" style={{position:'relative'}}>
                    {item.thumbnail_url?<img src={item.thumbnail_url} alt={item.title}/>:<div style={{width:'100%',height:'100%',background:'#1a0303',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'32px'}}>▶</div>}
                    <div style={{position:'absolute',bottom:0,left:0,right:0,height:'4px',background:'rgba(255,255,255,0.2)'}}><div style={{height:'100%',background:'#d4a843',width:`${item.percent}%`}}/></div>
                    <div style={{position:'absolute',top:'8px',right:'8px',background:'rgba(212,168,67,0.9)',color:'#0a0a0a',padding:'2px 8px',fontSize:'10px',fontWeight:'700'}}>{Math.floor(item.currentTime/60)}:{String(item.currentTime%60).padStart(2,'0')}</div>
                    <button onClick={(e)=>{e.stopPropagation();removeProgress(item.id);setContinueWatchingList(getContinueWatchingList());}} style={{display:'none'}}>✕</button>
                  </div>
                  <div className="video-info"><h3 className="video-title">{item.title}</h3><div className="video-meta" style={{color:'rgba(255,255,255,0.85)'}}><span style={{color:'#d4a843'}}>{item.speaker_name}</span><span>•</span><span style={{color:'#d4a843'}}>{item.percent}% watched</span></div></div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* CONTACT MODAL */}
      {showContact && (
        <div onClick={()=>setShowContact(false)} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.85)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}>
          <div onClick={e=>e.stopPropagation()} style={{background:'linear-gradient(160deg,#200404,#100101)',border:'1px solid rgba(212,168,67,0.3)',borderRadius:'12px',padding:'36px',maxWidth:'420px',width:'100%',position:'relative'}}>
            <button onClick={()=>setShowContact(false)} style={{position:'absolute',top:'12px',right:'12px',background:'rgba(212,168,67,0.1)',border:'1px solid rgba(212,168,67,0.3)',color:'#d4a843',width:'32px',height:'32px',borderRadius:'50%',cursor:'pointer',fontSize:'16px',display:'flex',alignItems:'center',justifyContent:'center'}}>✕</button>
            <div style={{fontFamily:"'Cinzel',serif",fontSize:'1.4em',fontWeight:'900',color:'#f5c842',letterSpacing:'3px',marginBottom:'6px',textAlign:'center'}}>CONTACT US</div>
            <div style={{height:'1px',background:'linear-gradient(90deg,transparent,#d4a843,transparent)',marginBottom:'24px'}}/>
            <div style={{display:'flex',flexDirection:'column',gap:'16px'}}>
              <a href="mailto:contact@nethajiprime.com" style={{display:'flex',alignItems:'center',gap:'14px',padding:'14px 16px',background:'rgba(212,168,67,0.06)',border:'1px solid rgba(212,168,67,0.15)',borderRadius:'8px',textDecoration:'none'}}><span style={{fontSize:'22px'}}>✉</span><div><div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'9px',fontWeight:'800',letterSpacing:'2px',color:'#c8902a',textTransform:'uppercase',marginBottom:'2px'}}>Email Us</div><div style={{color:'#f0e0c0',fontSize:'13px'}}>contact@nethajiprime.com</div></div></a>
              <a href="https://wa.me/919444456788" target="_blank" rel="noreferrer" style={{display:'flex',alignItems:'center',gap:'14px',padding:'14px 16px',background:'rgba(37,211,102,0.06)',border:'1px solid rgba(37,211,102,0.2)',borderRadius:'8px',textDecoration:'none'}}><span style={{fontSize:'22px'}}>📱</span><div><div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'9px',fontWeight:'800',letterSpacing:'2px',color:'#25d366',textTransform:'uppercase',marginBottom:'2px'}}>WhatsApp</div><div style={{color:'#f0e0c0',fontSize:'13px'}}>+91 94444 56788</div></div></a>
              <a href="https://nethajiprime.com" target="_blank" rel="noreferrer" style={{display:'flex',alignItems:'center',gap:'14px',padding:'14px 16px',background:'rgba(212,168,67,0.06)',border:'1px solid rgba(212,168,67,0.15)',borderRadius:'8px',textDecoration:'none'}}><span style={{fontSize:'22px'}}>🌐</span><div><div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'9px',fontWeight:'800',letterSpacing:'2px',color:'#c8902a',textTransform:'uppercase',marginBottom:'2px'}}>Website</div><div style={{color:'#f0e0c0',fontSize:'13px'}}>nethajiprime.com</div></div></a>
            </div>
          </div>
        </div>
      )}

      <footer className="App-footer">
        <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:'24px',margin:'12px 0',flexWrap:'wrap'}}>
          <a href="mailto:contact@nethajiprime.com" style={{display:'flex',alignItems:'center',gap:'6px',color:'rgba(212,168,67,0.8)',textDecoration:'none',fontSize:'12px'}}><span>✉</span><span>contact@nethajiprime.com</span></a>
          <span style={{color:'rgba(212,168,67,0.3)'}}>|</span>
          <a href="tel:+919444456788" style={{display:'flex',alignItems:'center',gap:'6px',color:'rgba(212,168,67,0.8)',textDecoration:'none',fontSize:'12px'}}><span>✆</span><span>+91 94444 56788</span></a>
        </div>

        <div className="footer-links">
          <button onClick={()=>setShowAbout(true)}>About Us</button>
          <button onClick={()=>setShowPricing(true)}>Pricing</button>
          <button onClick={()=>setShowLeaderboard(true)}>{t.top_charts}</button>
          <button onClick={()=>setShowMemeGenerator(true)}>MEME</button>
          <button onClick={()=>setShowContact(true)}>Contact</button>
          <button onClick={()=>setShowPrivacyPolicy(true)}>Privacy Policy</button>
        </div>
        <p className="footer-copy">&copy; 2026 Nethaji Prime. All rights reserved.</p>
      </footer>
      <LegalFooter />
    </div>
  );
}

// ⚖️ LEGAL TAB





// ══ STOCK MARKET BOT COMPONENT ══
function StockMarketBot({ lang = "en" }) {
  const [messages, setMessages] = React.useState([
    { role: 'assistant', text: lang === 'ta'
      ? 'வணக்கம்! 📈 நான் உங்கள் பங்கு சந்தை உதவியாளர். SENSEX, NIFTY, SIP கணக்கீடு மற்றும் முதலீட்டு கேள்விகளுக்கு உதவுவேன்!'
      : 'Vanakkam! 📈 I am your Stock Market Assistant. Ask me about SENSEX, NIFTY, SIP calculations, mutual funds and investment tips!'
    }
  ]);
  const [input, setInput] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [showSIP, setShowSIP] = React.useState(false);
  const [sip, setSip] = React.useState({ amount: 5000, rate: 12, years: 10 });
  const [stocks, setStocks] = React.useState([]);
  const [stocksLoading, setStocksLoading] = React.useState(true);
  const messagesEndRef = React.useRef(null);

  // Fetch live stock data
  React.useEffect(() => {
    const fetchStocks = async () => {
      try {
        const symbols = ['^BSESN','^NSEI','RELIANCE.NS','TCS.NS','INFY.NS','HDFCBANK.NS','WIPRO.NS','TATAMOTORS.NS'];
        const results = [];
        for (const sym of symbols) {
          try {
            const r = await fetch(`https://query1.finance.yahoo.com/v8/finance/chart/${sym}?interval=1d&range=1d`, {
              headers: { 'User-Agent': 'Mozilla/5.0' }
            });
            const d = await r.json();
            const meta = d?.chart?.result?.[0]?.meta;
            if (meta) {
              const change = meta.regularMarketPrice - meta.previousClose;
              const pct = (change / meta.previousClose * 100).toFixed(2);
              results.push({
                symbol: sym.replace('.NS','').replace('^',''),
                price: meta.regularMarketPrice?.toFixed(2),
                change: change.toFixed(2),
                pct: pct,
                up: change >= 0
              });
            }
          } catch(e) {}
        }
        if (results.length > 0) setStocks(results);
        else setStocks([
          {symbol:'SENSEX',price:'72,815',change:'+901',pct:'+1.24',up:true},
          {symbol:'NIFTY50',price:'21,954',change:'+213',pct:'+0.98',up:true},
          {symbol:'RELIANCE',price:'2,847',change:'+61',pct:'+2.15',up:true},
          {symbol:'TCS',price:'3,920',change:'-17',pct:'-0.43',up:false},
          {symbol:'INFY',price:'1,432',change:'+18',pct:'+1.27',up:true},
          {symbol:'HDFC',price:'1,680',change:'+28',pct:'+1.67',up:true},
        ]);
      } catch(e) {
        setStocks([
          {symbol:'SENSEX',price:'72,815',change:'+901',pct:'+1.24',up:true},
          {symbol:'NIFTY50',price:'21,954',change:'+213',pct:'+0.98',up:true},
          {symbol:'RELIANCE',price:'2,847',change:'+61',pct:'+2.15',up:true},
          {symbol:'TCS',price:'3,920',change:'-17',pct:'-0.43',up:false},
          {symbol:'HDFC',price:'1,680',change:'+28',pct:'+1.67',up:true},
        ]);
      }
      setStocksLoading(false);
    };
    fetchStocks();
    // Refresh every 5 minutes
    const interval = setInterval(fetchStocks, 300000);
    return () => clearInterval(interval);
  }, []);

  React.useEffect(() => { messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

  // SIP Calculator
  const calcSIP = () => {
    const n = sip.years * 12;
    const r = sip.rate / 12 / 100;
    const fv = sip.amount * ((Math.pow(1+r, n) - 1) / r) * (1+r);
    const invested = sip.amount * n;
    const returns = fv - invested;
    return { fv: Math.round(fv), invested: Math.round(invested), returns: Math.round(returns) };
  };

  // Stock Market FAQ
  const STOCK_FAQ = {
    sensex: 'SENSEX (Sensitive Index) என்பது BSE-யின் 30 முக்கிய நிறுவனங்களின் குறியீட்டு எண். இது இந்திய பங்கு சந்தையின் ஆரோக்கியத்தை காட்டுகிறது. தற்போதைய SENSEX: marketsmojo.com அல்லது moneycontrol.com-ல் பாருங்கள்.',
    nifty: 'NIFTY 50 என்பது NSE-யின் 50 முக்கிய நிறுவனங்களின் குறியீட்டு எண். SENSEX-ஐ விட இது பரந்த சந்தையை பிரதிபலிக்கிறது. Live: nseindia.com',
    sip: 'SIP (Systematic Investment Plan) என்பது தொடர்ந்து சிறிய தொகை முதலீடு செய்வது. உதாரணம்: ₹5000/மாதம், 12% returns, 10 ஆண்டுகள் = ₹11.6 லட்சம்! கீழே SIP Calculator பயன்படுத்துங்கள்.',
    mutual_fund: 'Mutual Fund என்பது பலர் சேர்ந்து முதலீடு செய்யும் திட்டம். வகைகள்:\n• Equity - அதிக returns, அதிக risk\n• Debt - குறைந்த risk, நிலையான returns\n• Hybrid - சமநிலை\n\nதொடங்க: Zerodha Coin, Groww, Paytm Money App',
    gold: 'தங்க முதலீட்டு வழிகள்:\n• Physical Gold - நகை, நாணயம்\n• Gold ETF - பங்கு சந்தையில் தங்கம்\n• Sovereign Gold Bond - அரசு வழங்கும் 2.5% கூடுதல் வட்டி\n• Digital Gold - PhonePe, Google Pay\n\nதற்போதைய விலை: mpconsortium.org',
    ipo: 'IPO (Initial Public Offering) என்பது நிறுவனம் முதல்முறையாக பங்குகளை விற்பது.\n\nIPO-ல் எப்படி முதலீடு செய்வது:\n1. Demat Account திறக்கவும்\n2. ASBA மூலம் விண்ணப்பிக்கவும்\n3. Allotment கிடைத்தால் listing-ல் விற்கலாம்\n\nவரவிருக்கும் IPO: chittorgarh.com/ipo',
    demat: 'Demat Account தொடங்க:\n• Zerodha - ₹200 charge, best for beginners\n• Groww - Free, easy to use\n• Angel One - Full service broker\n• Upstox - Low cost\n\nதேவையானவை: Aadhaar, PAN, Bank Account, Photo',
    beginner: 'முதலீட்டை எங்கு தொடங்குவது:\n\n1. முதலில் Emergency Fund - 6 மாத செலவுக்கு\n2. Term Insurance எடுங்கள்\n3. Health Insurance எடுங்கள்\n4. PPF/NPS - Tax saving\n5. Mutual Fund SIP - ₹500 முதல்\n6. பங்கு சந்தை - அனுபவம் பெற்ற பிறகு\n\nமுக்கியம்: கடன் வாங்கி முதலீடு வேண்டாம்!',
    tax: 'பங்கு முதலீட்டில் வரி:\n\n• Short Term Capital Gain (1 ஆண்டுக்கும் குறைவு): 15% வரி\n• Long Term Capital Gain (1 ஆண்டுக்கு மேல்): ₹1 லட்சம் வரை இலவசம், மேலே 10%\n• Dividend: Income tax slab பொறுத்து\n• SIP: ஒவ்வொரு installment-உம் தனி FIFO முறையில்'
  };

  const getStockIntent = (msg) => {
    const l = msg.toLowerCase();
    if (l.includes('sensex')) return 'sensex';
    if (l.includes('nifty')) return 'nifty';
    if (l.includes('sip') || l.includes('calculator') || l.includes('கணக்கீடு')) return 'sip';
    if (l.includes('mutual') || l.includes('fund') || l.includes('மியூச்சுவல்')) return 'mutual_fund';
    if (l.includes('gold') || l.includes('தங்கம்')) return 'gold';
    if (l.includes('ipo')) return 'ipo';
    if (l.includes('demat') || l.includes('account')) return 'demat';
    if (l.includes('beginner') || l.includes('start') || l.includes('தொடங்க') || l.includes('newbie')) return 'beginner';
    if (l.includes('tax') || l.includes('வரி')) return 'tax';
    return null;
  };

  const sendMessage = async (text) => {
    const userMsg = text || input.trim();
    if (!userMsg || loading) return;
    setInput('');
    setMessages(prev => [...prev, { role: 'user', text: userMsg }]);

    // SIP trigger
    if (userMsg.toLowerCase().includes('sip') || userMsg.toLowerCase().includes('calculator')) {
      setShowSIP(true);
      setMessages(prev => [...prev, { role: 'assistant', text: lang === 'ta' ? 'SIP Calculator கீழே பயன்படுத்துங்கள்! தொகை, வட்டி விகிதம், ஆண்டுகள் உள்ளிட்டு கணக்கிடுங்கள்.' : 'Use the SIP Calculator below! Enter amount, rate and years to calculate your returns.' }]);
      return;
    }

    const faqKey = getStockIntent(userMsg);
    if (faqKey && STOCK_FAQ[faqKey]) {
      setMessages(prev => [...prev, { role: 'assistant', text: STOCK_FAQ[faqKey] }]);
      return;
    }

    // Use AI for other questions
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/legal-chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: `You are a stock market assistant for Indian markets. Answer this question about stocks, investment, BSE, NSE, mutual funds in Tamil or English based on user language. Keep it simple and practical. Question: ${userMsg}`,
          lang: lang
        })
      });
      const data = await response.json();
      setMessages(prev => [...prev, { role: 'assistant', text: data.reply || 'Sorry, please try again.' }]);
    } catch(e) {
      setMessages(prev => [...prev, { role: 'assistant', text: 'Error connecting. Please try again.' }]);
    }
    setLoading(false);
  };

  const sipResult = calcSIP();

  return (
    <>
      {/* Floating Bot Button */}
      <div onClick={()=>setOpen(!open)} style={{position:'fixed',bottom:'24px',right:'24px',zIndex:9000,width:'60px',height:'60px',borderRadius:'50%',background:'linear-gradient(135deg,#006600,#00aa00)',boxShadow:'0 4px 24px rgba(0,180,0,0.5)',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',border:'3px solid rgba(0,255,65,0.4)',transition:'all 0.3s',fontSize:'24px'}}>
        {open ? '✕' : '📈'}
      </div>

      {/* Chat Window */}
      {open && (
        <div style={{position:'fixed',bottom:'90px',right:'24px',zIndex:8999,width:'clamp(300px,85vw,380px)',background:'linear-gradient(160deg,#000a00,#001200)',border:'1px solid rgba(0,255,65,0.3)',borderRadius:'16px',overflow:'hidden',boxShadow:'0 20px 60px rgba(0,0,0,0.9)',display:'flex',flexDirection:'column'}}>

          {/* Header */}
          <div style={{background:'linear-gradient(135deg,#001a00,#002800)',padding:'12px 16px',display:'flex',alignItems:'center',gap:'10px',borderBottom:'1px solid rgba(0,255,65,0.15)'}}>
            <div style={{width:'36px',height:'36px',borderRadius:'50%',background:'linear-gradient(135deg,#006600,#00aa00)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'18px',border:'2px solid rgba(0,255,65,0.4)'}}>📈</div>
            <div>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'13px',fontWeight:'900',color:'#00ff41',letterSpacing:'1px'}}>Stock Market AI</div>
              <div style={{fontSize:'10px',color:'rgba(0,212,0,0.7)',display:'flex',alignItems:'center',gap:'4px'}}><span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#00d480',display:'inline-block'}}></span>{stocksLoading?'Loading...':'Live Data'}</div>
            </div>
            <div style={{marginLeft:'auto',fontSize:'11px',color:'rgba(0,255,65,0.5)',fontFamily:"'Barlow Condensed',sans-serif"}}>NSE/BSE</div>
          </div>
          {/* Live Stock Ticker */}
          <div style={{background:'rgba(0,20,0,0.95)',padding:'8px 12px',borderBottom:'1px solid rgba(0,255,65,0.15)',overflowX:'auto',whiteSpace:'nowrap'}}>
            {stocksLoading ? (
              <span style={{fontSize:'10px',color:'rgba(0,255,65,0.4)',fontFamily:"'Barlow Condensed',sans-serif"}}>Loading live prices...</span>
            ) : (
              <div style={{display:'flex',gap:'16px'}}>
                {stocks.map((s,i)=>(
                  <div key={i} style={{display:'inline-flex',alignItems:'center',gap:'4px',flexShrink:0}}>
                    <span style={{fontSize:'10px',color:'rgba(0,255,65,0.7)',fontFamily:"'Courier New',monospace",fontWeight:'700'}}>{s.symbol}</span>
                    <span style={{fontSize:'10px',color:'#88ff88',fontFamily:"'Courier New',monospace"}}>{s.price}</span>
                    <span style={{fontSize:'9px',color:s.up?'#00ff41':'#ff4422',fontFamily:"'Courier New',monospace"}}>{s.up?'▲':'▼'}{s.pct}%</span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Messages */}
          <div style={{height:'250px',overflowY:'auto',padding:'12px',display:'flex',flexDirection:'column',gap:'10px'}}>
            {messages.map((msg,i)=>(
              <div key={i} style={{display:'flex',justifyContent:msg.role==='user'?'flex-end':'flex-start',gap:'6px'}}>
                {msg.role==='assistant' && <div style={{width:'24px',height:'24px',borderRadius:'50%',background:'linear-gradient(135deg,#006600,#00aa00)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'12px',flexShrink:0,marginTop:'2px'}}>📈</div>}
                <div style={{maxWidth:'80%',padding:'8px 12px',borderRadius:msg.role==='user'?'14px 14px 4px 14px':'14px 14px 14px 4px',background:msg.role==='user'?'linear-gradient(135deg,#006600,#004400)':'rgba(0,255,65,0.07)',border:msg.role==='user'?'none':'1px solid rgba(0,255,65,0.15)',color:msg.role==='user'?'#fff':'#c0ffc0',fontSize:'12px',lineHeight:'1.5',whiteSpace:'pre-line'}}>
                  {msg.text}
                </div>
              </div>
            ))}
            {loading && <div style={{display:'flex',gap:'4px',padding:'8px'}}>{[0,1,2].map(i=><div key={i} style={{width:'6px',height:'6px',borderRadius:'50%',background:'#00ff41',animation:`bounce 1s infinite ${i*0.2}s`}}></div>)}</div>}
            <div ref={messagesEndRef}/>
          </div>

          {/* SIP Calculator */}
          {showSIP && (
            <div style={{padding:'12px',background:'rgba(0,255,65,0.05)',borderTop:'1px solid rgba(0,255,65,0.15)'}}>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'11px',fontWeight:'900',color:'#00ff41',letterSpacing:'2px',marginBottom:'8px'}}>💰 SIP CALCULATOR</div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'6px',marginBottom:'8px'}}>
                <div>
                  <label style={{fontSize:'9px',color:'rgba(0,255,65,0.6)',display:'block',marginBottom:'2px'}}>AMOUNT (₹)</label>
                  <input type="number" value={sip.amount} onChange={e=>setSip(p=>({...p,amount:+e.target.value}))} style={{width:'100%',padding:'6px',background:'rgba(0,255,65,0.1)',border:'1px solid rgba(0,255,65,0.3)',borderRadius:'4px',color:'#00ff41',fontSize:'11px',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{fontSize:'9px',color:'rgba(0,255,65,0.6)',display:'block',marginBottom:'2px'}}>RETURNS (%)</label>
                  <input type="number" value={sip.rate} onChange={e=>setSip(p=>({...p,rate:+e.target.value}))} style={{width:'100%',padding:'6px',background:'rgba(0,255,65,0.1)',border:'1px solid rgba(0,255,65,0.3)',borderRadius:'4px',color:'#00ff41',fontSize:'11px',boxSizing:'border-box'}}/>
                </div>
                <div>
                  <label style={{fontSize:'9px',color:'rgba(0,255,65,0.6)',display:'block',marginBottom:'2px'}}>YEARS</label>
                  <input type="number" value={sip.years} onChange={e=>setSip(p=>({...p,years:+e.target.value}))} style={{width:'100%',padding:'6px',background:'rgba(0,255,65,0.1)',border:'1px solid rgba(0,255,65,0.3)',borderRadius:'4px',color:'#00ff41',fontSize:'11px',boxSizing:'border-box'}}/>
                </div>
              </div>
              <div style={{background:'rgba(0,40,0,0.8)',borderRadius:'8px',padding:'10px',border:'1px solid rgba(0,255,65,0.2)'}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:'4px'}}>
                  <span style={{fontSize:'10px',color:'rgba(0,255,65,0.6)'}}>Invested:</span>
                  <span style={{fontSize:'11px',color:'#88ff88',fontWeight:'700'}}>₹{sipResult.invested.toLocaleString('en-IN')}</span>
                </div>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:'4px'}}>
                  <span style={{fontSize:'10px',color:'rgba(0,255,65,0.6)'}}>Returns:</span>
                  <span style={{fontSize:'11px',color:'#00ff41',fontWeight:'700'}}>₹{sipResult.returns.toLocaleString('en-IN')}</span>
                </div>
                <div style={{display:'flex',justifyContent:'space-between',borderTop:'1px solid rgba(0,255,65,0.2)',paddingTop:'6px',marginTop:'4px'}}>
                  <span style={{fontSize:'11px',color:'#00ff41',fontWeight:'900',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px'}}>TOTAL VALUE:</span>
                  <span style={{fontSize:'13px',color:'#00ff41',fontWeight:'900'}}>₹{sipResult.fv.toLocaleString('en-IN')}</span>
                </div>
              </div>
            </div>
          )}

          {/* Quick Questions */}
          <div style={{padding:'6px 12px',display:'flex',gap:'5px',flexWrap:'wrap',borderTop:'1px solid rgba(0,255,65,0.1)'}}>
            {(lang==='ta'?['SENSEX என்ன?','NIFTY என்ன?','SIP Calculator','Mutual Funds','தங்க முதலீடு','IPO','வரி','தொடக்கநிலை']:
              ['What is SENSEX?','What is NIFTY?','SIP Calculator','Mutual Funds','Gold Investment','IPO Guide','Tax on Stocks','For Beginners']).map((q,i)=>(
              <button key={i} onClick={()=>sendMessage(q)} style={{padding:'3px 8px',background:'rgba(0,255,65,0.06)',border:'1px solid rgba(0,255,65,0.2)',borderRadius:'12px',color:'rgba(0,255,65,0.8)',fontSize:'10px',cursor:'pointer',fontFamily:"'Barlow Condensed',sans-serif",fontWeight:'700'}}>{q}</button>
            ))}
          </div>

          {/* Disclaimer */}
          <div style={{padding:'4px 12px',background:'rgba(255,200,0,0.04)',borderTop:'1px solid rgba(255,200,0,0.1)'}}>
            <p style={{fontSize:'9px',color:'rgba(255,200,0,0.4)',margin:0,fontStyle:'italic'}}>⚠️ {lang==='ta'?'முதலீட்டு ஆலோசனை அல்ல. நிபுணரை அணுகவும்.':'Not financial advice. Consult a certified advisor.'}</p>
          </div>

          {/* Input */}
          <div style={{padding:'10px 12px',display:'flex',gap:'6px',borderTop:'1px solid rgba(0,255,65,0.1)'}}>
            <input type="text" value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==='Enter'&&sendMessage()} placeholder={lang==='ta'?'பங்கு சந்தை கேள்வி கேளுங்கள்...':'Ask a stock market question...'}
              style={{flex:1,padding:'8px 12px',background:'rgba(0,255,65,0.06)',border:'1px solid rgba(0,255,65,0.2)',borderRadius:'8px',color:'#c0ffc0',fontSize:'12px',outline:'none'}}/>
            <button onClick={()=>sendMessage()} disabled={loading||!input.trim()}
              style={{padding:'8px 12px',background:loading||!input.trim()?'rgba(0,255,65,0.1)':'linear-gradient(135deg,#006600,#00aa00)',border:'none',borderRadius:'8px',color:'#fff',cursor:'pointer',fontSize:'14px'}}>➤</button>
          </div>
        </div>
      )}
    </>
  );
}

// Shown at the top of the Legal tab and mirrored in the Play Store listing. Keep the two in sync.
const LEGAL_DISCLAIMER = 'Nethaji Prime is a private media platform. We are not affiliated with, endorsed by, or representing any government entity, court, or law-enforcement agency. The legal information here is general awareness compiled from the official public sources linked in each section, and may not reflect the latest amendments. For advice on your own situation, consult a licensed advocate.';

// ══ LEGAL RESOURCES (INDEPENDENT PUBLISHERS ONLY) ══
// Google Play policy: "Misleading Claims - government information". The Legal tab carries
// ZERO government information by design - no government portals/links, no helpline numbers,
// no official procedures. /legal-news serves only independent publishers (LiveLaw, Bar &
// Bench, Indian Kanoon), rendered as a fixed link directory (no LIVE badge, no timestamps).
function sourceOf(link) {
  let host = '';
  try { host = new URL(link).hostname.replace(/^www\./, ''); } catch { return null; }
  return { host, label: 'Independent source', official: false };
}

function LegalNewsFeed() {
  const [news, setNews] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    let alive = true;
    fetch(`${API_URL}/legal-news`)
      .then(r => r.json())
      .then(data => { if (alive) { setNews(Array.isArray(data.articles) ? data.articles : []); setLoading(false); } })
      .catch(() => { if (alive) { setNews([]); setLoading(false); } });
    return () => { alive = false; };
  }, []);

  if (loading) return (
    <div style={{padding:'20px',textAlign:'center',color:'rgba(212,168,67,0.5)',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'2px',fontSize:'12px'}}>
      LOADING RESOURCES...
    </div>
  );

  // Nothing to show (backend down / empty payload): render nothing at all rather than a
  // bare section header over an empty list. There is no error state and no "no news today"
  // message by design - this is a fixed resource directory, not a feed that can be stale.
  if (news.length === 0) return null;

  return (
    <div style={{padding:'0 3% 20px'}}>
      <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:'8px',paddingBottom:'10px',borderBottom:'1px solid rgba(212,168,67,0.15)'}}>
        <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'10px',fontWeight:'900',letterSpacing:'2px',color:'#f0e6cc',background:'rgba(26,58,92,0.8)',padding:'4px 12px',borderRadius:'12px'}}>🔗 SOURCES</span>
        <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'1.3em',fontWeight:'800',letterSpacing:'2px',color:'#f0e6cc'}}>LEGAL NEWS & RESOURCES</span>
      </div>
      <p style={{color:'rgba(240,224,192,0.5)',fontSize:'11px',margin:'0 0 14px',lineHeight:1.5,fontFamily:"'Barlow',sans-serif"}}>
        Links open independent legal publishers. Nethaji Prime does not host or generate this content.
      </p>
      <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
        {news.map((item, i) => {
          const src = sourceOf(item.link);
          return (
            <a key={i} href={item.link} target="_blank" rel="noopener noreferrer"
              style={{display:'flex',alignItems:'flex-start',gap:'12px',padding:'12px 14px',background:'linear-gradient(160deg,#1e0404,#140202)',border:'1px solid rgba(212,168,67,0.12)',borderRadius:'10px',textDecoration:'none',transition:'all 0.2s'}}
              onMouseEnter={e=>e.currentTarget.style.borderColor='rgba(212,168,67,0.4)'}
              onMouseLeave={e=>e.currentTarget.style.borderColor='rgba(212,168,67,0.12)'}>
              <span style={{fontSize:'20px',flexShrink:0}}>{'📰'}</span>
              <div>
                <p style={{color:'#f0e0c0',fontSize:'13px',fontWeight:'700',margin:'0 0 5px',lineHeight:'1.4',fontFamily:"'Barlow',sans-serif"}}>{item.title}</p>
                {src && (
                  <span style={{display:'inline-flex',alignItems:'center',gap:'6px',flexWrap:'wrap'}}>
                    <span style={{fontSize:'9px',fontWeight:800,letterSpacing:'0.3px',padding:'2px 6px',borderRadius:'3px',color:src.official?'#7fc4ff':'rgba(240,224,192,0.6)',background:src.official?'rgba(0,85,170,0.25)':'rgba(255,255,255,0.06)'}}>{src.label}</span>
                    <span style={{fontSize:'9px',color:'rgba(240,224,192,0.4)'}}>{src.host}</span>
                  </span>
                )}
              </div>
              <span style={{marginLeft:'auto',color:'rgba(212,168,67,0.4)',fontSize:'16px',flexShrink:0}}>→</span>
            </a>
          );
        })}
      </div>
    </div>
  );
}

// ══ LEGAL CHATBOT FLOATING COMPONENT ══
let _legalGreetingPlayed = false;
function LegalChatbotFloat({ lang = "en" }) {
  const [open, setOpen] = React.useState(true);
  const [messages, setMessages] = React.useState([
    { role: 'assistant', text: lang === 'ta' ? 'வணக்கம்! நான் Nethaji Prime சட்ட உதவியாளர். உங்கள் சட்ட கேள்விகளுக்கு உதவ தயாராக இருக்கிறேன்!' : 'வணக்கம்! 🙏 Vanakkam! I am your Nethaji Prime Legal Assistant. Epadi ungaluku udavum?' }
  ]);
  const [input, setInput] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [listening, setListening] = React.useState(false);
  const messagesEndRef = React.useRef(null);
  const legalAudioRef = React.useRef(null);
  // Single-audio guarantee: hold a handle to the TTS Audio so it can be
  // stopped, and join the global coordinator (radio / video / bulletin stop
  // it, and it stops them). Also cancels the Web-Speech fallback.
  const stopLegalAudio = React.useCallback(() => {
    try { const a = legalAudioRef.current; if (a) { a.pause(); a.currentTime = 0; } } catch (e) {}
    legalAudioRef.current = null;
    try { window.speechSynthesis.cancel(); } catch (e) {}
  }, []);
  React.useEffect(() => {
    npAudio.register('legal-tts', stopLegalAudio);
    return () => { npAudio.unregister('legal-tts'); stopLegalAudio(); };
  }, [stopLegalAudio]);

  const startVoiceInput = () => {
    try {
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SpeechRecognition) {
        alert('Voice not supported. Please use Chrome browser.');
        return;
      }
      if (listening) return;
      const recognition = new SpeechRecognition();
      recognition.lang = 'ta-IN';
      recognition.interimResults = true;
      recognition.maxAlternatives = 3;
      recognition.continuous = false;

      recognition.onstart = () => {
        console.log('Listening started');
        setListening(true);
      };

      recognition.onresult = (e) => {
        let transcript = '';
        for (let i = e.resultIndex; i < e.results.length; i++) {
          if (e.results[i].isFinal) {
            transcript += e.results[i][0].transcript;
          }
        }
        if (transcript) {
          console.log('Transcript:', transcript);
          setInput(transcript);
          setListening(false);
          recognition.stop();
          setTimeout(() => sendMessage(transcript), 300);
        }
      };

      recognition.onerror = (e) => {
        console.log('Recognition error:', e.error, e.message);
        setListening(false);
        if (e.error === 'no-speech') alert('No speech detected. Please try again and speak clearly.');
        else if (e.error === 'not-allowed') alert('Microphone blocked. Go to Chrome Settings > Site Settings > Microphone and allow nethajiprime.com');
        else if (e.error === 'network') alert('Network error. Please check your connection.');
        else if (e.error === 'service-not-allowed') alert('Voice service not available on this device. Please type your question instead.');
        else alert('Error: ' + e.error + '. Please type your question.');
      };

      recognition.onend = () => {
        console.log('Recognition ended');
        setListening(false);
      };

      recognition.start();
      console.log('Recognition started');

    } catch(e) {
      console.log('Error:', e);
      setListening(false);
      alert('Voice input error: ' + e.message);
    }
  };


  // Beep and speak on mount
  React.useEffect(() => {
    if (_legalGreetingPlayed) return;
    _legalGreetingPlayed = true;
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain); gain.connect(ctx.destination);
      osc.frequency.setValueAtTime(880, ctx.currentTime);
      osc.frequency.exponentialRampToValueAtTime(440, ctx.currentTime + 0.3);
      gain.gain.setValueAtTime(0.3, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
      osc.start(ctx.currentTime); osc.stop(ctx.currentTime + 0.4);
    } catch(e) {}
    setTimeout(() => {
      try {
        const greetMsg = 'வணக்கம். நேதாஜி பிரைம் சட்ட உதவி மையத்திற்கு வரவேற்கிறோம். உங்களுக்கு எப்படி உதவலாம்?';
        // Use backend TTS proxy - natural Tamil female voice
        try {
          const ttsUrl = `${API_URL}/tts?text=${encodeURIComponent(greetMsg)}&lang=ta`;
          npAudio.stopOthers('legal-tts');   // greeting takes over: stop radio / bulletin / video
          stopLegalAudio();
          const audio = new Audio(ttsUrl);
          legalAudioRef.current = audio;
          audio.volume = 1.0;

          audio.playbackRate = 1.4;
          audio.play().catch(() => {
            window.speechSynthesis.cancel();
            const u = new SpeechSynthesisUtterance(greetMsg);
            u.lang = 'ta-IN'; u.rate = 1.4; u.pitch = 1.3; u.volume = 1.0;
            window.speechSynthesis.speak(u);
          });
        } catch(e) {}
      } catch(e) {}
    }, 600);
    return () => { window.speechSynthesis.cancel(); };
  }, []);
  const speakText = (text) => {
    try {
      // Use backend TTS - Google Translate Tamil voice
      const chunk = text.substring(0, 200);
      npAudio.stopOthers('legal-tts');
      stopLegalAudio();
      const audio = new Audio(`${API_URL}/tts?text=${encodeURIComponent(chunk)}&lang=ta`);
      legalAudioRef.current = audio;
      audio.volume = 0.9;
      audio.play().catch(() => {
        window.speechSynthesis.cancel();
        const u = new SpeechSynthesisUtterance(chunk);
        u.lang = 'ta-IN'; u.rate = 1.4; u.pitch = 1.3; u.volume = 0.9;
        window.speechSynthesis.speak(u);
      });
    } catch(e) {}
  };

  React.useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, open]);

  const CALENDLY_URL = 'https://calendly.com/nethajitv97/30min';
  const WHATSAPP_NUMBER = '919444456788';
  const [bookingMode, setBookingMode] = React.useState(false);
  const [showServices, setShowServices] = React.useState(false);

  // FAQ Database - general legal awareness only (no government portals,
  // procedures, or phone numbers).
  // FAQ Database
  const FAQ_DB = {
    'rights': { q: 'Know your rights', a: 'கைது செய்யப்பட்டால் அமைதியாக இருக்கவும், காரணத்தை கேட்கவும், உங்கள் விருப்பப்படி வழக்கறிஞரை அணுகவும் உரிமை உண்டு. உங்கள் புகார் பதிவு செய்யப்பட்டு அதன் நகலை இலவசமாகப் பெற உரிமை உண்டு. துல்லியமான ஆலோசனைக்கு உரிமம் பெற்ற வழக்கறிஞரை அணுகவும்.' },
    'property': { q: 'Property rights', a: 'சொத்து வாங்கும் முன் உரிமை ஆவணங்களையும் நிலுவை உரிமைகோரல்களையும் சரிபார்க்கவும். பத்திரங்களை பதிவு செய்யவும். பெண்களுக்கும் சம வாரிசு உரிமை உண்டு. துல்லியமான ஆலோசனைக்கு வழக்கறிஞரை அணுகவும்.' },
    'family': { q: 'Family & marriage law', a: 'திருமணத்தை பதிவு செய்வது நல்லது. ஜீவனாம்சம் உங்கள் உரிமையாக இருக்கலாம். குழந்தை காவல் குழந்தையின் நலனை முன்னிட்டு தீர்மானிக்கப்படும். வீட்டு வன்முறையை எதிர்கொள்பவர்களுக்கு பாதுகாப்பு உண்டு. வழக்கறிஞரை அணுகவும்.' },
    'labour': { q: 'Worker rights', a: 'குறைந்தபட்ச ஊதியம், PF/ESI பலன்கள், நியாயமற்ற பணிநீக்கத்திற்கு எதிரான பாதுகாப்பு, துன்புறுத்தல் இல்லாத பணியிடம் ஆகியன உங்கள் உரிமைகள். வழக்கறிஞரை அணுகவும்.' },
    'online': { q: 'Online safety', a: 'உங்கள் டிஜிட்டல் தனியுரிமை சட்டப்படி பாதுகாக்கப்படுகிறது. துன்புறுத்தல்/மோசடிக்கான எடுத்துக்காட்டல்களை ஆதாரமாக வைக்கவும். ஆன்லைன் துன்புறுத்தல் ஒரு குற்றம். ஆதாரங்களை பாதுகாத்து விரைவாக நடவடிக்கை எடுக்கவும். வழக்கறிஞரை அணுகவும்.' },
    'legal_terms': { q: 'Legal terms', a: 'அடிப்படை சட்ட வார்த்தைகள்: Bail (பிணை), Affidavit (சத்திய பிரமாணம்), Injunction (தடை உத்தரவு), Plaintiff (வாதி), Defendant (பிரதிவாதி), Verdict (தீர்ப்பு), Patta (நில உரிமை ஆவணம்). மேலும் தெரிந்துகொள்ள கேளுங்கள்.' },
    'video_recommend': { q: 'Legal videos', a: 'Nethaji Prime-ல் சட்ட விழிப்புணர்வு வீடியோக்கள் Legal பிரிவில் உள்ளன. தினமும் புதிய வீடியோக்கள் சேர்க்கப்படுகின்றன.' }
  };

  const handleBookingIntent = (msg) => {
    const lower = msg.toLowerCase();
    return lower.includes('appointment') || lower.includes('book') || lower.includes('consultation') ||
           lower.includes('meet') || lower.includes('varadaraj') || lower.includes('schedule') ||
           lower.includes('fee') || lower.includes('cost') || lower.includes('price') ||
           lower.includes('1000') || lower.includes('கட்டணம்') || lower.includes('சந்திப்பு') || lower.includes('ஆலோசனை பதிவு');
  };

  const handleFAQIntent = (msg) => {
    const lower = msg.toLowerCase();
    if (lower.includes('arrest') || lower.includes('fir') || lower.includes('police') || lower.includes('complaint') || lower.includes('காவல்') || lower.includes('கைது')) return 'rights';
    if (lower.includes('property') || lower.includes('சொத்து') || lower.includes('patta') || lower.includes('பட்டா')) return 'property';
    if (lower.includes('divorce') || lower.includes('family') || lower.includes('marriage') || lower.includes('விவாகரத்து') || lower.includes('குடும்ப')) return 'family';
    if (lower.includes('labour') || lower.includes('labor') || lower.includes('worker') || lower.includes('தொழிலாளர்') || lower.includes('salary') || lower.includes('ஊதியம்')) return 'labour';
    if (lower.includes('cyber') || lower.includes('online') || lower.includes('fraud') || lower.includes('hacking') || lower.includes('சைபர்')) return 'online';
    if (lower.includes('meaning') || lower.includes('what is') || lower.includes('define') || lower.includes('term') || lower.includes('விளக்கம்') || lower.includes('வார்த்தை')) return 'legal_terms';
    if (lower.includes('video') || lower.includes('watch') || lower.includes('வீடியோ') || lower.includes('recommend')) return 'video_recommend';
    return null;
  };

  const sendMessage = async (text) => {
    const userMsg = text || input.trim();
    if (!userMsg || loading) return;
    setInput('');
    setMessages(prev => [...prev, { role: 'user', text: userMsg }]);
    setLoading(true);

    if (handleBookingIntent(userMsg)) {
      setTimeout(() => {
        const bookingMsg = lang === 'ta'
          ? 'நிச்சயமாக! கட்டண விவரம்: 30 நிமிடம் = Rs.1000, 1 மணி நேரம் = Rs.2000. கீழே பதிவு செய்யுங்கள்.'
          : 'Sure! Fee: 30 min = Rs.1,000 | 1 hour = Rs.2,000. Book below:';
        setMessages(prev => [...prev, { role: 'assistant', text: bookingMsg, isBooking: true }]);
        setLoading(false);
      }, 800);
      return;
    }

    // Check FAQ intent
    const faqKey = handleFAQIntent(userMsg);
    if (faqKey && FAQ_DB[faqKey]) {
      setTimeout(() => {
        setMessages(prev => [...prev, {
          role: 'assistant',
          text: FAQ_DB[faqKey].a
        }]);
        setLoading(false);
      }, 600);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/legal-chat`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: userMsg, lang: lang })
      });
      const data = await response.json();
      const reply = data.reply || 'Sorry, please try again.';
      // Generative fallback: general awareness only.
      setMessages(prev => [...prev, { role: 'assistant', text: reply, source: 'AI-generated general legal awareness. For advice on your situation, consult a licensed advocate.' }]);
    } catch(err) {
      setMessages(prev => [...prev, { role: 'assistant', text: 'Error connecting. Please try again.' }]);
    }
    setLoading(false);
  };

  return (
    <>
      {/* Floating Button */}
      <div onClick={() => setOpen(!open)} title="Legal AI Assistant" style={{position:'fixed',bottom:'24px',right:'24px',zIndex:9000,width:'60px',height:'60px',borderRadius:'50%',background:'linear-gradient(135deg,#8B0000,#cc0000)',boxShadow:'0 4px 24px rgba(180,0,0,0.7)',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',border:'3px solid rgba(245,200,66,0.6)',transition:'all 0.3s',overflow:'hidden'}}>
        {open ? <span style={{fontSize:'20px',color:'#fff',fontWeight:'900'}}>✕</span> : (
          <svg viewBox="0 0 60 60" width="60" height="60" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="22" r="14" fill="#F4C2A1"/>
            <circle cx="30" cy="22" r="14" fill="none" stroke="#d4a843" strokeWidth="1"/>
            <ellipse cx="25" cy="20" rx="3" ry="3.5" fill="#4a2800"/>
            <ellipse cx="35" cy="20" rx="3" ry="3.5" fill="#4a2800"/>
            <circle cx="26" cy="19" r="1" fill="white"/>
            <circle cx="36" cy="19" r="1" fill="white"/>
            <path d="M24 27 Q30 32 36 27" stroke="#cc4444" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
            <ellipse cx="23" cy="24" rx="3" ry="1.5" fill="#ffb3a0" opacity="0.6"/>
            <ellipse cx="37" cy="24" rx="3" ry="1.5" fill="#ffb3a0" opacity="0.6"/>
            <path d="M20 12 Q30 6 40 12" stroke="#3a1a00" strokeWidth="2" fill="none" strokeLinecap="round"/>
            <rect x="10" y="36" width="40" height="24" rx="8" fill="linear-gradient(135deg,#cc0000,#880000)"/>
            <rect x="10" y="36" width="40" height="24" rx="8" fill="#cc0000"/>
            <text x="30" y="52" textAnchor="middle" fill="#f5c842" fontSize="8" fontWeight="bold" fontFamily="sans-serif">LEGAL AI</text>
          </svg>
        )}
      </div>

      {/* Chat Window */}
      {open && (
        <div style={{position:'fixed',bottom:'80px',right:'12px',zIndex:8999,width:'clamp(280px,85vw,360px)',background:'linear-gradient(160deg,#1a0303,#0e0101)',border:'1px solid rgba(212,168,67,0.3)',borderRadius:'16px',overflow:'hidden',boxShadow:'0 20px 60px rgba(0,0,0,0.8)',display:'flex',flexDirection:'column'}}>

          {/* Header */}
          <div style={{background:'linear-gradient(135deg,#2a0000,#1a0000)',padding:'12px 16px',display:'flex',alignItems:'center',gap:'10px',borderBottom:'1px solid rgba(212,168,67,0.15)'}}>
            <div style={{width:'36px',height:'36px',borderRadius:'50%',background:'linear-gradient(135deg,#8B0000,#cc0000)',display:'flex',alignItems:'center',justifyContent:'center',border:'2px solid rgba(212,168,67,0.4)',overflow:'hidden'}}>
              <svg viewBox="0 0 60 60" width="36" height="36" xmlns="http://www.w3.org/2000/svg">
                <circle cx="30" cy="22" r="14" fill="#F4C2A1"/>
                <ellipse cx="25" cy="20" rx="3" ry="3.5" fill="#4a2800"/>
                <ellipse cx="35" cy="20" rx="3" ry="3.5" fill="#4a2800"/>
                <circle cx="26" cy="19" r="1" fill="white"/>
                <circle cx="36" cy="19" r="1" fill="white"/>
                <path d="M24 27 Q30 32 36 27" stroke="#cc4444" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
                <path d="M20 12 Q30 6 40 12" stroke="#3a1a00" strokeWidth="2" fill="none" strokeLinecap="round"/>
              </svg>
            </div>
            <div>
              <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'13px',fontWeight:'900',color:'#f5c842',letterSpacing:'1px'}}>{lang==='ta'?'சட்ட AI உதவியாளர்':'Legal AI Assistant'}</div>
              <div style={{fontSize:'10px',color:'rgba(0,212,128,0.8)',display:'flex',alignItems:'center',gap:'4px'}}><span style={{width:'6px',height:'6px',borderRadius:'50%',background:'#00d480',display:'inline-block'}}></span>Online</div>
            </div>
          </div>

          {/* Messages */}
          <div style={{height:'clamp(180px,35vh,280px)',overflowY:'auto',padding:'12px',display:'flex',flexDirection:'column',gap:'10px'}}>
            {messages.map((msg, i) => (
              <div key={i} style={{display:'flex',justifyContent:msg.role==='user'?'flex-end':'flex-start',gap:'6px'}}>
                {msg.role==='assistant' && (
              <div style={{width:'28px',height:'28px',borderRadius:'50%',background:'linear-gradient(135deg,#8B0000,#cc0000)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,marginTop:'2px',border:'1px solid rgba(212,168,67,0.4)',overflow:'hidden'}}>
                <svg viewBox="0 0 60 60" width="28" height="28" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="30" cy="22" r="14" fill="#F4C2A1"/>
                  <ellipse cx="25" cy="20" rx="3" ry="3.5" fill="#4a2800"/>
                  <ellipse cx="35" cy="20" rx="3" ry="3.5" fill="#4a2800"/>
                  <circle cx="26" cy="19" r="1" fill="white"/>
                  <circle cx="36" cy="19" r="1" fill="white"/>
                  <path d="M24 27 Q30 32 36 27" stroke="#cc4444" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
                  <path d="M20 12 Q30 6 40 12" stroke="#3a1a00" strokeWidth="2" fill="none" strokeLinecap="round"/>
                </svg>
              </div>
            )}
                <div style={{maxWidth:'80%'}}>
                  <div style={{padding:'8px 12px',borderRadius:msg.role==='user'?'14px 14px 4px 14px':'14px 14px 14px 4px',background:msg.role==='user'?'linear-gradient(135deg,#cc0000,#880000)':'rgba(255,255,255,0.07)',border:msg.role==='user'?'none':'1px solid rgba(212,168,67,0.15)',color:'#f0e0c0',fontSize:'12px',lineHeight:'1.5',fontFamily:"'Barlow',sans-serif",whiteSpace:'pre-line'}}>
                    {msg.text}
                    {msg.source && (
                      <div style={{marginTop:'8px',paddingTop:'6px',borderTop:'1px solid rgba(212,168,67,0.2)'}}>
                        <div style={{fontSize:'9px',color:'rgba(245,200,66,0.55)',fontWeight:900,letterSpacing:'1px',marginBottom:'2px'}}>SOURCE</div>
                        <div style={{fontSize:'10px',color:'rgba(240,224,192,0.65)',lineHeight:1.4}}>{msg.source}</div>
                      </div>
                    )}
                  </div>
                  {msg.isBooking && (
                    <div style={{display:'flex',flexDirection:'column',gap:'6px',marginTop:'8px'}}>
                      <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer"
                        style={{display:'flex',alignItems:'center',gap:'8px',padding:'10px 14px',background:'linear-gradient(135deg,#1a6b3c,#0d4a28)',border:'1px solid rgba(0,212,128,0.4)',borderRadius:'8px',color:'#00d480',textDecoration:'none',fontSize:'12px',fontWeight:'800',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px'}}>
                        📅 Book Appointment on Calendly
                      </a>
                      <a href={'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent('Hello Mr. Varadaraj, I need legal consultation.')}
                        target="_blank" rel="noopener noreferrer"
                        style={{display:'flex',alignItems:'center',gap:'8px',padding:'10px 14px',background:'linear-gradient(135deg,#1a5c1a,#0d3d0d)',border:'1px solid rgba(37,211,102,0.4)',borderRadius:'8px',color:'#25d366',textDecoration:'none',fontSize:'12px',fontWeight:'800',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px'}}>
                        📱 WhatsApp Video Call with Mr. Varadaraj
                      </a>
                    </div>
                  )}
                </div>
              </div>
            ))}
            {loading && (
              <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                <div style={{width:'28px',height:'28px',borderRadius:'50%',background:'linear-gradient(135deg,#8B0000,#cc0000)',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,border:'1px solid rgba(212,168,67,0.4)',overflow:'hidden'}}>
                <svg viewBox="0 0 60 60" width="28" height="28" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="30" cy="22" r="14" fill="#F4C2A1"/>
                  <ellipse cx="25" cy="20" rx="3" ry="3.5" fill="#4a2800"/>
                  <ellipse cx="35" cy="20" rx="3" ry="3.5" fill="#4a2800"/>
                  <path d="M24 27 Q30 32 36 27" stroke="#cc4444" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
                </svg>
              </div>
                <div style={{padding:'8px 12px',borderRadius:'14px',background:'rgba(255,255,255,0.07)',border:'1px solid rgba(212,168,67,0.15)',display:'flex',gap:'3px'}}>
                  {[0,1,2].map(i=><div key={i} style={{width:'5px',height:'5px',borderRadius:'50%',background:'#d4a843',animation:`bounce 1s infinite ${i*0.2}s`}}></div>)}
                </div>
              </div>
            )}
            <div ref={messagesEndRef}/>
          </div>

          {/* Quick questions */}
          <div style={{padding:'6px 12px',display:'flex',gap:'5px',flexWrap:'wrap',borderTop:'1px solid rgba(212,168,67,0.1)'}}>
            {(lang==='ta'?['உரிமைகள்','சொத்து ஆவணங்கள்','குடும்ப சட்டம்','தொழிலாளர் உரிமை','சைபர் பாதுகாப்பு','சட்ட வார்த்தைகள்','வீடியோக்கள்','ஆலோசனை பதிவு']:['Your Rights','Property','Family Law','Worker Rights','Online Safety','Legal Terms','Legal Videos','Book Consultation']).map((q,i)=>(
              <button key={i} onClick={()=>sendMessage(q)} style={{padding:'3px 8px',background:'rgba(212,168,67,0.08)',border:'1px solid rgba(212,168,67,0.2)',borderRadius:'12px',color:'rgba(212,168,67,0.8)',fontSize:'10px',cursor:'pointer',fontFamily:"'Barlow Condensed',sans-serif",fontWeight:'700'}}>{q}</button>
            ))}
          </div>

          {/* Disclaimer - kept legible on purpose (was 9px at 40% opacity). */}
          <div style={{padding:'8px 12px',background:'rgba(245,200,66,0.08)',borderTop:'1px solid rgba(245,200,66,0.25)'}}>
            <p style={{fontSize:'11px',color:'rgba(245,200,66,0.85)',margin:0,lineHeight:1.45,textAlign:'center'}}>⚠️ Not a government service. General information from official public sources — not legal advice. Consult a licensed advocate.</p>
          </div>

          {/* Input */}
          <div style={{padding:'10px 12px',display:'flex',gap:'6px',borderTop:'1px solid rgba(212,168,67,0.1)'}}>
            <input type="text" value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==='Enter'&&sendMessage()} placeholder={lang==='ta'?'கேள்வி கேளுங்கள்...':'Ask a question...'}
              style={{flex:1,padding:'8px 12px',background:'rgba(255,255,255,0.06)',border:'1px solid rgba(212,168,67,0.2)',borderRadius:'8px',color:'#f0e0c0',fontSize:'12px',outline:'none'}} />

        <button onClick={()=>sendMessage()} disabled={loading||!input.trim()}
              style={{padding:'8px 12px',background:loading||!input.trim()?'rgba(212,168,67,0.1)':'linear-gradient(135deg,#cc0000,#880000)',border:'none',borderRadius:'8px',color:'#fff',cursor:'pointer',fontSize:'14px'}}>➤</button>
          </div>
        </div>
      )}
    </>
  );
}


// ══ SUN DETECTIVE TAB ══
function SunDetectiveTab({ onVideoClick, hasAccess, t = T.en, lang = "en" }) {
  const [videos, setVideos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [featured, setFeatured] = React.useState(null);

  React.useEffect(() => {
    fetch(`${API_URL}/speeches?category=Sun%20Detective`)
      .then(r => r.json())
      .then(data => {
        const list = data.speeches || [];
        setVideos(list);
        if (list.length > 0) setFeatured(list[0]);
        else setFeatured(null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div style={{minHeight:'100vh',background:'#050008',color:'#e0d0ff',fontFamily:"'Barlow',sans-serif"}}>

      {/* Hero Banner - Cinematic, No Video */}
      <div style={{position:'relative',height:'clamp(220px,40vw,340px)',background:'#050008',overflow:'hidden',borderBottom:'1px solid rgba(138,43,226,0.3)'}}>
        {/* Deep space background */}
        <div style={{position:'absolute',inset:0,background:'radial-gradient(ellipse at 20% 60%,rgba(138,43,226,0.35) 0%,transparent 60%)'}}></div>
        <div style={{position:'absolute',inset:0,background:'radial-gradient(ellipse at 80% 20%,rgba(75,0,130,0.25) 0%,transparent 55%)'}}></div>
        <div style={{position:'absolute',inset:0,background:'radial-gradient(ellipse at 50% 90%,rgba(30,0,60,0.8) 0%,transparent 50%)'}}></div>
        {/* Stars */}
        {[...Array(20)].map((_,i)=>(
          <div key={i} style={{position:'absolute',width:i%3===0?'3px':'2px',height:i%3===0?'3px':'2px',borderRadius:'50%',background:i%4===0?'rgba(255,255,255,0.9)':'rgba(180,120,255,0.7)',top:`${Math.floor(i*7+5)}%`,left:`${Math.floor(i*11+3)}%`,boxShadow:i%3===0?'0 0 6px rgba(180,120,255,0.9)':'none'}}></div>
        ))}
        {/* Magnifying glass icon */}
        <div style={{position:'absolute',right:'5%',top:'50%',transform:'translateY(-50%)',fontSize:'clamp(80px,15vw,120px)',opacity:0.12,filter:'drop-shadow(0 0 20px rgba(138,43,226,0.5))'}}>🔍</div>
        {/* Content */}
        <div style={{position:'absolute',inset:0,display:'flex',flexDirection:'column',justifyContent:'center',padding:'0 5%'}}>
          <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'16px'}}>
            <span style={{background:'linear-gradient(135deg,#8b00ff,#4b0082)',color:'#fff',fontFamily:"'Barlow Condensed',sans-serif",fontSize:'9px',fontWeight:'900',letterSpacing:'3px',padding:'5px 14px',borderRadius:'2px',boxShadow:'0 0 20px rgba(138,43,226,0.5)'}}>🕵️ SUN DETECTIVE</span>
            <div style={{height:'1px',flex:1,background:'linear-gradient(90deg,rgba(138,43,226,0.6),transparent)'}}></div>
          </div>
          <h1 style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'clamp(28px,5vw,52px)',fontWeight:'900',color:'#e8d5ff',letterSpacing:'3px',margin:'0 0 10px',textShadow:'0 0 40px rgba(138,43,226,0.6)',lineHeight:1.1}}>
            {lang==='ta'?'மர்மங்களை அம்பலப்படுத்துவோம்':'UNCOVER THE TRUTH'}
          </h1>
          <p style={{color:'rgba(180,140,255,0.8)',fontSize:'clamp(11px,1.5vw,14px)',margin:'0 0 20px',fontStyle:'italic',letterSpacing:'1px'}}>
            {lang==='ta'?'உண்மை குற்றவழக்குகள் · மர்ம விசாரணைகள் · நீதி':'True Crime · Mystery Investigations · Justice'}
          </p>
          <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
            <div style={{height:'2px',width:'40px',background:'linear-gradient(90deg,rgba(138,43,226,0.8),transparent)'}}></div>
            <span style={{color:'rgba(138,43,226,0.6)',fontSize:'10px',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'3px'}}>{videos.length} EPISODES</span>
            <div style={{height:'2px',flex:1,background:'linear-gradient(90deg,rgba(138,43,226,0.3),transparent)'}}></div>
          </div>
        </div>
        {/* Bottom fade */}
        <div style={{position:'absolute',bottom:0,left:0,right:0,height:'60px',background:'linear-gradient(transparent,#050008)'}}></div>
      </div>



      {/* All Episodes */}
      <div style={{padding:'10px 4% 40px'}}>
        <div style={{display:'flex',alignItems:'center',gap:'8px',marginBottom:'14px'}}>
          <span style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'9px',fontWeight:'900',letterSpacing:'3px',color:'#000',background:'linear-gradient(135deg,#9b30ff,#6600cc)',padding:'3px 10px',borderRadius:'2px'}}>📺 ALL EPISODES</span>
          <div style={{flex:1,height:'1px',background:'linear-gradient(90deg,rgba(138,43,226,0.4),transparent)'}}></div>
          <span style={{color:'rgba(180,140,255,0.5)',fontSize:'11px',fontFamily:"'Barlow Condensed',sans-serif"}}>{videos.length} episodes</span>
        </div>

        {loading && (
          <div style={{textAlign:'center',padding:'40px',color:'rgba(138,43,226,0.5)',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'3px',fontSize:'12px'}}>
            🔍 INVESTIGATING...
          </div>
        )}

        {!loading && videos.length === 0 && (
          <div style={{textAlign:'center',padding:'60px',color:'rgba(180,140,255,0.5)'}}>
            <div style={{fontSize:'48px',marginBottom:'16px'}}>🕵️</div>
            <p style={{fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'2px',fontSize:'14px'}}>NO EPISODES FOUND</p>
            <p style={{fontSize:'12px',opacity:0.6}}>{lang==='ta'?'விரைவில் வீடியோக்கள் சேர்க்கப்படும்':'Videos will be added soon'}</p>
          </div>
        )}

        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
          {videos.map((video, i) => (
            <div key={video.id} onClick={()=>onVideoClick&&onVideoClick(video)}
              style={{background:'linear-gradient(160deg,#100020,#080012)',border:'1px solid rgba(138,43,226,0.15)',borderRadius:'10px',overflow:'hidden',cursor:'pointer',transition:'all 0.3s'}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor='rgba(138,43,226,0.5)';e.currentTarget.style.transform='translateY(-4px)';e.currentTarget.style.boxShadow='0 8px 24px rgba(138,43,226,0.2)';}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor='rgba(138,43,226,0.15)';e.currentTarget.style.transform='none';e.currentTarget.style.boxShadow='none';}}>
              <div style={{position:'relative',height:'100px',background:'#0a0015',overflow:'hidden'}}>
                {video.thumbnail_url
                  ? <img src={video.thumbnail_url} alt={video.title} style={{width:'100%',height:'100%',objectFit:'cover',filter:'brightness(0.75) saturate(0.6) hue-rotate(260deg)'}}/>
                  : <div style={{width:'100%',height:'100%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'24px'}}>🔍</div>
                }
                <div style={{position:'absolute',inset:0,background:'linear-gradient(transparent 50%,rgba(8,0,18,0.8))'}}></div>
                <div style={{position:'absolute',bottom:'4px',right:'4px',background:'rgba(0,0,0,0.85)',color:'#c89fff',fontSize:'9px',fontWeight:'700',padding:'1px 5px',borderRadius:'2px',fontFamily:"'Barlow Condensed',sans-serif"}}>{formatDuration(video.duration)}</div>
                <div style={{position:'absolute',top:'4px',left:'4px',background:'rgba(138,43,226,0.85)',color:'#fff',fontSize:'8px',fontWeight:'900',padding:'2px 6px',borderRadius:'2px',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px'}}>EP {i+1}</div>
              </div>
              <div style={{padding:'8px 10px 10px',borderTop:'1px solid rgba(60,0,80,0.5)',background:'linear-gradient(180deg,#100018,#080010)'}}>
                <p style={{color:'#e8d5ff',fontSize:'11px',fontWeight:'700',margin:'0 0 3px',lineHeight:'1.3',overflow:'hidden',display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'0.3px'}}>{video.title}</p>
                <p style={{color:'rgba(138,43,226,0.7)',fontSize:'10px',margin:'0 0 4px',fontFamily:"'Barlow Condensed',sans-serif"}}>{video.speaker_name}</p>
                <div style={{display:'flex',gap:'8px',fontSize:'9px',color:'rgba(180,140,255,0.4)'}}>
                  <span>👁 {video.views_count||0}</span>
                  <span>🔥 {video.hype_count||0}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

}

function LegalTab({ onVideoClick, hasAccess, t = T.en, lang = "en" }) {
  const [activeRights, setActiveRights] = React.useState(null);
  const topics = [
    {icon:'🛡️',title:'FIR & Police Procedure',sub:'Your Rights When Arrested or Questioned'},
    {icon:'🏠',title:'Property & Documents',sub:'Land, Asset & Will Deeds Explained'},
    {icon:'🔒',title:'Cyber Crime & Social Media',sub:'Online Safety & Legal Protection Tips'},
    {icon:'👨‍👩‍👧',title:'Family & Matrimonial Law',sub:'Divorce, Custody & Domestic Rights'},
    {icon:'💼',title:'Labour & Employment Rights',sub:'Workplace Harassment, PF, ESI & More'},
    {icon:'🏥',title:'Consumer & Medical Rights',sub:'Negligence & Consumer Rights'},
    {icon:'📜',title:'Constitutional Rights',sub:'Fundamental Rights Every Citizen Must Know'},
    {icon:'❓',title:'Common Legal Myths',sub:'Dealing with Misconceptions & Facts'},
  ];
  const [videos, setVideos] = React.useState([]);
  React.useEffect(() => {
    fetch(`${API_URL}/speeches?category=Legal`)
      .then(r => r.json())
      .then(data => setVideos(data.speeches || []))
      .catch(err => console.error(err));
  }, []);
  // Plain-language rights only. No statutes, portals, numbers or source links.
  const rightsCards = [
    {icon:'🛡️',title:lang==='ta'?'கைது செய்யப்பட்டால்':'If You Are Arrested',color:'#cc3300',points:lang==='ta'?['அமைதியாக இருக்க உரிமை உண்டு','ஏன் தடுத்து வைக்கப்படுகிறீர்கள் எனக் கேட்க உரிமை உண்டு','உங்கள் விருப்பப்படி வழக்கறிஞரை அணுக உரிமை உண்டு','யாரும் உங்களை வலுக்கட்டாயப்படுத்த முடியாது']:['Right to remain silent','Right to be told why you are being detained','Right to consult a lawyer of your choice','No one may use force or threats against you','For a bailable offence, release on bail is your right']},
    {icon:'📄',title:lang==='ta'?'புகார் செய்வது':'Making a Complaint',color:'#0055aa',points:lang==='ta'?['உங்கள் புகார் பதிவு செய்யப்பட வேண்டும்','அதன் நகலை இலவசமாகப் பெற உரிமை உண்டு','மறுத்தால் மூத்த அதிகாரியிடம் தெரிவிக்கலாம்']:['Your complaint must be recorded','You are entitled to a free copy of it','If refused, raise it with a more senior officer','Keep your own written record of events']},
    {icon:'🏠',title:lang==='ta'?'சொத்து உரிமைகள்':'Property Rights',color:'#886600',points:lang==='ta'?['பெண்களுக்கும் சொத்தில் சம வாரிசு உரிமை உண்டு','வாங்கும் முன் உரிமை ஆவணங்களை சரிபார்க்கவும்','பத்திரங்களை பதிவு செய்யவும்']:['Women have equal inheritance rights','Verify ownership documents before buying','Check for any outstanding claims on the property','Register your documents — an unregistered sale is not secure']},
    {icon:'🔒',title:lang==='ta'?'ஆன்லைன் பாதுகாப்பு':'Online Safety Rights',color:'#005588',points:lang==='ta'?['உங்கள் டிஜிட்டல் தனியுரிமை சட்டப்படி பாதுகாக்கப்படுகிறது','ஸ்கிரீன்ஷாட்கள் செல்லுபடியாகும் ஆதாரம்','ஆதாரங்களை பாதுகாத்து விரைவாக நடவடிக்கை எடுக்கவும்']:['Your digital privacy is protected by law','Screenshots of abuse or fraud are valid evidence','Online harassment and identity theft are offences','Preserve evidence and act quickly']},
    {icon:'👨‍👩‍👧',title:lang==='ta'?'குடும்ப சட்டம்':'Family & Marriage Law',color:'#660033',points:lang==='ta'?['திருமணத்தை பதிவு செய்வது நல்லது','ஜீவனாம்சம் உங்கள் உரிமையாக இருக்கலாம்','குழந்தை காவல் குழந்தையின் நலனை முன்னிட்டு தீர்மானிக்கப்படும்']:['A marriage should be registered','Maintenance can be your legal right',"Custody is decided in the child's best interest",'Protection is available against domestic violence']},
    {icon:'💼',title:lang==='ta'?'தொழிலாளர் உரிமைகள்':'Worker Rights',color:'#004400',points:lang==='ta'?['குறைந்தபட்ச ஊதியம் பெற உரிமை உண்டு','PF/ESI பலன்கள் உங்கள் உரிமை','துன்புறுத்தல் இல்லாத பணியிடம் உங்கள் உரிமை']:['Right to at least the minimum wage','Right to provident-fund and insurance benefits','Wrongful termination can be challenged','Right to a workplace free of harassment']},
  ];
  // Expert Advocates section removed: the four listings were placeholders with unverifiable
  // credentials (Google Play "Misleading Claims"). Restore only with real, reachable advocates.

  return (
    <div className="legal-tab">
      {/* Non-affiliation disclaimer. Must stay above the fold - Google Play "Misleading Claims
          - government information" requires this to be prominent, not buried in a footer. */}
      <div style={{margin:'12px 3%',padding:'14px 16px',background:'rgba(245,200,66,0.07)',border:'1px solid rgba(245,200,66,0.35)',borderRadius:'8px'}}>
        <div style={{color:'#f5c842',fontSize:'11px',fontWeight:900,letterSpacing:'1px',marginBottom:'6px',fontFamily:"'Barlow Condensed',sans-serif"}}>ℹ️ NOT A GOVERNMENT SERVICE</div>
        <div style={{color:'rgba(240,224,192,0.8)',fontSize:'12px',lineHeight:1.6,fontFamily:"'Barlow',sans-serif"}}>{LEGAL_DISCLAIMER}</div>
      </div>
      <div style={{position:'relative',width:'100%',height:'clamp(420px,45vw,560px)',background:'linear-gradient(135deg,#3a0000,#1a0000,#060000)',overflow:'hidden'}}>
        <div style={{position:'absolute',right:'5%',top:'50%',transform:'translateY(-50%)',fontSize:'120px',opacity:0.15,zIndex:1}}>⚖️</div>
        <div style={{position:'absolute',top:0,bottom:0,left:0,width:'60%',zIndex:5,display:'flex',flexDirection:'column',justifyContent:'center',padding:'40px 0 40px 38px'}}>
          <div className="lt-badge"><span className="lt-badge-dot"></span><span className="lt-badge-text">⚖️ EXCLUSIVE · {lang==="ta"?"சட்ட விழிப்புணர்வு":"LEGAL AWARENESS"}</span></div>
          <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontWeight:900,textTransform:'uppercase',lineHeight:1.15,marginBottom:'14px',fontSize:'clamp(1.4em,2.8vw,2.8em)'}}><span style={{display:'block',color:'#ffffff',fontSize:'inherit'}}>{lang==="ta"?"உங்கள்":"KNOW"}</span><span style={{display:'block',color:'#f0e6cc',fontSize:'inherit'}}>{lang==="ta"?"உரிமைகளை":"YOUR"}</span><span style={{display:'block',background:'linear-gradient(135deg,#fff5c0,#f5c842 40%,#d4a843)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent',backgroundClip:'text',fontSize:'inherit'}}>{lang==="ta"?"அறியுங்கள்":"RIGHTS"}</span></div>
          <div className="lt-rule"><div className="lt-rule-l"></div><div className="lt-rule-d"></div><div className="lt-rule-r"></div></div>
          <div className="lt-sub">{lang==="ta"?"சட்டம் • குற்றம் • நீதி • உரிமைகள்":"Law • Crime • Justice • Rights"}<br/>{lang==="ta"?"நேத்தாஜி பிரைம் OTT-யில் சட்ட வல்லுநர்கள்":<>Expert lawyers exclusively on <span>Nethaji Prime OTT</span></>}</div>
          <div className="lt-tag-row"><span className="lt-tag">🛡️ FIR</span><span className="lt-tag">🏠 {lang==="ta"?"சொத்து":"Property"}</span><span className="lt-tag">🔒 {lang==="ta"?"சைபர்":"Cyber"}</span><span className="lt-tag">⚖️ {lang==="ta"?"உரிமைகள்":"Rights"}</span></div>
          <div className="lt-btns"><button className="lt-btn-watch">{t.watch_now_btn}</button><button className="lt-btn-trailer">{t.trailer}</button></div>
        </div>
      </div>
      {/* LEGAL NEWS FEED */}
      <LegalNewsFeed />

      {/* LEGAL AI CHATBOT - FLOATING BUTTON */}
      <LegalChatbotFloat lang={lang} />
      <div className="lt-sec-head"><span className="lt-sec-badge">{t.trending}</span><span className="lt-sec-title">{t.legal_videos}</span><span className="lt-sec-link">{t.see_all}</span></div>
      <div className="lt-scroll">
  {videos.length === 0 ? (
    <div style={{padding:'40px',color:'#8a7060',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'2px',textAlign:'center'}}>
      NO LEGAL VIDEOS YET — COMING SOON
    </div>
  ) : videos.map((v,i)=>(
    <div key={i} className="lt-vcard" onClick={()=>onVideoClick&&onVideoClick(v)}>
      <div className="lt-vthumb" style={{background:'linear-gradient(135deg,#1a0a00,#060000)'}}>
        {v.thumbnail_url ? <img src={v.thumbnail_url} alt={v.title} style={{width:'100%',height:'100%',objectFit:'cover',position:'absolute',inset:0}}/> : <span className="lt-vicon">⚖️</span>}
        <span className="lt-dur">{v.duration ? `${Math.floor(v.duration/60)}:${String(v.duration%60).padStart(2,'0')}` : ''}</span>
      </div>
      <div className="lt-vinfo">
        <div className="lt-vtitle">{v.title}</div>
        <div className="lt-vmeta">{v.speaker_name} • {v.views_count||0} views</div>
      </div>
    </div>
  ))}
</div>
      <div className="lt-sec-head"><span className="lt-sec-badge">⚖️ {lang==='ta'?'உரிமைகள்':'RIGHTS GUIDE'}</span><span className="lt-sec-title">{lang==='ta'?'உங்கள் சட்ட உரிமைகள்':'Know Your Legal Rights'}</span></div>
      <p style={{color:'rgba(240,224,192,0.5)',fontSize:'11px',margin:'0 3% 12px',lineHeight:1.5,fontFamily:"'Barlow',sans-serif"}}>
        Plain-language summaries of Indian law. Each card cites its statute and links the official source.
      </p>
      <div className="lt-rights-grid">{rightsCards.map((card,i)=>(<div key={i} className={`lt-rights-card ${activeRights===i?'active':''}`} onClick={()=>setActiveRights(activeRights===i?null:i)} style={{borderLeftColor:activeRights===i?card.color:'transparent',borderLeftWidth:'3px',borderLeftStyle:'solid'}}><div className="lt-rights-header"><span className="lt-rights-icon">{card.icon}</span><span className="lt-rights-title">{card.title}</span><span className="lt-rights-arrow">{activeRights===i?'▲':'▼'}</span></div>{activeRights===i&&(<div className="lt-rights-body">{card.points.map((pt,j)=>(<div key={j} className="lt-rights-point"><span className="lt-rights-check">✓</span><span>{pt}</span></div>))}</div>)}</div>))}</div>
      <div className="lt-sec-head"><span className="lt-sec-badge">📚 {lang==='ta'?'தலைப்புகள்':'TOPICS'}</span><span className="lt-sec-title">{lang==='ta'?'சட்ட தலைப்புகளை தேர்ந்தெடு':'Browse by Legal Topic'}</span></div>
      <div className="lt-topics">{topics.map((topic,i)=>(<div key={i} className="lt-topic-card"><div className="lt-topic-icon">{topic.icon}</div><div className="lt-topic-text"><div className="lt-topic-title">{topic.title}</div><div className="lt-topic-sub">{topic.sub}</div></div><div className="lt-topic-arrow">›</div></div>))}</div>
    </div>
  );
}

function useVideoThumbnail(videoUrl, enabled) {
  const [thumb, setThumb] = React.useState(null);
  React.useEffect(() => {
    if (!enabled || !videoUrl) return;
    const vid = document.createElement('video');
    vid.crossOrigin = 'anonymous';
    vid.muted = true;
    vid.preload = 'metadata';
    vid.src = videoUrl;
    const capture = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = vid.videoWidth || 360;
        canvas.height = vid.videoHeight || 640;
        canvas.getContext('2d').drawImage(vid, 0, 0, canvas.width, canvas.height);
        const data = canvas.toDataURL('image/jpeg', 0.75);
        if (data && data.length > 5000) setThumb(data);
      } catch(e) {}
      vid.src = '';
    };
    vid.addEventListener('loadeddata', () => { vid.currentTime = 1; });
    vid.addEventListener('seeked', capture);
    vid.load();
    return () => { vid.src = ''; };
  }, [videoUrl, enabled]);
  return thumb;
}
function VideoCard({ video, isNew, hasAccess, onClick, onSpeakerClick, t = T.en, id }) {
  const needsThumb = !video.thumbnail_url && (video.category === 'Shorts' || video.category === 'Reels');
  const autoThumb = useVideoThumbnail(video.video_url, needsThumb);
  const thumbSrc = video.thumbnail_url || autoThumb;
  return (
    <div id={id} className="video-card" onClick={onClick}>
      <div className="video-thumb">
        {thumbSrc ? <div style={{width:"100%",height:"100%",backgroundImage:"url("+thumbSrc+")",backgroundSize:"cover",backgroundPosition:"center",position:"absolute",top:0,left:0,pointerEvents:"none"}}></div> : (!needsThumb && <img src={video.thumbnail_url} alt={video.title} />)}
        <div className="video-duration">{formatDuration(video.duration)}</div>
        {video.is_premium && !hasAccess && (<div style={{position:'absolute',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',borderRadius:'6px 6px 0 0'}}><span style={{fontSize:'2em'}}>🔒</span><span style={{color:'#ffa500',fontSize:'11px',fontWeight:'700',marginTop:'4px'}}>PREMIUM</span></div>)}
        {isNew && (<div style={{position:'absolute',top:'8px',left:'8px',background:'linear-gradient(135deg,#00d480,#007040)',color:'#fff',padding:'2px 8px',borderRadius:'10px',fontSize:'10px',fontWeight:'700'}}>NEW</div>)}
        {video.is_premium && !isNew && (<div style={{position:'absolute',top:'8px',left:'8px',background:'#ffa500',color:'#fff',padding:'2px 8px',borderRadius:'10px',fontSize:'10px',fontWeight:'700'}}>✅ PREMIUM</div>)}
      </div>
      <div className="video-info">
        <h3 className="video-title">{video.title}</h3>
        <div className="video-meta" style={{color:'rgba(255,255,255,0.85)'}}><span style={{color:'#d4a843',cursor:'pointer'}} onClick={onSpeakerClick}>{video.speaker_name}</span><span>•</span><span>{video.views_count||0} {t.views}</span><span>•</span><span>{video.subscriber_count||0} followers</span></div>
        <p className="video-desc">{video.description}</p>
      </div>
    </div>
  );
}

function SearchPage({ onBack, onVideoSelect, categories }) {
  const [query, setQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  // Auto-set showMovies when user logs in (render guard will check isPaidMode)
  React.useEffect(() => {
    if (user) {
      setShowMovies(true);  // All users including admin go to WatchNow
    }
  }, [user]);

  const handleSearch = async (e) => {
    e?.preventDefault(); setLoading(true); setSearched(true);
    try { const params = new URLSearchParams(); if (query.trim()) params.set('q', query.trim()); if (selectedCategory && selectedCategory !== 'All') params.set('category', selectedCategory); const response = await fetch(`${API_URL}/search?${params.toString()}`); const data = await response.json(); setResults(data.speeches || []); }
    catch (err) { console.error('Search failed:', err); } finally { setLoading(false); }
  };
  useEffect(() => { if (searched) handleSearch(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCategory]);
  return (
    <div style={{minHeight:'100vh',background:'#040000',color:'#f0e0c0',fontFamily:"'Barlow',sans-serif"}}>
      {/* Header */}
      <div style={{background:'#0d0000',borderBottom:'1px solid rgba(212,168,67,0.2)',padding:'14px 4%',display:'flex',alignItems:'center',gap:'16px',position:'sticky',top:0,zIndex:100}}>
        <button onClick={onBack} style={{background:'rgba(212,168,67,0.1)',border:'1px solid rgba(212,168,67,0.3)',color:'#d4a843',cursor:'pointer',fontSize:'16px',padding:'6px 12px',borderRadius:'6px',fontFamily:"'Barlow Condensed',sans-serif",fontWeight:'700',letterSpacing:'1px'}}>← BACK</button>
        <h1 style={{color:'#f5c842',fontSize:'18px',fontWeight:'900',margin:0,fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'3px',textTransform:'uppercase',textShadow:'0 0 20px rgba(245,200,66,0.4)'}}>🔍 Advanced Search</h1>
      </div>
      <div style={{padding:'24px 4%'}}>
        {/* Search bar */}
        <form onSubmit={handleSearch} style={{display:'flex',gap:'10px',marginBottom:'24px'}}>
          <input type="text" value={query} onChange={(e)=>setQuery(e.target.value)} placeholder="Search by title, speaker, description..." style={{flex:1,padding:'12px 16px',background:'rgba(255,255,255,0.04)',border:'1px solid rgba(212,168,67,0.25)',borderRadius:'6px',color:'#f0e0c0',fontSize:'14px',outline:'none',fontFamily:"'Barlow',sans-serif"}} autoFocus />
          <button type="submit" style={{padding:'12px 24px',background:'linear-gradient(135deg,#cc0000,#880000)',color:'#fff',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'13px',fontWeight:'800',letterSpacing:'2px',textTransform:'uppercase',fontFamily:"'Barlow Condensed',sans-serif",whiteSpace:'nowrap',boxShadow:'0 4px 20px rgba(180,0,0,0.4)'}}>SEARCH</button>
        </form>
        {/* Category filter */}
        <div style={{marginBottom:'24px'}}>
          <p style={{color:'rgba(212,168,67,0.7)',fontSize:'11px',marginBottom:'10px',fontWeight:'800',letterSpacing:'3px',fontFamily:"'Barlow Condensed',sans-serif"}}>FILTER BY CATEGORY</p>
          <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
            {categories.map((cat)=>{ const name=typeof cat==='string'?cat:cat.name; const emoji=typeof cat==='object'&&cat.emoji?cat.emoji:''; const isActive=selectedCategory===name; return(<button key={name} onClick={()=>setSelectedCategory(name)} style={{padding:'7px 14px',borderRadius:'20px',cursor:'pointer',fontSize:'11px',fontWeight:'800',whiteSpace:'nowrap',letterSpacing:'1px',fontFamily:"'Barlow Condensed',sans-serif",background:isActive?'linear-gradient(135deg,#cc0000,#880000)':'rgba(212,168,67,0.06)',color:isActive?'#fff':'rgba(212,168,67,0.7)',border:`1px solid ${isActive?'#cc0000':'rgba(212,168,67,0.2)'}`,boxShadow:isActive?'0 4px 16px rgba(180,0,0,0.3)':'none',transition:'all 0.2s'}}>{emoji} {name}</button>); })}
          </div>
        </div>
        {/* Loading */}
        {loading && <div style={{textAlign:'center',padding:'60px',color:'rgba(212,168,67,0.6)',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'3px',fontSize:'14px'}}>SEARCHING...</div>}
        {/* No results */}
        {!loading && searched && results.length === 0 && (<div style={{textAlign:'center',padding:'60px'}}><div style={{fontSize:'48px',marginBottom:'16px'}}>🔍</div><h3 style={{color:'#f5c842',marginBottom:'8px',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'2px'}}>NO RESULTS FOUND</h3><p style={{color:'rgba(212,168,67,0.6)',fontSize:'13px'}}>Try a different search term or category</p></div>)}
        {/* Results count */}
        {!loading && results.length > 0 && (<p style={{color:'rgba(212,168,67,0.6)',fontSize:'11px',marginBottom:'16px',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'2px'}}>{results.length} RESULT{results.length!==1?'S':''} FOUND</p>)}
        {/* Results grid */}
        {!loading && results.length > 0 && (
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:'14px'}}>
            {results.map((video)=>{ const isNew=new Date(video.created_at)>new Date(Date.now()-3*24*60*60*1000); return(
              <div key={video.id} onClick={()=>onVideoSelect(video)} style={{background:'linear-gradient(160deg,#1e0404,#140202)',borderRadius:'10px',overflow:'hidden',cursor:'pointer',border:'1px solid rgba(212,168,67,0.12)',transition:'all 0.3s'}} onMouseEnter={e=>{e.currentTarget.style.borderColor='rgba(212,168,67,0.4)';e.currentTarget.style.transform='translateY(-4px)';}} onMouseLeave={e=>{e.currentTarget.style.borderColor='rgba(212,168,67,0.12)';e.currentTarget.style.transform='translateY(0)';}}>
                <div style={{position:'relative',height:'130px',background:'#0a0000',overflow:'hidden'}}>
                  {video.thumbnail_url?<img src={video.thumbnail_url} alt={video.title} style={{width:'100%',height:'100%',objectFit:'cover',filter:'brightness(0.88)'}}/>:<div style={{width:'100%',height:'100%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'32px',color:'rgba(212,168,67,0.3)'}}>▶</div>}
                  <div style={{position:'absolute',bottom:'6px',right:'6px',background:'rgba(0,0,0,0.88)',color:'#f0d060',fontSize:'10px',fontWeight:'700',padding:'2px 6px',borderRadius:'3px',fontFamily:"'Barlow Condensed',sans-serif"}}>{formatDuration(video.duration)}</div>
                  {isNew&&<div style={{position:'absolute',top:'6px',left:'6px',background:'linear-gradient(135deg,#00d480,#007040)',color:'#fff',padding:'2px 8px',borderRadius:'10px',fontSize:'9px',fontWeight:'800',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px'}}>NEW</div>}
                </div>
                <div style={{padding:'10px 12px 12px',borderTop:'1px solid rgba(60,8,8,0.7)',background:'linear-gradient(180deg,#180202,#100101)'}}>
                  <p style={{color:'#f0e0c0',fontSize:'12px',fontWeight:'700',margin:'0 0 4px',lineHeight:'1.3',overflow:'hidden',display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'0.3px'}}>{video.title}</p>
                  <p style={{color:'rgba(212,168,67,0.7)',fontSize:'11px',margin:'0 0 5px',fontFamily:"'Barlow Condensed',sans-serif"}}>{video.speaker_name}</p>
                  <div style={{display:'flex',gap:'8px',fontSize:'10px',color:'rgba(212,168,67,0.5)',flexWrap:'wrap',alignItems:'center'}}>
                    <span>👁 {video.views_count||0}</span>
                    <span>🔥 {video.hype_count||0}</span>
                    <span style={{background:'rgba(212,168,67,0.08)',padding:'1px 6px',borderRadius:'4px',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'1px',fontSize:'9px'}}>{video.category}</span>
                  </div>
                </div>
              </div>
            ); })}
          </div>
        )}
        {/* Empty state */}
        {!searched && (<div style={{textAlign:'center',padding:'80px 0'}}><div style={{fontSize:'52px',marginBottom:'16px'}}>🔍</div><p style={{color:'rgba(212,168,67,0.6)',fontSize:'14px',fontFamily:"'Barlow Condensed',sans-serif",letterSpacing:'2px'}}>SEARCH FOR SPEECHES, INTERVIEWS, SPEAKERS AND MORE</p></div>)}
      </div>
    </div>
  );
}

function LandingPage({ onLogin, onSignup, onLoginSuccess, referralCode, streakToast, onEnter }) {
  const [trending, setTrending] = React.useState([]);
  const [npOriginals, setNpOriginals] = React.useState([]);
  const [showLogin, setShowLogin] = React.useState(false);
  const [showSignupForm, setShowSignupForm] = React.useState(false);
  const [showContact, setShowContact] = React.useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = React.useState(false);
  useEffect(() => { fetch(`${API_URL}/public/trending`).then(r=>r.json()).then(data=>setTrending(data.speeches||[])).catch(err=>console.error(err)); }, []);
  if (showSignupForm) return <Signup onSignupSuccess={onLoginSuccess} onSwitchToLogin={()=>{setShowSignupForm(false);setShowLogin(true);}} referralCode={referralCode}/>;
  if (showLogin) return <Login onLoginSuccess={onLoginSuccess} onSwitchToSignup={()=>{setShowLogin(false);setShowSignupForm(true);}}/>;
  if (showPrivacyPolicy) return <PrivacyPolicy onBack={()=>setShowPrivacyPolicy(false)} />;
  return (
    <>
      {/* eslint-disable-next-line no-undef */}
      {streakToast && (
        <div style={{position:"fixed",top:"20px",left:"50%",transform:"translateX(-50%)",background:"linear-gradient(135deg,#ff6b00,#ff9500)",color:"#fff",padding:"14px 28px",borderRadius:"50px",fontWeight:"800",fontSize:"1.1em",zIndex:99999,boxShadow:"0 4px 24px rgba(255,107,0,0.5)"}}>
          🔥 {streakToast}-Day Streak! +10 Points Earned!
        </div>
      )}
    <div className="landing-page">
      <div className="lp-bg-glow"></div><div className="lp-bg-vignette"></div>
      <header className="landing-header">
        <div className="landing-logo"><div className="logo-stack"><span className="logo-nethaji">NETHAJI</span><div className="logo-prime-row"><span className="logo-rule-l"></span><span className="logo-prime-text">PRIME</span><span className="logo-rule-r"></span></div></div></div>
        <div className="landing-header-btns"><button onClick={()=>setShowLogin(true)} className="landing-btn-login">Login</button><button onClick={()=>setShowSignupForm(true)} className="landing-btn-signup">Start Free — Join Now</button></div>
      </header>
      {referralCode&&<div className="landing-referral">Gift You were invited! Sign up now and get <strong>10 days free</strong> instead of 7!</div>}
      <div className="landing-hero">
        <div className="np-landing-heroleft">
        <div className="landing-hero-flag" style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',background:'radial-gradient(ellipse 100% 100% at 50% 50%,#2d0505 0%,#180202 35%,#080000 70%,#040000 100%)',position:'relative',overflow:'hidden'}}>
          <div style={{position:'relative',zIndex:4,textAlign:'center',padding:'40px 20px'}}>
            <img src="https://media.nethajiprime.com/nethaji-logo.png" alt="Nethaji Prime OTT" style={{width:'clamp(200px,32vw,300px)',height:'auto',objectFit:'contain',display:'block',filter:'drop-shadow(0 0 30px rgba(212,168,67,0.8)) brightness(1.15)'}}/>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'clamp(9px,1.1vw,12px)',fontWeight:'900',letterSpacing:'5px',color:'rgba(212,168,67,0.65)',textTransform:'uppercase',marginTop:'10px'}}>Tamil Sociopolitical Media</div>
          </div>
          <div className="lhf-streaming-badge" style={{zIndex:5}}><span className="lhf-badge-dot"></span><span>NOW STREAMING</span></div>
          <div className="lhf-fade-b"></div>
        </div>
        <div className="np-hero-app">
          <div className="np-hero-app-qr"><GetAppQR size={132} /></div>
        </div>
        </div>
        <div className="landing-hero-content">
          <div className="lhc-brand"><div className="lhc-brand-logo"><span className="lhc-brand-nethaji">NETHAJI</span><div className="lhc-brand-prime-row"><span className="lhc-brand-line"></span><span className="lhc-brand-prime">PRIME</span><span className="lhc-brand-line"></span></div><span className="lhc-brand-ott">OTT</span></div></div>
          <div className="lhc-badge"><span className="lhc-dot"></span><span>EXCLUSIVE STREAMING PLATFORM</span></div>
          <div className="lhc-tagline"><p className="lhc-tag-line1">அரசியல் · சமூக பிரச்சனை · அறிவியல் · கலாச்சாரம் · விளையாட்டு · சினிமா · பொழுதுபோக்கு</p><p className="lhc-tag-line2">A Sociopolitical Tamil Media Channel · One Platform. All of Tamil.</p></div>
          <div className="lhc-quote"><span className="lhc-quote-mark">"</span><p>The voices of our leaders never die — they stream forever.</p></div>
          <div className="lhc-rule"><span className="lhc-rule-l"></span><span className="lhc-rule-d"></span><span className="lhc-rule-r"></span></div>
          <p className="lhc-sub">Rare speeches &bull; Historic debates &bull; Powerful interviews<br/>Preserved for future generations</p>
          <div className="lhc-stats"><div className="lhc-stat"><span className="lhcs-n">500+</span><span className="lhcs-l">Members</span></div><div className="lhcs-sep"></div><div className="lhc-stat"><span className="lhcs-n">50+</span><span className="lhcs-l">Videos</span></div><div className="lhcs-sep"></div><div className="lhc-stat"><span className="lhcs-n">7</span><span className="lhcs-l">Day Trial</span></div></div>
          <div className="lhc-btns"><button onClick={()=>setShowSignupForm(true)} className="lhc-btn-primary">▶ Start Free Trial</button><button onClick={()=>setShowLogin(true)} className="lhc-btn-secondary">Login</button></div><div style={{marginTop:"14px"}}><button onClick={()=>{ if(onEnter) { onEnter(); window.location.hash="movies"; } else { window.location.hash="movies"; window.dispatchEvent(new HashChangeEvent("hashchange")); } }} style={{background:"#FFD700",color:"#000",fontFamily:"'Bebas Neue',sans-serif",fontSize:"18px",letterSpacing:"2px",padding:"14px 36px",border:"none",borderRadius:"8px",cursor:"pointer",boxShadow:"0 0 30px rgba(255,215,0,0.6)",fontWeight:900,width:"100%"}}>▶ ENTER NETHAJI PRIME</button><p style={{fontFamily:"'Rajdhani',sans-serif",fontSize:"12px",color:"rgba(255,255,255,0.5)",marginTop:"6px",textAlign:"center"}}>Free access • No login required</p></div>
          <p className="lhc-trial">Free during Beta &bull; No credit card required</p>
          <div className="lhc-cats">{['Home','New','Shorts','Interviews','Devotional','Legal'].map(cat=>(<span key={cat} onClick={()=>setShowSignupForm(true)} className="lhc-cat">{cat}</span>))}</div>
        </div>
        <div className="np-landing-appcta">
          <a className="np-hero-app-btn" href="/get-app">&#128241; Download App</a>
        </div>
      </div>
      <div className="landing-trending">
        <div className="landing-sec-head"><span className="landing-sec-badge">TRENDING</span><span className="landing-sec-title">Watch Before You Subscribe</span><span className="landing-sec-line"></span></div>
        {trending.length===0?<div className="landing-loading">Loading...</div>:(
          <div className="landing-grid">{trending.slice(0,4).map((video)=>(<div key={video.id} onClick={()=>setShowSignupForm(true)} className="landing-vcard"><div className="landing-vthumb">{video.thumbnail_url?<img src={video.thumbnail_url} alt={video.title}/>:<div className="landing-vthumb-ph">Play</div>}<div className="landing-vthumb-ov"><div className="landing-vplay">Play</div></div><div className="landing-vdur">{formatDuration(video.duration)}</div>{video.is_premium&&<div className="landing-vprem">PREMIUM</div>}<div className="landing-vlock">Lock Sign up to watch</div></div><div className="landing-vinfo"><div className="landing-vtitle">{video.title}</div><div className="landing-vspeaker">{video.speaker_name}</div><div className="landing-vmeta"><span>{(video.views_count||0).toLocaleString('en-US')} views</span></div></div></div>))}</div>
        )}
        {npOriginals.length > 0 && (
          <div style={{marginTop:'24px',padding:'0 4%'}}>
            <div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'16px',fontWeight:'900',color:'#c9a84c',letterSpacing:'2px',marginBottom:'12px'}}>🎬 NP ORIGINALS</div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
              {npOriginals.map(v=>(
                <div key={v.id} onClick={()=>setShowSignupForm(true)} style={{cursor:'pointer',borderRadius:'10px',overflow:'hidden',background:'#0d0d10',border:'1px solid rgba(201,168,76,0.2)'}}>
                  <img src={v.thumbnail_url||'https://via.placeholder.com/160x90'} alt={v.title} style={{width:'100%',height:'90px',objectFit:'cover'}} onError={e=>e.target.style.display='none'} />
                  <div style={{padding:'8px'}}>
                    <div style={{color:'#fff',fontSize:'11px',fontWeight:'700',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{v.title}</div>
                    <div style={{color:'#c9a84c',fontSize:'9px',marginTop:'2px'}}>NP ORIGINAL</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="landing-cta-row"><button onClick={()=>setShowSignupForm(true)} className="landing-cta-btn">▶ Watch All Videos - Sign Up Free</button></div>
      </div>
      <div className="landing-benefits">
        <div className="landing-sec-head"><span className="landing-sec-badge">WHY JOIN</span><span className="landing-sec-title">Nethaji Prime Exclusive</span><span className="landing-sec-line"></span></div>
        <div className="landing-benefits-grid">{[{icon:'Camera',title:'Rare Footage',desc:'Exclusive speeches & interviews unavailable anywhere else'},{icon:'Mobile',title:'Watch Anywhere',desc:'Stream on mobile, tablet or desktop anytime'},{icon:'Free',title:'7-Day Free Trial',desc:'Try everything free for 7 days, no credit card needed'}].map((b,i)=>(<div key={i} className="landing-benefit-card"><div className="landing-benefit-icon">{b.icon}</div><h3 className="landing-benefit-title">{b.title}</h3><p className="landing-benefit-desc">{b.desc}</p></div>))}</div>
      </div>
      <footer className="landing-footer">
        <div className="lf-logo">NETHAJI PRIME</div>
        <p className="lf-copy">2026 Nethaji Prime. Politics · Social Issues · Science · Culture · Sports · Astrology · Devotional · Cinema · Entertainment.</p>
        <div className="lf-links"><button onClick={()=>setShowSignupForm(true)}>Sign Up</button><button onClick={()=>setShowLogin(true)}>Login</button><button onClick={()=>setShowPrivacyPolicy(true)}>Privacy Policy</button><button onClick={()=>setShowContact(true)}>Contact</button></div>
      </footer>
      <LegalFooter />
      {showContact&&(<div onClick={()=>setShowContact(false)} style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.85)',zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}><div onClick={e=>e.stopPropagation()} style={{background:'linear-gradient(160deg,#200404,#100101)',border:'1px solid rgba(212,168,67,0.3)',borderRadius:'12px',padding:'36px',maxWidth:'420px',width:'100%',position:'relative'}}><button onClick={()=>setShowContact(false)} style={{position:'absolute',top:'12px',right:'12px',background:'rgba(212,168,67,0.1)',border:'1px solid rgba(212,168,67,0.3)',color:'#d4a843',width:'32px',height:'32px',borderRadius:'50%',cursor:'pointer',fontSize:'16px',display:'flex',alignItems:'center',justifyContent:'center'}}>✕</button><div style={{fontFamily:"'Cinzel',serif",fontSize:'1.4em',fontWeight:'900',color:'#f5c842',letterSpacing:'3px',marginBottom:'6px',textAlign:'center'}}>CONTACT US</div><div style={{height:'1px',background:'linear-gradient(90deg,transparent,#d4a843,transparent)',marginBottom:'24px'}}/><div style={{display:'flex',flexDirection:'column',gap:'16px'}}><a href="mailto:contact@nethajiprime.com" style={{display:'flex',alignItems:'center',gap:'14px',padding:'14px 16px',background:'rgba(212,168,67,0.06)',border:'1px solid rgba(212,168,67,0.15)',borderRadius:'8px',textDecoration:'none'}}><span style={{fontSize:'22px'}}>✉</span><div><div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'9px',fontWeight:'800',letterSpacing:'2px',color:'#c8902a',textTransform:'uppercase',marginBottom:'2px'}}>Email Us</div><div style={{color:'#f0e0c0',fontSize:'13px'}}>contact@nethajiprime.com</div></div></a><a href="https://wa.me/919444456788" target="_blank" rel="noreferrer" style={{display:'flex',alignItems:'center',gap:'14px',padding:'14px 16px',background:'rgba(37,211,102,0.06)',border:'1px solid rgba(37,211,102,0.2)',borderRadius:'8px',textDecoration:'none'}}><span style={{fontSize:'22px'}}>📱</span><div><div style={{fontFamily:"'Barlow Condensed',sans-serif",fontSize:'9px',fontWeight:'800',letterSpacing:'2px',color:'#25d366',textTransform:'uppercase',marginBottom:'2px'}}>WhatsApp</div><div style={{color:'#f0e0c0',fontSize:'13px'}}>+91 94444 56788</div></div></a></div></div></div>)}
    </div>
    </>
  );
}


function MenChannelFeed({channel, apiUrl, onVideoSelect}) {
  const [videos, setVideos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [watching, setWatching] = React.useState(null);
  React.useEffect(()=>{
    fetch(apiUrl+"/api/youtube-feeds?channel_id="+channel.channelId+"&max_results=10")
      .then(r=>r.json())
      .then(d=>{if(d.items)setVideos(d.items);setLoading(false);})
      .catch(()=>setLoading(false));
  },[channel.channelId]);
  if(watching) return (
    <div style={{marginBottom:'20px',background:'rgba(0,0,0,0.3)',borderRadius:'12px',padding:'12px'}}>
      <button onClick={()=>setWatching(null)} style={{background:'rgba(255,255,255,0.1)',border:'none',color:'#fff',padding:'6px 12px',borderRadius:'6px',cursor:'pointer',marginBottom:'10px'}}>← Back</button>
      <iframe width="100%" height="360" src={"https://www.youtube.com/embed/"+watching.videoId+"?autoplay=1"} frameBorder="0" allowFullScreen style={{borderRadius:'8px'}} />
      <div style={{color:'#fff',fontWeight:700,marginTop:'8px',fontSize:'13px'}}>{watching.title}</div>
    </div>
  );
  if(!loading && videos.length === 0) return null;
  return (
    <div style={{marginBottom:'20px'}}>
      <div style={{color:channel.color,fontWeight:700,fontSize:'14px',marginBottom:'8px'}}>{channel.icon} {channel.name}</div>
      {loading ? <div style={{color:'rgba(255,255,255,0.3)',fontSize:'12px',padding:'10px'}}>Loading...</div> :
      videos.length === 0 ? null :
      <div style={{display:'flex',gap:'8px',overflowX:'auto',paddingBottom:'8px'}}>
        {videos.map((v,i)=>(
          <div key={i} onClick={()=>setWatching(v)} style={{minWidth:'160px',maxWidth:'160px',background:'rgba(255,255,255,0.05)',borderRadius:'8px',overflow:'hidden',cursor:'pointer',flexShrink:0}}>
            <img src={v.thumbnail} alt={v.title} style={{width:'100%',height:'90px',objectFit:'cover'}}/>
            <div style={{padding:'6px',color:'#fff',fontSize:'10px',fontWeight:600,lineHeight:'1.3'}}>{v.title?.slice(0,60)}</div>
          </div>
        ))}
      </div>}
    </div>
  );
}

function MenPage({ onBack, t, onVideoSelect }) {
  const [ottVideosMen, setOttVideosMen] = React.useState([]);
  React.useEffect(()=>{
    fetch((process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com")+"/speeches?category=Men")
      .then(r=>r.json()).then(d=>{if(d.speeches)setOttVideosMen(d.speeches);})
      .catch(()=>{});
  },[]);
  const MEN_CHANNELS = []
  return (
    <div style={{background:"#040000",minHeight:"100vh",color:"#f0e6cc",fontFamily:"'Barlow',sans-serif"}}>
      <BANNERS.Men />
      {ottVideosMen.length>0&&(
        <div style={{padding:'16px 4%',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
          <div style={{color:'#d4a843',fontWeight:900,fontSize:'14px',marginBottom:'12px'}}>Nethaji Prime Men Videos</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:'12px'}}>
            {ottVideosMen.map((v,i)=>(
              <VideoCard 
                key={v.id||i} 
                video={v} 
                isNew={false} 
                hasAccess={true}
                onClick={()=>{
                  if(v.video_url && !v.video_url.includes('youtube') && !v.video_url.includes('youtu.be')){
                    if(onVideoSelect) onVideoSelect(v);
                  } else {
                    window.open(v.video_url,'_blank');
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
      <div style={{background:"rgba(4,0,0,0.97)",borderBottom:"1px solid rgba(212,168,67,0.2)",padding:"0 4%",height:"66px",display:"flex",alignItems:"center",gap:"16px",position:"sticky",top:0,zIndex:100}}>
        <button onClick={onBack} style={{background:"none",border:"1px solid rgba(212,168,67,0.3)",color:"#d4a843",padding:"7px 18px",borderRadius:"20px",cursor:"pointer",fontSize:"13px",fontWeight:"700"}}>Back</button><button onClick={()=>window.open("https://wa.me/?text="+encodeURIComponent("Watch Men on Nethaji Prime OTT!\\n\\nhttps://nethajiprime.com/#men"),"_blank")} style={{marginLeft:"8px",padding:"6px 12px",background:"#25D366",border:"none",borderRadius:"6px",color:"#fff",fontSize:"11px",fontWeight:700,cursor:"pointer"}}>Share</button>
        <span style={{fontFamily:"'Cinzel',serif",fontSize:"1.2em",fontWeight:"900",color:"#f5c842"}}>Men</span>
      </div>
      <div style={{padding:"24px 4%",maxWidth:"900px",margin:"0 auto"}}>
        <div style={{textAlign:"center",marginBottom:"28px"}}>
          <div style={{fontSize:"48px",marginBottom:"8px"}}>👨</div>
          <h1 style={{fontFamily:"'Cinzel',serif",color:"#f5c842",fontSize:"2em",margin:"0 0 8px"}}>Men's Corner</h1>
          <p style={{color:"rgba(255,255,255,0.5)",fontSize:"14px"}}>Health, grooming, sports and lifestyle</p>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(250px,1fr))",gap:"16px",marginBottom:"24px"}}>
          {MEN_CHANNELS.map((ch,i)=>(
            <MenChannelFeed key={i} channel={ch} apiUrl={process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com"} onVideoSelect={onVideoSelect} />
        ))}
        </div>
        <div style={{padding:'16px',borderTop:'1px solid rgba(255,255,255,0.08)'}}>
          <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',fontWeight:'700',letterSpacing:'2px',marginBottom:'12px'}}>MEN'S PRODUCTS</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))',gap:'10px'}}>
            {[{name:'Traya Health',url:'https://traya.health',desc:'Hair fall solution',color:'#2c7a3a',emoji:'💇'},{name:'ManMatters',url:'https://manmatters.com',desc:'Men health',color:'#1a1a2e',emoji:'💪'},{name:'Beardo',url:'https://beardo.in',desc:'Grooming products',color:'#8B4513',emoji:'🧔'},{name:'Dream11',url:'https://dream11.com',desc:'Fantasy cricket',color:'#1a2e6b',emoji:'🏏'},{name:'Myntra Men',url:'https://myntra.com/men',desc:'Men fashion',color:'#ff3f6c',emoji:'👔'}].map((a,i)=>(
              <div key={i} onClick={()=>window.open(a.url,'_blank')} style={{background:'rgba(255,255,255,0.04)',border:'1px solid rgba(255,255,255,0.08)',borderRadius:'10px',padding:'12px',cursor:'pointer',borderTop:'2px solid '+a.color,textAlign:'center'}}>
                <div style={{fontSize:'22px',marginBottom:'4px'}}>{a.emoji}</div>
                <div style={{color:a.color,fontWeight:'800',fontSize:'12px',marginBottom:'3px'}}>{a.name}</div>
                <div style={{color:'rgba(255,255,255,0.35)',fontSize:'10px',marginBottom:'8px'}}>{a.desc}</div>
                <button style={{padding:'4px 10px',background:a.color,border:'none',borderRadius:'5px',color:'#fff',fontWeight:'700',cursor:'pointer',fontSize:'10px'}}>Shop</button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;






























